(function (lib, img, cjs, ss, an) {

var p; // shortcut to reference prototypes
lib.ssMetadata = [
		{name:"MWIntro_atlas_", frames: [[1226,1706,240,340],[730,1706,248,336],[1468,1706,236,340],[980,1706,244,340],[1706,1706,292,272],[730,1456,348,224],[1080,1468,348,224],[1032,888,340,268],[670,888,360,256],[1584,1178,320,272],[670,1146,300,304],[1374,888,308,288],[1278,1178,304,288],[1360,0,664,496],[0,526,668,508],[1584,1452,334,252],[1684,832,334,260],[0,0,684,524],[686,0,672,500],[0,1036,668,500],[686,502,812,384],[0,1538,728,445],[1500,498,336,332],[972,1158,304,296]]},
		{name:"MWIntro_atlas_2", frames: [[512,904,264,228],[1428,872,308,236],[1050,0,348,224],[700,0,348,224],[1400,0,348,224],[350,226,348,224],[0,226,348,224],[1458,226,348,224],[700,226,348,224],[700,678,348,224],[350,0,348,224],[350,678,348,224],[1050,646,348,224],[0,678,348,224],[0,0,348,224],[1050,420,348,224],[0,452,348,224],[350,452,348,224],[700,452,348,224],[1400,452,348,224],[1552,1446,328,156],[990,1664,328,156],[1714,1288,328,156],[1222,1348,328,156],[0,1178,328,156],[0,1336,328,156],[1650,1604,328,156],[660,1676,328,156],[1650,1762,328,156],[0,1810,328,156],[1320,1762,328,156],[330,1518,328,156],[1320,1604,328,156],[0,1652,328,156],[990,1506,328,156],[330,1676,328,156],[660,1360,328,156],[330,1360,328,156],[660,1518,328,156],[0,1494,328,156],[750,1146,256,204],[1738,872,304,236],[1806,584,228,248],[1808,330,228,252],[0,904,256,272],[1714,1110,304,176],[1222,1110,256,220],[258,904,252,264],[1024,1074,196,288],[1050,872,376,200],[778,904,244,240],[580,1834,235,203],[990,1822,254,201],[330,1834,248,196],[1050,226,406,192],[1400,678,404,192],[1480,1110,232,236],[512,1134,236,224],[1808,0,200,328]]},
		{name:"MWIntro_atlas_3", frames: [[1940,598,84,312],[528,1342,120,156],[223,1871,92,100],[744,996,76,72],[1044,964,92,60],[1443,1880,64,52],[1509,1880,64,52],[978,558,64,68],[1786,554,68,40],[486,748,68,44],[785,1416,68,68],[1214,0,244,184],[357,1783,124,90],[1706,1788,124,90],[1460,0,244,184],[1580,1788,124,90],[722,186,244,184],[861,1800,124,90],[476,186,244,184],[735,1800,124,90],[968,186,244,184],[1113,1861,124,90],[1706,0,244,184],[1832,1788,124,90],[230,186,244,184],[987,1822,124,90],[968,0,244,184],[1454,1788,124,90],[230,0,244,184],[483,1783,124,90],[476,0,244,184],[609,1785,124,90],[722,0,244,184],[1328,1788,124,90],[1582,1170,174,112],[0,1154,174,112],[362,1152,174,112],[1118,1204,174,112],[942,1174,174,112],[1294,1220,174,112],[1758,1182,174,112],[1406,1106,174,112],[714,1302,174,112],[558,1114,174,112],[1230,1090,174,112],[904,1288,174,112],[1646,1296,174,112],[1822,1296,174,112],[186,1126,174,112],[538,1228,174,112],[176,1240,174,112],[352,1266,174,112],[0,1268,174,112],[1470,1284,174,112],[1516,988,184,116],[558,996,184,116],[186,1008,184,116],[372,1034,184,116],[0,1036,184,116],[1702,1052,184,116],[1044,1056,184,116],[958,846,184,116],[1520,870,184,116],[186,890,184,116],[1334,854,184,116],[1148,820,184,116],[858,964,184,116],[1330,972,184,116],[672,878,184,116],[0,918,184,116],[486,798,184,116],[372,916,184,116],[1706,934,184,116],[1144,938,184,116],[664,1705,164,78],[868,1640,164,78],[1325,1621,164,78],[1698,1708,164,78],[830,1720,164,78],[1864,1708,164,78],[1366,1708,164,78],[702,1625,164,78],[996,1742,164,78],[1162,1781,164,78],[1532,1708,164,78],[332,1703,164,78],[0,1702,164,78],[498,1703,164,78],[166,1702,164,78],[1034,1662,164,78],[1491,1628,164,78],[1657,1628,164,78],[1200,1701,164,78],[1823,1628,164,78],[186,796,132,86],[0,1601,132,86],[223,1783,132,86],[1934,1182,92,104],[890,1402,128,112],[1786,598,152,192],[0,590,176,168],[734,1184,168,116],[210,372,172,228],[0,202,208,204],[672,798,103,68],[1148,688,196,130],[1270,1334,176,108],[105,1782,116,108],[1880,186,164,212],[395,1609,144,92],[1436,380,212,172],[1580,744,196,124],[978,688,168,156],[804,558,172,176],[558,916,92,60],[1868,400,176,196],[1448,1398,132,112],[582,522,220,152],[1604,554,180,172],[1892,934,156,112],[0,408,184,180],[1046,392,236,148],[178,602,144,192],[0,1492,133,107],[1958,1788,66,54],[432,1500,133,107],[1958,1844,66,54],[1425,1512,133,107],[1239,1861,66,54],[785,1516,133,107],[317,1875,66,54],[1560,1519,133,107],[385,1875,66,54],[1695,1519,133,107],[453,1875,66,54],[1830,1519,133,107],[521,1875,66,54],[567,1525,133,107],[589,1877,66,54],[920,1531,133,107],[657,1877,66,54],[1055,1553,133,107],[1307,1880,66,54],[1190,1553,133,107],[1375,1880,66,54],[297,1478,133,107],[609,1634,66,54],[1852,1410,133,107],[1582,1106,66,54],[650,1416,133,107],[1470,1220,66,54],[1020,1422,133,107],[978,628,66,54],[1155,1444,133,107],[702,1525,66,54],[1290,1444,133,107],[1325,1553,66,54],[162,1471,133,107],[541,1634,66,54],[1582,1410,133,107],[1346,686,66,54],[1717,1410,133,107],[1706,870,66,54],[1214,186,220,204],[582,372,260,148],[1268,610,128,74],[1080,1318,188,102],[858,878,88,76],[1666,186,212,204],[744,1082,196,100],[1046,542,220,144],[176,1354,160,115],[249,1587,144,92],[1952,0,96,152],[384,574,172,172],[324,748,160,140],[135,1580,112,120],[0,0,228,200],[1965,1519,76,102],[0,1382,160,108],[1436,186,228,192],[0,796,184,120],[844,372,200,184],[338,1380,184,96],[1284,392,148,216],[1346,744,232,108],[324,602,48,48],[792,736,164,140],[1778,792,154,140],[384,372,196,200],[1650,392,216,160],[1434,554,168,188],[558,676,232,120],[942,1082,100,88],[0,1782,103,124],[1888,1052,160,128]]}
];


// symbols:



(lib.forearm_001 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.Murray3ShirtHem = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.MurrayArm1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_"];
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.MurrayArm1_002 = function() {
	this.spriteSheet = ss["MWIntro_atlas_"];
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.MurrayArm1_007 = function() {
	this.spriteSheet = ss["MWIntro_atlas_"];
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.MurrayArm1_009 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.MurrayArm1_016 = function() {
	this.spriteSheet = ss["MWIntro_atlas_"];
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.MurrayArm2 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.MurrayBackHand_337 = function() {
	this.spriteSheet = ss["MWIntro_atlas_"];
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.MurrayEye = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.MurrayEyelash2 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.MurrayEyelash = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.MurrayEyelid2 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.MurrayEyelid2_02 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.MurrayEyelid2_03 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.MurrayEyelid = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.MurrayEyelid_3_01 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib.MurrayEyelid_3_02 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib.MurrayFace0001 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib.MurrayFace0001_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib.MurrayFace0010 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();



(lib.MurrayFace0011 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(14);
}).prototype = p = new cjs.Sprite();



(lib.MurrayFace0011_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(15);
}).prototype = p = new cjs.Sprite();



(lib.MurrayFace0012 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(16);
}).prototype = p = new cjs.Sprite();



(lib.MurrayFace0012_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(17);
}).prototype = p = new cjs.Sprite();



(lib.MurrayFace0013 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(18);
}).prototype = p = new cjs.Sprite();



(lib.MurrayFace0013_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(19);
}).prototype = p = new cjs.Sprite();



(lib.MurrayFace0014 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(20);
}).prototype = p = new cjs.Sprite();



(lib.MurrayFace0014_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(21);
}).prototype = p = new cjs.Sprite();



(lib.MurrayFace0015 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(22);
}).prototype = p = new cjs.Sprite();



(lib.MurrayFace0015_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(23);
}).prototype = p = new cjs.Sprite();



(lib.MurrayFace0016 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(24);
}).prototype = p = new cjs.Sprite();



(lib.MurrayFace0016_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(25);
}).prototype = p = new cjs.Sprite();



(lib.MurrayFace0017 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(26);
}).prototype = p = new cjs.Sprite();



(lib.MurrayFace0017_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(27);
}).prototype = p = new cjs.Sprite();



(lib.MurrayFace0018 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(28);
}).prototype = p = new cjs.Sprite();



(lib.MurrayFace0018_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(29);
}).prototype = p = new cjs.Sprite();



(lib.MurrayFace0019 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(30);
}).prototype = p = new cjs.Sprite();



(lib.MurrayFace0019_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(31);
}).prototype = p = new cjs.Sprite();



(lib.MurrayFace0020 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(32);
}).prototype = p = new cjs.Sprite();



(lib.MurrayFace0020_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(33);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom0001 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom0001_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(34);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom0002 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom0002_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(35);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom0003 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom0003_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(36);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom0004 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom0004_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(37);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom0005 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom0005_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(38);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom0006 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom0006_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(39);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom0007 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom0007_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(40);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom0008 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom0008_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(41);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom0009 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom0009_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(42);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom0010 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom0010_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(43);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom0011 = function() {
	this.spriteSheet = ss["MWIntro_atlas_"];
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom0011_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(44);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom0012 = function() {
	this.spriteSheet = ss["MWIntro_atlas_"];
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom0012_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(45);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom0013 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom0013_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(46);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom0014 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom0014_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(47);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom0015 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(14);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom0015_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(48);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom0016 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(15);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom0016_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(49);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom0017 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(16);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom0017_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(50);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom0018 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(17);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom0018_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(51);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom0019 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(18);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom0019_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(52);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom0020 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(19);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom0020_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(53);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom_dryer0001 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(54);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom_dryer0002 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(55);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom_dryer0003 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(56);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom_dryer0004 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(57);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom_dryer0005 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(58);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom_dryer0006 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(59);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom_dryer0007 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(60);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom_dryer0008 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(61);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom_dryer0009 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(62);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom_dryer0010 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(63);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom_dryer0011 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(64);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom_dryer0012 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(65);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom_dryer0013 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(66);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom_dryer0014 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(67);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom_dryer0015 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(68);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom_dryer0016 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(69);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom_dryer0017 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(70);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom_dryer0018 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(71);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom_dryer0019 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(72);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawbottom_dryer0020 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(73);
}).prototype = p = new cjs.Sprite();



(lib.Murrayjawtop0001 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(20);
}).prototype = p = new cjs.Sprite();



(lib.Murrayjawtop0001_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(74);
}).prototype = p = new cjs.Sprite();



(lib.Murrayjawtop0002 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(21);
}).prototype = p = new cjs.Sprite();



(lib.Murrayjawtop0002_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(75);
}).prototype = p = new cjs.Sprite();



(lib.Murrayjawtop0003 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(22);
}).prototype = p = new cjs.Sprite();



(lib.Murrayjawtop0003_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(76);
}).prototype = p = new cjs.Sprite();



(lib.Murrayjawtop0004 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(23);
}).prototype = p = new cjs.Sprite();



(lib.Murrayjawtop0004_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(77);
}).prototype = p = new cjs.Sprite();



(lib.Murrayjawtop0005 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(24);
}).prototype = p = new cjs.Sprite();



(lib.Murrayjawtop0005_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(78);
}).prototype = p = new cjs.Sprite();



(lib.Murrayjawtop0006 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(25);
}).prototype = p = new cjs.Sprite();



(lib.Murrayjawtop0006_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(79);
}).prototype = p = new cjs.Sprite();



(lib.Murrayjawtop0007 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(26);
}).prototype = p = new cjs.Sprite();



(lib.Murrayjawtop0007_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(80);
}).prototype = p = new cjs.Sprite();



(lib.Murrayjawtop0008 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(27);
}).prototype = p = new cjs.Sprite();



(lib.Murrayjawtop0008_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(81);
}).prototype = p = new cjs.Sprite();



(lib.Murrayjawtop0009 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(28);
}).prototype = p = new cjs.Sprite();



(lib.Murrayjawtop0009_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(82);
}).prototype = p = new cjs.Sprite();



(lib.Murrayjawtop0010 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(29);
}).prototype = p = new cjs.Sprite();



(lib.Murrayjawtop0010_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(83);
}).prototype = p = new cjs.Sprite();



(lib.Murrayjawtop0011 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(30);
}).prototype = p = new cjs.Sprite();



(lib.Murrayjawtop0011_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(84);
}).prototype = p = new cjs.Sprite();



(lib.Murrayjawtop0012 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(31);
}).prototype = p = new cjs.Sprite();



(lib.Murrayjawtop0012_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(85);
}).prototype = p = new cjs.Sprite();



(lib.Murrayjawtop0013 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(32);
}).prototype = p = new cjs.Sprite();



(lib.Murrayjawtop0013_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(86);
}).prototype = p = new cjs.Sprite();



(lib.Murrayjawtop0014 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(33);
}).prototype = p = new cjs.Sprite();



(lib.Murrayjawtop0014_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(87);
}).prototype = p = new cjs.Sprite();



(lib.Murrayjawtop0015 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(34);
}).prototype = p = new cjs.Sprite();



(lib.Murrayjawtop0015_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(88);
}).prototype = p = new cjs.Sprite();



(lib.Murrayjawtop0016 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(35);
}).prototype = p = new cjs.Sprite();



(lib.Murrayjawtop0016_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(89);
}).prototype = p = new cjs.Sprite();



(lib.Murrayjawtop0017 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(36);
}).prototype = p = new cjs.Sprite();



(lib.Murrayjawtop0017_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(90);
}).prototype = p = new cjs.Sprite();



(lib.Murrayjawtop0018 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(37);
}).prototype = p = new cjs.Sprite();



(lib.Murrayjawtop0018_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(91);
}).prototype = p = new cjs.Sprite();



(lib.Murrayjawtop0019 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(38);
}).prototype = p = new cjs.Sprite();



(lib.Murrayjawtop0019_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(92);
}).prototype = p = new cjs.Sprite();



(lib.Murrayjawtop0020 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(39);
}).prototype = p = new cjs.Sprite();



(lib.Murrayjawtop0020_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(93);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawunderlip = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(40);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawunderlip_dryer0001 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(94);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawunderlip_dryer0002 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(95);
}).prototype = p = new cjs.Sprite();



(lib.MurrayJawunderlip_dryer0003 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(96);
}).prototype = p = new cjs.Sprite();



(lib.MurrayLeftArm1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(41);
}).prototype = p = new cjs.Sprite();



(lib.MurrayLeftArm2_0001 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(42);
}).prototype = p = new cjs.Sprite();



(lib.MurrayLeftArm2_003 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(43);
}).prototype = p = new cjs.Sprite();



(lib.MurrayLeftBackHand_337 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(44);
}).prototype = p = new cjs.Sprite();



(lib.MurrayLeftEye = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(97);
}).prototype = p = new cjs.Sprite();



(lib.MurrayLeftMiddleFinger_0000 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(98);
}).prototype = p = new cjs.Sprite();



(lib.MurrayLeftMiddleFinger_234 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(99);
}).prototype = p = new cjs.Sprite();



(lib.MurrayLeftMiddleFinger_338 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(100);
}).prototype = p = new cjs.Sprite();



(lib.MurrayLeftMiddleFinger_340 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(101);
}).prototype = p = new cjs.Sprite();



(lib.MurrayLeftMiddleFinger_353 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(102);
}).prototype = p = new cjs.Sprite();



(lib.MurrayLeftPalm_0001 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(103);
}).prototype = p = new cjs.Sprite();



(lib.MurrayLeftPalm_079 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(45);
}).prototype = p = new cjs.Sprite();



(lib.MurrayLeftPalm_095 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(104);
}).prototype = p = new cjs.Sprite();



(lib.MurrayLeftPalm_108 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(105);
}).prototype = p = new cjs.Sprite();



(lib.MurrayLeftPalm_234 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(106);
}).prototype = p = new cjs.Sprite();



(lib.MurrayLeftPalm_241 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(46);
}).prototype = p = new cjs.Sprite();



(lib.MurrayLeftPalm_340 = function() {
	this.spriteSheet = ss["MWIntro_atlas_"];
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.MurrayLeftPinky_234 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(107);
}).prototype = p = new cjs.Sprite();



(lib.MurrayLeftPinky_338 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(108);
}).prototype = p = new cjs.Sprite();



(lib.MurrayLeftPointerFinger_0000 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(109);
}).prototype = p = new cjs.Sprite();



(lib.MurrayLeftPointerFinger_234 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(110);
}).prototype = p = new cjs.Sprite();



(lib.MurrayLeftPointerFinger_340 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(111);
}).prototype = p = new cjs.Sprite();



(lib.MurrayLeftThumb_110 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(112);
}).prototype = p = new cjs.Sprite();



(lib.MurrayLeftThumb_234 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(113);
}).prototype = p = new cjs.Sprite();



(lib.MurrayLeftThumb_337 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(114);
}).prototype = p = new cjs.Sprite();



(lib.MurrayleftThumb_338 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(47);
}).prototype = p = new cjs.Sprite();



(lib.MurrayLeftThumb_353 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(48);
}).prototype = p = new cjs.Sprite();



(lib.MurrayLeftThumb_76 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(115);
}).prototype = p = new cjs.Sprite();



(lib.MurrayMiddleFinger = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(116);
}).prototype = p = new cjs.Sprite();



(lib.MurrayMiddleFinger_079 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(117);
}).prototype = p = new cjs.Sprite();



(lib.MurrayMiddleFinger_108 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(118);
}).prototype = p = new cjs.Sprite();



(lib.MurrayMiddleFinger_111 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(119);
}).prototype = p = new cjs.Sprite();



(lib.MurrayMiddleFinger_237 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(120);
}).prototype = p = new cjs.Sprite();



(lib.MurrayMiddleFinger_338 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(121);
}).prototype = p = new cjs.Sprite();



(lib.MurrayMiddleFinger_353 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(122);
}).prototype = p = new cjs.Sprite();



(lib.MurrayMouth0001 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(123);
}).prototype = p = new cjs.Sprite();



(lib.MurrayMouth0001_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(124);
}).prototype = p = new cjs.Sprite();



(lib.MurrayMouth0002 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(125);
}).prototype = p = new cjs.Sprite();



(lib.MurrayMouth0002_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(126);
}).prototype = p = new cjs.Sprite();



(lib.MurrayMouth0003 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(127);
}).prototype = p = new cjs.Sprite();



(lib.MurrayMouth0003_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(128);
}).prototype = p = new cjs.Sprite();



(lib.MurrayMouth0004 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(129);
}).prototype = p = new cjs.Sprite();



(lib.MurrayMouth0004_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(130);
}).prototype = p = new cjs.Sprite();



(lib.MurrayMouth0005 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(131);
}).prototype = p = new cjs.Sprite();



(lib.MurrayMouth0005_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(132);
}).prototype = p = new cjs.Sprite();



(lib.MurrayMouth0006 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(133);
}).prototype = p = new cjs.Sprite();



(lib.MurrayMouth0006_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(134);
}).prototype = p = new cjs.Sprite();



(lib.MurrayMouth0007 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(135);
}).prototype = p = new cjs.Sprite();



(lib.MurrayMouth0007_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(136);
}).prototype = p = new cjs.Sprite();



(lib.MurrayMouth0008 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(137);
}).prototype = p = new cjs.Sprite();



(lib.MurrayMouth0008_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(138);
}).prototype = p = new cjs.Sprite();



(lib.MurrayMouth0009 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(139);
}).prototype = p = new cjs.Sprite();



(lib.MurrayMouth0009_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(140);
}).prototype = p = new cjs.Sprite();



(lib.MurrayMouth0010 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(141);
}).prototype = p = new cjs.Sprite();



(lib.MurrayMouth0010_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(142);
}).prototype = p = new cjs.Sprite();



(lib.MurrayMouth0011 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(143);
}).prototype = p = new cjs.Sprite();



(lib.MurrayMouth0011_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(144);
}).prototype = p = new cjs.Sprite();



(lib.MurrayMouth0012 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(145);
}).prototype = p = new cjs.Sprite();



(lib.MurrayMouth0012_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(146);
}).prototype = p = new cjs.Sprite();



(lib.MurrayMouth0013 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(147);
}).prototype = p = new cjs.Sprite();



(lib.MurrayMouth0013_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(148);
}).prototype = p = new cjs.Sprite();



(lib.MurrayMouth0014 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(149);
}).prototype = p = new cjs.Sprite();



(lib.MurrayMouth0014_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(150);
}).prototype = p = new cjs.Sprite();



(lib.MurrayMouth0015 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(151);
}).prototype = p = new cjs.Sprite();



(lib.MurrayMouth0015_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(152);
}).prototype = p = new cjs.Sprite();



(lib.MurrayMouth0016 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(153);
}).prototype = p = new cjs.Sprite();



(lib.MurrayMouth0016_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(154);
}).prototype = p = new cjs.Sprite();



(lib.MurrayMouth0017 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(155);
}).prototype = p = new cjs.Sprite();



(lib.MurrayMouth0017_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(156);
}).prototype = p = new cjs.Sprite();



(lib.MurrayMouth0018 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(157);
}).prototype = p = new cjs.Sprite();



(lib.MurrayMouth0018_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(158);
}).prototype = p = new cjs.Sprite();



(lib.MurrayMouth0019 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(159);
}).prototype = p = new cjs.Sprite();



(lib.MurrayMouth0019_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(160);
}).prototype = p = new cjs.Sprite();



(lib.MurrayMouth0020 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(161);
}).prototype = p = new cjs.Sprite();



(lib.MurrayMouth0020_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(162);
}).prototype = p = new cjs.Sprite();



(lib.MurrayNeck1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(163);
}).prototype = p = new cjs.Sprite();



(lib.MurrayNeck2 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(164);
}).prototype = p = new cjs.Sprite();



(lib.MurrayNeck2_3_4 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(165);
}).prototype = p = new cjs.Sprite();



(lib.MurrayNeck3 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(49);
}).prototype = p = new cjs.Sprite();



(lib.MurrayNeck3_002 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(166);
}).prototype = p = new cjs.Sprite();



(lib.MurrayNose = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(167);
}).prototype = p = new cjs.Sprite();



(lib.MurrayPalm = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(168);
}).prototype = p = new cjs.Sprite();



(lib.MurrayPalm_037 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(50);
}).prototype = p = new cjs.Sprite();



(lib.MurrayPalm_053 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(169);
}).prototype = p = new cjs.Sprite();



(lib.MurrayPalm_057 = function() {
	this.spriteSheet = ss["MWIntro_atlas_"];
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.MurrayPalm_077 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(51);
}).prototype = p = new cjs.Sprite();



(lib.MurrayPalm_079 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(170);
}).prototype = p = new cjs.Sprite();



(lib.MurrayPalm_108 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(171);
}).prototype = p = new cjs.Sprite();



(lib.MurrayPalm_111 = function() {
	this.spriteSheet = ss["MWIntro_atlas_"];
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib.MurrayPalm_340 = function() {
	this.spriteSheet = ss["MWIntro_atlas_"];
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib.MurrayPalm_41 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(52);
}).prototype = p = new cjs.Sprite();



(lib.MurrayPatch = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(172);
}).prototype = p = new cjs.Sprite();



(lib.MurrayPinky_037 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(173);
}).prototype = p = new cjs.Sprite();



(lib.MurrayPinky_079 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(174);
}).prototype = p = new cjs.Sprite();



(lib.MurrayPinky_108 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(175);
}).prototype = p = new cjs.Sprite();



(lib.MurrayPinky_237 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(176);
}).prototype = p = new cjs.Sprite();



(lib.MurrayPinky_338 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(177);
}).prototype = p = new cjs.Sprite();



(lib.MurrayPinky_353 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(178);
}).prototype = p = new cjs.Sprite();



(lib.MurrayPointerFinger = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(179);
}).prototype = p = new cjs.Sprite();



(lib.MurrayPointerFinger_039 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(180);
}).prototype = p = new cjs.Sprite();



(lib.MurrayPointerFinger_079 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(181);
}).prototype = p = new cjs.Sprite();



(lib.MurrayPointerFinger_108 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(182);
}).prototype = p = new cjs.Sprite();



(lib.MurrayPointerFinger_111 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(183);
}).prototype = p = new cjs.Sprite();



(lib.MurrayPointerFinger_237 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(184);
}).prototype = p = new cjs.Sprite();



(lib.MurrayPointerFinger_338 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(185);
}).prototype = p = new cjs.Sprite();



(lib.MurrayShirtButton1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(186);
}).prototype = p = new cjs.Sprite();



(lib.MurrayShirtCollarLeft = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(187);
}).prototype = p = new cjs.Sprite();



(lib.MurrayShirtCollarRight = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(53);
}).prototype = p = new cjs.Sprite();



(lib.MurrayShirtLeftArm_001 = function() {
	this.spriteSheet = ss["MWIntro_atlas_"];
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib.MurrayShirtRightArm = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(188);
}).prototype = p = new cjs.Sprite();



(lib.MurrayShirtRightArm_001 = function() {
	this.spriteSheet = ss["MWIntro_atlas_"];
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib.MurrayShirtShape_000 = function() {
	this.spriteSheet = ss["MWIntro_atlas_"];
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();



(lib.MurrayShirtShape_001 = function() {
	this.spriteSheet = ss["MWIntro_atlas_"];
	this.gotoAndStop(14);
}).prototype = p = new cjs.Sprite();



(lib.MurrayShirtShape_001_B = function() {
	this.spriteSheet = ss["MWIntro_atlas_"];
	this.gotoAndStop(15);
}).prototype = p = new cjs.Sprite();



(lib.MurrayShirtShape_002_B = function() {
	this.spriteSheet = ss["MWIntro_atlas_"];
	this.gotoAndStop(16);
}).prototype = p = new cjs.Sprite();



(lib.MurrayShirtShape_003 = function() {
	this.spriteSheet = ss["MWIntro_atlas_"];
	this.gotoAndStop(17);
}).prototype = p = new cjs.Sprite();



(lib.MurrayShirtShape_004 = function() {
	this.spriteSheet = ss["MWIntro_atlas_"];
	this.gotoAndStop(18);
}).prototype = p = new cjs.Sprite();



(lib.MurrayShirtShape_005 = function() {
	this.spriteSheet = ss["MWIntro_atlas_"];
	this.gotoAndStop(19);
}).prototype = p = new cjs.Sprite();



(lib.MurrayShorts_001 = function() {
	this.spriteSheet = ss["MWIntro_atlas_"];
	this.gotoAndStop(20);
}).prototype = p = new cjs.Sprite();



(lib.MurrayShorts_001_1 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(54);
}).prototype = p = new cjs.Sprite();



(lib.MurrayShorts_017 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(55);
}).prototype = p = new cjs.Sprite();



(lib.MurrayThumb_037 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(56);
}).prototype = p = new cjs.Sprite();



(lib.MurrayThumb_039 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(189);
}).prototype = p = new cjs.Sprite();



(lib.MurrayThumb_108 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(190);
}).prototype = p = new cjs.Sprite();



(lib.MurrayThumb_234 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(191);
}).prototype = p = new cjs.Sprite();



(lib.MurrayThumb_241 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(57);
}).prototype = p = new cjs.Sprite();



(lib.MurrayThumb_338 = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(192);
}).prototype = p = new cjs.Sprite();



(lib.MurrayThumb_353 = function() {
	this.spriteSheet = ss["MWIntro_atlas_2"];
	this.gotoAndStop(58);
}).prototype = p = new cjs.Sprite();



(lib.MurrayTongue = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(193);
}).prototype = p = new cjs.Sprite();



(lib.Murray_bottom = function() {
	this.spriteSheet = ss["MWIntro_atlas_"];
	this.gotoAndStop(21);
}).prototype = p = new cjs.Sprite();



(lib.neckPatc = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(194);
}).prototype = p = new cjs.Sprite();



(lib.ShirtLeftArm = function() {
	this.spriteSheet = ss["MWIntro_atlas_3"];
	this.gotoAndStop(195);
}).prototype = p = new cjs.Sprite();



(lib.ShirtLeftArm_008 = function() {
	this.spriteSheet = ss["MWIntro_atlas_"];
	this.gotoAndStop(22);
}).prototype = p = new cjs.Sprite();



(lib.ShirtRightArm_008 = function() {
	this.spriteSheet = ss["MWIntro_atlas_"];
	this.gotoAndStop(23);
}).prototype = p = new cjs.Sprite();
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.ShirtRightArm_008_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Shirt Right Arm 008
	this.instance = new lib.ShirtRightArm_008();
	this.instance.parent = this;
	this.instance.setTransform(2,-10,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ShirtRightArm_008_1, new cjs.Rectangle(-11.5,-10,89.5,74), null);


(lib.ShirtLeftArm_008_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Shirt Left Arm 008
	this.instance = new lib.ShirtLeftArm_008();
	this.instance.parent = this;
	this.instance.setTransform(-7,-9,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ShirtLeftArm_008_1, new cjs.Rectangle(-7,-9,84,83), null);


(lib.ShirtLeftArm_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.instance = new lib.ShirtLeftArm();
	this.instance.parent = this;
	this.instance.setTransform(-4.1,-8.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ShirtLeftArm_1, new cjs.Rectangle(-4.1,-8.9,80,64), null);


(lib.neckPatc_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// neckPatc
	this.instance = new lib.neckPatc();
	this.instance.parent = this;
	this.instance.setTransform(0,0,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.neckPatc_1, new cjs.Rectangle(0,0,25.8,31), null);


(lib.MurrayTongue_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Tongue PNG
	this.instance = new lib.MurrayTongue();
	this.instance.parent = this;
	this.instance.setTransform(-2,-2,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayTongue_1, new cjs.Rectangle(-2,-2,25,22), null);


(lib.MurrayThumb_353_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Thumb 353
	this.instance = new lib.MurrayThumb_353();
	this.instance.parent = this;
	this.instance.setTransform(-1,-3,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayThumb_353_1, new cjs.Rectangle(-1,-3,50,82), null);


(lib.MurrayThumb_338_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Thumb 338
	this.instance = new lib.MurrayThumb_338();
	this.instance.parent = this;
	this.instance.setTransform(-2,-3,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayThumb_338_1, new cjs.Rectangle(-2,-3,58,30), null);


(lib.MurrayThumb_241_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Thumb_241
	this.instance = new lib.MurrayThumb_241();
	this.instance.parent = this;
	this.instance.setTransform(-5,-9,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayThumb_241_1, new cjs.Rectangle(-5,-9,59,56), null);


(lib.MurrayThumb_234_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Thumb_234
	this.instance = new lib.MurrayThumb_234();
	this.instance.parent = this;
	this.instance.setTransform(-5,-5,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayThumb_234_1, new cjs.Rectangle(-5,-5,42,47), null);


(lib.MurrayThumb_108_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Thumb_108
	this.instance = new lib.MurrayThumb_108();
	this.instance.parent = this;
	this.instance.setTransform(-3,-2,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayThumb_108_1, new cjs.Rectangle(-3,-2,54,40), null);


(lib.MurrayThumb_039_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Thumb_039
	this.instance = new lib.MurrayThumb_039();
	this.instance.parent = this;
	this.instance.setTransform(-3,-6,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayThumb_039_1, new cjs.Rectangle(-3,-6,49,50), null);


(lib.MurrayThumb_037_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Thumb_037
	this.instance = new lib.MurrayThumb_037();
	this.instance.parent = this;
	this.instance.setTransform(-11,-7,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayThumb_037_1, new cjs.Rectangle(-11,-7,58,59), null);


(lib.MurrayShorts_017_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Shorts_017.png
	this.instance = new lib.MurrayShorts_017();
	this.instance.parent = this;
	this.instance.setTransform(-20.9,-3.5,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayShorts_017_1, new cjs.Rectangle(-29.3,-3.5,215,96), null);


(lib.MurrayShorts_007 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Pockets
	this.instance = new lib.MurrayShorts_001_1();
	this.instance.parent = this;
	this.instance.setTransform(-20,-3.5,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayShorts_007, new cjs.Rectangle(-28.1,-3.5,216.8,96), null);


(lib.MurrayShorts_005 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Pockets
	this.instance = new lib.MurrayShorts_001_1();
	this.instance.parent = this;
	this.instance.setTransform(-20,-3.5,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayShorts_005, new cjs.Rectangle(-28.2,-3.5,217.9,96), null);


(lib.MurrayShorts_004 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Pockets
	this.instance = new lib.MurrayShorts_001_1();
	this.instance.parent = this;
	this.instance.setTransform(-20,-3.5,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayShorts_004, new cjs.Rectangle(-28.3,-3.5,217.5,96), null);


(lib.MurrayShirtStitches = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

}).prototype = getMCSymbolPrototype(lib.MurrayShirtStitches, null, null);


(lib.MurrayShirtShape_005_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Shirt Shape_005
	this.instance = new lib.MurrayShirtShape_005();
	this.instance.parent = this;
	this.instance.setTransform(-5,-4,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayShirtShape_005_1, new cjs.Rectangle(-9,-8,174,132), null);


(lib.MurrayShirtShape_004_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.MurrayShirtShape_004();
	this.instance.parent = this;
	this.instance.setTransform(-5,-4,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayShirtShape_004_1, new cjs.Rectangle(-9,-8.2,176,132), null);


(lib.MurrayShirtShape_003_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Shirt Shape_003
	this.instance = new lib.MurrayShirtShape_003();
	this.instance.parent = this;
	this.instance.setTransform(-7,-10,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayShirtShape_003_1, new cjs.Rectangle(-10.2,-13.9,178,137), null);


(lib.MurrayShirtShape_002_B_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.MurrayShirtShape_002_B();
	this.instance.parent = this;
	this.instance.setTransform(-6.3,-9.2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayShirtShape_002_B_1, new cjs.Rectangle(-10.2,-13.1,174,137), null);


(lib.MurrayShirtShape_001_B_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.MurrayShirtShape_001_B();
	this.instance.parent = this;
	this.instance.setTransform(-4.9,-6.6,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayShirtShape_001_B_1, new cjs.Rectangle(-9,-10.2,175,134), null);


(lib.MurrayShirtShape_001_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Shirt Shape_001
	this.instance = new lib.MurrayShirtShape_001();
	this.instance.parent = this;
	this.instance.setTransform(-5,-6,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayShirtShape_001_1, new cjs.Rectangle(-9,-10.2,175,134), null);


(lib.MurrayShirtShape_000_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Shirt Shape_000
	this.instance = new lib.MurrayShirtShape_000();
	this.instance.parent = this;
	this.instance.setTransform(-5,-4,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayShirtShape_000_1, new cjs.Rectangle(-9,-8,174,132), null);


(lib.MurrayShirtRightArm_001_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Shirt Right Arm 001
	this.instance = new lib.MurrayShirtRightArm_001();
	this.instance.parent = this;
	this.instance.setTransform(2,-10,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayShirtRightArm_001_1, new cjs.Rectangle(-11.5,-10,89.5,72), null);


(lib.MurrayShirtRightArm_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.instance = new lib.MurrayShirtRightArm();
	this.instance.parent = this;
	this.instance.setTransform(-14.2,-10.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayShirtRightArm_1, new cjs.Rectangle(-14.2,-10.9,77,70), null);


(lib.MurrayShirtLeftArm_001_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Shirt Left Arm 001
	this.instance = new lib.MurrayShirtLeftArm_001();
	this.instance.parent = this;
	this.instance.setTransform(-1,-9,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayShirtLeftArm_001_1, new cjs.Rectangle(-1,-9,77,72), null);


(lib.MurrayShirtCollarRight_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Shirt Collar Right
	this.instance = new lib.MurrayShirtCollarRight();
	this.instance.parent = this;
	this.instance.setTransform(-6,-3,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayShirtCollarRight_1, new cjs.Rectangle(-6,-3,62,49), null);


(lib.MurrayShirtCollarLeft_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Shirt Collar Left
	this.instance = new lib.MurrayShirtCollarLeft();
	this.instance.parent = this;
	this.instance.setTransform(25,-3,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayShirtCollarLeft_1, new cjs.Rectangle(25,-3,41,35), null);


(lib.MurrayShirtButton1_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Shirt Button 1
	this.instance = new lib.MurrayShirtButton1();
	this.instance.parent = this;
	this.instance.setTransform(-3,-2,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayShirtButton1_1, new cjs.Rectangle(-3,-2,12,12), null);


(lib.MurrayPointerFinger_338_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Pointer Finger 338
	this.instance = new lib.MurrayPointerFinger_338();
	this.instance.parent = this;
	this.instance.setTransform(-2,-2,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayPointerFinger_338_1, new cjs.Rectangle(-2,-2,58,27), null);


(lib.MurrayPointerFinger_237_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Pointer Finger_237
	this.instance = new lib.MurrayPointerFinger_237();
	this.instance.parent = this;
	this.instance.setTransform(-5,-5,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayPointerFinger_237_1, new cjs.Rectangle(-5,-5,37,54), null);


(lib.MurrayPointerFinger_111_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Pointer Finger_111
	this.instance = new lib.MurrayPointerFinger_111();
	this.instance.parent = this;
	this.instance.setTransform(-2,-2,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayPointerFinger_111_1, new cjs.Rectangle(-2,-2,46,24), null);


(lib.MurrayPointerFinger_108_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Pointer Finger_108
	this.instance = new lib.MurrayPointerFinger_108();
	this.instance.parent = this;
	this.instance.setTransform(-5,-5,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayPointerFinger_108_1, new cjs.Rectangle(-5,-5,50,46), null);


(lib.MurrayPointerFinger_079_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Pointer Finger_079
	this.instance = new lib.MurrayPointerFinger_079();
	this.instance.parent = this;
	this.instance.setTransform(-2,-2,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayPointerFinger_079_1, new cjs.Rectangle(-2,-2,46,30), null);


(lib.MurrayPointerFinger_039_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Pointer Finger_039
	this.instance = new lib.MurrayPointerFinger_039();
	this.instance.parent = this;
	this.instance.setTransform(-3,-5,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayPointerFinger_039_1, new cjs.Rectangle(-3,-5,57,48), null);


(lib.MurrayPointerFinger_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Pointer Finger
	this.instance = new lib.MurrayPointerFinger();
	this.instance.parent = this;
	this.instance.setTransform(-5,-5,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayPointerFinger_1, new cjs.Rectangle(-5,-5,40,27), null);


(lib.MurrayPocketFlap = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#F1E8E2").s().p("AAABEQgygEgKgCQgmgFAAgCQAEhBAGgoQAAgJAEgFQAHgHAOABQA1AEAxAIQAoAGAMAMQAIAIAAAVQAAAOgFAcQgJAogMAAQgaAAgvgDg");
	this.shape.setTransform(9.9,7.1);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayPocketFlap, new cjs.Rectangle(0,0,19.8,14.3), null);


(lib.MurrayPinky_353_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Pinky 353
	this.instance = new lib.MurrayPinky_353();
	this.instance.parent = this;
	this.instance.setTransform(0,0,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayPinky_353_1, new cjs.Rectangle(0,0,19,25.6), null);


(lib.MurrayPinky_338_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Pinky 338
	this.instance = new lib.MurrayPinky_338();
	this.instance.parent = this;
	this.instance.setTransform(-4,-5,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayPinky_338_1, new cjs.Rectangle(-4,-5,57,50), null);


(lib.MurrayPinky_237_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Pinky_237
	this.instance = new lib.MurrayPinky_237();
	this.instance.parent = this;
	this.instance.setTransform(-2,-2,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayPinky_237_1, new cjs.Rectangle(-2,-2,28,30), null);


(lib.MurrayPinky_108_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Pinky_108
	this.instance = new lib.MurrayPinky_108();
	this.instance.parent = this;
	this.instance.setTransform(-2,-2,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayPinky_108_1, new cjs.Rectangle(-2,-2,40,35), null);


(lib.MurrayPinky_079_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Pinky_079
	this.instance = new lib.MurrayPinky_079();
	this.instance.parent = this;
	this.instance.setTransform(-5,-5,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// VectorArt
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#EC4420").s().p("ABiCSQiGgZglgrQgTgVgXgeQgbghAAgEQAAgPAJgoQAIgmAEgJQATgoBDAIQA/AHAPAeQANAhAWBEQAXA6AoAnQgDAEgCABQgbAAgIgDQAFALANALQAPANAJAOIgFAEg");
	this.shape.setTransform(14.3,14.6);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayPinky_079_1, new cjs.Rectangle(-5,-5,43,43), null);


(lib.MurrayPinky_037_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.MurrayPinky_037();
	this.instance.parent = this;
	this.instance.setTransform(-2,-2,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayPinky_037_1, new cjs.Rectangle(-2,-2,24,38), null);


(lib.MurrayPatch_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Patch
	this.instance = new lib.MurrayPatch();
	this.instance.parent = this;
	this.instance.setTransform(-5,-4,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayPatch_1, new cjs.Rectangle(-5,-4,36,23), null);


(lib.MurrayPalm_340_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.MurrayPalm_340();
	this.instance.parent = this;
	this.instance.setTransform(-1,-3,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayPalm_340_1, new cjs.Rectangle(-1,-3,75,76), null);


(lib.MurrayPalm_111_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Palm_111
	this.instance = new lib.MurrayPalm_111();
	this.instance.parent = this;
	this.instance.setTransform(-5,-5,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayPalm_111_1, new cjs.Rectangle(-5,-5,80,68), null);


(lib.MurrayPalm_108_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Palm_108
	this.instance = new lib.MurrayPalm_108();
	this.instance.parent = this;
	this.instance.setTransform(0,0,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayPalm_108_1, new cjs.Rectangle(0,0,40.1,28.8), null);


(lib.MurrayPalm_079_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Palm_079
	this.instance = new lib.MurrayPalm_079();
	this.instance.parent = this;
	this.instance.setTransform(0,0,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayPalm_079_1, new cjs.Rectangle(0,0,55.1,36), null);


(lib.MurrayPalm_077_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Palm_077
	this.instance = new lib.MurrayPalm_077();
	this.instance.parent = this;
	this.instance.setTransform(0,0,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayPalm_077_1, new cjs.Rectangle(0,0,58.8,50.8), null);


(lib.MurrayPalm_057_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Palm_057
	this.instance = new lib.MurrayPalm_057();
	this.instance.parent = this;
	this.instance.setTransform(-5,-5,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayPalm_057_1, new cjs.Rectangle(-5,-5,90,64), null);


(lib.MurrayPalm_053_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.MurrayPalm_053();
	this.instance.parent = this;
	this.instance.setTransform(0,3,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayPalm_053_1, new cjs.Rectangle(0,3,49.1,25.2), null);


(lib.MurrayPalm_41_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Palm_41
	this.instance = new lib.MurrayPalm_41();
	this.instance.parent = this;
	this.instance.setTransform(0,0,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayPalm_41_1, new cjs.Rectangle(0,0,63.5,50.3), null);


(lib.MurrayPalm_037_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.MurrayPalm_037();
	this.instance.parent = this;
	this.instance.setTransform(-5,-4,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayPalm_037_1, new cjs.Rectangle(-5,-4,61,60), null);


(lib.MurrayPalm_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Palm
	this.instance = new lib.MurrayPalm();
	this.instance.parent = this;
	this.instance.setTransform(-5,-5,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayPalm_1, new cjs.Rectangle(-5,-5,53,51), null);


(lib.MurrayNose_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.MurrayNose();
	this.instance.parent = this;
	this.instance.setTransform(-4,-3,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayNose_1, new cjs.Rectangle(-4,-3,22,19), null);


(lib.MurrayNeck3_002_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.MurrayNeck3_002();
	this.instance.parent = this;
	this.instance.setTransform(-3.8,-2.2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayNeck3_002_1, new cjs.Rectangle(-3.8,-2.2,94,51), null);


(lib.MurrayNeck3_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Neck 3
	this.instance = new lib.MurrayNeck3();
	this.instance.parent = this;
	this.instance.setTransform(-4,-2,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayNeck3_1, new cjs.Rectangle(-4,-2,94,50), null);


(lib.MurrayNeck2_3_4_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.MurrayNeck2_3_4();
	this.instance.parent = this;
	this.instance.setTransform(-2,-1.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayNeck2_3_4_1, new cjs.Rectangle(-2,-1.9,64,37), null);


(lib.MurrayNeck2_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// MurrayNeck2
	this.instance = new lib.MurrayNeck2();
	this.instance.parent = this;
	this.instance.setTransform(-2,-2,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayNeck2_1, new cjs.Rectangle(-2,-2,65,37), null);


(lib.MurrayNeck1_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Neck 1 PNG
	this.instance = new lib.MurrayNeck1();
	this.instance.parent = this;
	this.instance.setTransform(-2,-2,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayNeck1_1, new cjs.Rectangle(-2,-2,55,51), null);


(lib.MurrayMiddleFinger_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Middle Finger 
	this.instance = new lib.MurrayMiddleFinger();
	this.instance.parent = this;
	this.instance.setTransform(-5,-5,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayMiddleFinger_1, new cjs.Rectangle(-5,-5,33,28), null);


(lib.MurrayMiddleFinger_353_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Middle Finger 353
	this.instance = new lib.MurrayMiddleFinger_353();
	this.instance.parent = this;
	this.instance.setTransform(-5,-5,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayMiddleFinger_353_1, new cjs.Rectangle(-5,-5,36,48), null);


(lib.MurrayMiddleFinger_338_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Middle Finger 338
	this.instance = new lib.MurrayMiddleFinger_338();
	this.instance.parent = this;
	this.instance.setTransform(-5,-5,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayMiddleFinger_338_1, new cjs.Rectangle(-5,-5,59,37), null);


(lib.MurrayMiddleFinger_237_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Middle Finger_237
	this.instance = new lib.MurrayMiddleFinger_237();
	this.instance.parent = this;
	this.instance.setTransform(-7,-7,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayMiddleFinger_237_1, new cjs.Rectangle(-7,-7,46,45), null);


(lib.MurrayMiddleFinger_111_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Middle Finger_111
	this.instance = new lib.MurrayMiddleFinger_111();
	this.instance.parent = this;
	this.instance.setTransform(-5,-5,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayMiddleFinger_111_1, new cjs.Rectangle(-5,-5,39,28), null);


(lib.MurrayMiddleFinger_108_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Middle Finger_108
	this.instance = new lib.MurrayMiddleFinger_108();
	this.instance.parent = this;
	this.instance.setTransform(-5,-5,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayMiddleFinger_108_1, new cjs.Rectangle(-5,-5,45,43), null);


(lib.MurrayMiddleFinger_079_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Middle Finger_079
	this.instance = new lib.MurrayMiddleFinger_079();
	this.instance.parent = this;
	this.instance.setTransform(-5,-5,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayMiddleFinger_079_1, new cjs.Rectangle(-5,-5,55,38), null);


(lib.MurrayLeftThumb_353_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Left Thumb 353
	this.instance = new lib.MurrayLeftThumb_353();
	this.instance.parent = this;
	this.instance.setTransform(-4,-1,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayLeftThumb_353_1, new cjs.Rectangle(-4,-1,49,72), null);


(lib.MurrayleftThumb_338_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Left Thumb 338
	this.instance = new lib.MurrayleftThumb_338();
	this.instance.parent = this;
	this.instance.setTransform(-5,-2,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayleftThumb_338_1, new cjs.Rectangle(-5,-2,63,66), null);


(lib.MurrayLeftThumb_337_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.MurrayLeftThumb_337();
	this.instance.parent = this;
	this.instance.setTransform(-3,-2.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayLeftThumb_337_1, new cjs.Rectangle(-3,-2.9,46,30), null);


(lib.MurrayLeftThumb_234_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Left Thumb_234
	this.instance = new lib.MurrayLeftThumb_234();
	this.instance.parent = this;
	this.instance.setTransform(-5,-5,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayLeftThumb_234_1, new cjs.Rectangle(-5,-5,43,44), null);


(lib.MurrayLeftThumb_110_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Left Thumb_110
	this.instance = new lib.MurrayLeftThumb_110();
	this.instance.parent = this;
	this.instance.setTransform(-5,-5,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayLeftThumb_110_1, new cjs.Rectangle(-5,-5,42,39), null);


(lib.MurrayLeftThumb_76_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Left Thumb_76
	this.instance = new lib.MurrayLeftThumb_76();
	this.instance.parent = this;
	this.instance.setTransform(-1,-3,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayLeftThumb_76_1, new cjs.Rectangle(-1,-3,44,49), null);


(lib.MurrayLeftPointerFinger_340_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Left Pointer Finger 340
	this.instance = new lib.MurrayLeftPointerFinger_340();
	this.instance.parent = this;
	this.instance.setTransform(-5,-5,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayLeftPointerFinger_340_1, new cjs.Rectangle(-5,-5,49,31), null);


(lib.MurrayLeftPointerFinger_234_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Left Pointer Finger_234
	this.instance = new lib.MurrayLeftPointerFinger_234();
	this.instance.parent = this;
	this.instance.setTransform(-5,-5,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayLeftPointerFinger_234_1, new cjs.Rectangle(-5,-5,53,43), null);


(lib.MurrayLeftPointerFinger_0000_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Left Pointer Finger_0000
	this.instance = new lib.MurrayLeftPointerFinger_0000();
	this.instance.parent = this;
	this.instance.setTransform(-2,-2,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayLeftPointerFinger_0000_1, new cjs.Rectangle(-2,-2,36,23), null);


(lib.MurrayLeftPinky_338_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Left Pinky 338
	this.instance = new lib.MurrayLeftPinky_338();
	this.instance.parent = this;
	this.instance.setTransform(-5,-2,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayLeftPinky_338_1, new cjs.Rectangle(-5,-2,41,53), null);


(lib.MurrayLeftPinky_234_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Left Pinky_234
	this.instance = new lib.MurrayLeftPinky_234();
	this.instance.parent = this;
	this.instance.setTransform(-2,-2,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayLeftPinky_234_1, new cjs.Rectangle(-2,-2,29,27), null);


(lib.MurrayLeftPalm_340_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Left Palm 340
	this.instance = new lib.MurrayLeftPalm_340();
	this.instance.parent = this;
	this.instance.setTransform(-1,-3,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayLeftPalm_340_1, new cjs.Rectangle(-1,-3,85,67), null);


(lib.MurrayLeftPalm_241_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Left Palm_241
	this.instance = new lib.MurrayLeftPalm_241();
	this.instance.parent = this;
	this.instance.setTransform(-3,-16,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayLeftPalm_241_1, new cjs.Rectangle(-3,-16,64,55), null);


(lib.MurrayLeftPalm_234_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray LEft Palm_234
	this.instance = new lib.MurrayLeftPalm_234();
	this.instance.parent = this;
	this.instance.setTransform(-2,-2,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayLeftPalm_234_1, new cjs.Rectangle(-2,-2,44,27), null);


(lib.MurrayLeftPalm_108_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// murray Left Palm_108
	this.instance = new lib.MurrayLeftPalm_108();
	this.instance.parent = this;
	this.instance.setTransform(0,0,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayLeftPalm_108_1, new cjs.Rectangle(0,0,49.1,32.6), null);


(lib.MurrayLeftPalm_095_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.MurrayLeftPalm_095();
	this.instance.parent = this;
	this.instance.setTransform(0.2,0,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayLeftPalm_095_1, new cjs.Rectangle(0,0,51.7,34), null);


(lib.MurrayLeftPalm_079_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Left Palm_079
	this.instance = new lib.MurrayLeftPalm_079();
	this.instance.parent = this;
	this.instance.setTransform(-2,-4,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayLeftPalm_079_1, new cjs.Rectangle(-2,-4,76,44), null);


(lib.MurrayLeftPalm_0001_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Left Palm_0001
	this.instance = new lib.MurrayLeftPalm_0001();
	this.instance.parent = this;
	this.instance.setTransform(-5,-5,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayLeftPalm_0001_1, new cjs.Rectangle(-5,-5,52,51), null);


(lib.MurrayLeftMiddleFinger_353_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Left Middle Finger353
	this.instance = new lib.MurrayLeftMiddleFinger_353();
	this.instance.parent = this;
	this.instance.setTransform(-5,-5,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayLeftMiddleFinger_353_1, new cjs.Rectangle(-5,-5,43,57), null);


(lib.MurrayLeftMiddleFinger_340_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Left Middle Finger 340
	this.instance = new lib.MurrayLeftMiddleFinger_340();
	this.instance.parent = this;
	this.instance.setTransform(-5,-5,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayLeftMiddleFinger_340_1, new cjs.Rectangle(-5,-5,42,29), null);


(lib.MurrayLeftMiddleFinger_338_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Left Middle Finger 338
	this.instance = new lib.MurrayLeftMiddleFinger_338();
	this.instance.parent = this;
	this.instance.setTransform(-5,-5,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayLeftMiddleFinger_338_1, new cjs.Rectangle(-5,-5,44,42), null);


(lib.MurrayLeftMiddleFinger_234_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Left Middle Finger_234
	this.instance = new lib.MurrayLeftMiddleFinger_234();
	this.instance.parent = this;
	this.instance.setTransform(-5,-5,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayLeftMiddleFinger_234_1, new cjs.Rectangle(-5,-5,38,48), null);


(lib.MurrayLeftMiddleFinger_0000_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Left Middle Finger_0000
	this.instance = new lib.MurrayLeftMiddleFinger_0000();
	this.instance.parent = this;
	this.instance.setTransform(-5,-5,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayLeftMiddleFinger_0000_1, new cjs.Rectangle(-5,-5,32,28), null);


(lib.MurrayLeftBackHand_337_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.MurrayLeftBackHand_337();
	this.instance.parent = this;
	this.instance.setTransform(-5,-2,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayLeftBackHand_337_1, new cjs.Rectangle(-5,-2,64,68), null);


(lib.MurrayLeftArm2_003_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Left Arm 2_003
	this.instance = new lib.MurrayLeftArm2_003();
	this.instance.parent = this;
	this.instance.setTransform(-2,-3,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayLeftArm2_003_1, new cjs.Rectangle(-2,-3,57,63), null);


(lib.MurrayLeftArm2_0001_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Left Art 2
	this.instance = new lib.MurrayLeftArm2_0001();
	this.instance.parent = this;
	this.instance.setTransform(-2,-3,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayLeftArm2_0001_1, new cjs.Rectangle(-2,-3,57,62), null);


(lib.MurrayLeftArm1_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Left Arm 1
	this.instance = new lib.MurrayLeftArm1();
	this.instance.parent = this;
	this.instance.setTransform(-2,-3,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayLeftArm1_1, new cjs.Rectangle(-2,-3,76,59), null);


(lib.MurrayJawunderlip_dryer = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Jaw under lip_dryer0001.png
	this.instance = new lib.MurrayJawunderlip_dryer0001();
	this.instance.parent = this;
	this.instance.setTransform(-2.8,-3.9,0.5,0.5);

	this.instance_1 = new lib.MurrayJawunderlip_dryer0002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-2.8,-3.9,0.5,0.5);

	this.instance_2 = new lib.MurrayJawunderlip_dryer0003();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-2.8,-3.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-2.8,-3.9,66,43);


(lib.MurrayJawunderlip_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// UnderLip_PNG
	this.instance = new lib.MurrayJawunderlip();
	this.instance.parent = this;
	this.instance.setTransform(-7,-8,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayJawunderlip_1, new cjs.Rectangle(-7,-8,64,51), null);


(lib.MurrayjawtopDryer = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(20));

	// Murray jaw top0001.png
	this.instance = new lib.Murrayjawtop0001_1();
	this.instance.parent = this;
	this.instance.setTransform(-1.9,-2.1,0.5,0.5);

	this.instance_1 = new lib.Murrayjawtop0002_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-1.9,-2.1,0.5,0.5);

	this.instance_2 = new lib.Murrayjawtop0003_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-1.9,-2.1,0.5,0.5);

	this.instance_3 = new lib.Murrayjawtop0004_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-1.9,-2.1,0.5,0.5);

	this.instance_4 = new lib.Murrayjawtop0005_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-1.9,-2.1,0.5,0.5);

	this.instance_5 = new lib.Murrayjawtop0006_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(-1.9,-2.1,0.5,0.5);

	this.instance_6 = new lib.Murrayjawtop0007_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(-1.9,-2.1,0.5,0.5);

	this.instance_7 = new lib.Murrayjawtop0008_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(-1.9,-2.1,0.5,0.5);

	this.instance_8 = new lib.Murrayjawtop0009_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(-1.9,-2.1,0.5,0.5);

	this.instance_9 = new lib.Murrayjawtop0010_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(-1.9,-2.1,0.5,0.5);

	this.instance_10 = new lib.Murrayjawtop0011_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(-1.9,-2.1,0.5,0.5);

	this.instance_11 = new lib.Murrayjawtop0012_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(-1.9,-2.1,0.5,0.5);

	this.instance_12 = new lib.Murrayjawtop0013_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(-1.9,-2.1,0.5,0.5);

	this.instance_13 = new lib.Murrayjawtop0014_1();
	this.instance_13.parent = this;
	this.instance_13.setTransform(-1.9,-2.1,0.5,0.5);

	this.instance_14 = new lib.Murrayjawtop0015_1();
	this.instance_14.parent = this;
	this.instance_14.setTransform(-1.9,-2.1,0.5,0.5);

	this.instance_15 = new lib.Murrayjawtop0016_1();
	this.instance_15.parent = this;
	this.instance_15.setTransform(-1.9,-2.1,0.5,0.5);

	this.instance_16 = new lib.Murrayjawtop0017_1();
	this.instance_16.parent = this;
	this.instance_16.setTransform(-1.9,-2.1,0.5,0.5);

	this.instance_17 = new lib.Murrayjawtop0018_1();
	this.instance_17.parent = this;
	this.instance_17.setTransform(-1.9,-2.1,0.5,0.5);

	this.instance_18 = new lib.Murrayjawtop0019_1();
	this.instance_18.parent = this;
	this.instance_18.setTransform(-1.9,-2.1,0.5,0.5);

	this.instance_19 = new lib.Murrayjawtop0020_1();
	this.instance_19.parent = this;
	this.instance_19.setTransform(-1.9,-2.1,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_7}]},1).to({state:[{t:this.instance_8}]},1).to({state:[{t:this.instance_9}]},1).to({state:[{t:this.instance_10}]},1).to({state:[{t:this.instance_11}]},1).to({state:[{t:this.instance_12}]},1).to({state:[{t:this.instance_13}]},1).to({state:[{t:this.instance_14}]},1).to({state:[{t:this.instance_15}]},1).to({state:[{t:this.instance_16}]},1).to({state:[{t:this.instance_17}]},1).to({state:[{t:this.instance_18}]},1).to({state:[{t:this.instance_19}]},1).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-1.9,-2.1,82,39);


(lib.Murrayjawtop = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(20));

	// Murray jaw top0001.png
	this.instance = new lib.Murrayjawtop0001_1();
	this.instance.parent = this;
	this.instance.setTransform(-1.9,-2.1,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(20));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-1.9,-2.1,82,39);


(lib.MurrayJawbottomDryer = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(20));

	// Layer 2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#EC4420").s().p("AB1DHIABgLIgHAMQgDgBAAgEIAAgHIAAAAQgHAOgNABIAKggIAFgNQgVACgPAKQgOALgNAVQgCgUANgZQgOALgIABQgIgBgIABQgOACgNAMIgGAGQAAgJAHgJIAQgSIgEgBQgTAAgOARQgKASgBAAQgCAAACgOQABgOACgKIgHAQQgFAOgHADIgCAAIgBgBIACgMQAAgJgDgFIgNgQQAHAigNAWQAAglgHgMQgHgNgJgLQgKgMAAgHIgCAIQgCAFgEAEQgOAOgQAGIgOADQAHgQgFACQgJAGgPAEQgNADgCAAQACgEAPgSQAMgPAAgHIABgVIgEANQgDAJgBAAIgBgIQgBgIgFgFQgKgIABgZIgIALQgEAGgMAeIgLggQgFgSAAgUIABgFIgQASQgVAYgEARQAAAAAAAAQAAAAAAABQAAAAgBAAQAAAAgBAAQgCAAgCgHIgBgGQAAgNAGgOIAMgbQAFgKACgSIACgUQgHAKgdATIgPAAIgCgBIABgBIgBAAIABgBIAFgGQATgXACgLIAAgtQABgFAFgGIACgDIgVAEIgZgCIgBAAIgCgBIACgDIAAAAIAHgGIAAgDIgPAGIgKAEIgCgBQABgIAUgIQAcgLADgCQAdgUAPgHIgOgBIgCgBQADgGAPgEIAVgEQAJgCAPgJQATgJAmgDQBAgGCFAoQCAAlBCAnQAcAQAUAeQAUAdAAAYIgCAMQgCgCgFgLQgFgKgGgDIgBAEQAAADAHAKQADAKgPgCQAKAKAEAOIADAZIACAaQAGAQAgAHQAAAAABAAQAAABAAAAQAAAAAAAAQAAAAgBABQgJAGgOAAQgKAAgEgCIAEAHIgCABIgGABQgNAAgSgTIgDAQQgDAJAAAGIAAAHIAAAGQAGAUgDAAQgCAAgDgHQgEgGgCgJQgBgDAAAIQADASgCAAQgIAAgHgMQgFgKAAgIIAAgOQgFAOgWAQQgWAQgHAUIgCABQgEgIABgLIAAgBQgDADgIADIgIACQAAgKAGgJQAKgPACgGIgLgBQgMAAgJAMQgGAHgCAJIgGAZQgEAMgJAEIAAAAQgBAAAAgLg");
	this.shape.setTransform(34.6,21);
	this.shape._off = true;

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(19).to({_off:false},0).wait(1));

	// Murray Jaw bottom_dryer0001.png
	this.instance = new lib.MurrayJawbottom_dryer0001();
	this.instance.parent = this;
	this.instance.setTransform(-4.4,-0.2,0.5,0.5);

	this.instance_1 = new lib.MurrayJawbottom_dryer0002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-4.4,-0.2,0.5,0.5);

	this.instance_2 = new lib.MurrayJawbottom_dryer0003();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-4.4,-0.2,0.5,0.5);

	this.instance_3 = new lib.MurrayJawbottom_dryer0004();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-4.4,-0.2,0.5,0.5);

	this.instance_4 = new lib.MurrayJawbottom_dryer0005();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-4.4,-0.2,0.5,0.5);

	this.instance_5 = new lib.MurrayJawbottom_dryer0006();
	this.instance_5.parent = this;
	this.instance_5.setTransform(-4.4,-0.2,0.5,0.5);

	this.instance_6 = new lib.MurrayJawbottom_dryer0007();
	this.instance_6.parent = this;
	this.instance_6.setTransform(-4.4,-0.2,0.5,0.5);

	this.instance_7 = new lib.MurrayJawbottom_dryer0008();
	this.instance_7.parent = this;
	this.instance_7.setTransform(-4.4,-0.2,0.5,0.5);

	this.instance_8 = new lib.MurrayJawbottom_dryer0009();
	this.instance_8.parent = this;
	this.instance_8.setTransform(-4.4,-0.2,0.5,0.5);

	this.instance_9 = new lib.MurrayJawbottom_dryer0010();
	this.instance_9.parent = this;
	this.instance_9.setTransform(-4.4,-0.2,0.5,0.5);

	this.instance_10 = new lib.MurrayJawbottom_dryer0011();
	this.instance_10.parent = this;
	this.instance_10.setTransform(-4.4,-0.2,0.5,0.5);

	this.instance_11 = new lib.MurrayJawbottom_dryer0012();
	this.instance_11.parent = this;
	this.instance_11.setTransform(-4.4,-0.2,0.5,0.5);

	this.instance_12 = new lib.MurrayJawbottom_dryer0013();
	this.instance_12.parent = this;
	this.instance_12.setTransform(-4.4,-0.2,0.5,0.5);

	this.instance_13 = new lib.MurrayJawbottom_dryer0014();
	this.instance_13.parent = this;
	this.instance_13.setTransform(-4.4,-0.2,0.5,0.5);

	this.instance_14 = new lib.MurrayJawbottom_dryer0015();
	this.instance_14.parent = this;
	this.instance_14.setTransform(-4.4,-0.2,0.5,0.5);

	this.instance_15 = new lib.MurrayJawbottom_dryer0016();
	this.instance_15.parent = this;
	this.instance_15.setTransform(-4.4,-0.2,0.5,0.5);

	this.instance_16 = new lib.MurrayJawbottom_dryer0017();
	this.instance_16.parent = this;
	this.instance_16.setTransform(-4.4,-0.2,0.5,0.5);

	this.instance_17 = new lib.MurrayJawbottom_dryer0018();
	this.instance_17.parent = this;
	this.instance_17.setTransform(-4.4,-0.2,0.5,0.5);

	this.instance_18 = new lib.MurrayJawbottom_dryer0019();
	this.instance_18.parent = this;
	this.instance_18.setTransform(-4.4,-0.2,0.5,0.5);

	this.instance_19 = new lib.MurrayJawbottom_dryer0020();
	this.instance_19.parent = this;
	this.instance_19.setTransform(-4.4,-0.2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_7}]},1).to({state:[{t:this.instance_8}]},1).to({state:[{t:this.instance_9}]},1).to({state:[{t:this.instance_10}]},1).to({state:[{t:this.instance_11}]},1).to({state:[{t:this.instance_12}]},1).to({state:[{t:this.instance_13}]},1).to({state:[{t:this.instance_14}]},1).to({state:[{t:this.instance_15}]},1).to({state:[{t:this.instance_16}]},1).to({state:[{t:this.instance_17}]},1).to({state:[{t:this.instance_18}]},1).to({state:[{t:this.instance_19}]},1).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-4.4,-0.2,92,58);


(lib.MurrayJawbottom = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(20));

	// Layer 4
	this.instance = new lib.MurrayJawbottom0020_1();
	this.instance.parent = this;
	this.instance.setTransform(-6,0,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(20));

	// Layer 3
	this.instance_1 = new lib.MurrayJawbottom0001_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-6,0,0.5,0.5);

	this.instance_2 = new lib.MurrayJawbottom0002_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-6,0,0.5,0.5);

	this.instance_3 = new lib.MurrayJawbottom0003_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-6,0,0.5,0.5);

	this.instance_4 = new lib.MurrayJawbottom0004_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-6,0,0.5,0.5);

	this.instance_5 = new lib.MurrayJawbottom0005_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(-6,0,0.5,0.5);

	this.instance_6 = new lib.MurrayJawbottom0006_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(-6,0,0.5,0.5);

	this.instance_7 = new lib.MurrayJawbottom0007_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(-6,0,0.5,0.5);

	this.instance_8 = new lib.MurrayJawbottom0008_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(-6,0,0.5,0.5);

	this.instance_9 = new lib.MurrayJawbottom0009_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(-6,0,0.5,0.5);

	this.instance_10 = new lib.MurrayJawbottom0010_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(-6,0,0.5,0.5);

	this.instance_11 = new lib.MurrayJawbottom0011_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(-6,0,0.5,0.5);

	this.instance_12 = new lib.MurrayJawbottom0012_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(-6,0,0.5,0.5);

	this.instance_13 = new lib.MurrayJawbottom0013_1();
	this.instance_13.parent = this;
	this.instance_13.setTransform(-6,0,0.5,0.5);

	this.instance_14 = new lib.MurrayJawbottom0014_1();
	this.instance_14.parent = this;
	this.instance_14.setTransform(-6,0,0.5,0.5);

	this.instance_15 = new lib.MurrayJawbottom0015_1();
	this.instance_15.parent = this;
	this.instance_15.setTransform(-6,0,0.5,0.5);

	this.instance_16 = new lib.MurrayJawbottom0016_1();
	this.instance_16.parent = this;
	this.instance_16.setTransform(-6,0,0.5,0.5);

	this.instance_17 = new lib.MurrayJawbottom0017_1();
	this.instance_17.parent = this;
	this.instance_17.setTransform(-6,0,0.5,0.5);

	this.instance_18 = new lib.MurrayJawbottom0018_1();
	this.instance_18.parent = this;
	this.instance_18.setTransform(-6,0,0.5,0.5);

	this.instance_19 = new lib.MurrayJawbottom0019_1();
	this.instance_19.parent = this;
	this.instance_19.setTransform(-6,0,0.5,0.5);

	this.instance_20 = new lib.MurrayJawbottom0020_1();
	this.instance_20.parent = this;
	this.instance_20.setTransform(-6,0,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_7}]},1).to({state:[{t:this.instance_8}]},1).to({state:[{t:this.instance_9}]},1).to({state:[{t:this.instance_10}]},1).to({state:[{t:this.instance_11}]},1).to({state:[{t:this.instance_12}]},1).to({state:[{t:this.instance_13}]},1).to({state:[{t:this.instance_14}]},1).to({state:[{t:this.instance_15}]},1).to({state:[{t:this.instance_16}]},1).to({state:[{t:this.instance_17}]},1).to({state:[{t:this.instance_18}]},1).to({state:[{t:this.instance_19}]},1).to({state:[{t:this.instance_20}]},1).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-6,0,87,56);


(lib.MurrayHair3 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#ED981B").s().p("AEdDVQhDg6hxgmQgmgNgqgLIgBgEIgTgBIgDgEQg1gHgXgGQgYgJgjgFIgVgBQgMgLgVAJQgVAHgOgOIgagBIgVgWQgHgGgMgGQghgJgSAAQhTABg5AgQgnAdAAgDQAAgUAqg3QA2hKBGgIQgGgHgaAAQg0gBhlAgQgGACAKgRQAMgSAWgQQBEgxB3AKQAQACAUAMQAJAHATAMQgGgGgGgVQgGgTAAgKQgDg0AQgiIASgYQAGgMAFAEQAFAEAAAQIgBAEQgDAJgMAaQgQAnAAATQAAAMAFARQAGAVAGAGQAEgFAAgSIABgUQAHAFAKAVQAJATAHAAQAYAAACgWIgCgXQAKAJAYAhQAYAgANAKIgRgiQgTgmgFgXQgIgpgBgXQgCg/AdgkQgHBCAZAvQAPAdAlAhIAQAQQgGgIAAgRIAAghQgFgsgageIgagWIAxALQA0AVASAuQALAdAFATQAHAaAAAZIAAABQAXgcAlgSQBIghBVAiQgJgCgPADQgeAGgeAZQgIAHgFANQgHAOgDADQAmgMAfADQAPABAHAEQAQAEBNAsQA0AdBxAPQgUAJhJALQhGAMgGgCQAAACAFAGQAGAJAMAEQA6AXAXA3IALAiQAFAOAHAAQAtgBAjgEQgLADgIAJQgHAHAAADIAdgJIgNAOQgUAZg2AOQg3AOgTgSQgFAMANAeQAMAbgSARQgFgWgMgHQgQgJgCgDIAFAUQAGAWAEAJQgBAggFAAQALhAhShEg");
	this.shape.setTransform(54,34.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayHair3, new cjs.Rectangle(0,0,108.1,69), null);


(lib.MurrayHair2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#ED981B").s().p("AAMAvQgJgFgDgHQgCgKgQgJIgQgIQAAgBAMABIATACIAAAAIADAAQgLgTgfgFIgfgCQALgLAkgCQAsgCAYAaIAFAFQgOghgVgRIgBAAIAFABQAFADAFADIAIAIIAKALQAMAOAEAOIAEAHQAEgjgOgcIABAAQATAgAAAhQAAAjggAEIgIABQgMAAgKgGg");
	this.shape.setTransform(7.4,5.3);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayHair2, new cjs.Rectangle(0,0,14.8,10.6), null);


(lib.MurrayHair1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#ED981B").s().p("AgkA5QgggBgDgYQAAgMACgCIAEgRQAGgSAFgJQALgSAMgIQAIgEADAAIABAAQgKAFgLAUQgKASABABIALgMQAWgMAYgCQATgBAEACQgKABgNAEQgYAHgJAOQATgHAUABQASAAACAEQgGgBgLACIgKADQgNAGAlAGQATAEAWACQggAEgJAFQADgCALACQAPACAGAHIggACQgHAEgJALQgEAHgRACQgOAEgPAAIgEAAg");
	this.shape.setTransform(7.2,5.7);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayHair1, new cjs.Rectangle(0,0,14.4,11.5), null);


(lib.MurrayButton = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#F1E8E2").s().p("AgLAHQgCgDAAgEQAAgNANAAQAOAAAAANQAAAEgDAFQgDAFgIAAQgIAAgDgHg");
	this.shape.setTransform(1.4,1.4);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayButton, new cjs.Rectangle(0,0,2.8,2.8), null);


(lib.MurrayBackHand_337_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Back Hand 337
	this.instance = new lib.MurrayBackHand_337();
	this.instance.parent = this;
	this.instance.setTransform(-2,-3,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayBackHand_337_1, new cjs.Rectangle(-2,-3,73,68), null);


(lib.MurrayArm2_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Arm 2
	this.instance = new lib.MurrayArm2();
	this.instance.parent = this;
	this.instance.setTransform(-5,-3,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayArm2_1, new cjs.Rectangle(-5,-3,77,59), null);


(lib.MurrayArm1_016_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Arm1_016
	this.instance = new lib.MurrayArm1_016();
	this.instance.parent = this;
	this.instance.setTransform(-6,-10,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayArm1_016_1, new cjs.Rectangle(-6,-10,61,85), null);


(lib.MurrayArm1_009_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.MurrayArm1_009();
	this.instance.parent = this;
	this.instance.setTransform(-6.2,-3.6,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayArm1_009_1, new cjs.Rectangle(-6.2,-3.6,60,78), null);


(lib.MurrayArm1_007_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Arm 1_007
	this.instance = new lib.MurrayArm1_007();
	this.instance.parent = this;
	this.instance.setTransform(-6,-12,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayArm1_007_1, new cjs.Rectangle(-6,-12,59,85), null);


(lib.MurrayArm1_002_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Arm 1_002
	this.instance = new lib.MurrayArm1_002();
	this.instance.parent = this;
	this.instance.setTransform(-6,-10,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayArm1_002_1, new cjs.Rectangle(-6,-10,62,84), null);


(lib.MurrayArm1_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Arm 1
	this.instance = new lib.MurrayArm1();
	this.instance.parent = this;
	this.instance.setTransform(-6,-10,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayArm1_1, new cjs.Rectangle(-6,-10,60,85), null);


(lib.Murray3ShirtHem_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray 3Shirt Hem
	this.instance = new lib.Murray3ShirtHem();
	this.instance.parent = this;
	this.instance.setTransform(-4,-4,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Murray3ShirtHem_1, new cjs.Rectangle(-4,-4,21,78), null);


(lib.Murray3pantsHem = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#E7D6CB").s().p("AAaFUQgEgEAAgBIABgEQgHgZgJhRQgPiPgHgyIgXixQgPh6AAgJIgCgyQAAgPAeAAQAEANgBABQARB1AeD9QAfECAAAWIgBAMIgbAHIgCgCg");
	this.shape.setTransform(5.4,33.4);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.Murray3pantsHem, new cjs.Rectangle(-0.1,-0.7,11.1,68.4), null);


(lib.Murray_bottom_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray_Bottom
	this.instance = new lib.Murray_bottom();
	this.instance.parent = this;
	this.instance.setTransform(-2,-2,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Murray_bottom_1, new cjs.Rectangle(-5,-5,189,121.4), null);


(lib.Murray_Blink_002 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Bitmap
	this.instance = new lib.MurrayEyelash();
	this.instance.parent = this;
	this.instance.setTransform(-2,-1,0.25,0.25);

	this.instance_1 = new lib.MurrayEyelid();
	this.instance_1.parent = this;
	this.instance_1.setTransform(1,0,0.25,0.25);

	this.instance_2 = new lib.MurrayEyelid_3_01();
	this.instance_2.parent = this;
	this.instance_2.setTransform(1,0,0.25,0.25);

	this.instance_3 = new lib.MurrayEyelid_3_02();
	this.instance_3.parent = this;
	this.instance_3.setTransform(1,0,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance,p:{scaleY:0.25,y:-1,scaleX:0.25,skewX:0,x:-2}}]}).to({state:[{t:this.instance_2},{t:this.instance,p:{scaleY:0.13,y:4,scaleX:0.25,skewX:0,x:-2}}]},59).to({state:[{t:this.instance_3},{t:this.instance,p:{scaleY:0.13,y:14.8,scaleX:0.23,skewX:180,x:-1}}]},1).to({state:[{t:this.instance_2},{t:this.instance,p:{scaleY:0.13,y:4,scaleX:0.25,skewX:0,x:-2}}]},1).to({state:[{t:this.instance_1},{t:this.instance,p:{scaleY:0.25,y:-1,scaleX:0.25,skewX:0,x:-2}}]},1).wait(67));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-3,-2.2,25,17);


(lib.Murray_blink_01 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// EyeLidLashBitmaps
	this.instance = new lib.MurrayEyelash2();
	this.instance.parent = this;
	this.instance.setTransform(-2,-2,0.25,0.25);

	this.instance_1 = new lib.MurrayEyelid2();
	this.instance_1.parent = this;
	this.instance_1.setTransform(0,0,0.25,0.25);

	this.instance_2 = new lib.MurrayEyelid2_02();
	this.instance_2.parent = this;
	this.instance_2.setTransform(0,0,0.25,0.25);

	this.instance_3 = new lib.MurrayEyelid2_03();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-1,0,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance,p:{scaleX:0.25,scaleY:0.25,skewX:0,skewY:0,x:-2,y:-2}}]}).to({state:[{t:this.instance_2},{t:this.instance,p:{scaleX:0.28,scaleY:0.14,skewX:-4,skewY:10.3,x:-3,y:1.6}}]},59).to({state:[{t:this.instance_3},{t:this.instance,p:{scaleX:0.25,scaleY:0.18,skewX:-132.4,skewY:35.1,x:-5.4,y:9.6}}]},1).to({state:[{t:this.instance_2},{t:this.instance,p:{scaleX:0.28,scaleY:0.14,skewX:-4,skewY:10.3,x:-3,y:1.6}}]},1).to({state:[{t:this.instance_1},{t:this.instance,p:{scaleX:0.25,scaleY:0.25,skewX:0,skewY:0,x:-2,y:-2}}]},1).wait(67));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-3.9,-3.7,23,22);


(lib.forearm_001_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// forearm_001
	this.instance = new lib.forearm_001();
	this.instance.parent = this;
	this.instance.setTransform(-4,-14,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.forearm_001_1, new cjs.Rectangle(-4,-14,66,57), null);


(lib.BeltStrap = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#996A4D").s().p("ArnCBQgOgCgJgLQgOg1AWgBIAtAGQAqAFAjgBIGKAAQEtgPBvgWQBugVBhgUQBggWA9gSQBFgVAlgRIBwgwQAJgFAEANIAHAfQAIAbhtApQhlAmioAlQmEBYkCgFImOABIhlgFg");
	this.shape.setTransform(74.4,11.8);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.BeltStrap, new cjs.Rectangle(-2.8,-1.6,154.5,26.9), null);


(lib.BeltLoops = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#E7D6CB").s().p("Al/B+QgGgDgCgNIAAg8QAFgQAeACQAeABACAPQAEAXgHAuQAAAHgpAAQgLAAgEgCgAqxB+QgGgDgCgNIAAg8QAFgQAdACQAeABACAPQAEAXgGAuQAAAHgpAAQgLAAgEgCgAFoAzQgGgCgGgLIgPg6QABgQAdgGQAegHAFAOQAJAVAGAuQACAHgnAKIgOACIgCAAgAKFgeQgHgCgFgMIgQg6QABgRAdgGQAegGAGANQAJAVAGAvQACAHgoALIgNACIgCAAg");
	this.shape.setTransform(69.8,12.8);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.BeltLoops, new cjs.Rectangle(0,0,139.6,25.6), null);


(lib.BeltBuckle = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFDB88").s().p("AiPAhQgGgigBgjQAAgVCHgRQCFgRACAHIAKAoQAVA8AAAjQAAAKhyANQhoANgwAAQgRAAgLg2gAhcA2IAAAAIgGgQQAEAMACAEgAhVgRQgBAXAOAaQAbABA4gIQA+gJAVgKQgFgHgBgNQgBgMgHgJQgLgCgPAAQg0AAhXAUg");
	this.shape.setTransform(15.1,8.7);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.BeltBuckle, new cjs.Rectangle(0,0,30.2,17.4), null);


(lib.MurrayShortsPocket = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 4
	this.instance = new lib.MurrayButton();
	this.instance.parent = this;
	this.instance.setTransform(5,6.6,1,1,0,0,0,1.4,1.4);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",-1,0,5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer 3
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#D8BFAF").s().p("AA4B5IgJgBQgDgBgBgDIAFABIAQABQABAAAAAAQAAAAAAAAQAAABAAAAQAAABAAAAQAAAAgBABQAAAAAAAAQgBAAgBAAQgBAAAAAAIgFAAgAAWB5IgJgBQgDgBgBgDIAFABIAQABQAAAAABAAQAAAAAAAAQAAABAAAAQAAABAAAAQAAAAgBABQAAAAAAAAQgBAAgBAAQAAAAgBAAIgFAAgAgNB5IgJgBQgCgBgBgDIAEABIARABQAAAAAAAAQAAAAAAAAQAAABAAAAQAAABAAAAQAAAAAAABQAAAAgBAAQgBAAAAAAQgBAAgBAAIgFAAgAgnBkIgBgJQAAgDADgCIABAFIADAQQAAAAAAABQgBAAAAAAQAAAAAAAAQgBAAAAAAQgCAAgCgIgABLBjIACgRQAAgBAAAAQAAAAABAAQAAAAAAAAQAAAAABAAQACABgBAJIgBAIQgBADgDABIAAgEgABLA7IACgRQAAgBAAAAQAAAAABAAQAAAAAAAAQAAAAABAAQACABgBAJIgBAIQgBADgDABIAAgEgAgwA3IgBgJQAAgDADgCIAAAFIADAQQAAAAAAABQAAAAAAAAQAAAAgBAAQAAAAgBAAQgCAAgBgIgAgyAMIgCgPQAAAAAAAAQAAgBAAAAQAAAAABAAQAAAAAAAAQADAAABAIIABAIQAAADgDACIgBgFgABMgEIgBgJQAAgCACgDIACAFIACAPQAAAAAAABQAAAAgBAAQAAAAAAAAQAAAAgBAAQgCAAgBgHgAgygqQgCAAAAgJIACgJQAAgCAEgCIgBAFIgCARIAAAAIgBAAgABKguIgDgRQAAAAAAAAQABgBAAAAQAAAAAAAAQABAAAAAAQACAAACAJIABAJQAAACgDACIgBgEgAAfhpIgJgBQAAAAgBgBQAAAAgBAAQAAgBAAAAQAAgBgBgBIAEABIARABQAAAAABAAQAAAAAAAAQAAABAAAAQAAAAAAABQgBABgEAAIgFAAgAgVhsIgJgBQAAAAgBgBQAAAAgBAAQAAgBAAAAQgBgBAAgBIAEABIARABQAAAAABAAQAAAAAAAAQAAABAAAAQAAAAAAABQgBABgEAAIgFAAgAhFhwIgIgDQgDgCAAgDIAEABIAQAHQAAAAABAAQAAAAAAAAQAAAAAAAAQgBABAAAAIgCABIgHgCg");
	this.shape.setTransform(7,21.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	// Layer 2
	this.instance_1 = new lib.MurrayPocketFlap();
	this.instance_1.parent = this;
	this.instance_1.setTransform(7.7,5.5,1,1,0,0,0,9.9,7.1);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",-1,0,5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// Layer 1
	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#E7D6CB").s().p("AhFB8QgDg6gDgTIAAhgQgIgcAAg8IABgPQACgPAJgEIBHAAQBFARAJAHQAGAEAAAaQAAAWgDAMIgDCMIAGBIIgEAZQgLAXglgIIg/ABIgQACQgRAAgFgwg");
	this.shape_1.setTransform(8.4,17.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayShortsPocket, new cjs.Rectangle(-9.2,-7.6,35,42.1), null);


(lib.MurrayMouth = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Tongue
	this.instance = new lib.MurrayTongue_1();
	this.instance.parent = this;
	this.instance.setTransform(19.9,-0.8,1,1,0,0,0,7.8,6.5);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,5);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({x:18.9,y:2.5},1).to({x:16,y:11.8},18).wait(1));

	// Murray Mouth PNG New
	this.instance_1 = new lib.MurrayMouth0001();
	this.instance_1.parent = this;
	this.instance_1.setTransform(0,-6,0.25,0.25);

	this.instance_2 = new lib.MurrayMouth0002();
	this.instance_2.parent = this;
	this.instance_2.setTransform(0,-6,0.25,0.25);

	this.instance_3 = new lib.MurrayMouth0003();
	this.instance_3.parent = this;
	this.instance_3.setTransform(0,-6,0.25,0.25);

	this.instance_4 = new lib.MurrayMouth0004();
	this.instance_4.parent = this;
	this.instance_4.setTransform(0,-6,0.25,0.25);

	this.instance_5 = new lib.MurrayMouth0005();
	this.instance_5.parent = this;
	this.instance_5.setTransform(0,-6,0.25,0.25);

	this.instance_6 = new lib.MurrayMouth0006();
	this.instance_6.parent = this;
	this.instance_6.setTransform(0,-6,0.25,0.25);

	this.instance_7 = new lib.MurrayMouth0007();
	this.instance_7.parent = this;
	this.instance_7.setTransform(0,-6,0.25,0.25);

	this.instance_8 = new lib.MurrayMouth0008();
	this.instance_8.parent = this;
	this.instance_8.setTransform(0,-6,0.25,0.25);

	this.instance_9 = new lib.MurrayMouth0009();
	this.instance_9.parent = this;
	this.instance_9.setTransform(0,-6,0.25,0.25);

	this.instance_10 = new lib.MurrayMouth0010();
	this.instance_10.parent = this;
	this.instance_10.setTransform(0,-6,0.25,0.25);

	this.instance_11 = new lib.MurrayMouth0011();
	this.instance_11.parent = this;
	this.instance_11.setTransform(0,-6,0.25,0.25);

	this.instance_12 = new lib.MurrayMouth0012();
	this.instance_12.parent = this;
	this.instance_12.setTransform(0,-6,0.25,0.25);

	this.instance_13 = new lib.MurrayMouth0013();
	this.instance_13.parent = this;
	this.instance_13.setTransform(0,-6,0.25,0.25);

	this.instance_14 = new lib.MurrayMouth0014();
	this.instance_14.parent = this;
	this.instance_14.setTransform(0,-6,0.25,0.25);

	this.instance_15 = new lib.MurrayMouth0015();
	this.instance_15.parent = this;
	this.instance_15.setTransform(0,-6,0.25,0.25);

	this.instance_16 = new lib.MurrayMouth0016();
	this.instance_16.parent = this;
	this.instance_16.setTransform(0,-6,0.25,0.25);

	this.instance_17 = new lib.MurrayMouth0017();
	this.instance_17.parent = this;
	this.instance_17.setTransform(0,-6,0.25,0.25);

	this.instance_18 = new lib.MurrayMouth0018();
	this.instance_18.parent = this;
	this.instance_18.setTransform(0,-6,0.25,0.25);

	this.instance_19 = new lib.MurrayMouth0019();
	this.instance_19.parent = this;
	this.instance_19.setTransform(0,-6,0.25,0.25);

	this.instance_20 = new lib.MurrayMouth0020();
	this.instance_20.parent = this;
	this.instance_20.setTransform(0,-6,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_7}]},1).to({state:[{t:this.instance_8}]},1).to({state:[{t:this.instance_9}]},1).to({state:[{t:this.instance_10}]},1).to({state:[{t:this.instance_11}]},1).to({state:[{t:this.instance_12}]},1).to({state:[{t:this.instance_13}]},1).to({state:[{t:this.instance_14}]},1).to({state:[{t:this.instance_15}]},1).to({state:[{t:this.instance_16}]},1).to({state:[{t:this.instance_17}]},1).to({state:[{t:this.instance_18}]},1).to({state:[{t:this.instance_19}]},1).to({state:[{t:this.instance_20}]},1).wait(1));

	// Murray Jaw Under Lip
	this.instance_21 = new lib.MurrayJawunderlip_1();
	this.instance_21.parent = this;
	this.instance_21.setTransform(18.4,4.5,0.849,0.675,0,-5.1,0,22.6,15.8);

	this.timeline.addTween(cjs.Tween.get(this.instance_21).to({scaleX:0.89,scaleY:0.76,skewX:-3.6,x:17.7,y:7.1},1).to({regX:22.7,scaleX:1,scaleY:1,skewX:0,x:15.7,y:14.4},18).wait(1));

	// Murray Jaw Bottom PNG_ 288dpi
	this.instance_22 = new lib.MurrayJawbottom0001();
	this.instance_22.parent = this;
	this.instance_22.setTransform(-26,-6,0.25,0.25);

	this.instance_23 = new lib.MurrayJawbottom0002();
	this.instance_23.parent = this;
	this.instance_23.setTransform(-25,-10,0.25,0.25);

	this.instance_24 = new lib.MurrayJawbottom0003();
	this.instance_24.parent = this;
	this.instance_24.setTransform(-25,-10,0.25,0.25);

	this.instance_25 = new lib.MurrayJawbottom0004();
	this.instance_25.parent = this;
	this.instance_25.setTransform(-25,-10,0.25,0.25);

	this.instance_26 = new lib.MurrayJawbottom0005();
	this.instance_26.parent = this;
	this.instance_26.setTransform(-25,-10,0.25,0.25);

	this.instance_27 = new lib.MurrayJawbottom0006();
	this.instance_27.parent = this;
	this.instance_27.setTransform(-25,-10,0.25,0.25);

	this.instance_28 = new lib.MurrayJawbottom0007();
	this.instance_28.parent = this;
	this.instance_28.setTransform(-25,-10,0.25,0.25);

	this.instance_29 = new lib.MurrayJawbottom0008();
	this.instance_29.parent = this;
	this.instance_29.setTransform(-25,-10,0.25,0.25);

	this.instance_30 = new lib.MurrayJawbottom0009();
	this.instance_30.parent = this;
	this.instance_30.setTransform(-25,-10,0.25,0.25);

	this.instance_31 = new lib.MurrayJawbottom0010();
	this.instance_31.parent = this;
	this.instance_31.setTransform(-25,-10,0.25,0.25);

	this.instance_32 = new lib.MurrayJawbottom0011();
	this.instance_32.parent = this;
	this.instance_32.setTransform(-25,-10,0.25,0.25);

	this.instance_33 = new lib.MurrayJawbottom0012();
	this.instance_33.parent = this;
	this.instance_33.setTransform(-25,-10,0.25,0.25);

	this.instance_34 = new lib.MurrayJawbottom0013();
	this.instance_34.parent = this;
	this.instance_34.setTransform(-25,-10,0.25,0.25);

	this.instance_35 = new lib.MurrayJawbottom0014();
	this.instance_35.parent = this;
	this.instance_35.setTransform(-25,-10,0.25,0.25);

	this.instance_36 = new lib.MurrayJawbottom0015();
	this.instance_36.parent = this;
	this.instance_36.setTransform(-25,-10,0.25,0.25);

	this.instance_37 = new lib.MurrayJawbottom0016();
	this.instance_37.parent = this;
	this.instance_37.setTransform(-25,-10,0.25,0.25);

	this.instance_38 = new lib.MurrayJawbottom0017();
	this.instance_38.parent = this;
	this.instance_38.setTransform(-25,-10,0.25,0.25);

	this.instance_39 = new lib.MurrayJawbottom0018();
	this.instance_39.parent = this;
	this.instance_39.setTransform(-25,-10,0.25,0.25);

	this.instance_40 = new lib.MurrayJawbottom0019();
	this.instance_40.parent = this;
	this.instance_40.setTransform(-25,-10,0.25,0.25);

	this.instance_41 = new lib.MurrayJawbottom0020();
	this.instance_41.parent = this;
	this.instance_41.setTransform(-25,-10,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_22}]}).to({state:[{t:this.instance_23}]},1).to({state:[{t:this.instance_24}]},1).to({state:[{t:this.instance_25}]},1).to({state:[{t:this.instance_26}]},1).to({state:[{t:this.instance_27}]},1).to({state:[{t:this.instance_28}]},1).to({state:[{t:this.instance_29}]},1).to({state:[{t:this.instance_30}]},1).to({state:[{t:this.instance_31}]},1).to({state:[{t:this.instance_32}]},1).to({state:[{t:this.instance_33}]},1).to({state:[{t:this.instance_34}]},1).to({state:[{t:this.instance_35}]},1).to({state:[{t:this.instance_36}]},1).to({state:[{t:this.instance_37}]},1).to({state:[{t:this.instance_38}]},1).to({state:[{t:this.instance_39}]},1).to({state:[{t:this.instance_40}]},1).to({state:[{t:this.instance_41}]},1).wait(1));

	// Murray Jaw Top PNG_288dpi
	this.instance_42 = new lib.Murrayjawtop0001();
	this.instance_42.parent = this;
	this.instance_42.setTransform(-20,-14,0.25,0.25);

	this.instance_43 = new lib.Murrayjawtop0002();
	this.instance_43.parent = this;
	this.instance_43.setTransform(-18,-14,0.25,0.25);

	this.instance_44 = new lib.Murrayjawtop0003();
	this.instance_44.parent = this;
	this.instance_44.setTransform(-18,-16,0.25,0.25);

	this.instance_45 = new lib.Murrayjawtop0004();
	this.instance_45.parent = this;
	this.instance_45.setTransform(-18,-16,0.25,0.25);

	this.instance_46 = new lib.Murrayjawtop0005();
	this.instance_46.parent = this;
	this.instance_46.setTransform(-18,-16,0.25,0.25);

	this.instance_47 = new lib.Murrayjawtop0006();
	this.instance_47.parent = this;
	this.instance_47.setTransform(-18,-16,0.25,0.25);

	this.instance_48 = new lib.Murrayjawtop0007();
	this.instance_48.parent = this;
	this.instance_48.setTransform(-18,-16,0.25,0.25);

	this.instance_49 = new lib.Murrayjawtop0008();
	this.instance_49.parent = this;
	this.instance_49.setTransform(-18,-16,0.25,0.25);

	this.instance_50 = new lib.Murrayjawtop0009();
	this.instance_50.parent = this;
	this.instance_50.setTransform(-18,-16,0.25,0.25);

	this.instance_51 = new lib.Murrayjawtop0010();
	this.instance_51.parent = this;
	this.instance_51.setTransform(-18,-16,0.25,0.25);

	this.instance_52 = new lib.Murrayjawtop0011();
	this.instance_52.parent = this;
	this.instance_52.setTransform(-18,-16,0.25,0.25);

	this.instance_53 = new lib.Murrayjawtop0012();
	this.instance_53.parent = this;
	this.instance_53.setTransform(-18,-16,0.25,0.25);

	this.instance_54 = new lib.Murrayjawtop0013();
	this.instance_54.parent = this;
	this.instance_54.setTransform(-18,-16,0.25,0.25);

	this.instance_55 = new lib.Murrayjawtop0014();
	this.instance_55.parent = this;
	this.instance_55.setTransform(-18,-16,0.25,0.25);

	this.instance_56 = new lib.Murrayjawtop0015();
	this.instance_56.parent = this;
	this.instance_56.setTransform(-18,-16,0.25,0.25);

	this.instance_57 = new lib.Murrayjawtop0016();
	this.instance_57.parent = this;
	this.instance_57.setTransform(-18,-16,0.25,0.25);

	this.instance_58 = new lib.Murrayjawtop0017();
	this.instance_58.parent = this;
	this.instance_58.setTransform(-18,-16,0.25,0.25);

	this.instance_59 = new lib.Murrayjawtop0018();
	this.instance_59.parent = this;
	this.instance_59.setTransform(-18,-16,0.25,0.25);

	this.instance_60 = new lib.Murrayjawtop0019();
	this.instance_60.parent = this;
	this.instance_60.setTransform(-18,-16,0.25,0.25);

	this.instance_61 = new lib.Murrayjawtop0020();
	this.instance_61.parent = this;
	this.instance_61.setTransform(-18,-16,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_42}]}).to({state:[{t:this.instance_43}]},1).to({state:[{t:this.instance_44}]},1).to({state:[{t:this.instance_45}]},1).to({state:[{t:this.instance_46}]},1).to({state:[{t:this.instance_47}]},1).to({state:[{t:this.instance_48}]},1).to({state:[{t:this.instance_49}]},1).to({state:[{t:this.instance_50}]},1).to({state:[{t:this.instance_51}]},1).to({state:[{t:this.instance_52}]},1).to({state:[{t:this.instance_53}]},1).to({state:[{t:this.instance_54}]},1).to({state:[{t:this.instance_55}]},1).to({state:[{t:this.instance_56}]},1).to({state:[{t:this.instance_57}]},1).to({state:[{t:this.instance_58}]},1).to({state:[{t:this.instance_59}]},1).to({state:[{t:this.instance_60}]},1).to({state:[{t:this.instance_61}]},1).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-26,-19.3,88,69.4);


(lib.MurrayMouthDryer = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(20));

	// Layer 2
	this.instance = new lib.MurrayTongue_1();
	this.instance.parent = this;
	this.instance.setTransform(19.9,-0.8,1,1,0,0,0,7.8,6.5);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,5);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({x:18.9,y:2.5},1).to({x:16,y:11.8},18).wait(1));

	// Murray Mouth0001.png
	this.instance_1 = new lib.MurrayMouth0001_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-0.1,-6.4,0.5,0.5);

	this.instance_2 = new lib.MurrayMouth0002_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-0.1,-6.4,0.5,0.5);

	this.instance_3 = new lib.MurrayMouth0003_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-0.1,-6.4,0.5,0.5);

	this.instance_4 = new lib.MurrayMouth0004_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-0.1,-6.4,0.5,0.5);

	this.instance_5 = new lib.MurrayMouth0005_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(-0.1,-6.4,0.5,0.5);

	this.instance_6 = new lib.MurrayMouth0006_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(-0.1,-6.4,0.5,0.5);

	this.instance_7 = new lib.MurrayMouth0007_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(-0.1,-6.4,0.5,0.5);

	this.instance_8 = new lib.MurrayMouth0008_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(-0.1,-6.4,0.5,0.5);

	this.instance_9 = new lib.MurrayMouth0009_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(-0.1,-6.4,0.5,0.5);

	this.instance_10 = new lib.MurrayMouth0010_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(-0.1,-6.4,0.5,0.5);

	this.instance_11 = new lib.MurrayMouth0011_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(-0.1,-6.4,0.5,0.5);

	this.instance_12 = new lib.MurrayMouth0012_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(-0.1,-6.4,0.5,0.5);

	this.instance_13 = new lib.MurrayMouth0013_1();
	this.instance_13.parent = this;
	this.instance_13.setTransform(-0.1,-6.4,0.5,0.5);

	this.instance_14 = new lib.MurrayMouth0014_1();
	this.instance_14.parent = this;
	this.instance_14.setTransform(-0.1,-6.4,0.5,0.5);

	this.instance_15 = new lib.MurrayMouth0015_1();
	this.instance_15.parent = this;
	this.instance_15.setTransform(-0.1,-6.4,0.5,0.5);

	this.instance_16 = new lib.MurrayMouth0016_1();
	this.instance_16.parent = this;
	this.instance_16.setTransform(-0.1,-6.4,0.5,0.5);

	this.instance_17 = new lib.MurrayMouth0017_1();
	this.instance_17.parent = this;
	this.instance_17.setTransform(-0.1,-6.4,0.5,0.5);

	this.instance_18 = new lib.MurrayMouth0018_1();
	this.instance_18.parent = this;
	this.instance_18.setTransform(-0.1,-6.4,0.5,0.5);

	this.instance_19 = new lib.MurrayMouth0019_1();
	this.instance_19.parent = this;
	this.instance_19.setTransform(-0.1,-6.4,0.5,0.5);

	this.instance_20 = new lib.MurrayMouth0020_1();
	this.instance_20.parent = this;
	this.instance_20.setTransform(-0.1,-6.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_7}]},1).to({state:[{t:this.instance_8}]},1).to({state:[{t:this.instance_9}]},1).to({state:[{t:this.instance_10}]},1).to({state:[{t:this.instance_11}]},1).to({state:[{t:this.instance_12}]},1).to({state:[{t:this.instance_13}]},1).to({state:[{t:this.instance_14}]},1).to({state:[{t:this.instance_15}]},1).to({state:[{t:this.instance_16}]},1).to({state:[{t:this.instance_17}]},1).to({state:[{t:this.instance_18}]},1).to({state:[{t:this.instance_19}]},1).to({state:[{t:this.instance_20}]},1).wait(1));

	// Layer 3
	this.instance_21 = new lib.MurrayJawunderlip_dryer();
	this.instance_21.parent = this;
	this.instance_21.setTransform(18.4,4.5,0.849,0.675,0,-5.1,0,22.6,15.8);
	this.instance_21.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,7);

	this.timeline.addTween(cjs.Tween.get(this.instance_21).to({scaleX:0.89,scaleY:0.76,skewX:-3.6,x:17.7,y:7.1},1).to({regX:22.7,scaleX:1,scaleY:1,skewX:0,x:15.7,y:14.4},18).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-20.4,-24.7,97,67);


(lib.MurrayMouth_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.MurrayNose_1();
	this.instance.parent = this;
	this.instance.setTransform(20.5,-2.7,1,0.798,4.6,0,0,7.2,4.7);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(9).to({regX:7.3,regY:4.8,x:20.7,y:-3.8},10).wait(1));

	// Murray Face0001.png
	this.instance_1 = new lib.MurrayFace0001_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-9,-22,0.5,0.5);

	this.instance_2 = new lib.MurrayFace0010();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-9,-22,0.5,0.5);

	this.instance_3 = new lib.MurrayFace0011_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-9,-22,0.5,0.5);

	this.instance_4 = new lib.MurrayFace0012_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-9,-22,0.5,0.5);

	this.instance_5 = new lib.MurrayFace0013_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(-9,-22,0.5,0.5);

	this.instance_6 = new lib.MurrayFace0014_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(-9,-22,0.5,0.5);

	this.instance_7 = new lib.MurrayFace0015_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(-9,-22,0.5,0.5);

	this.instance_8 = new lib.MurrayFace0016_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(-9,-22,0.5,0.5);

	this.instance_9 = new lib.MurrayFace0017_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(-9,-22,0.5,0.5);

	this.instance_10 = new lib.MurrayFace0018_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(-9,-22,0.5,0.5);

	this.instance_11 = new lib.MurrayFace0019_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(-9,-22,0.5,0.5);

	this.instance_12 = new lib.MurrayFace0020_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(-9,-22,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_2}]},9).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_7}]},1).to({state:[{t:this.instance_8}]},1).to({state:[{t:this.instance_9}]},1).to({state:[{t:this.instance_10}]},1).to({state:[{t:this.instance_11}]},1).to({state:[{t:this.instance_12}]},1).wait(1));

	// Layer 2
	this.instance_13 = new lib.MurrayTongue_1();
	this.instance_13.parent = this;
	this.instance_13.setTransform(19.9,-0.8,1,1,0,0,0,7.8,6.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_13).to({x:18.9,y:2.5},1).to({x:16,y:11.8},18).wait(1));

	// Murray Mouth0001.png
	this.instance_14 = new lib.MurrayMouth0001_1();
	this.instance_14.parent = this;
	this.instance_14.setTransform(-0.1,-6.4,0.5,0.5);

	this.instance_15 = new lib.MurrayMouth0002_1();
	this.instance_15.parent = this;
	this.instance_15.setTransform(-0.1,-6.4,0.5,0.5);

	this.instance_16 = new lib.MurrayMouth0003_1();
	this.instance_16.parent = this;
	this.instance_16.setTransform(-0.1,-6.4,0.5,0.5);

	this.instance_17 = new lib.MurrayMouth0004_1();
	this.instance_17.parent = this;
	this.instance_17.setTransform(-0.1,-6.4,0.5,0.5);

	this.instance_18 = new lib.MurrayMouth0005_1();
	this.instance_18.parent = this;
	this.instance_18.setTransform(-0.1,-6.4,0.5,0.5);

	this.instance_19 = new lib.MurrayMouth0006_1();
	this.instance_19.parent = this;
	this.instance_19.setTransform(-0.1,-6.4,0.5,0.5);

	this.instance_20 = new lib.MurrayMouth0007_1();
	this.instance_20.parent = this;
	this.instance_20.setTransform(-0.1,-6.4,0.5,0.5);

	this.instance_21 = new lib.MurrayMouth0008_1();
	this.instance_21.parent = this;
	this.instance_21.setTransform(-0.1,-6.4,0.5,0.5);

	this.instance_22 = new lib.MurrayMouth0009_1();
	this.instance_22.parent = this;
	this.instance_22.setTransform(-0.1,-6.4,0.5,0.5);

	this.instance_23 = new lib.MurrayMouth0010_1();
	this.instance_23.parent = this;
	this.instance_23.setTransform(-0.1,-6.4,0.5,0.5);

	this.instance_24 = new lib.MurrayMouth0011_1();
	this.instance_24.parent = this;
	this.instance_24.setTransform(-0.1,-6.4,0.5,0.5);

	this.instance_25 = new lib.MurrayMouth0012_1();
	this.instance_25.parent = this;
	this.instance_25.setTransform(-0.1,-6.4,0.5,0.5);

	this.instance_26 = new lib.MurrayMouth0013_1();
	this.instance_26.parent = this;
	this.instance_26.setTransform(-0.1,-6.4,0.5,0.5);

	this.instance_27 = new lib.MurrayMouth0014_1();
	this.instance_27.parent = this;
	this.instance_27.setTransform(-0.1,-6.4,0.5,0.5);

	this.instance_28 = new lib.MurrayMouth0015_1();
	this.instance_28.parent = this;
	this.instance_28.setTransform(-0.1,-6.4,0.5,0.5);

	this.instance_29 = new lib.MurrayMouth0016_1();
	this.instance_29.parent = this;
	this.instance_29.setTransform(-0.1,-6.4,0.5,0.5);

	this.instance_30 = new lib.MurrayMouth0017_1();
	this.instance_30.parent = this;
	this.instance_30.setTransform(-0.1,-6.4,0.5,0.5);

	this.instance_31 = new lib.MurrayMouth0018_1();
	this.instance_31.parent = this;
	this.instance_31.setTransform(-0.1,-6.4,0.5,0.5);

	this.instance_32 = new lib.MurrayMouth0019_1();
	this.instance_32.parent = this;
	this.instance_32.setTransform(-0.1,-6.4,0.5,0.5);

	this.instance_33 = new lib.MurrayMouth0020_1();
	this.instance_33.parent = this;
	this.instance_33.setTransform(-0.1,-6.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_14}]}).to({state:[{t:this.instance_15}]},1).to({state:[{t:this.instance_16}]},1).to({state:[{t:this.instance_17}]},1).to({state:[{t:this.instance_18}]},1).to({state:[{t:this.instance_19}]},1).to({state:[{t:this.instance_20}]},1).to({state:[{t:this.instance_21}]},1).to({state:[{t:this.instance_22}]},1).to({state:[{t:this.instance_23}]},1).to({state:[{t:this.instance_24}]},1).to({state:[{t:this.instance_25}]},1).to({state:[{t:this.instance_26}]},1).to({state:[{t:this.instance_27}]},1).to({state:[{t:this.instance_28}]},1).to({state:[{t:this.instance_29}]},1).to({state:[{t:this.instance_30}]},1).to({state:[{t:this.instance_31}]},1).to({state:[{t:this.instance_32}]},1).to({state:[{t:this.instance_33}]},1).wait(1));

	// Layer 3
	this.instance_34 = new lib.MurrayJawunderlip_1();
	this.instance_34.parent = this;
	this.instance_34.setTransform(18.4,4.5,0.849,0.675,0,-5.1,0,22.6,15.8);

	this.timeline.addTween(cjs.Tween.get(this.instance_34).to({scaleX:0.89,scaleY:0.76,skewX:-3.6,x:17.7,y:7.1},1).to({regX:22.7,scaleX:1,scaleY:1,skewX:0,x:15.7,y:14.4},18).wait(1));

	// Layer 3
	this.instance_35 = new lib.MurrayJawbottom0001_1();
	this.instance_35.parent = this;
	this.instance_35.setTransform(-24,-7,0.5,0.5);

	this.instance_36 = new lib.MurrayJawbottom0002_1();
	this.instance_36.parent = this;
	this.instance_36.setTransform(-24,-7,0.5,0.5);

	this.instance_37 = new lib.MurrayJawbottom0003_1();
	this.instance_37.parent = this;
	this.instance_37.setTransform(-24,-7,0.5,0.5);

	this.instance_38 = new lib.MurrayJawbottom0004_1();
	this.instance_38.parent = this;
	this.instance_38.setTransform(-24,-7,0.5,0.5);

	this.instance_39 = new lib.MurrayJawbottom0005_1();
	this.instance_39.parent = this;
	this.instance_39.setTransform(-24,-7,0.5,0.5);

	this.instance_40 = new lib.MurrayJawbottom0006_1();
	this.instance_40.parent = this;
	this.instance_40.setTransform(-24,-7,0.5,0.5);

	this.instance_41 = new lib.MurrayJawbottom0007_1();
	this.instance_41.parent = this;
	this.instance_41.setTransform(-24,-7,0.5,0.5);

	this.instance_42 = new lib.MurrayJawbottom0008_1();
	this.instance_42.parent = this;
	this.instance_42.setTransform(-24,-7,0.5,0.5);

	this.instance_43 = new lib.MurrayJawbottom0009_1();
	this.instance_43.parent = this;
	this.instance_43.setTransform(-24,-7,0.5,0.5);

	this.instance_44 = new lib.MurrayJawbottom0010_1();
	this.instance_44.parent = this;
	this.instance_44.setTransform(-24,-7,0.5,0.5);

	this.instance_45 = new lib.MurrayJawbottom0011_1();
	this.instance_45.parent = this;
	this.instance_45.setTransform(-24,-7,0.5,0.5);

	this.instance_46 = new lib.MurrayJawbottom0012_1();
	this.instance_46.parent = this;
	this.instance_46.setTransform(-24,-7,0.5,0.5);

	this.instance_47 = new lib.MurrayJawbottom0013_1();
	this.instance_47.parent = this;
	this.instance_47.setTransform(-24,-7,0.5,0.5);

	this.instance_48 = new lib.MurrayJawbottom0014_1();
	this.instance_48.parent = this;
	this.instance_48.setTransform(-24,-7,0.5,0.5);

	this.instance_49 = new lib.MurrayJawbottom0015_1();
	this.instance_49.parent = this;
	this.instance_49.setTransform(-24,-7,0.5,0.5);

	this.instance_50 = new lib.MurrayJawbottom0016_1();
	this.instance_50.parent = this;
	this.instance_50.setTransform(-24,-7,0.5,0.5);

	this.instance_51 = new lib.MurrayJawbottom0017_1();
	this.instance_51.parent = this;
	this.instance_51.setTransform(-24,-7,0.5,0.5);

	this.instance_52 = new lib.MurrayJawbottom0018_1();
	this.instance_52.parent = this;
	this.instance_52.setTransform(-24,-7,0.5,0.5);

	this.instance_53 = new lib.MurrayJawbottom0019_1();
	this.instance_53.parent = this;
	this.instance_53.setTransform(-24,-7,0.5,0.5);

	this.instance_54 = new lib.MurrayJawbottom0020_1();
	this.instance_54.parent = this;
	this.instance_54.setTransform(-24,-7,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_35}]}).to({state:[{t:this.instance_36}]},1).to({state:[{t:this.instance_37}]},1).to({state:[{t:this.instance_38}]},1).to({state:[{t:this.instance_39}]},1).to({state:[{t:this.instance_40}]},1).to({state:[{t:this.instance_41}]},1).to({state:[{t:this.instance_42}]},1).to({state:[{t:this.instance_43}]},1).to({state:[{t:this.instance_44}]},1).to({state:[{t:this.instance_45}]},1).to({state:[{t:this.instance_46}]},1).to({state:[{t:this.instance_47}]},1).to({state:[{t:this.instance_48}]},1).to({state:[{t:this.instance_49}]},1).to({state:[{t:this.instance_50}]},1).to({state:[{t:this.instance_51}]},1).to({state:[{t:this.instance_52}]},1).to({state:[{t:this.instance_53}]},1).to({state:[{t:this.instance_54}]},1).wait(1));

	// Murray jaw top0001.png
	this.instance_55 = new lib.Murrayjawtop0001_1();
	this.instance_55.parent = this;
	this.instance_55.setTransform(-21,-14,0.5,0.5);

	this.instance_56 = new lib.Murrayjawtop0002_1();
	this.instance_56.parent = this;
	this.instance_56.setTransform(-21,-14,0.5,0.5);

	this.instance_57 = new lib.Murrayjawtop0003_1();
	this.instance_57.parent = this;
	this.instance_57.setTransform(-21,-14,0.5,0.5);

	this.instance_58 = new lib.Murrayjawtop0004_1();
	this.instance_58.parent = this;
	this.instance_58.setTransform(-21,-14,0.5,0.5);

	this.instance_59 = new lib.Murrayjawtop0005_1();
	this.instance_59.parent = this;
	this.instance_59.setTransform(-21,-14,0.5,0.5);

	this.instance_60 = new lib.Murrayjawtop0006_1();
	this.instance_60.parent = this;
	this.instance_60.setTransform(-21,-14,0.5,0.5);

	this.instance_61 = new lib.Murrayjawtop0007_1();
	this.instance_61.parent = this;
	this.instance_61.setTransform(-21,-14,0.5,0.5);

	this.instance_62 = new lib.Murrayjawtop0008_1();
	this.instance_62.parent = this;
	this.instance_62.setTransform(-21,-14,0.5,0.5);

	this.instance_63 = new lib.Murrayjawtop0009_1();
	this.instance_63.parent = this;
	this.instance_63.setTransform(-21,-14,0.5,0.5);

	this.instance_64 = new lib.Murrayjawtop0010_1();
	this.instance_64.parent = this;
	this.instance_64.setTransform(-21,-14,0.5,0.5);

	this.instance_65 = new lib.Murrayjawtop0011_1();
	this.instance_65.parent = this;
	this.instance_65.setTransform(-21,-14,0.5,0.5);

	this.instance_66 = new lib.Murrayjawtop0012_1();
	this.instance_66.parent = this;
	this.instance_66.setTransform(-21,-14,0.5,0.5);

	this.instance_67 = new lib.Murrayjawtop0013_1();
	this.instance_67.parent = this;
	this.instance_67.setTransform(-21,-14,0.5,0.5);

	this.instance_68 = new lib.Murrayjawtop0014_1();
	this.instance_68.parent = this;
	this.instance_68.setTransform(-21,-14,0.5,0.5);

	this.instance_69 = new lib.Murrayjawtop0015_1();
	this.instance_69.parent = this;
	this.instance_69.setTransform(-21,-14,0.5,0.5);

	this.instance_70 = new lib.Murrayjawtop0016_1();
	this.instance_70.parent = this;
	this.instance_70.setTransform(-21,-14,0.5,0.5);

	this.instance_71 = new lib.Murrayjawtop0017_1();
	this.instance_71.parent = this;
	this.instance_71.setTransform(-21,-14,0.5,0.5);

	this.instance_72 = new lib.Murrayjawtop0018_1();
	this.instance_72.parent = this;
	this.instance_72.setTransform(-21,-14,0.5,0.5);

	this.instance_73 = new lib.Murrayjawtop0019_1();
	this.instance_73.parent = this;
	this.instance_73.setTransform(-21,-14,0.5,0.5);

	this.instance_74 = new lib.Murrayjawtop0020_1();
	this.instance_74.parent = this;
	this.instance_74.setTransform(-21,-14,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_55}]}).to({state:[{t:this.instance_56}]},1).to({state:[{t:this.instance_57}]},1).to({state:[{t:this.instance_58}]},1).to({state:[{t:this.instance_59}]},1).to({state:[{t:this.instance_60}]},1).to({state:[{t:this.instance_61}]},1).to({state:[{t:this.instance_62}]},1).to({state:[{t:this.instance_63}]},1).to({state:[{t:this.instance_64}]},1).to({state:[{t:this.instance_65}]},1).to({state:[{t:this.instance_66}]},1).to({state:[{t:this.instance_67}]},1).to({state:[{t:this.instance_68}]},1).to({state:[{t:this.instance_69}]},1).to({state:[{t:this.instance_70}]},1).to({state:[{t:this.instance_71}]},1).to({state:[{t:this.instance_72}]},1).to({state:[{t:this.instance_73}]},1).to({state:[{t:this.instance_74}]},1).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-24,-22,87,71);


(lib.MurrayLeftEye_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// EyeLidAnim
	this.instance = new lib.Murray_blink_01();
	this.instance.parent = this;
	this.instance.setTransform(7.5,5.6,1,1,0,0,0,6.3,5.8);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// EyeBaseBitmap
	this.instance_1 = new lib.MurrayLeftEye();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-3,-3,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayLeftEye_1, new cjs.Rectangle(-3,-3,23,26), null);


(lib.MurrayHair = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Vector
	this.instance = new lib.MurrayHair2();
	this.instance.parent = this;
	this.instance.setTransform(12.8,14,1,1,0,0,0,7.4,5.3);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,4);

	this.instance_1 = new lib.MurrayHair1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(21,8.4);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,3);

	this.instance_2 = new lib.MurrayHair3();
	this.instance_2.parent = this;
	this.instance_2.setTransform(21.7,13.9,0.402,0.402,0,0,0,54,34.5);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayHair, new cjs.Rectangle(-5,-5,57,41), null);


(lib.MurrayFaceDryer = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(20));

	// Layer 5
	this.instance = new lib.MurrayNose_1();
	this.instance.parent = this;
	this.instance.setTransform(21.9,13.5,1,0.798,4.6,0,0,7.2,4.7);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(9).to({regX:7.3,regY:4.8,x:22.1,y:12.4},10).wait(1));

	// Murray Face0001.png
	this.instance_1 = new lib.MurrayFace0001_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-6.8,-4.9,0.5,0.5);

	this.instance_2 = new lib.MurrayFace0010();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-6.8,-4.9,0.5,0.5);

	this.instance_3 = new lib.MurrayFace0011_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-6.8,-4.9,0.5,0.5);

	this.instance_4 = new lib.MurrayFace0012_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-6.8,-4.9,0.5,0.5);

	this.instance_5 = new lib.MurrayFace0013_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(-6.8,-4.9,0.5,0.5);

	this.instance_6 = new lib.MurrayFace0014_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(-6.8,-4.9,0.5,0.5);

	this.instance_7 = new lib.MurrayFace0015_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(-6.8,-4.9,0.5,0.5);

	this.instance_8 = new lib.MurrayFace0016_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(-6.8,-4.9,0.5,0.5);

	this.instance_9 = new lib.MurrayFace0017_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(-6.8,-4.9,0.5,0.5);

	this.instance_10 = new lib.MurrayFace0018_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(-6.8,-4.9,0.5,0.5);

	this.instance_11 = new lib.MurrayFace0019_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(-6.8,-4.9,0.5,0.5);

	this.instance_12 = new lib.MurrayFace0020_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(-6.8,-4.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_2}]},9).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_7}]},1).to({state:[{t:this.instance_8}]},1).to({state:[{t:this.instance_9}]},1).to({state:[{t:this.instance_10}]},1).to({state:[{t:this.instance_11}]},1).to({state:[{t:this.instance_12}]},1).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-6.8,-4.9,62,45);


(lib.MurrayFace = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(20));

	// Nose
	this.instance = new lib.MurrayNose_1();
	this.instance.parent = this;
	this.instance.setTransform(21.9,13.5,1,0.798,4.6,0,0,7.2,4.7);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(9).to({regX:7.3,regY:4.8,x:22.1,y:12.4},10).wait(1));

	// Face_PNG
	this.instance_1 = new lib.MurrayFace0001();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-7,-5,0.25,0.25);

	this.instance_2 = new lib.MurrayFace0011();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-7,-5,0.25,0.25);

	this.instance_3 = new lib.MurrayFace0012();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-7,-5,0.25,0.25);

	this.instance_4 = new lib.MurrayFace0013();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-7,-5,0.25,0.25);

	this.instance_5 = new lib.MurrayFace0014();
	this.instance_5.parent = this;
	this.instance_5.setTransform(-7,-5,0.25,0.25);

	this.instance_6 = new lib.MurrayFace0015();
	this.instance_6.parent = this;
	this.instance_6.setTransform(-7,-5,0.25,0.25);

	this.instance_7 = new lib.MurrayFace0016();
	this.instance_7.parent = this;
	this.instance_7.setTransform(-7,-5,0.25,0.25);

	this.instance_8 = new lib.MurrayFace0017();
	this.instance_8.parent = this;
	this.instance_8.setTransform(-7,-5,0.25,0.25);

	this.instance_9 = new lib.MurrayFace0018();
	this.instance_9.parent = this;
	this.instance_9.setTransform(-7,-5,0.25,0.25);

	this.instance_10 = new lib.MurrayFace0019();
	this.instance_10.parent = this;
	this.instance_10.setTransform(-7,-5,0.25,0.25);

	this.instance_11 = new lib.MurrayFace0020();
	this.instance_11.parent = this;
	this.instance_11.setTransform(-7,-5,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_2}]},10).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_7}]},1).to({state:[{t:this.instance_8}]},1).to({state:[{t:this.instance_9}]},1).to({state:[{t:this.instance_10}]},1).to({state:[{t:this.instance_11}]},1).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-7,-5,61,46);


(lib.MurrayEye_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// EyelidBitmap
	this.instance = new lib.Murray_Blink_002();
	this.instance.parent = this;
	this.instance.setTransform(6.4,3.8,1,1,0,0,0,7.6,4);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// PupilBitmap
	this.instance_1 = new lib.MurrayEye();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-3,-2,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayEye_1, new cjs.Rectangle(-3.2,-2,23.3,25), null);


(lib.Murray_right_arm_down = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.MurrayShirtRightArm_001_1();
	this.instance.parent = this;
	this.instance.setTransform(97.8,54.1,1.426,1.532,0,-71.7,-60,39.1,30.9);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,6);

	this.instance_1 = new lib.MurrayArm1_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(78.3,78.3,1.5,1.123,0,-164.3,15.7,32.8,37.1);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,-2,5);

	this.instance_2 = new lib.MurrayPalm_41_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(41.9,118.3,1,1.092,-38.2,0,0,31.7,25.2);

	this.instance_3 = new lib.MurrayPointerFinger_039_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(48.2,117.4,1,1,0,134.1,-45.9,28.4,28.3);

	this.instance_4 = new lib.MurrayMiddleFinger_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(32.3,107.1,2.068,1.984,0,119.2,-67.1,16.2,13.3);

	this.instance_5 = new lib.MurrayPinky_037_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(18.6,126.5,1,0.999,143.9,0,0,9.8,27.5);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.Murray_right_arm_down, new cjs.Rectangle(-1.6,-20.6,183.4,189.3), null);


(lib.exitarm = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_2
	this.instance = new lib.MurrayLeftArm2_0001_1();
	this.instance.parent = this;
	this.instance.setTransform(-19.9,-26.7,1.499,1.351,0,154.8,-25.2,19.1,38.8);

	this.instance_1 = new lib.MurrayPalm_41_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(12,19.8,1,1.092,0,38.2,-141.8,31.7,25.2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

	// Layer 1
	this.instance_2 = new lib.MurrayPointerFinger_039_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(7,14.5,1,1,-134.1,0,0,28.2,29.2);

	this.instance_3 = new lib.MurrayMiddleFinger_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(20.7,11.4,2.068,1.984,0,-119.2,-112.9,16,12.8);

	this.instance_4 = new lib.MurrayPinky_037_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(34.5,26.9,1,0.999,0,-143.9,36.1,10,27.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2}]}).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-60.2,-74.4,115.5,143.1);


(lib.Belt_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.instance = new lib.BeltLoops();
	this.instance.parent = this;
	this.instance.setTransform(76.8,13.6,1,1,0,0,0,69.8,12.8);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",-1,0,5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer 2
	this.instance_1 = new lib.BeltBuckle();
	this.instance_1.parent = this;
	this.instance_1.setTransform(78.2,20.7,1,1,0,0,0,15.1,8.7);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",-1,0,5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// Layer 1
	this.instance_2 = new lib.BeltStrap();
	this.instance_2.parent = this;
	this.instance_2.setTransform(74.9,12.6,1,1,0,0,0,74.9,12.6);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",-1,0,5);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

}).prototype = getMCSymbolPrototype(lib.Belt_001, new cjs.Rectangle(-16.8,-13.6,184,63.6), null);


(lib.MurrayShorts_001_2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Murray Shorts_001
	this.instance = new lib.MurrayShorts_001();
	this.instance.parent = this;
	this.instance.setTransform(-20,-3,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Shorts Pocket
	this.instance_1 = new lib.MurrayShortsPocket();
	this.instance_1.parent = this;
	this.instance_1.setTransform(155.5,36.1,1.084,0.892,0,-36.8,143.2,8.7,17.2);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",-1,0,5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// Shorts Pocket
	this.instance_2 = new lib.MurrayShortsPocket();
	this.instance_2.parent = this;
	this.instance_2.setTransform(1.5,52.6,1.084,0.892,21.6,0,0,8.2,17.2);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",-1,0,5);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// Layer 3
	this.instance_3 = new lib.Belt_001();
	this.instance_3.parent = this;
	this.instance_3.setTransform(74.9,18.7,1,1,0,0,0,74.9,12.6);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

	// Layer 4
	this.instance_4 = new lib.Murray3pantsHem();
	this.instance_4.parent = this;
	this.instance_4.setTransform(77.5,47.9,1,0.602,8,0,0,3.6,33.5);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",-1,0,5);

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(1));

	// Shorts
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#E7D6CB").s().p("AmnGgQhHgFhhgVQhSgRhhgcQiTgqgEgVQASg1AThBQAniDALg/QAGgsgHhcQgFhGALABQJOAdHuhlQD5gzCWg8QAGgHASArQAOAiAHAcQAGAWAXA1QAWA0AFAXQAKAuBSBoQBLBfgBABQgrBGhrBKQiTBni1AiQlFA7gtAAQgQgugLgVQgRghgSgSQgRgRgTAcQgHAMgFAPIgGAYQgJAUgLAmIheACQjLAAg/gEg");
	this.shape.setTransform(81.5,42.6);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.MurrayShorts_001_2, new cjs.Rectangle(-28.4,-3,219.1,96), null);


(lib.MurrayHead = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{MW_03:0,MW_03_stop:81,MW_04:82,MW_04_stop:177,MW_05:178,MW_05_stop:245,MW_06:246,MW_06_stop:374,MW_07:375,MW_07_stop:421,MW_09:422,MW_09_stop:470,cham:471,cham_stop:493,cheetah:494,cheetah_stop:513,condor:514,condor_stop:542,cow:543,cow_stop:563,croc:564,croc_stop:594,elephant:595,elephant_stop:618,giraffe:619,giraffe_stop:640,iguana:641,iguana_stop:664,lion:665,lion_stop:688,monkey:689,monkey_stop:726,ostrich:727,ostrich_stop:750,penguin:751,penguin_stop:770,pig:771,pig_stop:788,polar:789,polar_stop:812,sheep:813,sheep_stop:828,sloth:829,sloth_stop:849,tiger:850,tiger_stop:872,toucan:873,toucan_stop:898,walrus:899,walrus_stop:925,zebra:926,zebra_stop:947,MW_01_adjust:948,MW_01_adjust_stop:1280,first:1281,first_stop:1303,letsWash:1304,letsWash_stop:1346,part:1347,part_stop:1363});

	// Murray Eye
	this.instance = new lib.MurrayEye_1();
	this.instance.parent = this;
	this.instance.setTransform(34.7,16.7,1,1,0,0,0,6.8,6.8);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(471).to({_off:true},893).wait(19));

	// Murray Left Eye
	this.instance_1 = new lib.MurrayLeftEye_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(40,13.6);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(471).to({_off:true},893).wait(19));

	// Murray Hair
	this.instance_2 = new lib.MurrayHair();
	this.instance_2.parent = this;
	this.instance_2.setTransform(42.1,13.1,1,1,0,0,0,21.7,13.8);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(471).to({_off:true},893).wait(19));

	// Mouth_Synced
	this.instance_3 = new lib.MurrayMouth_1("single",0);
	this.instance_3.parent = this;
	this.instance_3.setTransform(35.1,41.8,1,1,0,0,0,16.6,10.2);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(5).to({startPosition:2},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:17},0).wait(1).to({startPosition:13},0).wait(1).to({startPosition:17},0).wait(1).to({startPosition:19},0).wait(1).to({startPosition:17},0).wait(1).to({startPosition:12},0).wait(1).to({startPosition:13},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:7},0).wait(1).to({startPosition:0},0).wait(2).to({startPosition:5},0).wait(1).to({startPosition:13},0).wait(1).to({startPosition:13},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:7},0).wait(1).to({startPosition:4},0).wait(1).to({startPosition:2},0).wait(1).to({startPosition:0},0).wait(9).to({startPosition:7},0).wait(1).to({startPosition:19},0).wait(1).to({startPosition:15},0).wait(1).to({startPosition:14},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:11},0).wait(1).to({startPosition:4},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:2},0).wait(1).to({startPosition:2},0).wait(1).to({startPosition:0},0).wait(2).to({startPosition:3},0).wait(1).to({startPosition:10},0).wait(1).to({startPosition:19},0).wait(1).to({startPosition:18},0).wait(1).to({startPosition:16},0).wait(1).to({startPosition:17},0).wait(1).to({startPosition:15},0).wait(1).to({startPosition:12},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:0},0).wait(6).to({startPosition:3},0).wait(1).to({startPosition:10},0).wait(1).to({startPosition:11},0).wait(1).to({startPosition:15},0).wait(1).to({startPosition:16},0).wait(1).to({startPosition:15},0).wait(1).to({startPosition:11},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:14},0).wait(1).to({startPosition:11},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:7},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:0},0).wait(5).to({startPosition:2},0).wait(1).to({startPosition:16},0).wait(1).to({startPosition:13},0).wait(1).to({startPosition:14},0).wait(1).to({startPosition:19},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:10},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:11},0).wait(1).to({startPosition:2},0).wait(1).to({startPosition:0},0).wait(4).to({startPosition:14},0).wait(1).to({startPosition:14},0).wait(1).to({startPosition:11},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:13},0).wait(1).to({startPosition:15},0).wait(1).to({startPosition:14},0).wait(1).to({startPosition:14},0).wait(1).to({startPosition:11},0).wait(1).to({startPosition:11},0).wait(1).to({startPosition:10},0).wait(1).to({startPosition:10},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:0},0).wait(13).to({startPosition:2},0).wait(1).to({startPosition:10},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:3},0).wait(2).to({startPosition:0},0).wait(1).to({startPosition:2},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:15},0).wait(1).to({startPosition:12},0).wait(1).to({startPosition:7},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:4},0).wait(1).to({startPosition:4},0).wait(2).to({startPosition:7},0).wait(2).to({startPosition:6},0).wait(1).to({startPosition:0},0).wait(2).to({startPosition:3},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:10},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:7},0).wait(1).to({startPosition:10},0).wait(1).to({startPosition:16},0).wait(1).to({startPosition:18},0).wait(1).to({startPosition:19},0).wait(1).to({startPosition:15},0).wait(1).to({startPosition:14},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:0},0).wait(5).to({startPosition:7},0).wait(1).to({startPosition:13},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:10},0).wait(1).to({startPosition:12},0).wait(1).to({startPosition:13},0).wait(1).to({startPosition:0},0).wait(8).to({startPosition:5},0).wait(1).to({startPosition:15},0).wait(1).to({startPosition:19},0).wait(1).to({startPosition:16},0).wait(1).to({startPosition:10},0).wait(1).to({startPosition:2},0).wait(1).to({startPosition:0},0).wait(2).to({startPosition:7},0).wait(1).to({startPosition:12},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:13},0).wait(1).to({startPosition:14},0).wait(1).to({startPosition:13},0).wait(1).to({startPosition:10},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:4},0).wait(1).to({startPosition:4},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:2},0).wait(1).to({startPosition:0},0).wait(7).to({startPosition:8},0).wait(1).to({startPosition:11},0).wait(1).to({startPosition:19},0).wait(1).to({startPosition:18},0).wait(1).to({startPosition:15},0).wait(1).to({startPosition:17},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:15},0).wait(1).to({startPosition:13},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:0},0).wait(4).to({startPosition:14},0).wait(1).to({startPosition:17},0).wait(2).to({startPosition:5},0).wait(1).to({startPosition:2},0).wait(3).to({startPosition:4},0).wait(1).to({startPosition:4},0).wait(1).to({startPosition:7},0).wait(1).to({startPosition:7},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:0},0).wait(8).to({startPosition:4},0).wait(1).to({startPosition:7},0).wait(1).to({startPosition:15},0).wait(1).to({startPosition:15},0).wait(1).to({startPosition:14},0).wait(1).to({startPosition:13},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:5},0).wait(2).to({startPosition:3},0).wait(1).to({startPosition:0},0).wait(2).to({startPosition:2},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:4},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:14},0).wait(1).to({startPosition:12},0).wait(1).to({startPosition:10},0).wait(1).to({startPosition:7},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:12},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:2},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:4},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:4},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:0},0).wait(4).to({startPosition:7},0).wait(1).to({startPosition:13},0).wait(1).to({startPosition:19},0).wait(1).to({startPosition:15},0).wait(1).to({startPosition:4},0).wait(2).to({startPosition:4},0).wait(1).to({startPosition:4},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:7},0).wait(1).to({startPosition:3},0).wait(2).to({startPosition:3},0).wait(1).to({startPosition:16},0).wait(2).to({startPosition:11},0).wait(1).to({startPosition:0},0).wait(3).to({startPosition:9},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:7},0).wait(1).to({startPosition:7},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:2},0).wait(1).to({startPosition:10},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:2},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:11},0).wait(1).to({startPosition:12},0).wait(1).to({startPosition:17},0).wait(1).to({startPosition:11},0).wait(1).to({startPosition:12},0).wait(1).to({startPosition:12},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:0},0).wait(4).to({startPosition:6},0).wait(1).to({startPosition:7},0).wait(1).to({startPosition:7},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:0},0).wait(2).to({startPosition:6},0).wait(1).to({startPosition:7},0).wait(1).to({startPosition:4},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:2},0).wait(1).to({startPosition:0},0).wait(10).to({startPosition:2},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:10},0).wait(1).to({startPosition:15},0).wait(1).to({startPosition:17},0).wait(1).to({startPosition:11},0).wait(1).to({startPosition:0},0).wait(2).to({startPosition:7},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:0},0).wait(3).to({startPosition:18},0).wait(1).to({startPosition:15},0).wait(1).to({startPosition:13},0).wait(1).to({startPosition:12},0).wait(1).to({startPosition:17},0).wait(1).to({startPosition:7},0).wait(1).to({startPosition:0},0).wait(6).to({startPosition:3},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:14},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:10},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:0},0).wait(3).to({startPosition:13},0).wait(1).to({startPosition:19},0).wait(1).to({startPosition:12},0).wait(1).to({startPosition:11},0).wait(1).to({startPosition:15},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:7},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:4},0).wait(1).to({startPosition:0},0).wait(5).to({startPosition:12},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:10},0).wait(1).to({startPosition:12},0).wait(1).to({startPosition:10},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:2},0).wait(1).to({startPosition:0},0).wait(8).to({startPosition:0},0).wait(3).to({startPosition:7},0).wait(1).to({startPosition:15},0).wait(1).to({startPosition:18},0).wait(1).to({startPosition:15},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:4},0).wait(1).to({startPosition:4},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:4},0).wait(1).to({startPosition:4},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:19},0).wait(1).to({startPosition:14},0).wait(1).to({startPosition:16},0).wait(1).to({startPosition:19},0).wait(1).to({startPosition:14},0).wait(1).to({startPosition:15},0).wait(1).to({startPosition:10},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:13},0).wait(1).to({startPosition:16},0).wait(1).to({startPosition:17},0).wait(1).to({startPosition:10},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:0},0).wait(8).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(2).to({startPosition:5},0).wait(1).to({startPosition:18},0).wait(1).to({startPosition:14},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:14},0).wait(1).to({startPosition:19},0).wait(3).to({startPosition:18},0).wait(1).to({startPosition:13},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:7},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:0},0).wait(6).to({startPosition:2},0).wait(1).to({startPosition:4},0).wait(2).to({startPosition:0},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:18},0).wait(1).to({startPosition:19},0).wait(1).to({startPosition:17},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:13},0).wait(1).to({startPosition:12},0).wait(1).to({startPosition:11},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:2},0).wait(1).to({startPosition:0},0).wait(4).to({startPosition:3},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:7},0).wait(1).to({startPosition:11},0).wait(1).to({startPosition:15},0).wait(1).to({startPosition:19},0).wait(1).to({startPosition:18},0).wait(1).to({startPosition:10},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:3},0).wait(2).to({startPosition:11},0).wait(1).to({startPosition:17},0).wait(1).to({startPosition:14},0).wait(1).to({startPosition:12},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:12},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:7},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:0},0).wait(8).to({startPosition:9},0).wait(1).to({startPosition:19},0).wait(1).to({startPosition:19},0).wait(3).to({startPosition:17},0).wait(1).to({startPosition:15},0).wait(1).to({startPosition:15},0).wait(1).to({startPosition:15},0).wait(1).to({startPosition:15},0).wait(1).to({startPosition:10},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:0},0).wait(7).to({startPosition:2},0).wait(1).to({startPosition:0},0).wait(2).to({startPosition:2},0).wait(1).to({startPosition:4},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:19},0).wait(1).to({startPosition:14},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:0},0).wait(2).to({startPosition:3},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:2},0).wait(1).to({startPosition:4},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:7},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:2},0).wait(1).to({startPosition:0},0).wait(11).to({startPosition:8},0).wait(1).to({startPosition:16},0).wait(1).to({startPosition:19},0).wait(2).to({startPosition:12},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:16},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:0},0).wait(2).to({startPosition:3},0).wait(1).to({startPosition:10},0).wait(1).to({startPosition:4},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:0},0).wait(10).to({startPosition:8},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:10},0).wait(1).to({startPosition:13},0).wait(1).to({startPosition:12},0).wait(1).to({startPosition:14},0).wait(1).to({startPosition:19},0).wait(2).to({startPosition:12},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:7},0).wait(1).to({startPosition:7},0).wait(1).to({startPosition:4},0).wait(1).to({startPosition:0},0).wait(8).to({startPosition:5},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:19},0).wait(1).to({startPosition:15},0).wait(1).to({startPosition:10},0).wait(1).to({startPosition:12},0).wait(1).to({startPosition:12},0).wait(1).to({startPosition:4},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:10},0).wait(1).to({startPosition:13},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:0},0).wait(6).to({startPosition:7},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:15},0).wait(1).to({startPosition:19},0).wait(1).to({startPosition:17},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:10},0).wait(1).to({startPosition:14},0).wait(1).to({startPosition:12},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:4},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:4},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:2},0).wait(1).to({startPosition:2},0).wait(2).to({startPosition:0},0).wait(6).to({startPosition:3},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:0},0).wait(6).to({startPosition:7},0).wait(1).to({startPosition:16},0).wait(1).to({startPosition:19},0).wait(1).to({startPosition:15},0).wait(1).to({startPosition:11},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:14},0).wait(1).to({startPosition:13},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:7},0).wait(1).to({startPosition:10},0).wait(1).to({startPosition:7},0).wait(2).to({startPosition:2},0).wait(1).to({startPosition:0},0).wait(2).to({startPosition:2},0).wait(2).to({startPosition:0},0).wait(9).to({startPosition:13},0).wait(1).to({startPosition:19},0).wait(1).to({startPosition:14},0).wait(1).to({startPosition:14},0).wait(1).to({startPosition:4},0).wait(1).to({startPosition:0},0).wait(4).to({startPosition:4},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:7},0).wait(1).to({startPosition:0},0).wait(10).to({startPosition:3},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:19},0).wait(1).to({startPosition:16},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:7},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:4},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:2},0).wait(1).to({startPosition:0},0).wait(5).to({startPosition:2},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:15},0).wait(1).to({startPosition:19},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:0},0).wait(8).to({startPosition:2},0).wait(1).to({startPosition:17},0).wait(1).to({startPosition:19},0).wait(1).to({startPosition:18},0).wait(1).to({startPosition:10},0).wait(1).to({startPosition:7},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:7},0).wait(1).to({startPosition:2},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:4},0).wait(1).to({startPosition:4},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:0},0).wait(12).to({startPosition:4},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:19},0).wait(1).to({startPosition:13},0).wait(1).to({startPosition:7},0).wait(1).to({startPosition:2},0).wait(1).to({startPosition:0},0).wait(10).to({startPosition:3},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:19},0).wait(2).to({startPosition:16},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:0},0).wait(10).to({startPosition:4},0).wait(1).to({startPosition:13},0).wait(1).to({startPosition:19},0).wait(2).to({startPosition:16},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:0},0).wait(2).to({startPosition:4},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:0},0).wait(8).to({startPosition:5},0).wait(1).to({startPosition:16},0).wait(1).to({startPosition:19},0).wait(1).to({startPosition:11},0).wait(1).to({startPosition:0},0).wait(2).to({startPosition:8},0).wait(1).to({startPosition:11},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:7},0).wait(1).to({startPosition:5},0).wait(3).to({startPosition:3},0).wait(1).to({startPosition:2},0).wait(2).to({startPosition:3},0).wait(1).to({startPosition:0},0).wait(6).to({startPosition:5},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:18},0).wait(1).to({startPosition:19},0).wait(1).to({startPosition:19},0).wait(1).to({startPosition:17},0).wait(1).to({startPosition:17},0).wait(1).to({startPosition:18},0).wait(1).to({startPosition:12},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:4},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:0},0).wait(12).to({startPosition:2},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:4},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:11},0).wait(1).to({startPosition:19},0).wait(2).to({startPosition:12},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:4},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:7},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:0},0).wait(56).to({startPosition:6},0).wait(1).to({startPosition:15},0).wait(1).to({startPosition:14},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:0},0).wait(8).to({startPosition:3},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:13},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:0},0).wait(3).to({startPosition:6},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:4},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:11},0).wait(1).to({startPosition:10},0).wait(1).to({startPosition:10},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:7},0).wait(1).to({startPosition:4},0).wait(1).to({startPosition:0},0).wait(3).to({startPosition:2},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:7},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:0},0).wait(13).to({startPosition:3},0).wait(1).to({startPosition:10},0).wait(1).to({startPosition:7},0).wait(1).to({startPosition:2},0).wait(2).to({startPosition:0},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:17},0).wait(1).to({startPosition:15},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:0},0).wait(3).to({startPosition:5},0).wait(1).to({startPosition:0},0).wait(2).to({startPosition:3},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:0},0).wait(2).to({startPosition:8},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:0},0).wait(5).to({startPosition:6},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:7},0).wait(1).to({startPosition:7},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:11},0).wait(1).to({startPosition:17},0).wait(1).to({startPosition:11},0).wait(1).to({startPosition:13},0).wait(1).to({startPosition:14},0).wait(1).to({startPosition:13},0).wait(1).to({startPosition:11},0).wait(1).to({startPosition:12},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:4},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:10},0).wait(1).to({startPosition:10},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:7},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:10},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:10},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:2},0).wait(1).to({startPosition:4},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:7},0).wait(1).to({startPosition:0},0).wait(3).to({startPosition:8},0).wait(1).to({startPosition:11},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:2},0).wait(1).to({startPosition:0},0).wait(19).to({startPosition:2},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:16},0).wait(1).to({startPosition:19},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:11},0).wait(1).to({startPosition:0},0).wait(2).to({startPosition:4},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:2},0).wait(1).to({startPosition:0},0).wait(2).to({startPosition:2},0).wait(1).to({startPosition:7},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:11},0).wait(1).to({startPosition:12},0).wait(1).to({startPosition:12},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:0},0).wait(2).to({startPosition:4},0).wait(1).to({startPosition:2},0).wait(1).to({startPosition:0},0).wait(4).to({startPosition:14},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:4},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:4},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:11},0).wait(1).to({startPosition:13},0).wait(1).to({startPosition:10},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:2},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:0},0).wait(2).to({startPosition:6},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:2},0).wait(1).to({startPosition:0},0).wait(3).to({startPosition:5},0).wait(1).to({startPosition:14},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:9},0).wait(2).to({startPosition:10},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:0},0).wait(12).to({startPosition:4},0).wait(1).to({startPosition:10},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:4},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:4},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:7},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:4},0).wait(1).to({startPosition:4},0).wait(1).to({startPosition:7},0).wait(1).to({startPosition:12},0).wait(1).to({startPosition:10},0).wait(1).to({startPosition:7},0).wait(1).to({startPosition:2},0).wait(1).to({startPosition:0},0).wait(3).to({startPosition:4},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:0},0).wait(2).to({startPosition:2},0).wait(1).to({startPosition:2},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:10},0).wait(1).to({startPosition:9},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:7},0).wait(1).to({startPosition:7},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:3},0).wait(2).to({startPosition:3},0).wait(2).to({startPosition:3},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:0},0).wait(11).to({startPosition:11},0).wait(1).to({startPosition:19},0).wait(1).to({startPosition:18},0).wait(1).to({startPosition:14},0).wait(1).to({startPosition:12},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:7},0).wait(1).to({startPosition:4},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:4},0).wait(1).to({startPosition:2},0).wait(1).to({startPosition:0},0).wait(8).to({startPosition:3},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:11},0).wait(1).to({startPosition:19},0).wait(1).to({startPosition:16},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:0},0).wait(7).to({startPosition:14},0).wait(1).to({startPosition:19},0).wait(1).to({startPosition:15},0).wait(1).to({startPosition:13},0).wait(1).to({startPosition:11},0).wait(1).to({startPosition:7},0).wait(1).to({startPosition:3},0).wait(1).to({startPosition:2},0).wait(1).to({startPosition:0},0).wait(2).to({startPosition:3},0).wait(1).to({startPosition:4},0).wait(1).to({startPosition:4},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:5},0).wait(1).to({startPosition:7},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:4},0).wait(1).to({startPosition:0},0).wait(2).to({startPosition:2},0).wait(1).to({startPosition:0},0).wait(7).to({startPosition:9},0).wait(1).to({startPosition:19},0).wait(1).to({startPosition:16},0).wait(1).to({startPosition:8},0).wait(1).to({startPosition:7},0).wait(1).to({startPosition:6},0).wait(1).to({startPosition:0},0).to({_off:true},9).wait(19));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-6,-5.7,87.5,87.2);


// stage content:
(lib.MWIntro = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{off:0,off_stop:8,enter:9,enter_stop:35,enter2:37,enter2_stop:58,intro:60,intro_stop:462,exclamation:463,exclamation_stop:557,animalName:558,"MW_09":576,"MW_09_stop":592,firstLets:593,firstLets_stop:714,exit:716,exit_stop:736});

	// ---forearm_003
	this.instance = new lib.MurrayThumb_234_1();
	this.instance.parent = this;
	this.instance.setTransform(358.7,432.5,1,1,0,0,0,17,17.9);

	this.instance_1 = new lib.MurrayPointerFinger_108_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(333.1,419.9,1.117,1.02,0,8.8,20.3,16.9,15.8);

	this.instance_2 = new lib.MurrayMiddleFinger_108_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(313.6,431,0.899,1.102,-69.7,0,0,5.5,0.2);

	this.instance_3 = new lib.MurrayPinky_108_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(326.4,435.1,0.749,0.91,-39.7,0,0,25.9,21.4);

	this.instance_4 = new lib.MurrayPalm_108_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(349.7,433.5,1,1,-9.7,0,0,31.9,13.6);

	this.instance_5 = new lib.MurrayLeftThumb_234_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(535.2,501.2,1,1,0,0,0,14.3,14.8);

	this.instance_6 = new lib.MurrayLeftPointerFinger_234_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(556.4,496.9,1,1,0,0,0,19.8,14.3);

	this.instance_7 = new lib.MurrayLeftMiddleFinger_234_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(574,509.9,1,1,0,0,0,12.1,17);

	this.instance_8 = new lib.MurrayLeftPinky_234_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(586.3,512.6,1,1,0,0,0,9.2,8.6);

	this.instance_9 = new lib.MurrayLeftPalm_234_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(553.6,508.8,1,1,0,0,0,16.9,8.6);

	this.instance_10 = new lib.MurrayPointerFinger_237_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(356,385,1,1,0,0,0,11.9,25.8);

	this.instance_11 = new lib.MurrayMiddleFinger_237_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(343.9,393.5,1,1,0,0,0,13,12.5);

	this.instance_12 = new lib.MurrayPinky_237_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(327.8,397.5,1,1,0,0,0,9,10);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_9,p:{scaleX:1,scaleY:1,x:553.6,y:508.8}},{t:this.instance_8,p:{regY:8.6,scaleX:1,scaleY:1,rotation:0,x:586.3,y:512.6}},{t:this.instance_7,p:{regX:12.1,regY:17,rotation:0,x:574,y:509.9}},{t:this.instance_6,p:{regX:19.8,regY:14.3,rotation:0,x:556.4,y:496.9}},{t:this.instance_5,p:{x:535.2,y:501.2}},{t:this.instance_4,p:{regX:31.9,regY:13.6,rotation:-9.7,x:349.7,y:433.5}},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance,p:{regX:17,regY:17.9,scaleX:1,scaleY:1,rotation:0,x:358.7,y:432.5}}]},601).to({state:[{t:this.instance_8,p:{regY:8.7,scaleX:1.564,scaleY:1.247,rotation:-15,x:575.6,y:500.4}},{t:this.instance_7,p:{regX:3.6,regY:2.1,rotation:-60,x:553.8,y:492.3}},{t:this.instance_6,p:{regX:-1.2,regY:7.7,rotation:-36.7,x:535.6,y:488.7}},{t:this.instance_9,p:{scaleX:1.115,scaleY:1.362,x:549.5,y:498.2}},{t:this.instance_5,p:{x:535.9,y:499.6}},{t:this.instance_4,p:{regX:29.6,regY:18.1,rotation:5.3,x:354,y:413.8}},{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance,p:{regX:27.4,regY:28.2,scaleX:1.123,scaleY:1.119,rotation:4,x:372.8,y:419.9}}]},2).to({state:[]},2).to({state:[{t:this.instance_8,p:{regY:8.7,scaleX:1.564,scaleY:1.247,rotation:-15,x:575.6,y:500.4}},{t:this.instance_7,p:{regX:3.6,regY:2.1,rotation:-60,x:553.8,y:492.3}},{t:this.instance_6,p:{regX:-1.2,regY:7.7,rotation:-36.7,x:535.6,y:488.7}},{t:this.instance_9,p:{scaleX:1.115,scaleY:1.362,x:549.5,y:498.2}},{t:this.instance_5,p:{x:535.9,y:499.6}},{t:this.instance_4,p:{regX:29.6,regY:18.1,rotation:5.3,x:354,y:413.8}},{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance,p:{regX:27.4,regY:28.2,scaleX:1.123,scaleY:1.119,rotation:4,x:372.8,y:419.9}}]},48).to({state:[{t:this.instance_9,p:{scaleX:1,scaleY:1,x:553.6,y:508.8}},{t:this.instance_8,p:{regY:8.6,scaleX:1,scaleY:1,rotation:0,x:586.3,y:512.6}},{t:this.instance_7,p:{regX:12.1,regY:17,rotation:0,x:574,y:509.9}},{t:this.instance_6,p:{regX:19.8,regY:14.3,rotation:0,x:556.4,y:496.9}},{t:this.instance_5,p:{x:535.2,y:501.2}},{t:this.instance_4,p:{regX:31.9,regY:13.6,rotation:-9.7,x:349.7,y:433.5}},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance,p:{regX:17,regY:17.9,scaleX:1,scaleY:1,rotation:0,x:358.7,y:432.5}}]},2).to({state:[]},2).wait(81));

	// Layer 144
	this.instance_13 = new lib.MurrayLeftArm2_0001_1();
	this.instance_13.parent = this;
	this.instance_13.setTransform(361.3,440.7,1.313,0.801,0,-119.7,61.3,19,38.8);
	this.instance_13._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_13).wait(601).to({_off:false},0).to({_off:true},2).wait(52).to({_off:false},0).to({_off:true},2).wait(81));

	// Layer 145
	this.instance_14 = new lib.MurrayShorts_001_2();
	this.instance_14.parent = this;
	this.instance_14.setTransform(444.6,770.3,1.049,0.961,6.7,0,0,78.4,41.4);
	this.instance_14._off = true;

	this.instance_15 = new lib.MurrayThumb_039_1();
	this.instance_15.parent = this;
	this.instance_15.setTransform(356.5,484.3,1,1,14.8,0,0,31.2,6.8);

	this.instance_16 = new lib.MurrayPalm_037_1();
	this.instance_16.parent = this;
	this.instance_16.setTransform(336.3,468,0.76,1.134,0,-75,-68.9,46.8,19);

	this.instance_17 = new lib.MurrayPointerFinger_039_1();
	this.instance_17.parent = this;
	this.instance_17.setTransform(316.7,463.3,1,1,0,0,0,21.6,16.8);

	this.instance_18 = new lib.MurrayMiddleFinger_1();
	this.instance_18.parent = this;
	this.instance_18.setTransform(316,487.6,2.068,1.984,0,18.1,24.4,16.6,13.2);

	this.instance_19 = new lib.MurrayPinky_037_1();
	this.instance_19.parent = this;
	this.instance_19.setTransform(305.6,484.2,1,1.42,-53.8,0,0,6,14.5);

	this.instance_20 = new lib.MurrayPalm_053_1();
	this.instance_20.parent = this;
	this.instance_20.setTransform(367.4,492.1,1.025,1,0,22.4,9.8,25.1,31.5);

	this.instance_21 = new lib.MurrayLeftArm1_1();
	this.instance_21.parent = this;
	this.instance_21.setTransform(341.7,483.8,0.875,0.913,0,55.2,-118.4,33.5,24.1);

	this.instance_22 = new lib.MurrayPalm_079_1();
	this.instance_22.parent = this;
	this.instance_22.setTransform(342.2,397.2,0.905,1.12,0,-54.5,-45,27.1,17.4);

	this.instance_23 = new lib.MurrayPinky_079_1();
	this.instance_23.parent = this;
	this.instance_23.setTransform(367.3,402.3,0.905,1.12,0,-54.5,-45,14.2,14.7);

	this.instance_24 = new lib.MurrayMiddleFinger_079_1();
	this.instance_24.parent = this;
	this.instance_24.setTransform(363.6,386,0.905,1.12,0,-54.5,-45,20.9,11.7);

	this.instance_25 = new lib.MurrayArm1_002_1();
	this.instance_25.parent = this;
	this.instance_25.setTransform(329.4,416.5,1.427,0.914,0,-112,-131.4,32.5,36.9);

	this.instance_26 = new lib.MurrayPointerFinger_079_1();
	this.instance_26.parent = this;
	this.instance_26.setTransform(360.4,376.5,0.905,1.12,0,-54.5,-45,18.1,9.9);

	this.instance_27 = new lib.MurrayPalm_057_1();
	this.instance_27.parent = this;
	this.instance_27.setTransform(331.5,370.1,1,1,3.2,0,0,38,20.9);

	this.instance_28 = new lib.MurrayPointerFinger_1();
	this.instance_28.parent = this;
	this.instance_28.setTransform(334.4,374.1,1.537,1.5,0,-170.1,9.9,21.3,8.3);

	this.instance_29 = new lib.neckPatc_1();
	this.instance_29.parent = this;
	this.instance_29.setTransform(344.8,480.5,1,0.712,0,28.1,15,12.8,15.6);

	this.instance_30 = new lib.MurrayPalm_077_1();
	this.instance_30.parent = this;
	this.instance_30.setTransform(369.2,455.9,1,1,0,0,0,29.3,25.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_14}]},9).to({state:[{t:this.instance_14}]},8).to({state:[{t:this.instance_14}]},2).to({state:[{t:this.instance_14}]},2).to({state:[{t:this.instance_14}]},2).to({state:[{t:this.instance_14}]},2).to({state:[{t:this.instance_14}]},2).to({state:[]},10).to({state:[{t:this.instance_19,p:{regX:6,scaleX:1,scaleY:1.42,rotation:-53.8,skewX:0,skewY:0,x:305.6,y:484.2,regY:14.5}},{t:this.instance_18,p:{regX:16.6,regY:13.2,scaleX:2.068,scaleY:1.984,skewX:18.1,skewY:24.4,x:316,y:487.6}},{t:this.instance_17,p:{regX:21.6,scaleX:1,scaleY:1,skewX:0,skewY:0,x:316.7,y:463.3,regY:16.8,rotation:0}},{t:this.instance_16,p:{regX:46.8,scaleX:0.76,scaleY:1.134,skewX:-75,skewY:-68.9,x:336.3,y:468}},{t:this.instance_15,p:{regX:31.2,scaleX:1,scaleY:1,rotation:14.8,skewX:0,skewY:0,x:356.5,y:484.3}}]},104).to({state:[{t:this.instance_19,p:{regX:6.3,scaleX:1.018,scaleY:1.312,rotation:0,skewX:-121.5,skewY:-107.8,x:326.6,y:517.1,regY:14.5}},{t:this.instance_18,p:{regX:16.1,regY:13.6,scaleX:2.016,scaleY:1.868,skewX:-35,skewY:-43.5,x:333.4,y:510.4}},{t:this.instance_17,p:{regX:21.9,scaleX:1.063,scaleY:0.871,skewX:-55.3,skewY:-64.9,x:316.9,y:496.2,regY:16.8,rotation:0}},{t:this.instance_16,p:{regX:46.7,scaleX:0.791,scaleY:1.008,skewX:-119.8,skewY:-108.5,x:328.9,y:479.8}},{t:this.instance_15,p:{regX:31.1,scaleX:0.889,scaleY:1.033,rotation:0,skewX:-23.9,skewY:-30.1,x:351.5,y:479.1}}]},2).to({state:[]},2).to({state:[{t:this.instance_21,p:{regX:33.5,regY:24.1,skewX:55.2,skewY:-118.4,x:341.7,y:483.8}},{t:this.instance_18,p:{regX:15.8,regY:13,scaleX:2.068,scaleY:1.984,skewX:-99.5,skewY:-93.3,x:392.2,y:484.2}},{t:this.instance_17,p:{regX:28.4,scaleX:1,scaleY:1,skewX:0,skewY:0,x:378.4,y:486.6,regY:28.2,rotation:-110.7}},{t:this.instance_19,p:{regX:10,scaleX:1.332,scaleY:1.699,rotation:0,skewX:-177.7,skewY:2.3,x:363.1,y:478.2,regY:27.2}},{t:this.instance_20,p:{regY:31.5,scaleX:1.025,skewX:22.4,skewY:9.8,x:367.4,y:492.1}}]},36).to({state:[{t:this.instance_21,p:{regX:33.2,regY:24.2,skewX:32.8,skewY:-140.8,x:338,y:465.5}},{t:this.instance_18,p:{regX:15.6,regY:13,scaleX:2.068,scaleY:1.984,skewX:-121.9,skewY:-115.7,x:384.8,y:446.8}},{t:this.instance_17,p:{regX:28.7,scaleX:1,scaleY:1,skewX:0,skewY:0,x:373,y:453.3,regY:28.7,rotation:-133.1}},{t:this.instance_19,p:{regX:9.8,scaleX:1.332,scaleY:1.699,rotation:0,skewX:159.9,skewY:-20.1,x:355.2,y:451.9,regY:27.2}},{t:this.instance_20,p:{regY:31.7,scaleX:1,skewX:0,skewY:0,x:366.1,y:462.8}}]},2).to({state:[{t:this.instance_26},{t:this.instance_25,p:{regX:32.5,regY:36.9,scaleX:1.427,skewX:-112,skewY:-131.4,x:329.4,y:416.5}},{t:this.instance_24},{t:this.instance_23},{t:this.instance_22}]},2).to({state:[{t:this.instance_28},{t:this.instance_18,p:{regX:10.8,regY:4,scaleX:2.028,scaleY:1.119,skewX:-166.8,skewY:13.2,x:316.4,y:379.6}},{t:this.instance_27}]},2).to({state:[]},64).to({state:[{t:this.instance_19,p:{regX:6,scaleX:1,scaleY:1.42,rotation:-53.8,skewX:0,skewY:0,x:305.6,y:484.2,regY:14.5}},{t:this.instance_18,p:{regX:16.6,regY:13.4,scaleX:2.068,scaleY:1.984,skewX:18.1,skewY:24.4,x:315.9,y:487.9}},{t:this.instance_17,p:{regX:21.6,scaleX:1,scaleY:1,skewX:0,skewY:0,x:316.7,y:463.3,regY:16.8,rotation:0}},{t:this.instance_16,p:{regX:46.8,scaleX:0.76,scaleY:1.134,skewX:-75,skewY:-68.9,x:336.3,y:468}},{t:this.instance_15,p:{regX:31.2,scaleX:1,scaleY:1,rotation:14.8,skewX:0,skewY:0,x:356.5,y:484.3}},{t:this.instance_29,p:{regX:12.8,regY:15.6,skewX:28.1,skewY:15,x:344.8,y:480.5}}]},2).to({state:[{t:this.instance_19,p:{regX:6.3,scaleX:1.018,scaleY:1.312,rotation:0,skewX:-121.5,skewY:-107.8,x:326.6,y:517.1,regY:14.5}},{t:this.instance_18,p:{regX:16,regY:13.6,scaleX:2.016,scaleY:1.868,skewX:-35,skewY:-43.5,x:333.3,y:510.5}},{t:this.instance_17,p:{regX:21.9,scaleX:1.063,scaleY:0.871,skewX:-55.3,skewY:-64.9,x:316.6,y:496,regY:16.5,rotation:0}},{t:this.instance_16,p:{regX:46.7,scaleX:0.791,scaleY:1.008,skewX:-119.8,skewY:-108.5,x:328.9,y:479.8}},{t:this.instance_15,p:{regX:31.1,scaleX:0.889,scaleY:1.033,rotation:0,skewX:-23.9,skewY:-30.1,x:351.5,y:479.1}},{t:this.instance_29,p:{regX:12.9,regY:15.5,skewX:13.1,skewY:0,x:345.8,y:479.9}}]},2).to({state:[]},2).to({state:[{t:this.instance_25,p:{regX:32.6,regY:37,scaleX:1.186,skewX:-39.4,skewY:-66.6,x:347,y:449.6}},{t:this.instance_19,p:{regX:9.7,scaleX:1,scaleY:0.81,rotation:127.7,skewX:0,skewY:0,x:346.4,y:470.2,regY:27.6}},{t:this.instance_18,p:{regX:8.1,regY:1.3,scaleX:1.934,scaleY:2.147,skewX:72.4,skewY:-113.9,x:378.9,y:469}},{t:this.instance_17,p:{regX:34.2,scaleX:1,scaleY:1,skewX:92,skewY:-88,x:355.9,y:452,regY:33.6,rotation:0}},{t:this.instance_30,p:{regX:29.3,regY:25.4,rotation:0,x:369.2,y:455.9}}]},4).to({state:[{t:this.instance_25,p:{regX:32.6,regY:37,scaleX:1.186,skewX:-61,skewY:-88.2,x:362.6,y:432}},{t:this.instance_19,p:{regX:9.8,scaleX:1,scaleY:0.81,rotation:106.1,skewX:0,skewY:0,x:369.7,y:451.4,regY:27.7}},{t:this.instance_18,p:{regX:9.1,regY:1,scaleX:1.934,scaleY:2.147,skewX:50.7,skewY:-135.6,x:398.5,y:436.4}},{t:this.instance_17,p:{regX:30.1,scaleX:1,scaleY:1,skewX:70.3,skewY:-109.7,x:376.4,y:433.6,regY:30.2,rotation:0}},{t:this.instance_30,p:{regX:29.2,regY:25.3,rotation:-21.7,x:385.5,y:429.5}}]},2).to({state:[]},2).to({state:[{t:this.instance_14}]},80).to({state:[{t:this.instance_14}]},2).to({state:[{t:this.instance_14}]},2).to({state:[]},2).to({state:[{t:this.instance_14}]},55).to({state:[]},2).to({state:[{t:this.instance_14}]},55).to({state:[{t:this.instance_14}]},4).to({state:[{t:this.instance_14}]},2).to({state:[{t:this.instance_14}]},2).to({state:[{t:this.instance_14}]},2).to({state:[{t:this.instance_14}]},2).to({state:[{t:this.instance_14}]},2).to({state:[{t:this.instance_14}]},2).to({state:[{t:this.instance_14}]},4).to({state:[{t:this.instance_14}]},2).to({state:[{t:this.instance_14}]},2).to({state:[{t:this.instance_14}]},10).to({state:[{t:this.instance_14}]},2).to({state:[{t:this.instance_14}]},2).to({state:[{t:this.instance_14}]},2).to({state:[{t:this.instance_14}]},2).to({state:[{t:this.instance_14}]},2).to({state:[{t:this.instance_14}]},2).to({state:[{t:this.instance_14}]},2).to({state:[{t:this.instance_14}]},2).to({state:[{t:this.instance_14}]},2).to({state:[{t:this.instance_14}]},2).to({state:[]},44).to({state:[{t:this.instance_14}]},6).to({state:[{t:this.instance_14}]},26).to({state:[{t:this.instance_14}]},8).to({state:[{t:this.instance_14}]},2).to({state:[{t:this.instance_14}]},2).to({state:[{t:this.instance_14}]},4).to({state:[{t:this.instance_14}]},2).to({state:[{t:this.instance_14}]},2).to({state:[{t:this.instance_14}]},40).to({state:[{t:this.instance_14}]},2).to({state:[{t:this.instance_14}]},2).to({state:[{t:this.instance_14}]},59).to({state:[{t:this.instance_14}]},4).to({state:[{t:this.instance_14}]},2).to({state:[{t:this.instance_14}]},2).to({state:[{t:this.instance_14}]},2).to({state:[{t:this.instance_14}]},6).wait(6));
	this.timeline.addTween(cjs.Tween.get(this.instance_14).wait(9).to({_off:false},0).to({y:517.3},8).wait(2).to({regY:41.5,scaleX:1.07,scaleY:0.95,rotation:0,skewX:6.8,skewY:6.3,x:444.4,y:518.8},0).wait(2).to({regX:78.9,scaleX:1.08,scaleY:0.93,skewX:7.1,x:444.3,y:520.1},0).wait(2).to({regX:78.5,regY:41.9,scaleX:1.07,scaleY:0.95,skewX:6.8,x:444.2,y:519.1},0).wait(2).to({regX:78.7,regY:41.6,scaleX:1.06,scaleY:0.95,skewY:6.5,x:444.6,y:518.2},0).wait(2).to({regX:78.4,regY:41.4,scaleX:1.05,scaleY:0.96,rotation:6.7,skewX:0,skewY:0,y:517.3},0).to({_off:true},10).wait(308).to({_off:false,regX:79.5,regY:41.9,scaleX:1.06,rotation:0,skewX:6.6,skewY:6.3,x:445.6,y:518.4},0).wait(2).to({regY:42.5,scaleX:1.07,skewY:5.8,y:519.5},0).wait(2).to({regY:42.1,scaleX:1.1,skewX:6.7,skewY:5.1,x:445.7,y:520.2},0).to({_off:true},2).wait(55).to({_off:false},0).to({_off:true},2).wait(55).to({_off:false,regX:78.4,regY:41.4,scaleX:1.05,rotation:6.7,skewX:0,skewY:0,x:444.6,y:517.3},0).wait(6).to({regX:79.5,regY:41.9,scaleX:1.06,rotation:0,skewX:6.6,skewY:6.3,x:445.6,y:518.4},0).wait(2).to({regY:42.5,scaleX:1.07,skewY:5.8,y:519.5},0).wait(2).to({regY:42.1,scaleX:1.1,skewX:6.7,skewY:5.1,x:445.7,y:520.2},0).wait(2).to({regY:42.2,scaleX:1.05,rotation:6.6,skewX:0,skewY:0,x:445.5,y:518.2},0).wait(2).to({regX:79,regY:41.2,scaleX:1.03,rotation:6.5,x:447.3,y:516.1},0).wait(2).to({regX:79.4,regY:42.1,scaleX:1,rotation:6.7,x:449.8,y:516},0).wait(4).to({regX:79.5,scaleX:1.03,rotation:6.6,x:447.7,y:517.1},0).wait(2).to({regX:79.4,regY:42,scaleX:1.04,x:446.6,y:517.6},0).wait(2).to({regX:78.4,regY:41.4,scaleX:1.05,rotation:6.7,x:444.6,y:517.3},0).wait(12).to({regX:79.5,regY:42.1,rotation:6.6,x:445.5,y:518.1},0).wait(2).to({regX:78.4,regY:41.4,rotation:6.7,x:444.6,y:517.3},0).wait(2).to({regX:79.5,regY:42.5,scaleX:1.07,rotation:0,skewX:6.6,skewY:5.8,x:445.6,y:519.5},0).wait(2).to({regX:79.4,regY:42,scaleX:1.05,rotation:6.5,skewX:0,skewY:0,x:445.5,y:518.1},0).wait(2).to({scaleX:1.06,x:445.6,y:518.2},0).wait(2).to({scaleX:1.07},0).wait(2).to({regX:79.8,regY:42.5,scaleX:1.09,rotation:6.7,x:445.9,y:518.6},0).wait(2).to({regX:80.4,scaleX:1.08,rotation:6.6,x:446.5},0).wait(2).to({regX:79.5,scaleX:1.07,x:445.6,y:518.5},0).wait(2).to({regX:81,regY:41.6,scaleX:1.07,rotation:6.7,x:447.3,y:517.8},0).to({_off:true},44).wait(6).to({_off:false,regX:78.4,regY:41.4,scaleX:1.05,x:444.6,y:517.3},0).wait(36).to({regX:79.5,regY:42.2,rotation:6.6,x:445.5,y:518.2},0).wait(2).to({regX:79.4,regY:42.1,scaleX:1.1,rotation:6.7,x:445.6,y:518.1},0).wait(4).to({scaleX:1.07,rotation:6.6},0).wait(2).to({scaleX:1.06,x:445.5,y:518.2},0).wait(2).to({regX:78.4,regY:41.4,scaleX:1.05,rotation:6.7,x:444.6,y:517.3},0).wait(40).to({regX:79.5,regY:42.2,rotation:6.6,x:445.5,y:518.2},0).wait(2).to({regX:78.4,regY:41.4,rotation:6.7,x:444.6,y:517.3},0).wait(65).to({regX:78.5,regY:41.3,rotation:6.6,y:514.3},0).wait(2).to({regX:78.4,regY:41.8,scaleX:1.05,rotation:6.5,x:444.5,y:513.2},0).wait(2).to({regX:78.5,scaleX:1.05,x:444.7,y:512.6},0).wait(2).to({regY:41.4,rotation:6.7,y:511.3},0).to({regX:78.4,x:444.6,y:773.3},6).wait(6));

	// Murray Shirt
	this.instance_31 = new lib.MurrayShirtCollarRight_1();
	this.instance_31.parent = this;
	this.instance_31.setTransform(439.8,667.4,1.128,0.995,0,6,9.3,45.3,15.1);
	this.instance_31._off = true;

	this.instance_32 = new lib.MurrayShorts_017_1();
	this.instance_32.parent = this;
	this.instance_32.setTransform(504.1,808.1,1.021,0.961,-18.7,0,0,80,42.5);
	this.instance_32.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,7);
	this.instance_32._off = true;

	this.instance_33 = new lib.MurrayPalm_079_1();
	this.instance_33.parent = this;
	this.instance_33.setTransform(348.1,468.4,1,1.101,0,-49.2,-45,27.7,18.1);

	this.instance_34 = new lib.MurrayPinky_079_1();
	this.instance_34.parent = this;
	this.instance_34.setTransform(340.3,478,1.09,1.056,0,-153.5,26.5);

	this.instance_35 = new lib.MurrayMiddleFinger_079_1();
	this.instance_35.parent = this;
	this.instance_35.setTransform(359.6,459.4,1,1,0,-172.5,7.5,20.2,12.2);

	this.instance_36 = new lib.MurrayPointerFinger_079_1();
	this.instance_36.parent = this;
	this.instance_36.setTransform(360.1,450.8,1,1.039,0,162.4,-7.4,18.3,10.2);

	this.instance_37 = new lib.MurrayLeftBackHand_337_1();
	this.instance_37.parent = this;
	this.instance_37.setTransform(509.8,428.8,1,1,0,0,0,27.2,28.9);

	this.instance_38 = new lib.MurrayBackHand_337_1();
	this.instance_38.parent = this;
	this.instance_38.setTransform(350.1,412,1,1,0,0,0,31.7,28.9);

	this.instance_39 = new lib.MurrayLeftArm2_0001_1();
	this.instance_39.parent = this;
	this.instance_39.setTransform(346.1,404.3,1.341,1.338,0,-132.5,-146.9,18.7,38.6);

	this.instance_40 = new lib.MurrayPinky_338_1();
	this.instance_40.parent = this;
	this.instance_40.setTransform(318.1,368.2,1,1,0,0,0,21.8,18.2);

	this.instance_41 = new lib.MurrayMiddleFinger_338_1();
	this.instance_41.parent = this;
	this.instance_41.setTransform(323.8,356.8,1,1,0,0,0,22.6,11.9);

	this.instance_42 = new lib.MurrayThumb_338_1();
	this.instance_42.parent = this;
	this.instance_42.setTransform(331.9,377.6,1,1,0,0,0,23.9,9.6);

	this.instance_43 = new lib.MurrayPointerFinger_338_1();
	this.instance_43.parent = this;
	this.instance_43.setTransform(335.7,349.2,1,1,0,0,0,23.9,8.7);

	this.instance_44 = new lib.MurrayLeftPinky_338_1();
	this.instance_44.parent = this;
	this.instance_44.setTransform(560.1,379.2,1,1,0,0,0,15.6,21.6);

	this.instance_45 = new lib.MurrayLeftMiddleFinger_338_1();
	this.instance_45.parent = this;
	this.instance_45.setTransform(550,364.1,1,1,0,0,0,15.2,14.1);

	this.instance_46 = new lib.MurrayleftThumb_338_1();
	this.instance_46.parent = this;
	this.instance_46.setTransform(539.5,365.3,1,1,0,0,0,26.4,28.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_31}]},9).to({state:[{t:this.instance_31}]},8).to({state:[{t:this.instance_31}]},2).to({state:[{t:this.instance_31}]},2).to({state:[{t:this.instance_31}]},2).to({state:[{t:this.instance_31}]},2).to({state:[{t:this.instance_31}]},2).to({state:[{t:this.instance_32}]},10).to({state:[{t:this.instance_32}]},2).to({state:[{t:this.instance_32}]},2).to({state:[{t:this.instance_32}]},2).to({state:[{t:this.instance_32}]},2).to({state:[{t:this.instance_32}]},2).to({state:[{t:this.instance_32}]},24).to({state:[{t:this.instance_32}]},2).to({state:[{t:this.instance_32}]},2).to({state:[{t:this.instance_32}]},2).to({state:[{t:this.instance_32}]},62).to({state:[{t:this.instance_32}]},2).to({state:[{t:this.instance_32}]},2).to({state:[{t:this.instance_32}]},2).to({state:[{t:this.instance_32}]},36).to({state:[{t:this.instance_32}]},2).to({state:[{t:this.instance_32}]},2).to({state:[{t:this.instance_32}]},2).to({state:[]},64).to({state:[{t:this.instance_36},{t:this.instance_35},{t:this.instance_34},{t:this.instance_33}]},48).to({state:[]},2).to({state:[{t:this.instance_31}]},44).to({state:[{t:this.instance_31}]},2).to({state:[{t:this.instance_31}]},2).to({state:[]},2).to({state:[{t:this.instance_31}]},55).to({state:[]},2).to({state:[{t:this.instance_39},{t:this.instance_38},{t:this.instance_37}]},67).to({state:[{t:this.instance_46},{t:this.instance_45},{t:this.instance_44},{t:this.instance_43},{t:this.instance_42},{t:this.instance_41},{t:this.instance_40}]},2).to({state:[]},2).to({state:[{t:this.instance_31}]},241).to({state:[{t:this.instance_31}]},2).to({state:[{t:this.instance_31}]},2).to({state:[{t:this.instance_31}]},2).to({state:[{t:this.instance_31}]},6).wait(6));
	this.timeline.addTween(cjs.Tween.get(this.instance_31).wait(9).to({_off:false},0).to({y:414.5},8).wait(2).to({regX:45,regY:15,scaleX:1.14,scaleY:0.98,skewY:9,x:439,y:417.2},0).wait(2).to({regX:45.4,regY:15.2,scaleX:1.16,scaleY:0.96,skewX:6.3,skewY:8.8,x:438.9,y:420.3},0).wait(2).to({regX:44.9,regY:15,scaleX:1.14,scaleY:0.98,skewX:6,skewY:9,y:417.2},0).wait(2).to({regX:45.2,regY:15.2,scaleX:1.14,scaleY:0.99,skewY:9.1,x:439.5,y:415.9},0).wait(2).to({regX:45.3,regY:15.1,scaleX:1.13,scaleY:1,skewY:9.3,x:439.8,y:414.5},0).to({_off:true},10).wait(308).to({_off:false,regX:46,regY:14.8,scaleX:1.14,scaleY:0.99,skewY:10.3,x:440.4,y:415.5},0).wait(2).to({regX:45.4,regY:15.2,scaleX:1.15,scaleY:0.98,skewY:11.3,x:439.6,y:417},0).wait(2).to({regX:45.3,scaleX:1.18,scaleY:0.97,skewX:6.4,skewY:13.5,x:439.1,y:419.3},0).to({_off:true},2).wait(55).to({_off:false},0).to({_off:true},2).wait(312).to({_off:false,regX:45.1,regY:15.5,scaleX:1.13,scaleY:0.99,skewX:5.8,skewY:9.3,x:439.6,y:411.9},0).wait(2).to({regX:45.5,regY:15.6,x:440,y:410.5},0).wait(2).to({regX:45.3,regY:15.1,x:439.9,y:409.3},0).wait(2).to({scaleX:1.13,scaleY:1,skewX:6,x:439.8,y:408.5},0).to({regX:45.2,x:439.7,y:670.4},6).wait(6));
	this.timeline.addTween(cjs.Tween.get(this.instance_32).wait(37).to({_off:false},0).wait(2).to({regX:80.4,regY:42.6,rotation:-5.8,x:473.7,y:664.5},0).wait(2).to({regX:80.2,regY:42.8,rotation:0.3,x:458.2,y:593},0).wait(2).to({regX:80.3,regY:42.5,rotation:3.5,x:450.6,y:556.7},0).wait(2).to({regX:79.9,regY:42.6,scaleX:1.02,rotation:5,x:446.2,y:538.7},0).wait(2).to({regX:80,regY:42.5,scaleX:1.02,rotation:6.7,x:446.3,y:518.1},0).wait(24).to({regX:79.2,regY:42.4,rotation:7.1,x:441.1,y:520.3},0).wait(2).to({regX:79.9,regY:42.2,rotation:7.6,x:441,y:519.8},0).wait(2).to({regX:79.8,regY:42.6,scaleX:1.02,rotation:8,x:440.1},0).wait(2).to({regX:79.9,regY:42.3,scaleX:1.02,rotation:8.7,x:439.3,y:519.1},0).wait(62).to({regX:79.8,regY:42.6,scaleX:1.02,rotation:8,x:440.1,y:519.8},0).wait(2).to({regX:79.9,regY:42.2,scaleX:1.02,rotation:7.6,x:441},0).wait(2).to({regX:79.2,regY:42.4,rotation:7.1,x:441.1,y:520.3},0).wait(2).to({regX:80,regY:42.5,rotation:6.7,x:442.6,y:520.9},0).wait(36).to({regY:42.2,scaleX:1.02,rotation:8,x:442.1,y:520.2},0).wait(2).to({regX:80.7,regY:43.1,rotation:9.3,x:442,y:520.7},0).wait(2).to({regX:81,regY:41.9,rotation:10.5,x:441.8,y:519.1},0).wait(2).to({regX:79.9,regY:42.3,scaleX:1.02,rotation:11.9,x:440.2,y:518.8},0).to({_off:true},64).wait(487));

	// Murray Shirt
	this.instance_47 = new lib.MurrayShirtButton1_1();
	this.instance_47.parent = this;
	this.instance_47.setTransform(445,709.4,1.006,0.985,0,8.6,11.5,2.2,2);
	this.instance_47._off = true;

	this.instance_48 = new lib.MurrayShorts_017_1();
	this.instance_48.parent = this;
	this.instance_48.setTransform(440.1,519.8,1.02,0.961,8,0,0,79.8,42.6);
	this.instance_48._off = true;

	this.instance_49 = new lib.MurrayShorts_007();
	this.instance_49.parent = this;
	this.instance_49.setTransform(444.5,518.4,1.021,0.961,4.3,0,0,79.9,42.6);

	this.instance_50 = new lib.MurrayShorts_005();
	this.instance_50.parent = this;
	this.instance_50.setTransform(445.1,517.1,1.021,0.961,5.1,0,0,79.9,42.3);

	this.instance_51 = new lib.MurrayShorts_004();
	this.instance_51.parent = this;
	this.instance_51.setTransform(445.5,516,1.02,0.961,5.8,0,0,79.9,42.2);

	this.instance_52 = new lib.MurrayShorts_001_2();
	this.instance_52.parent = this;
	this.instance_52.setTransform(446,515,1.021,0.961,6.7,0,0,79.8,42.2);
	this.instance_52._off = true;

	this.instance_53 = new lib.MurrayShirtCollarRight_1();
	this.instance_53.parent = this;
	this.instance_53.setTransform(439.8,414.5,1.128,0.995,0,6,9.3,45.3,15.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_47}]},9).to({state:[{t:this.instance_47}]},8).to({state:[{t:this.instance_47}]},2).to({state:[{t:this.instance_47}]},2).to({state:[{t:this.instance_47}]},2).to({state:[{t:this.instance_47}]},2).to({state:[{t:this.instance_47}]},2).to({state:[]},10).to({state:[{t:this.instance_48}]},214).to({state:[{t:this.instance_48}]},2).to({state:[{t:this.instance_48}]},2).to({state:[{t:this.instance_48}]},2).to({state:[{t:this.instance_49}]},2).to({state:[{t:this.instance_50}]},2).to({state:[{t:this.instance_51}]},2).to({state:[{t:this.instance_52}]},2).to({state:[{t:this.instance_52}]},34).to({state:[{t:this.instance_52}]},2).to({state:[{t:this.instance_52}]},2).to({state:[{t:this.instance_52}]},2).to({state:[{t:this.instance_52}]},2).to({state:[{t:this.instance_47}]},38).to({state:[{t:this.instance_47}]},2).to({state:[{t:this.instance_47}]},2).to({state:[{t:this.instance_52}]},2).to({state:[{t:this.instance_52}]},4).to({state:[{t:this.instance_52}]},2).to({state:[{t:this.instance_52}]},2).to({state:[{t:this.instance_52}]},39).to({state:[{t:this.instance_52}]},2).to({state:[{t:this.instance_52}]},2).to({state:[{t:this.instance_47}]},4).to({state:[{t:this.instance_52}]},2).to({state:[{t:this.instance_52}]},2).to({state:[]},2).to({state:[{t:this.instance_53}]},304).to({state:[{t:this.instance_47}]},4).to({state:[{t:this.instance_47}]},2).to({state:[{t:this.instance_47}]},2).to({state:[{t:this.instance_47}]},2).to({state:[{t:this.instance_47}]},6).wait(6));
	this.timeline.addTween(cjs.Tween.get(this.instance_47).wait(9).to({_off:false},0).to({y:456.5},8).wait(2).to({regX:2.1,regY:1.6,scaleX:1.02,scaleY:0.97,skewX:8.8,skewY:11.1,x:444.5,y:458.4},0).wait(2).to({regX:2.2,regY:2.2,scaleX:1.03,scaleY:0.96,skewX:9.1,skewY:10.9,x:444.1,y:461.1},0).wait(2).to({regX:3.2,regY:0.4,scaleX:1.02,scaleY:0.97,skewX:8.8,skewY:11.1,x:445.8,y:457.4},0).wait(2).to({regX:2.2,regY:2,scaleX:1.01,scaleY:0.98,skewX:8.6,skewY:11.3,x:444.7,y:457.5},0).wait(2).to({scaleX:1.01,scaleY:0.99,skewY:11.5,x:445,y:456.5},0).to({_off:true},10).wait(308).to({_off:false,scaleX:1.01,scaleY:0.98,skewY:11.3,x:444.9,y:457.5},0).wait(2).to({regX:2,regY:0.6,scaleX:1.02,scaleY:0.97,skewX:8.8,skewY:11,x:444.8,y:457},0).wait(2).to({regX:2.2,regY:2,scaleX:1.05,scaleY:0.96,skewX:9.2,skewY:10.8,x:444.6,y:460.2},0).to({_off:true},2).wait(55).to({_off:false},0).to({_off:true},2).wait(312).to({_off:false,scaleX:1,scaleY:0.99,skewX:8.5,skewY:11.5,x:445,y:453.3},0).wait(2).to({scaleY:0.98,y:451.8},0).wait(2).to({regX:1.9,regY:2.2,scaleY:0.99,x:444.7,y:451.1},0).wait(2).to({regX:2.5,regY:1.2,scaleX:1.01,skewX:8.6,x:445.4,y:449.7},0).to({regX:2.2,regY:1.4,x:445.1,y:711.8},6).wait(6));
	this.timeline.addTween(cjs.Tween.get(this.instance_48).wait(251).to({_off:false},0).wait(2).to({regX:79.9,regY:42.2,scaleX:1.02,rotation:7.6,x:441},0).wait(2).to({regX:-9.9,regY:69.2,rotation:0,skewX:7.1,skewY:6.5,x:347.7,y:534.7},0).wait(2).to({regX:80.5,regY:42.4,rotation:5.6,skewX:0,skewY:0,x:444,y:519.2},0).to({_off:true},2).wait(479));
	this.timeline.addTween(cjs.Tween.get(this.instance_52).wait(265).to({_off:false},0).wait(34).to({regX:79.3,regY:42.4,scaleX:1.03,rotation:6.6,x:445.4,y:516.9},0).wait(2).to({regX:79.5,regY:42.5,scaleX:1.07,rotation:0,skewX:6.6,skewY:5.8,x:445.6,y:519.5},0).wait(2).to({regY:41.9,scaleX:1.06,skewY:6.3,y:518.4},0).wait(2).to({regX:78.4,regY:41.4,scaleX:1.05,rotation:6.7,skewX:0,skewY:0,x:444.6,y:517.3},0).wait(2).to({_off:true},38).wait(6).to({_off:false,regX:79.8,regY:42.2,scaleX:1.02,rotation:0,x:443.1,y:508.2},0).wait(4).to({regX:79.2,regY:42,x:442,y:509.5},0).wait(2).to({regX:79.5,regY:42.2,y:510.5},0).wait(2).to({regX:79.8,x:442.1,y:511.2},0).wait(39).to({regX:79.5,x:442,y:510.5},0).wait(2).to({regX:79.2,regY:42,y:509.5},0).wait(2).to({regX:79.8,regY:42.2,x:443.1,y:508.2},0).to({_off:true},4).wait(2).to({_off:false,regX:79.5,regY:42.5,scaleX:1.07,skewX:6.6,skewY:5.8,x:445.6,y:519.5},0).wait(2).to({regY:41.9,scaleX:1.06,skewY:6.3,y:518.4},0).to({_off:true},2).wait(326));

	// Layer 148
	this.instance_54 = new lib.MurrayShirtButton1_1();
	this.instance_54.parent = this;
	this.instance_54.setTransform(445.5,693,1.006,0.985,0,8.6,11.5,2.4,2.1);
	this.instance_54._off = true;

	this.instance_55 = new lib.MurrayPalm_079_1();
	this.instance_55.parent = this;
	this.instance_55.setTransform(377,416.5,1,1,-30,0,0,26.5,17.5);

	this.instance_56 = new lib.MurrayPinky_079_1();
	this.instance_56.parent = this;
	this.instance_56.setTransform(397.3,427.1,1,1,-30,0,0,14.2,14.8);

	this.instance_57 = new lib.MurrayMiddleFinger_079_1();
	this.instance_57.parent = this;
	this.instance_57.setTransform(401.5,410.1,1,1,-30,0,0,20.6,12);

	this.instance_58 = new lib.MurrayArm1_002_1();
	this.instance_58.parent = this;
	this.instance_58.setTransform(357.2,432.5,1.34,0.921,0,-99.5,-104.3,32.6,37);

	this.instance_59 = new lib.MurrayPointerFinger_079_1();
	this.instance_59.parent = this;
	this.instance_59.setTransform(403.6,399.4,1,1,-30,0,0,18.4,10.1);

	this.instance_60 = new lib.MurrayShorts_001_2();
	this.instance_60.parent = this;
	this.instance_60.setTransform(444.6,517.3,1.049,0.961,6.7,0,0,78.4,41.4);

	this.instance_61 = new lib.neckPatc_1();
	this.instance_61.parent = this;
	this.instance_61.setTransform(535.6,478.4,0.826,0.826,0,0,0,12.9,15.5);

	this.instance_62 = new lib.MurrayLeftThumb_110_1();
	this.instance_62.parent = this;
	this.instance_62.setTransform(546.9,478.3,1,1,0,0,0,14.2,12.7);

	this.instance_63 = new lib.MurrayPointerFinger_108_1();
	this.instance_63.parent = this;
	this.instance_63.setTransform(567.6,474.5,1,1,0,0,180,16.9,15.8);

	this.instance_64 = new lib.MurrayMiddleFinger_108_1();
	this.instance_64.parent = this;
	this.instance_64.setTransform(580.8,483.7,1,1,0,15,-165,15.4,14.8);

	this.instance_65 = new lib.MurrayPinky_108_1();
	this.instance_65.parent = this;
	this.instance_65.setTransform(595.5,475.7,1,1,0,0,180,15,12.7);

	this.instance_66 = new lib.MurrayLeftPalm_108_1();
	this.instance_66.parent = this;
	this.instance_66.setTransform(563.2,480,1,1,0,0,0,24.5,16.3);

	this.instance_67 = new lib.forearm_001_1();
	this.instance_67.parent = this;
	this.instance_67.setTransform(562.1,483.5,1.089,0.782,0,-15.2,-23.9,22.8,4);

	this.instance_68 = new lib.MurrayShirtCollarRight_1();
	this.instance_68.parent = this;
	this.instance_68.setTransform(439.8,414.5,1.128,0.995,0,6,9.3,45.3,15.1);
	this.instance_68._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_54}]},9).to({state:[{t:this.instance_54}]},8).to({state:[{t:this.instance_54}]},2).to({state:[{t:this.instance_54}]},2).to({state:[{t:this.instance_54}]},2).to({state:[{t:this.instance_54}]},2).to({state:[{t:this.instance_54}]},2).to({state:[]},10).to({state:[{t:this.instance_59},{t:this.instance_58},{t:this.instance_57},{t:this.instance_56},{t:this.instance_55}]},228).to({state:[]},34).to({state:[{t:this.instance_60}]},113).to({state:[]},51).to({state:[{t:this.instance_67},{t:this.instance_66},{t:this.instance_65},{t:this.instance_64},{t:this.instance_63},{t:this.instance_62},{t:this.instance_61}]},100).to({state:[]},2).to({state:[{t:this.instance_68}]},36).to({state:[{t:this.instance_68}]},2).to({state:[{t:this.instance_68}]},2).to({state:[{t:this.instance_68}]},4).to({state:[{t:this.instance_68}]},2).to({state:[{t:this.instance_68}]},2).to({state:[{t:this.instance_68}]},40).to({state:[{t:this.instance_68}]},2).to({state:[{t:this.instance_68}]},2).to({state:[{t:this.instance_54}]},59).to({state:[]},4).wait(18));
	this.timeline.addTween(cjs.Tween.get(this.instance_54).wait(9).to({_off:false},0).to({y:440.1},8).wait(2).to({scaleX:1.02,scaleY:0.97,skewX:8.8,skewY:11.1,x:445.1,y:442.6},0).wait(2).to({regY:2.2,scaleX:1.03,scaleY:0.96,skewX:9.1,skewY:10.9,x:444.7,y:445.1},0).wait(2).to({regX:3.3,regY:3.1,scaleX:1.02,scaleY:0.97,skewX:8.8,skewY:11.1,x:445.9,y:443.7},0).wait(2).to({regX:3.4,regY:0.7,scaleX:1.01,scaleY:0.98,skewX:8.6,skewY:11.3,x:446.5,y:440.2},0).wait(2).to({regX:2.4,regY:2.1,scaleX:1.01,scaleY:0.99,skewY:11.5,x:445.5,y:440.1},0).to({_off:true},10).wait(679).to({_off:false,regX:2.2,regY:2,x:445,y:456.5},0).to({_off:true},4).wait(18));
	this.timeline.addTween(cjs.Tween.get(this.instance_68).wait(601).to({_off:false},0).wait(2).to({regX:46,regY:15,scaleX:1.13,scaleY:0.99,skewX:5.8,x:440.6,y:412.6},0).wait(2).to({regX:45.3,regY:15.2,scaleX:1.16,scaleY:0.98,skewX:6.2,skewY:8.9,x:439.1,y:412.1},0).wait(4).to({regX:45.5,scaleX:1.14,scaleY:0.99,skewX:6,skewY:9,x:439.6,y:411.1},0).wait(2).to({regX:44.2,regY:14.5,scaleX:1.14,scaleY:0.99,skewY:9.1,x:438.4,y:409.6},0).wait(2).to({regX:45.4,regY:15.8,scaleX:1.13,scaleY:1,skewY:9.3,x:439.8,y:410.7},0).wait(40).to({regX:46,regY:15,scaleX:1.13,scaleY:0.99,skewX:5.8,x:440.6,y:412.6},0).wait(2).to({regX:45.3,regY:15.1,scaleX:1.13,scaleY:1,skewX:6,x:439.8,y:414.5},0).wait(2).to({_off:true},59).wait(22));

	// forearm_003
	this.instance_69 = new lib.MurrayShirtButton1_1();
	this.instance_69.parent = this;
	this.instance_69.setTransform(445.3,677.4,1.006,0.985,0,8.6,11.5,2.1,1.9);
	this.instance_69._off = true;

	this.instance_70 = new lib.MurrayShirtCollarRight_1();
	this.instance_70.parent = this;
	this.instance_70.setTransform(432.6,727.2,0.687,1.035,0,13.7,-6.7,45,14.9);
	this.instance_70.shadow = new cjs.Shadow("rgba(0,0,0,1)",-1,3,9);
	this.instance_70._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_69).wait(9).to({_off:false},0).to({y:424.5},8).wait(2).to({regX:2.3,regY:1.8,scaleX:1.02,scaleY:0.97,skewX:8.8,skewY:11.1,x:445.2,y:427.2},0).wait(2).to({regX:2.1,regY:1.9,scaleX:1.03,scaleY:0.96,skewX:9.1,skewY:10.9,x:444.5,y:429.9},0).wait(2).to({regX:3.1,regY:1.8,scaleX:1.02,scaleY:0.97,skewX:8.8,skewY:11.1,x:445.9,y:427.3},0).wait(2).to({regX:2.4,regY:1.9,scaleX:1.01,scaleY:0.98,skewX:8.6,skewY:11.3,x:445.3,y:425.9},0).wait(2).to({regX:2.1,scaleX:1.01,scaleY:0.99,skewY:11.5,y:424.5},0).to({_off:true},10).wait(308).to({_off:false,regX:2.5,regY:2.4,scaleX:1.01,scaleY:0.98,skewY:11.3,x:445.5,y:441.4},0).wait(2).to({regX:1.9,regY:1.9,scaleX:1.02,scaleY:0.97,skewX:8.8,skewY:11,x:444.8,y:441.9},0).wait(2).to({regX:2.4,regY:2.1,scaleX:1.05,scaleY:0.96,skewX:9.2,skewY:10.8,x:445.1,y:444.2},0).to({_off:true},2).wait(55).to({_off:false},0).to({_off:true},2).wait(193).to({_off:false,regX:2.2,regY:2,scaleX:1.01,scaleY:0.99,skewX:8.6,skewY:11.5,x:445,y:456.5},0).wait(2).to({scaleX:1,skewX:8.5,x:444.9,y:454.5},0).wait(2).to({regY:1.9,scaleX:1.03,scaleY:0.97,skewX:9,skewY:11,x:444.5,y:453.2},0).wait(4).to({regY:2,scaleX:1.02,scaleY:0.98,skewX:8.8,skewY:11.3,x:444.7,y:452.7},0).wait(2).to({regY:1.9,scaleX:1.01,scaleY:0.98,skewX:8.5,x:444.9,y:452.2},0).wait(2).to({regX:7.4,regY:-1.5,scaleX:1.01,scaleY:0.99,skewX:8.6,skewY:11.5,x:450.6,y:449.6},0).wait(40).to({regX:2.2,regY:2,scaleX:1,skewX:8.5,x:444.9,y:454.5},0).wait(2).to({scaleX:1.01,skewX:8.6,x:445,y:456.5},0).wait(2).to({_off:true},59).wait(4).to({_off:false,regY:2.1,scaleX:1,skewX:8.5,x:445.3,y:437.1},0).wait(2).to({regX:2.8,scaleY:0.98,x:446,y:435.7},0).wait(2).to({regX:1.9,scaleY:0.99,x:445.1,y:434.7},0).wait(2).to({regX:2.4,scaleX:1.01,skewX:8.6,x:445.5,y:434.1},0).to({y:696},6).wait(6));
	this.timeline.addTween(cjs.Tween.get(this.instance_70).wait(37).to({_off:false},0).wait(2).to({scaleY:1.03,skewX:26.3,skewY:6,x:422.8,y:572.2},0).wait(2).to({regX:44.9,regY:15,scaleY:1.03,skewX:32.6,skewY:12.3,x:417.8,y:494.7},0).wait(2).to({regX:45,regY:14.8,scaleX:0.69,scaleY:1.03,skewX:35.9,skewY:15.5,x:415.4,y:455.8},0).wait(2).to({scaleY:1.03,skewX:37.4,skewY:17,x:414.2,y:436.4},0).wait(2).to({regY:14.9,scaleX:0.69,scaleY:1.03,skewX:39.1,skewY:18.7,x:416.5,y:414.3},0).wait(24).to({regX:44.1,regY:14.8,scaleX:0.69,scaleY:1.03,skewX:39.6,skewY:19.1,x:412.4,y:416.2},0).wait(2).to({regX:45.1,skewX:40.1,skewY:19.6,x:413.1,y:415.8},0).wait(2).to({regX:45.3,regY:15,scaleY:1.03,skewX:40.6,skewY:20.1,x:413.2,y:415.4},0).wait(2).to({regX:45.1,regY:14.8,scaleX:0.69,scaleY:1.03,skewX:41.1,skewY:20.7,x:413.3,y:414.5},0).wait(62).to({regX:45.3,regY:15,scaleX:0.69,scaleY:1.03,skewX:40.6,skewY:20.1,x:413.2,y:415.4},0).wait(2).to({regX:45.1,regY:14.8,scaleY:1.03,skewX:40.1,skewY:19.6,x:413.1,y:415.8},0).wait(2).to({regX:44.1,skewX:39.6,skewY:19.1,x:412.4,y:416.2},0).wait(2).to({regX:45,regY:14.9,scaleX:0.69,scaleY:1.03,skewX:39.1,skewY:18.7,x:412.9,y:417.1},0).wait(36).to({regX:45.1,regY:15.2,scaleX:0.69,scaleY:1.03,skewX:40.4,skewY:20,x:414.6,y:416.2},0).wait(2).to({regX:44.7,regY:15.1,skewX:41.6,skewY:21.3,x:416.2,y:415.1},0).wait(2).to({regX:46.9,regY:13.7,skewX:42.9,skewY:22.5,x:420.3,y:413.5},0).wait(2).to({regX:45.1,regY:14.8,scaleX:0.69,scaleY:1.03,skewX:44.3,skewY:23.9,x:420,y:412.9},0).wait(64).to({regX:45.3,regY:15,scaleX:0.69,scaleY:1.03,skewX:40.6,skewY:20.1,x:413.2,y:415.4},0).wait(2).to({regX:45.1,regY:14.8,scaleY:1.03,skewX:40.1,skewY:19.6,x:413.1,y:415.8},0).wait(2).to({regX:44.1,skewX:39.6,skewY:19.1,x:412.4,y:416.2},0).wait(2).to({regX:44.4,regY:15.3,scaleX:0.69,scaleY:1.02,skewX:39.4,skewY:19.7,x:415,y:415.8},0).wait(2).to({regX:45,regY:14.9,scaleX:0.73,scaleY:1.02,skewX:36.1,skewY:19,x:423.3,y:412.9},0).wait(2).to({regX:45.2,regY:15.1,scaleX:0.77,scaleY:1.02,skewX:32.8,skewY:18.3,x:432.3,y:410.1},0).wait(2).to({regX:45.3,regY:15.2,scaleX:0.82,scaleY:1.01,skewX:28.6,skewY:17.3,x:441.7,y:408},0).wait(2).to({regX:45,scaleX:0.86,scaleY:1,skewX:24.4,skewY:16.2,x:451.3,y:405.5},0).wait(34).to({regX:44.6,regY:15.3,scaleX:1,scaleY:1,skewX:15.1,skewY:12.8,x:445.1,y:410},0).wait(2).to({regX:45.4,regY:15.2,scaleX:1.15,scaleY:0.98,skewX:6,skewY:11.3,x:439.6,y:417},0).wait(2).to({regX:46,regY:14.8,scaleX:1.14,scaleY:0.99,skewY:10.3,x:440.4,y:415.5},0).wait(2).to({regX:45.3,regY:15.1,scaleX:1.13,scaleY:1,skewY:9.3,x:439.8,y:414.5},0).wait(2).to({_off:true},38).wait(6).to({_off:false,regX:45.1,scaleX:1,scaleY:1.04,skewX:0.3,skewY:0,x:425.7,y:398.5},0).wait(4).to({regX:52.3,scaleY:1.02,skewX:0,x:432.5,y:401.6},0).wait(2).to({regX:45.1,regY:15.6,scaleY:1.01,x:425.2,y:403.6},0).wait(2).to({regY:15.1,scaleY:1,x:424.9,y:404.6},0).wait(39).to({regY:15.6,scaleY:1.01,x:425.2,y:403.6},0).wait(2).to({regX:52.4,regY:15.1,scaleY:1.02,x:432.6,y:401.6},0).wait(2).to({regX:45.1,scaleY:1.04,skewX:0.3,x:425.7,y:398.5},0).to({_off:true},4).wait(2).to({_off:false,regX:45.4,regY:15.2,scaleX:1.15,scaleY:0.98,skewX:6,skewY:11.3,x:439.6,y:417},0).wait(2).to({regX:46,regY:14.8,scaleX:1.14,scaleY:0.99,skewY:10.3,x:440.4,y:415.5},0).to({_off:true},2).wait(51).to({_off:false,regX:45.3,regY:15.1,scaleX:1.13,scaleY:1,skewY:9.3,x:439.8,y:414.5},0).wait(6).to({regX:46,regY:14.8,scaleX:1.14,scaleY:0.99,skewY:10.3,x:440.4,y:415.5},0).wait(2).to({regX:45.4,regY:15.2,scaleX:1.15,scaleY:0.98,skewY:11.3,x:439.6,y:417},0).wait(2).to({regX:45.3,scaleX:1.18,scaleY:0.97,skewX:6.4,skewY:13.5,x:439.1,y:419.3},0).wait(2).to({regX:44.9,regY:14.7,scaleX:1.12,scaleY:1.03,skewX:6,skewY:9.8,x:440.7,y:406.3},0).wait(2).to({regX:45.2,regY:15.1,scaleX:1.11,scaleY:1.05,skewY:10,x:441.6,y:402.9},0).wait(2).to({regY:15,scaleX:1.16,scaleY:1.07,skewX:6.6,skewY:10.7,x:441.9,y:396},0).wait(4).to({regX:45.3,regY:15.1,scaleX:1.13,skewX:6.3,skewY:10.3,x:442.1,y:397.6},0).wait(2).to({regX:45.5,scaleX:1.12,scaleY:1.07,x:442.3,y:398.3},0).wait(2).to({regX:44.5,regY:14.6,scaleX:1.11,skewY:10.2,x:441.3,y:398.4},0).wait(12).to({regX:45.2,regY:15,scaleX:1.11,scaleY:1.05,skewX:6,skewY:10,x:441.4,y:402.8},0).wait(2).to({regX:45,regY:15.2,scaleX:1.12,scaleY:1.03,skewY:9.8,x:440.6,y:406.8},0).wait(2).to({regX:45.4,scaleX:1.15,scaleY:0.98,skewY:11.3,x:439.6,y:417},0).wait(2).to({regX:44.1,regY:17.1,scaleX:1.13,scaleY:0.99,skewX:5.8,skewY:9.3,x:438.3,y:417.1},0).wait(2).to({regX:45.1,regY:14.7,scaleX:1.14,skewY:9,x:439.6,y:416.9},0).wait(2).to({regX:43.9,regY:15.7,scaleX:1.16,skewX:6,x:438.2,y:419.7},0).wait(2).to({regX:45.2,regY:15.2,scaleX:1.18,scaleY:1,skewX:6.3,skewY:8.9,x:439.8,y:423.5},0).wait(2).to({regX:45.1,regY:15.5,scaleX:1.17,skewX:6,skewY:9,x:439.5,y:422.9},0).wait(2).to({regY:15.2,scaleX:1.16,y:422},0).wait(2).to({regX:45.2,scaleX:1.15,skewX:6.1,skewY:9.1,y:421.5},0).to({_off:true},44).wait(6).to({_off:false,regX:45.3,regY:15.1,scaleX:1.13,skewX:6,skewY:9.3,x:439.8,y:414.5},0).wait(26).to({_off:true},8).wait(137));

	// forearm_003
	this.instance_71 = new lib.MurrayPatch_1();
	this.instance_71.parent = this;
	this.instance_71.setTransform(476.6,702.2,1.492,1.492,6,0,0,11.8,6.2);
	this.instance_71._off = true;

	this.instance_72 = new lib.MurrayShirtButton1_1();
	this.instance_72.parent = this;
	this.instance_72.setTransform(446.2,759.7,0.995,0.995,-13.2,0,0,0.9,1.6);
	this.instance_72.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,2);
	this.instance_72._off = true;

	this.instance_73 = new lib.MurrayShirtCollarRight_1();
	this.instance_73.parent = this;
	this.instance_73.setTransform(439.8,414.5,1.128,0.995,0,6,9.3,45.3,15.1);

	this.instance_74 = new lib.MurrayShorts_001_2();
	this.instance_74.parent = this;
	this.instance_74.setTransform(444.6,518.1,1.051,0.991,6.6,0,0,78.5,41.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_71}]},9).to({state:[{t:this.instance_71}]},8).to({state:[{t:this.instance_71}]},2).to({state:[{t:this.instance_71}]},2).to({state:[{t:this.instance_71}]},2).to({state:[{t:this.instance_71}]},2).to({state:[{t:this.instance_71}]},2).to({state:[{t:this.instance_72}]},10).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},24).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},62).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},36).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},64).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},34).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},38).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},4).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},39).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},4).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_73}]},2).to({state:[{t:this.instance_72}]},51).to({state:[{t:this.instance_72}]},4).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},4).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},10).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_74,p:{regX:78.5,regY:41.5,scaleX:1.051,scaleY:0.991,rotation:6.6,x:444.6,y:518.1}}]},44).to({state:[{t:this.instance_74,p:{regX:78.4,regY:41.4,scaleX:1.05,scaleY:0.976,rotation:6.5,x:444.5,y:518}}]},2).to({state:[{t:this.instance_74,p:{regX:78.5,regY:41.3,scaleX:1.049,scaleY:0.968,rotation:6.5,x:444.7,y:517.4}}]},2).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},26).to({state:[]},8).to({state:[{t:this.instance_72}]},115).to({state:[{t:this.instance_72}]},4).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},2).to({state:[{t:this.instance_72}]},6).wait(6));
	this.timeline.addTween(cjs.Tween.get(this.instance_71).wait(9).to({_off:false},0).to({regX:11.7,regY:6.5,x:476.4,y:449.6},8).wait(2).to({regX:12.1,regY:6.4,scaleX:1.51,scaleY:1.47,rotation:0,skewX:6,skewY:5.8,x:477.2,y:450.3},0).wait(2).to({regX:11.6,regY:4.2,scaleX:1.54,scaleY:1.45,skewX:6.3,skewY:5.6,x:476.7,y:451},0).wait(2).to({regX:9.6,regY:7.2,scaleX:1.51,scaleY:1.47,skewX:6,skewY:5.8,x:473.1,y:452.7},0).wait(2).to({regX:12.8,scaleX:1.5,scaleY:1.48,x:477.9,y:451.9},0).wait(2).to({regX:11.7,regY:6.5,scaleX:1.49,scaleY:1.49,rotation:6,skewX:0,skewY:0,x:476.4,y:449.6},0).to({_off:true},10).wait(701));
	this.timeline.addTween(cjs.Tween.get(this.instance_72).wait(37).to({_off:false},0).wait(2).to({regX:0.8,regY:1.5,rotation:-0.3,x:428.6,y:605.9},0).wait(2).to({scaleX:0.99,scaleY:0.99,rotation:5.8,x:419.9,y:529.1},0).wait(2).to({regX:1,rotation:9,x:415.7,y:490.7},0).wait(2).to({regX:0.8,regY:1.4,rotation:10.5,x:413.3,y:471.4},0).wait(2).to({regY:1.6,scaleX:1,scaleY:1,rotation:12.2,x:414.8,y:449.4},0).wait(24).to({regX:2.6,regY:2.1,scaleX:0.99,scaleY:0.99,rotation:12.6,x:412.6,y:452.6},0).wait(2).to({regX:2.5,regY:2.4,rotation:13.1,x:412.1,y:452.2},0).wait(2).to({regX:2.1,regY:2.2,scaleX:0.99,scaleY:0.99,rotation:13.5,x:411.6,y:451.3},0).wait(2).to({regX:2,regY:2.1,scaleX:1,scaleY:1,rotation:14.2,x:411.3,y:450.5},0).wait(62).to({regX:2.1,regY:2.2,scaleX:0.99,scaleY:0.99,rotation:13.5,x:411.6,y:451.3},0).wait(2).to({regX:2.5,regY:2.4,scaleX:0.99,scaleY:0.99,rotation:13.1,x:412.1,y:452.2},0).wait(2).to({regX:2.6,regY:2.1,rotation:12.6,x:412.6,y:452.6},0).wait(2).to({regX:0.8,regY:1.6,scaleX:1,scaleY:1,rotation:12.2,x:411.1,y:452.3},0).wait(36).to({regX:2.1,regY:2.1,scaleX:0.99,scaleY:0.99,rotation:13.5,x:413.2,y:452},0).wait(2).to({regX:1.9,regY:1.7,rotation:14.8,x:414.2,y:450.5},0).wait(2).to({regX:2.1,regY:2.1,rotation:16,x:415.2,y:449.8},0).wait(2).to({regX:2.5,regY:2.4,scaleX:1,scaleY:1,rotation:17.4,x:416.4,y:449.1},0).wait(64).to({regX:2.1,regY:2.2,scaleX:0.99,scaleY:0.99,rotation:13.5,x:411.6,y:451.3},0).wait(2).to({regX:2.5,regY:2.4,scaleX:0.99,scaleY:0.99,rotation:13.1,x:412.1,y:452.2},0).wait(2).to({regX:2.6,regY:2.1,rotation:12.6,x:412.6,y:452.6},0).wait(2).to({regX:2.1,regY:2,scaleX:1,scaleY:1,rotation:14.2,x:414.6,y:450.4},0).wait(2).to({regY:2.2,scaleX:0.99,scaleY:1,rotation:0,skewX:14,skewY:13.3,x:423.2,y:448.4},0).wait(2).to({regY:2.1,scaleX:0.99,scaleY:1,skewX:13.8,skewY:12.8,x:431.9,y:445.8},0).wait(2).to({regX:3.2,regY:1.7,scaleX:0.99,scaleY:1,skewY:12,x:443.4,y:443.3},0).wait(2).to({regX:2.4,regY:2.1,scaleX:0.98,scaleY:1.01,skewY:11.4,x:452.6,y:441.1},0).wait(34).to({regY:1.6,scaleX:0.99,scaleY:1,skewX:11,skewY:11.3,x:448.9,y:448.3},0).wait(2).to({regX:2,regY:0.6,scaleX:1.02,scaleY:0.97,skewX:8.8,skewY:11,x:444.8,y:457},0).wait(2).to({regX:2.2,regY:2,scaleX:1.01,scaleY:0.98,skewX:8.6,skewY:11.3,x:444.9,y:457.5},0).wait(2).to({scaleX:1.01,scaleY:0.99,skewY:11.5,x:445,y:456.5},0).wait(40).to({regX:2,regY:1.9,scaleX:1.01,scaleY:0.98,skewY:11.3,x:445.1,y:425.6},0).wait(2).to({regX:1.8,scaleX:1.02,scaleY:0.97,skewX:8.8,skewY:11,x:444.8,y:426.7},0).wait(2).to({regX:1.9,regY:2,scaleX:1.05,scaleY:0.96,skewX:9.2,skewY:10.8,x:444.7,y:429.1},0).wait(2).to({regX:2,regY:1.9,scaleX:1,scaleY:1.04,skewX:0.3,skewY:0,x:435.3,y:441.2},0).wait(4).to({regY:2.9,scaleY:1.02,skewX:0,x:435.1,y:444.4},0).wait(2).to({regY:2,scaleY:1.01,x:435,y:444.5},0).wait(2).to({regX:2.1,regY:1.9,scaleY:1,x:434.8,y:445.5},0).wait(39).to({regX:2,regY:2,scaleY:1.01,x:435,y:444.5},0).wait(2).to({regY:2.9,scaleY:1.02,x:435.1,y:444.4},0).wait(2).to({regY:1.9,scaleY:1.04,skewX:0.3,x:435.3,y:441.2},0).wait(4).to({regX:1.9,regY:2,scaleX:1.05,scaleY:0.96,skewX:9.2,skewY:10.8,x:444.7,y:429.1},0).wait(2).to({regX:2,regY:0.6,scaleX:1.02,scaleY:0.97,skewX:8.8,skewY:11,x:444.8,y:457},0).wait(2).to({regX:2.2,regY:2,scaleX:1.01,scaleY:0.98,skewX:8.6,skewY:11.3,x:444.9,y:457.5},0).to({_off:true},2).wait(51).to({_off:false,scaleX:1.01,scaleY:0.99,skewY:11.5,x:445,y:456.5},0).wait(6).to({scaleX:1.01,scaleY:0.98,skewY:11.3,x:444.9,y:457.5},0).wait(2).to({regX:2,regY:0.6,scaleX:1.02,scaleY:0.97,skewX:8.8,skewY:11,x:444.8,y:457},0).wait(2).to({regX:2.2,regY:2,scaleX:1.05,scaleY:0.96,skewX:9.2,skewY:10.8,x:444.6,y:460.2},0).wait(2).to({regX:2.1,scaleX:1,scaleY:1.02,skewX:8.5,skewY:12,x:445.3,y:450.8},0).wait(2).to({scaleX:0.99,scaleY:1.04,skewY:12.3,x:445.5,y:448.1},0).wait(2).to({regX:1.9,regY:2.5,scaleX:0.99,scaleY:1.06,skewX:8.6,skewY:12.7,x:445.3,y:442.4},0).wait(4).to({regY:2.2,scaleX:0.99,scaleY:1.06,skewX:8.5,skewY:12.6,x:445.4,y:443.8},0).wait(2).to({regY:2.5,x:445.3,y:445},0).wait(2).to({scaleX:0.99,scaleY:1.06,skewX:8.6,skewY:12.7,y:445.7},0).wait(12).to({regX:2.3,regY:2,scaleX:0.99,scaleY:1.04,skewX:8.5,skewY:12.3,x:445.6,y:448},0).wait(2).to({regX:2.8,regY:1.5,scaleX:1,scaleY:1.02,skewY:12,x:446,y:450.5},0).wait(2).to({regX:2,regY:0.6,scaleX:1.02,scaleY:0.97,skewX:8.8,skewY:11,x:444.8,y:457},0).wait(2).to({regY:2,scaleX:1.01,scaleY:0.98,skewX:8.5,skewY:11.3,x:444.9,y:457.3},0).wait(2).to({regX:0.4,regY:1,scaleX:1.02,skewY:11.1,x:443.5,y:458.1},0).wait(2).to({regX:2,regY:2,scaleX:1.03,scaleY:0.99,skewX:8.8,skewY:11,x:445,y:461.4},0).wait(2).to({regX:2.5,regY:2.9,scaleX:1.05,scaleY:0.99,skewX:9,x:445.6,y:466.4},0).wait(2).to({regX:1.9,regY:1,scaleX:1.04,scaleY:0.99,skewX:8.8,x:445,y:463.4},0).wait(2).to({regX:3.4,regY:1.9,scaleX:1.03,skewY:11.1,x:446.3,y:464},0).wait(2).to({regX:1,regY:0.8,scaleX:1.03,scaleY:0.99,skewY:11.3,x:443.9,y:462.1},0).to({_off:true},44).wait(6).to({_off:false,regX:2.2,regY:2,scaleX:1.01,scaleY:0.99,skewX:8.6,skewY:11.5,x:445,y:456.5},0).wait(26).to({_off:true},8).wait(115).to({_off:false,regX:2.4,regY:2.1,x:445.5,y:440.1},0).wait(4).to({regX:2.1,regY:1.9,scaleX:1,skewX:8.5,x:445.3,y:421.4},0).wait(2).to({regX:1.7,regY:2.1,scaleY:0.98,x:444.8,y:420.1},0).wait(2).to({regY:2,scaleY:0.99,y:419.3},0).wait(2).to({regX:2.1,regY:1.9,scaleX:1.01,skewX:8.6,x:445.3,y:418.5},0).to({y:680.4},6).wait(6));

	// forearm_003
	this.instance_75 = new lib.MurrayPatch_1();
	this.instance_75.parent = this;
	this.instance_75.setTransform(473.8,453.5,1.507,1.482,0,6,5.8,10,8.7);
	this.instance_75._off = true;

	this.instance_76 = new lib.MurrayShirtButton1_1();
	this.instance_76.parent = this;
	this.instance_76.setTransform(445,456.5,1.006,0.985,0,8.6,11.5,2.2,2);
	this.instance_76._off = true;

	this.instance_77 = new lib.MurrayPalm_111_1();
	this.instance_77.parent = this;
	this.instance_77.setTransform(568.4,414.2,1,1,0,0,180,33,27.1);

	this.instance_78 = new lib.MurrayMiddleFinger_111_1();
	this.instance_78.parent = this;
	this.instance_78.setTransform(586.4,408.1,1.095,1.143,0,-4.5,175.5,11,6.4);

	this.instance_79 = new lib.MurrayPointerFinger_111_1();
	this.instance_79.parent = this;
	this.instance_79.setTransform(576.7,406,1,1,0,-7.9,172.1,17.9,6.8);

	this.instance_80 = new lib.forearm_001_1();
	this.instance_80.parent = this;
	this.instance_80.setTransform(559.3,437.6,1.089,1.543,0,29.8,21.1,22.9,4);

	this.instance_81 = new lib.MurrayShirtCollarRight_1();
	this.instance_81.parent = this;
	this.instance_81.setTransform(439.8,418.2,1.14,0.994,0,6,9.1,45.4,15.3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_75}]},345).to({state:[{t:this.instance_75}]},2).to({state:[{t:this.instance_75}]},2).to({state:[]},2).to({state:[{t:this.instance_75}]},55).to({state:[]},2).to({state:[{t:this.instance_76}]},4).to({state:[]},51).to({state:[{t:this.instance_80,p:{x:559.3,y:437.6,regX:22.9,regY:4}},{t:this.instance_79,p:{regX:17.9,regY:6.8,x:576.7,y:406}},{t:this.instance_78,p:{regX:11,regY:6.4,x:586.4,y:408.1}},{t:this.instance_77,p:{x:568.4,y:414.2}}]},48).to({state:[{t:this.instance_80,p:{x:559.8,y:440.6,regX:22.9,regY:4}},{t:this.instance_79,p:{regX:19.8,regY:4.9,x:575.1,y:407.4}},{t:this.instance_78,p:{regX:11.1,regY:8.4,x:587,y:413.3}},{t:this.instance_77,p:{x:568.9,y:417.2}}]},2).to({state:[{t:this.instance_80,p:{x:559.9,y:440.8,regX:22.1,regY:3.2}},{t:this.instance_79,p:{regX:18.8,regY:7.9,x:576.7,y:411.7}},{t:this.instance_78,p:{regX:11.2,regY:6.4,x:586.9,y:412.6}},{t:this.instance_77,p:{x:569.2,y:418.7}}]},2).to({state:[{t:this.instance_80,p:{x:560.3,y:443.6,regX:22.9,regY:4}},{t:this.instance_79,p:{regX:17.9,regY:6.8,x:577.7,y:412}},{t:this.instance_78,p:{regX:10.8,regY:6.5,x:587.6,y:414.1}},{t:this.instance_77,p:{x:569.4,y:420.2}}]},2).to({state:[{t:this.instance_81,p:{regX:45.4,regY:15.3,scaleX:1.14,skewX:6,x:439.8,y:418.2}}]},44).to({state:[{t:this.instance_81,p:{regX:45.2,regY:15.2,scaleX:1.133,skewX:5.8,x:439.7,y:416.3}}]},2).to({state:[{t:this.instance_81,p:{regX:45.3,regY:15.2,scaleX:1.13,skewX:5.8,x:439.9,y:415.5}}]},2).to({state:[]},2).to({state:[{t:this.instance_76}]},34).to({state:[{t:this.instance_76}]},2).to({state:[{t:this.instance_76}]},2).to({state:[{t:this.instance_76}]},4).to({state:[{t:this.instance_76}]},2).to({state:[{t:this.instance_76}]},2).to({state:[{t:this.instance_76}]},40).to({state:[{t:this.instance_76}]},2).to({state:[{t:this.instance_76}]},2).to({state:[{t:this.instance_76}]},59).to({state:[{t:this.instance_75}]},4).to({state:[{t:this.instance_75}]},2).to({state:[{t:this.instance_75}]},2).to({state:[{t:this.instance_75}]},2).to({state:[{t:this.instance_75}]},6).wait(6));
	this.timeline.addTween(cjs.Tween.get(this.instance_75).wait(345).to({_off:false},0).wait(2).to({regX:10.9,regY:6,scaleX:1.52,scaleY:1.47,x:475.7,y:450.7},0).wait(2).to({regX:11.7,regY:6.4,scaleX:1.55,scaleY:1.45,skewX:6.4,skewY:5.6,x:477.3,y:453.4},0).to({_off:true},2).wait(55).to({_off:false},0).to({_off:true},2).wait(312).to({_off:false,scaleX:1.49,scaleY:1.49,rotation:5.8,skewX:0,skewY:0,x:476.4,y:446.7},0).wait(2).to({regY:6.5,y:445.3},0).wait(2).to({regY:6.4,y:444.4},0).wait(2).to({regY:6.5,scaleX:1.49,scaleY:1.49,rotation:6,y:443.6},0).to({regY:6.4,y:705.4},6).wait(6));
	this.timeline.addTween(cjs.Tween.get(this.instance_76).wait(412).to({_off:false},0).to({_off:true},51).wait(138).to({_off:false,regX:2.4,regY:2.1,x:445.5,y:440.1},0).wait(2).to({regX:2.2,scaleX:1,skewX:8.5,x:445.3,y:438.1},0).wait(2).to({regX:2.5,regY:0.6,scaleX:1.03,scaleY:0.97,skewX:9,skewY:11,y:435.7},0).wait(4).to({regX:2.4,regY:2.1,scaleX:1.02,scaleY:0.98,skewX:8.8,skewY:11.3,x:445.2,y:436.5},0).wait(2).to({regX:3.1,scaleX:1.01,scaleY:0.98,skewX:8.5,x:446.1,y:436.1},0).wait(2).to({regY:2.9,scaleX:1.01,scaleY:0.99,skewX:8.6,skewY:11.5,y:436.4},0).wait(40).to({regX:2.2,regY:2.1,scaleX:1,skewX:8.5,x:445.3,y:438.1},0).wait(2).to({regX:2.4,scaleX:1.01,skewX:8.6,x:445.5,y:440.1},0).wait(61).to({regX:2.1,regY:1.9,x:445.3,y:424.5},0).to({_off:true},4).wait(18));

	// Shorts
	this.instance_82 = new lib.MurrayShirtCollarLeft_1();
	this.instance_82.parent = this;
	this.instance_82.setTransform(444.1,665.1,1.609,1.519,0,3.2,-6.1,32.4,9.7);
	this.instance_82._off = true;

	this.instance_83 = new lib.MurrayShirtButton1_1();
	this.instance_83.parent = this;
	this.instance_83.setTransform(442.4,744.9,0.995,0.995,-13.2,0,0,2.6,2.7);
	this.instance_83.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,2);
	this.instance_83._off = true;

	this.instance_84 = new lib.MurrayShirtStitches();
	this.instance_84.parent = this;
	this.instance_84.setTransform(437.3,448.9,1.492,1.492,0,0,0,48.4,34.8);
	this.instance_84._off = true;

	this.instance_85 = new lib.MurrayPatch_1();
	this.instance_85.parent = this;
	this.instance_85.setTransform(476.4,449.6,1.492,1.492,6,0,0,11.7,6.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_82}]},9).to({state:[{t:this.instance_82}]},8).to({state:[{t:this.instance_82}]},2).to({state:[{t:this.instance_82}]},2).to({state:[{t:this.instance_82}]},2).to({state:[{t:this.instance_82}]},2).to({state:[{t:this.instance_82}]},2).to({state:[{t:this.instance_83}]},10).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},24).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},62).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},36).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},64).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},34).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_84}]},38).to({state:[{t:this.instance_84}]},2).to({state:[{t:this.instance_84}]},2).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},4).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},39).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_84}]},4).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},2).to({state:[]},2).to({state:[{t:this.instance_83}]},51).to({state:[{t:this.instance_83}]},4).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},4).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},10).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},44).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},26).to({state:[{t:this.instance_83}]},8).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},4).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},40).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_83}]},2).to({state:[{t:this.instance_85}]},59).to({state:[]},4).wait(18));
	this.timeline.addTween(cjs.Tween.get(this.instance_82).wait(9).to({_off:false},0).to({regX:32.1,regY:10.1,x:443.5,y:412.8},8).wait(2).to({scaleX:1.63,scaleY:1.5,skewX:3.3,skewY:-5.8,x:443.2,y:416.1},0).wait(2).to({regX:32.4,regY:10.7,scaleX:1.66,scaleY:1.47,skewX:3.4,skewY:-5.7,x:443,y:419.4},0).wait(2).to({regX:32.1,regY:10.3,scaleX:1.63,scaleY:1.5,skewX:3.3,skewY:-5.8,x:442.9,y:415.9},0).wait(2).to({regY:10.1,scaleX:1.62,scaleY:1.51,skewX:3.1,x:443.3,y:414.3},0).wait(2).to({scaleX:1.61,scaleY:1.52,skewX:3.2,skewY:-6.1,x:443.5,y:412.8},0).to({_off:true},10).wait(701));
	this.timeline.addTween(cjs.Tween.get(this.instance_83).wait(37).to({_off:false},0).wait(2).to({regX:3,regY:3.1,rotation:-0.3,x:428.8,y:591.5},0).wait(2).to({regX:2.8,regY:2.8,scaleX:0.99,scaleY:0.99,rotation:5.8,x:421.4,y:514.3},0).wait(2).to({regX:2.4,regY:3.1,rotation:9,x:417.4,y:476.1},0).wait(2).to({regX:3,regY:2.6,rotation:10.5,x:416.4,y:456.5},0).wait(2).to({regX:2.6,regY:2.8,scaleX:1,scaleY:1,rotation:12.2,x:417.8,y:434.5},0).wait(24).to({regX:2.2,regY:2.3,scaleX:0.99,scaleY:0.99,rotation:12.6,x:413.8,y:436.2},0).wait(2).to({rotation:13.1,x:413.7,y:435.6},0).wait(2).to({regX:2.3,scaleX:0.99,scaleY:0.99,rotation:13.5,x:413.8,y:434.9},0).wait(2).to({scaleX:1,scaleY:1,rotation:14.2,x:413.6,y:434.3},0).wait(62).to({scaleX:0.99,scaleY:0.99,rotation:13.5,x:413.8,y:434.9},0).wait(2).to({regX:2.2,scaleX:0.99,scaleY:0.99,rotation:13.1,x:413.7,y:435.6},0).wait(2).to({rotation:12.6,x:413.8,y:436.2},0).wait(2).to({regX:2.6,regY:2.7,scaleX:1,scaleY:1,rotation:12.2,x:414.2,y:437.3},0).wait(36).to({regX:2.2,regY:2.3,scaleX:0.99,scaleY:0.99,rotation:13.5,x:415.2,y:435.8},0).wait(2).to({regX:3.8,regY:0.6,rotation:14.8,x:418.5,y:433.4},0).wait(2).to({regX:2.4,regY:2.5,rotation:16,x:418,y:433.9},0).wait(2).to({regX:2.5,regY:2.6,scaleX:1,scaleY:1,rotation:17.4,x:419.4,y:433},0).wait(64).to({regX:2.3,regY:2.3,scaleX:0.99,scaleY:0.99,rotation:13.5,x:413.8,y:434.9},0).wait(2).to({regX:2.2,scaleX:0.99,scaleY:0.99,rotation:13.1,x:413.7,y:435.6},0).wait(2).to({rotation:12.6,x:413.8,y:436.2},0).wait(2).to({regX:2.3,scaleX:1,scaleY:1,rotation:14.2,x:416.8,y:434.3},0).wait(2).to({regX:2.1,regY:2.2,scaleX:0.99,scaleY:1,rotation:0,skewX:14,skewY:13.3,x:425.3,y:431.9},0).wait(2).to({regX:2.3,scaleX:0.99,scaleY:1,skewX:13.8,skewY:12.8,x:434.1,y:429.5},0).wait(2).to({regX:2,regY:2.3,scaleX:0.99,scaleY:1,skewY:12,x:444,y:427.2},0).wait(2).to({regX:2.3,regY:2.4,scaleX:0.98,scaleY:1.01,skewY:11.4,x:454.4,y:424.8},0).wait(34).to({regX:3.2,regY:1.1,scaleX:0.99,scaleY:1,skewX:11,skewY:11.3,x:451,y:431.3},0).wait(2).to({regX:1.9,regY:1.9,scaleX:1.02,scaleY:0.97,skewX:8.8,skewY:11,x:444.8,y:441.9},0).wait(2).to({regX:2.5,regY:2.4,scaleX:1.01,scaleY:0.98,skewX:8.6,skewY:11.3,x:445.5,y:441.4},0).wait(2).to({regX:2.4,regY:2.1,scaleX:1.01,scaleY:0.99,skewY:11.5,y:440.1},0).wait(2).to({_off:true},38).wait(6).to({_off:false,regX:2.2,regY:2.8,scaleX:1,scaleY:1.04,skewX:0.3,skewY:0,x:433.5,y:424.9},0).wait(4).to({scaleY:1.02,skewX:0,x:433.2,y:427.5},0).wait(2).to({scaleY:1.01,x:433,y:428.7},0).wait(2).to({regY:4.6,scaleY:1,x:432.9,y:431.7},0).wait(39).to({regY:2.8,scaleY:1.01,x:433,y:428.7},0).wait(2).to({scaleY:1.02,x:433.2,y:427.5},0).wait(2).to({scaleY:1.04,skewX:0.3,x:433.5,y:424.9},0).to({_off:true},4).wait(2).to({_off:false,regX:1.9,regY:1.9,scaleX:1.02,scaleY:0.97,skewX:8.8,skewY:11,x:444.8,y:441.9},0).wait(2).to({regX:2.5,regY:2.4,scaleX:1.01,scaleY:0.98,skewX:8.6,skewY:11.3,x:445.5,y:441.4},0).to({_off:true},2).wait(51).to({_off:false,regX:2.4,regY:2.1,scaleX:1.01,scaleY:0.99,skewY:11.5,y:440.1},0).wait(6).to({regX:2.5,regY:2.4,scaleX:1.01,scaleY:0.98,skewY:11.3,y:441.4},0).wait(2).to({regX:1.9,regY:1.9,scaleX:1.02,scaleY:0.97,skewX:8.8,skewY:11,x:444.8,y:441.9},0).wait(2).to({regX:2.4,regY:2.1,scaleX:1.05,scaleY:0.96,skewX:9.2,skewY:10.8,x:445.1,y:444.2},0).wait(2).to({scaleX:1,scaleY:1.02,skewX:8.5,skewY:12,x:446,y:433.8},0).wait(2).to({regX:2.3,regY:2,scaleX:0.99,scaleY:1.04,skewY:12.3,x:446.1,y:430.6},0).wait(2).to({regX:1.9,regY:2.3,scaleX:0.99,scaleY:1.06,skewX:8.6,skewY:12.7,x:445.9,y:424.4},0).wait(4).to({regY:2.2,scaleX:0.99,scaleY:1.06,skewX:8.5,skewY:12.6,x:446,y:425.9},0).wait(2).to({y:426.8},0).wait(2).to({scaleX:0.99,scaleY:1.06,skewX:8.6,skewY:12.7,x:445.9,y:427.6},0).wait(12).to({regX:2.2,scaleX:0.99,scaleY:1.04,skewX:8.5,skewY:12.3,x:446,y:430.7},0).wait(2).to({regX:2.3,regY:2.1,scaleX:1,scaleY:1.02,skewY:12,y:433.8},0).wait(2).to({regX:1.9,regY:1.9,scaleX:1.02,scaleY:0.97,skewX:8.8,skewY:11,x:444.8,y:441.9},0).wait(2).to({regX:2,regY:2.1,scaleX:1.01,scaleY:0.98,skewX:8.5,skewY:11.3,x:445.2,y:440.8},0).wait(2).to({regX:3.9,regY:2.9,scaleX:1.02,skewY:11.1,x:447.1,y:443.9},0).wait(2).to({regX:2.6,scaleX:1.03,scaleY:0.99,skewX:8.8,skewY:11,x:445.9,y:445.8},0).wait(2).to({regX:2.3,regY:2.1,scaleX:1.05,scaleY:0.99,skewX:9,y:449},0).wait(2).to({regX:2.2,regY:1.4,scaleX:1.04,scaleY:0.99,skewX:8.8,x:445.7,y:447.3},0).wait(2).to({regX:2.3,regY:2.1,scaleX:1.03,skewY:11.1,x:445.5,y:447.5},0).wait(2).to({regX:2.4,scaleX:1.03,scaleY:0.99,skewY:11.3,y:447.1},0).wait(44).to({regX:1.1,regY:1,scaleX:1.02,scaleY:0.99,skewX:8.5,x:444.6,y:459.5},0).wait(2).to({regX:0.7,scaleX:1.01,x:444.4,y:458},0).wait(2).to({regX:1,scaleX:1.01,scaleY:0.98,x:444.9,y:457.3},0).wait(2).to({regX:2.4,regY:2.1,scaleX:1.01,scaleY:0.99,skewX:8.6,skewY:11.5,x:445.5,y:440.1},0).wait(34).to({regX:2.1,regY:1.9,x:445.3,y:424.5},0).wait(2).to({scaleX:1,skewX:8.5,y:422.4},0).wait(2).to({regX:1.4,regY:1.8,scaleX:1.03,scaleY:0.97,skewX:9,skewY:11,x:444.1,y:421.6},0).wait(4).to({regX:2.1,regY:1.9,scaleX:1.02,scaleY:0.98,skewX:8.8,skewY:11.3,x:445,y:421},0).wait(2).to({regX:2,scaleX:1.01,scaleY:0.98,skewX:8.5,x:445.1,y:420.5},0).wait(2).to({regX:2.1,scaleX:1.01,scaleY:0.99,skewX:8.6,skewY:11.5,x:445.3,y:420},0).wait(40).to({scaleX:1,skewX:8.5,y:422.4},0).wait(2).to({scaleX:1.01,skewX:8.6,y:424.5},0).wait(2).to({_off:true},59).wait(22));
	this.timeline.addTween(cjs.Tween.get(this.instance_84).wait(345).to({_off:false},0).wait(2).to({y:449.4},0).wait(2).to({y:450.5},0).to({_off:true},2).wait(55).to({_off:false},0).to({_off:true},2).wait(330));

	// Shorts
	this.instance_86 = new lib.Murray3ShirtHem_1();
	this.instance_86.parent = this;
	this.instance_86.setTransform(444,692.7,1.515,0.752,0,14.2,16.9,5.6,34);
	this.instance_86._off = true;

	this.instance_87 = new lib.MurrayShirtButton1_1();
	this.instance_87.parent = this;
	this.instance_87.setTransform(436,728,0.995,0.995,-13.2,0,0,2.4,0);
	this.instance_87.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,2);
	this.instance_87._off = true;

	this.instance_88 = new lib.MurrayShirtCollarLeft_1();
	this.instance_88.parent = this;
	this.instance_88.setTransform(443.5,413.9,1.643,1.508,0,3.1,-8.3,32.1,10.1);
	this.instance_88._off = true;

	this.instance_89 = new lib.MurrayPatch_1();
	this.instance_89.parent = this;
	this.instance_89.setTransform(476.4,449.6,1.492,1.492,6,0,0,11.7,6.5);
	this.instance_89._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_86).wait(9).to({_off:false},0).to({y:439.8},8).wait(2).to({regX:5.4,regY:33.7,scaleX:1.53,scaleY:0.74,skewX:14.6,skewY:16.3,x:443.4,y:442},0).wait(2).to({regX:5.6,regY:33.9,scaleX:1.55,scaleY:0.73,skewX:15.1,skewY:16,x:443.2,y:444.7},0).wait(2).to({regX:5.5,regY:34.1,scaleX:1.53,scaleY:0.74,skewX:14.6,skewY:16.3,x:443.4,y:442.2},0).wait(2).to({scaleX:1.52,scaleY:0.75,skewX:14.3,skewY:16.6,x:443.7,y:441.1},0).wait(2).to({regX:5.6,regY:34,scaleX:1.52,scaleY:0.75,skewX:14.2,skewY:16.9,x:444,y:439.8},0).to({_off:true},10).wait(701));
	this.timeline.addTween(cjs.Tween.get(this.instance_87).wait(37).to({_off:false},0).wait(2).to({regX:2.6,rotation:-0.3,x:426,y:573.7},0).wait(2).to({regX:2.7,regY:0.1,scaleX:0.99,scaleY:0.99,rotation:5.8,x:421,y:496.6},0).wait(2).to({regX:2.4,regY:-0.1,rotation:9,x:418.1,y:457.8},0).wait(2).to({regX:3,regY:0.2,rotation:10.5,x:417.4,y:439},0).wait(2).to({regX:2.7,regY:0.1,scaleX:1,scaleY:1,rotation:12.2,x:419.5,y:416.6},0).wait(24).to({regX:2.6,regY:1.8,scaleX:0.99,scaleY:0.99,rotation:12.6,x:415.4,y:420.5},0).wait(2).to({regX:2,regY:2,rotation:13.1,x:414.8,y:419.9},0).wait(2).to({regY:1.9,scaleX:0.99,scaleY:0.99,rotation:13.5,x:414.9,y:419.2},0).wait(2).to({scaleX:1,scaleY:1,rotation:14.2,x:415,y:418.6},0).wait(62).to({scaleX:0.99,scaleY:0.99,rotation:13.5,x:414.9,y:419.2},0).wait(2).to({regY:2,scaleX:0.99,scaleY:0.99,rotation:13.1,x:414.8,y:419.9},0).wait(2).to({regX:2.6,regY:1.8,rotation:12.6,x:415.4,y:420.5},0).wait(2).to({regX:2.7,regY:0.1,scaleX:1,scaleY:1,rotation:12.2,x:415.8,y:419.5},0).wait(36).to({regX:2.2,regY:1.9,scaleX:0.99,scaleY:0.99,rotation:13.5,x:416.6,y:420.2},0).wait(2).to({regX:2,rotation:14.8,x:418,y:419.2},0).wait(2).to({regX:1.6,regY:2.8,rotation:16,x:419.3,y:418.9},0).wait(2).to({regX:2,regY:2,scaleX:1,scaleY:1,rotation:17.4,x:421.4,y:417.1},0).wait(64).to({regY:1.9,scaleX:0.99,scaleY:0.99,rotation:13.5,x:414.9,y:419.2},0).wait(2).to({regY:2,scaleX:0.99,scaleY:0.99,rotation:13.1,x:414.8,y:419.9},0).wait(2).to({regX:2.6,regY:1.8,rotation:12.6,x:415.4,y:420.5},0).wait(2).to({regX:2.1,regY:1.9,scaleX:1,scaleY:1,rotation:14.2,x:418.2,y:418.6},0).wait(2).to({regX:2.3,regY:2.2,scaleX:0.99,scaleY:1,rotation:0,skewX:14,skewY:13.3,x:427,y:416.5},0).wait(2).to({regX:2.1,regY:1.9,scaleX:0.99,scaleY:1,skewX:13.8,skewY:12.8,x:435.5,y:413.8},0).wait(2).to({scaleX:0.99,scaleY:1,skewY:12,x:445.6,y:411.5},0).wait(2).to({regX:5,regY:2.3,scaleX:0.98,scaleY:1.01,skewY:11.4,x:458.4,y:409.9},0).wait(34).to({regX:2.8,regY:2.1,scaleX:0.99,scaleY:1,skewX:11,skewY:11.3,x:451.1,y:417},0).wait(2).to({regX:1.8,regY:1.9,scaleX:1.02,scaleY:0.97,skewX:8.8,skewY:11,x:444.8,y:426.7},0).wait(2).to({regX:2,scaleX:1.01,scaleY:0.98,skewX:8.6,skewY:11.3,x:445.1,y:425.6},0).wait(2).to({regX:2.1,scaleX:1.01,scaleY:0.99,skewY:11.5,x:445.3,y:424.5},0).wait(2).to({_off:true},38).wait(6).to({_off:false,regX:2,regY:2.2,scaleX:1,scaleY:1.04,skewX:0.3,skewY:0,x:431.2,y:408.5},0).wait(4).to({regY:1.9,scaleY:1.02,skewX:0,x:430.8,y:411.1},0).wait(2).to({scaleY:1.01,x:430.7,y:412.5},0).wait(2).to({scaleY:1,x:430.4,y:413.9},0).wait(39).to({scaleY:1.01,x:430.7,y:412.5},0).wait(2).to({scaleY:1.02,x:430.8,y:411.1},0).wait(2).to({regY:2.2,scaleY:1.04,skewX:0.3,x:431.2,y:408.5},0).to({_off:true},4).wait(2).to({_off:false,regX:1.8,regY:1.9,scaleX:1.02,scaleY:0.97,skewX:8.8,skewY:11,x:444.8,y:426.7},0).wait(2).to({regX:2,scaleX:1.01,scaleY:0.98,skewX:8.6,skewY:11.3,x:445.1,y:425.6},0).wait(2).to({regX:2.4,regY:2.1,scaleX:1.01,scaleY:0.99,skewY:11.5,x:445.5,y:440.1},0).wait(51).to({regX:2.1,regY:1.9,x:445.3,y:424.5},0).wait(6).to({regX:2,scaleX:1.01,scaleY:0.98,skewY:11.3,x:445.1,y:425.6},0).wait(2).to({regX:1.8,scaleX:1.02,scaleY:0.97,skewX:8.8,skewY:11,x:444.8,y:426.7},0).wait(2).to({regX:1.9,regY:2,scaleX:1.05,scaleY:0.96,skewX:9.2,skewY:10.8,x:444.7,y:429.1},0).wait(2).to({regX:2,scaleX:1,scaleY:1.02,skewX:8.5,skewY:12,x:445.8,y:417.7},0).wait(2).to({regX:2.3,regY:2.4,scaleX:0.99,scaleY:1.04,skewY:12.3,x:446.3,y:414.8},0).wait(2).to({regX:1.9,regY:1.9,scaleX:0.99,scaleY:1.06,skewX:8.6,skewY:12.7,y:407.5},0).wait(4).to({scaleX:0.99,scaleY:1.06,skewX:8.5,skewY:12.6,x:446.2,y:409.2},0).wait(2).to({regY:2,y:410.2},0).wait(2).to({regY:1.8,scaleX:0.99,scaleY:1.06,skewX:8.6,skewY:12.7,x:446.3,y:410.7},0).wait(12).to({regX:2,regY:1.9,scaleX:0.99,scaleY:1.04,skewX:8.5,skewY:12.3,x:446.1,y:414.3},0).wait(2).to({scaleX:1,scaleY:1.02,skewY:12,x:445.9,y:417.7},0).wait(2).to({regX:1.8,scaleX:1.02,scaleY:0.97,skewX:8.8,skewY:11,x:444.8,y:426.7},0).wait(2).to({regX:2,scaleX:1.01,scaleY:0.98,skewX:8.5,skewY:11.3,x:445.3,y:425.2},0).wait(2).to({regX:1.8,regY:1,scaleX:1.02,skewY:11.1,y:426.4},0).wait(2).to({regX:-1,regY:2.8,scaleX:1.03,scaleY:0.99,skewX:8.8,skewY:11,x:442.3,y:429.7},0).wait(2).to({regX:1.3,regY:3,scaleX:1.05,scaleY:0.99,skewX:9,x:444.8,y:434.4},0).wait(2).to({regX:2.2,regY:1,scaleX:1.04,scaleY:0.99,skewX:8.8,x:445.8,y:431.6},0).wait(2).to({regX:-0.5,regY:2.9,scaleX:1.03,skewY:11.1,x:442.6,y:432.4},0).wait(2).to({regX:2.1,regY:1.9,scaleX:1.03,scaleY:0.99,skewY:11.3,x:445.2,y:431.5},0).wait(44).to({regX:2.6,regY:2.4,scaleX:1.02,scaleY:0.99,skewX:8.5,x:445.7,y:443.9},0).wait(2).to({regY:2.1,scaleX:1.01,y:441.9},0).wait(2).to({regX:2.2,regY:1.8,scaleX:1.01,scaleY:0.98,x:445.4,y:440.6},0).wait(2).to({regX:2.1,regY:1.9,scaleX:1.01,scaleY:0.99,skewX:8.6,skewY:11.5,x:445.3,y:424.5},0).wait(26).to({_off:true},8).wait(137));
	this.timeline.addTween(cjs.Tween.get(this.instance_88).wait(345).to({_off:false},0).wait(2).to({regX:32,regY:10.2,scaleX:1.68,scaleY:1.5,skewX:3.3,skewY:-10.5,x:443.2,y:415.4},0).wait(2).to({regX:32.4,regY:10,scaleX:1.75,scaleY:1.48,skewX:3.4,skewY:-15.2,x:443.5,y:417.3},0).to({_off:true},2).wait(55).to({_off:false},0).to({_off:true},2).wait(312).to({_off:false,regX:32.8,regY:10.1,scaleX:1.61,scaleY:1.52,skewX:3,skewY:-6,x:444.7,y:409.6},0).wait(2).to({regX:32.2,x:443.8,y:408.2},0).wait(2).to({regX:32.7,x:444.5,y:407.4},0).wait(2).to({regX:32.2,scaleY:1.52,skewX:3.2,skewY:-6.1,x:443.7,y:406.7},0).to({regX:32.6,regY:9.6,x:444.4,y:667.9},6).wait(6));
	this.timeline.addTween(cjs.Tween.get(this.instance_89).wait(601).to({_off:false},0).wait(2).to({regY:6.4,scaleX:1.49,scaleY:1.49,rotation:5.8,y:447.9},0).wait(2).to({regX:12.2,regY:7.4,scaleX:1.53,scaleY:1.47,rotation:0,skewX:6.2,skewY:5.7,x:477.2,y:448.4},0).wait(4).to({regX:11.6,regY:6.8,scaleX:1.51,scaleY:1.48,skewX:6,skewY:5.8,x:476.3,y:446.7},0).wait(2).to({regX:11.8,regY:6.4,scaleX:1.5,scaleY:1.49,x:476.6,y:445.8},0).wait(2).to({regX:11.7,scaleX:1.49,scaleY:1.49,rotation:6,skewX:0,skewY:0,x:476.4,y:445.5},0).wait(40).to({scaleX:1.49,scaleY:1.49,rotation:5.8,y:447.9},0).wait(2).to({regY:6.5,scaleX:1.49,scaleY:1.49,rotation:6,y:449.6},0).wait(2).to({_off:true},59).wait(22));

	// Layer 154
	this.instance_90 = new lib.MurrayShirtShape_004_1();
	this.instance_90.parent = this;
	this.instance_90.setTransform(447.2,710.6,0.998,0.991,0,11.4,6,77.2,56.4);
	this.instance_90._off = true;

	this.instance_91 = new lib.MurrayPatch_1();
	this.instance_91.parent = this;
	this.instance_91.setTransform(472.2,751.6,1.492,1.492,-6.4,0,0,11.8,6.7);
	this.instance_91.shadow = new cjs.Shadow("rgba(0,0,0,1)",-1,0,5);
	this.instance_91._off = true;

	this.instance_92 = new lib.Murray3ShirtHem_1();
	this.instance_92.parent = this;
	this.instance_92.setTransform(443.7,440.9,1.527,0.748,0,14.3,16.6,5.5,34.2);
	this.instance_92._off = true;

	this.instance_93 = new lib.MurrayShirtButton1_1();
	this.instance_93.parent = this;
	this.instance_93.setTransform(445.3,424.5,1.006,0.985,0,8.6,11.5,2.1,1.9);
	this.instance_93._off = true;

	this.instance_94 = new lib.MurrayShirtStitches();
	this.instance_94.parent = this;
	this.instance_94.setTransform(437.3,448.5,1.492,1.492,0,0,0,48.4,34.8);
	this.instance_94._off = true;

	this.instance_95 = new lib.MurrayShirtCollarLeft_1();
	this.instance_95.parent = this;
	this.instance_95.setTransform(443.5,412.8,1.609,1.519,0,3.2,-6.1,32.1,10.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_90}]},9).to({state:[{t:this.instance_90}]},8).to({state:[{t:this.instance_90}]},2).to({state:[{t:this.instance_90}]},2).to({state:[{t:this.instance_90}]},2).to({state:[{t:this.instance_90}]},2).to({state:[{t:this.instance_90}]},2).to({state:[{t:this.instance_91}]},10).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_91}]},24).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_91}]},62).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_91}]},36).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_91}]},64).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_91}]},34).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_92}]},38).to({state:[{t:this.instance_92}]},2).to({state:[{t:this.instance_92}]},2).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_91}]},4).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_91}]},39).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_92}]},4).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_93}]},2).to({state:[{t:this.instance_91}]},51).to({state:[{t:this.instance_91}]},4).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_91}]},4).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_91}]},10).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_93}]},44).to({state:[{t:this.instance_93}]},2).to({state:[{t:this.instance_93}]},2).to({state:[{t:this.instance_91}]},2).to({state:[{t:this.instance_91}]},26).to({state:[{t:this.instance_94}]},8).to({state:[{t:this.instance_94}]},2).to({state:[{t:this.instance_94}]},2).to({state:[{t:this.instance_94}]},4).to({state:[{t:this.instance_94}]},2).to({state:[{t:this.instance_94}]},2).to({state:[{t:this.instance_94}]},40).to({state:[{t:this.instance_94}]},2).to({state:[{t:this.instance_94}]},2).to({state:[{t:this.instance_95}]},59).to({state:[{t:this.instance_92}]},4).to({state:[{t:this.instance_92}]},2).to({state:[{t:this.instance_92}]},2).to({state:[{t:this.instance_92}]},2).to({state:[{t:this.instance_92}]},6).wait(6));
	this.timeline.addTween(cjs.Tween.get(this.instance_90).wait(9).to({_off:false},0).to({y:457.7},8).wait(2).to({regX:76.9,regY:56.2,scaleX:1.01,scaleY:0.98,skewX:11.8,skewY:5.8,x:446.7,y:459.6},0).wait(2).to({regX:77.3,regY:56.4,scaleX:1.03,scaleY:0.96,skewX:12.1,skewY:5.6,x:446.6,y:462.1},0).wait(2).to({regX:77.2,regY:56.5,scaleX:1.01,scaleY:0.98,skewX:11.8,skewY:5.8,x:446.8,y:459.9},0).wait(2).to({regX:76,regY:56.7,scaleX:1,scaleY:0.98,skewX:11.5,x:445.8,y:458.9},0).wait(2).to({regX:77.2,regY:56.4,scaleX:1,scaleY:0.99,skewX:11.4,skewY:6,x:447.2,y:457.7},0).to({_off:true},10).wait(701));
	this.timeline.addTween(cjs.Tween.get(this.instance_91).wait(37).to({_off:false},0).wait(2).to({regX:11.7,regY:7,scaleX:1.49,scaleY:1.49,rotation:6.3,x:455.1,y:604.2},0).wait(2).to({regY:6.7,rotation:12.5,x:446.6,y:529.8},0).wait(2).to({regX:11.6,regY:6.8,scaleX:1.49,scaleY:1.49,rotation:15.8,x:442.1,y:493},0).wait(2).to({rotation:17.3,x:440,y:474.5},0).wait(2).to({regY:6.6,scaleX:1.49,scaleY:1.49,rotation:19,x:441.6,y:453.1},0).wait(24).to({regY:6.7,scaleX:1.49,scaleY:1.49,rotation:19.5,x:437.6,y:455.8},0).wait(2).to({regY:6.5,rotation:19.8,x:437.5,y:455},0).wait(2).to({regX:11.4,rotation:20.3,x:437,y:454.5},0).wait(2).to({regX:11.6,regY:6.6,scaleX:1.49,scaleY:1.49,rotation:21,y:454.3},0).wait(62).to({regX:11.4,regY:6.5,scaleX:1.49,scaleY:1.49,rotation:20.3,y:454.5},0).wait(2).to({regX:11.6,rotation:19.8,x:437.5,y:455},0).wait(2).to({regY:6.7,rotation:19.5,x:437.6,y:455.8},0).wait(2).to({regY:6.6,scaleX:1.49,scaleY:1.49,rotation:19,x:438,y:455.9},0).wait(36).to({regY:6.7,scaleX:1.49,scaleY:1.49,rotation:20.3,x:438.8,y:455.5},0).wait(2).to({regX:11.7,regY:6.5,rotation:21.5,x:440,y:454.8},0).wait(2).to({regX:11.6,regY:6.6,rotation:22.8,x:440.6,y:454.4},0).wait(2).to({regX:11.7,regY:6.7,scaleX:1.49,scaleY:1.49,rotation:24.2,x:441.5,y:454},0).wait(64).to({regX:11.4,regY:6.5,scaleX:1.49,scaleY:1.49,rotation:20.3,x:437,y:454.5},0).wait(2).to({regX:11.6,rotation:19.8,x:437.5,y:455},0).wait(2).to({regY:6.7,rotation:19.5,x:437.6,y:455.8},0).wait(2).to({regY:6.6,scaleX:1.49,scaleY:1.49,rotation:21,x:440.2,y:454.3},0).wait(2).to({scaleX:1.49,scaleY:1.49,rotation:0,skewX:19.1,skewY:18.5,x:451.2,y:450.8},0).wait(2).to({regX:11.8,regY:6.5,scaleX:1.48,scaleY:1.5,skewX:17.3,skewY:16.1,x:462,y:447.2},0).wait(2).to({scaleX:1.48,scaleY:1.5,skewX:15.5,skewY:13.6,x:474.4,y:443.7},0).wait(2).to({regX:11.7,scaleX:1.48,scaleY:1.51,skewX:13.8,skewY:11.4,x:486.6,y:440.1},0).wait(34).to({scaleX:1.48,scaleY:1.5,skewX:9.8,skewY:8.5,x:481.5,y:444.8},0).wait(2).to({regX:10.9,regY:6,scaleX:1.52,scaleY:1.47,skewX:6,skewY:5.8,x:475.7,y:450.7},0).wait(2).to({regX:10,regY:8.7,scaleX:1.51,scaleY:1.48,x:473.8,y:453.5},0).wait(2).to({regX:11.7,regY:6.5,scaleX:1.49,scaleY:1.49,rotation:6,skewX:0,skewY:0,x:476.4,y:449.6},0).wait(2).to({_off:true},38).wait(6).to({_off:false,regY:6.2,scaleY:1.56,rotation:0,skewX:0.3,x:463.5,y:433.5},0).wait(4).to({regY:6.4,scaleY:1.53,skewX:0,x:463.2,y:436.1},0).wait(2).to({scaleY:1.51,x:463,y:437.3},0).wait(2).to({regY:6.3,scaleY:1.49,x:462.9,y:438.3},0).wait(39).to({regY:6.4,scaleY:1.51,x:463,y:437.3},0).wait(2).to({scaleY:1.53,x:463.2,y:436.1},0).wait(2).to({regY:6.2,scaleY:1.56,skewX:0.3,x:463.5,y:433.5},0).to({_off:true},4).wait(2).to({_off:false,regX:10.9,regY:6,scaleX:1.52,scaleY:1.47,skewX:6,skewY:5.8,x:475.7,y:450.7},0).wait(2).to({regX:10,regY:8.7,scaleX:1.51,scaleY:1.48,x:473.8,y:453.5},0).to({_off:true},2).wait(51).to({_off:false,regX:11.7,regY:6.5,scaleX:1.49,scaleY:1.49,rotation:6,skewX:0,skewY:0,x:476.4,y:449.6},0).wait(6).to({regX:10,regY:8.7,scaleX:1.51,scaleY:1.48,rotation:0,skewX:6,skewY:5.8,x:473.8,y:453.5},0).wait(2).to({regX:10.9,regY:6,scaleX:1.52,scaleY:1.47,x:475.7,y:450.7},0).wait(2).to({regX:11.7,regY:6.4,scaleX:1.55,scaleY:1.45,skewX:6.4,skewY:5.6,x:477.3,y:453.4},0).wait(2).to({regX:10.2,regY:6.8,scaleX:1.48,scaleY:1.55,skewX:6,skewY:6.3,x:474.2,y:444},0).wait(2).to({regX:11.6,regY:6.4,scaleX:1.47,scaleY:1.58,x:476.4,y:440.7},0).wait(2).to({regX:11.7,regY:6.5,scaleX:1.46,scaleY:1.61,skewX:6.3,skewY:6.6,x:476.9,y:432.3},0).wait(4).to({regX:10.7,scaleX:1.46,skewY:6.5,x:475.2,y:434.9},0).wait(2).to({regX:11.6,x:476.4,y:436.5},0).wait(2).to({regX:11.2,scaleX:1.46,skewY:6.6,x:475.7,y:437.8},0).wait(12).to({regX:11.7,regY:6.4,scaleX:1.47,scaleY:1.58,skewX:6,skewY:6.3,x:476.5,y:440.9},0).wait(2).to({regX:11.4,regY:6.7,scaleX:1.48,scaleY:1.55,x:476,y:444},0).wait(2).to({regX:10.9,regY:6,scaleX:1.52,scaleY:1.47,skewY:5.8,x:475.7,y:450.7},0).wait(2).to({regX:11.7,regY:6.5,scaleX:1.5,scaleY:1.49,rotation:5.8,skewX:0,skewY:0,x:476.4,y:450.6},0).wait(2).to({regX:12.7,regY:4.9,scaleX:1.51,x:478.6,y:450.3},0).wait(2).to({regX:11.7,regY:6.4,scaleX:1.53,rotation:0,skewX:6,skewY:5.6,x:477.4,y:454.4},0).wait(2).to({regX:11.6,regY:6.5,scaleX:1.57,scaleY:1.49,skewX:6.3,skewY:5.7,x:478.2,y:458.6},0).wait(2).to({regX:11.7,scaleX:1.55,scaleY:1.49,skewX:6,skewY:5.8,x:477.8,y:457.7},0).wait(2).to({regX:13.8,regY:7.2,scaleX:1.54,x:480.5,y:458.6},0).wait(2).to({regX:11.7,regY:6.5,scaleX:1.53,skewX:6.1,x:477,y:456.6},0).to({_off:true},44).wait(6).to({_off:false,scaleX:1.49,rotation:6,skewX:0,skewY:0,x:476.4,y:449.6},0).wait(26).to({_off:true},8).wait(137));
	this.timeline.addTween(cjs.Tween.get(this.instance_92).wait(345).to({_off:false},0).wait(2).to({regY:34,scaleX:1.54,scaleY:0.74,skewX:14.6,skewY:16.3,y:441.9},0).wait(2).to({regX:5.7,scaleX:1.57,scaleY:0.74,skewX:15.2,skewY:15.9,y:444},0).to({_off:true},2).wait(55).to({_off:false},0).to({_off:true},2).wait(312).to({_off:false,regX:5.2,regY:33.8,scaleX:1.51,scaleY:0.75,skewX:14.1,skewY:16.8,x:443.4,y:436.5},0).wait(2).to({regX:5.6,regY:34.2,scaleX:1.51,scaleY:0.75,x:443.9,y:435.5},0).wait(2).to({scaleY:0.75,x:444,y:434.7},0).wait(2).to({regY:34,scaleX:1.52,skewX:14.2,skewY:16.9,y:433.8},0).to({y:695.7},6).wait(6));
	this.timeline.addTween(cjs.Tween.get(this.instance_93).wait(412).to({_off:false},0).to({_off:true},51).wait(98).to({_off:false,regX:1.9,regY:2.2,scaleX:1.02,skewX:8.5,skewY:11.3,x:445,y:428.3},0).wait(2).to({regX:2,regY:1.9,scaleX:1.01,x:445.2,y:426.2},0).wait(2).to({regY:2.1,scaleX:1.01,scaleY:0.98,y:425.5},0).to({_off:true},2).wait(171));
	this.timeline.addTween(cjs.Tween.get(this.instance_94).wait(601).to({_off:false},0).wait(2).to({y:448.4},0).wait(2).to({y:448.5},0).wait(4).to({y:448.4},0).wait(4).to({y:448.5},0).wait(40).to({y:448.4},0).wait(2).to({y:448.5},0).wait(2).to({_off:true},59).wait(22));

	// Layer 155
	this.instance_96 = new lib.MurrayShirtLeftArm_001_1();
	this.instance_96.parent = this;
	this.instance_96.setTransform(508.3,685,1.188,1.507,0,106.1,100.5,22.4,29.6);
	this.instance_96._off = true;

	this.instance_97 = new lib.MurrayShirtStitches();
	this.instance_97.parent = this;
	this.instance_97.setTransform(469,746.4,1.492,1.492,-27.4,0,0,47.9,34.7);
	this.instance_97._off = true;

	this.instance_98 = new lib.MurrayShirtShape_004_1();
	this.instance_98.parent = this;
	this.instance_98.setTransform(447.3,459.8,1.008,0.985,0,11.5,5.8,77.5,57.7);
	this.instance_98._off = true;

	this.instance_99 = new lib.MurrayPatch_1();
	this.instance_99.parent = this;
	this.instance_99.setTransform(476.4,449.6,1.492,1.492,6,0,0,11.7,6.5);
	this.instance_99._off = true;

	this.instance_100 = new lib.MurrayShirtCollarLeft_1();
	this.instance_100.parent = this;
	this.instance_100.setTransform(443.6,412.8,1.725,1.519,0,3.2,-6.1,32.1,10.1);
	this.instance_100._off = true;

	this.instance_101 = new lib.Murray3ShirtHem_1();
	this.instance_101.parent = this;
	this.instance_101.setTransform(444,439.8,1.515,0.752,0,14.2,16.9,5.6,34);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_96}]},9).to({state:[{t:this.instance_96}]},8).to({state:[{t:this.instance_96}]},2).to({state:[{t:this.instance_96}]},2).to({state:[{t:this.instance_96}]},2).to({state:[{t:this.instance_96}]},2).to({state:[{t:this.instance_96}]},2).to({state:[{t:this.instance_97}]},10).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_97}]},24).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_97}]},62).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_97}]},36).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_97}]},64).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_97}]},34).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_98}]},38).to({state:[{t:this.instance_98}]},2).to({state:[{t:this.instance_98}]},2).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_97}]},4).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_97}]},39).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_98}]},4).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_99}]},2).to({state:[{t:this.instance_97}]},51).to({state:[{t:this.instance_97}]},4).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_97}]},4).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_97}]},10).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_99}]},44).to({state:[{t:this.instance_99}]},2).to({state:[{t:this.instance_99}]},2).to({state:[{t:this.instance_97}]},2).to({state:[{t:this.instance_97}]},26).to({state:[{t:this.instance_100}]},8).to({state:[{t:this.instance_100}]},2).to({state:[{t:this.instance_100}]},2).to({state:[{t:this.instance_100}]},4).to({state:[{t:this.instance_100}]},2).to({state:[{t:this.instance_100}]},2).to({state:[{t:this.instance_100}]},40).to({state:[{t:this.instance_100}]},2).to({state:[{t:this.instance_100}]},2).to({state:[{t:this.instance_101}]},59).to({state:[{t:this.instance_98}]},4).to({state:[{t:this.instance_98}]},2).to({state:[{t:this.instance_98}]},2).to({state:[{t:this.instance_98}]},2).to({state:[{t:this.instance_98}]},6).wait(6));
	this.timeline.addTween(cjs.Tween.get(this.instance_96).wait(9).to({_off:false},0).to({regX:22.1,x:508.4,y:431.7},8).wait(2).to({regX:22,regY:29.2,skewX:99.3,skewY:93.5,x:509.6,y:429},0).wait(2).to({regX:22.1,regY:29.6,skewX:92.4,skewY:86.8,x:509.7,y:426.3},0).wait(2).to({regY:28.5,skewX:99.3,skewY:93.5,x:510.8,y:429.4},0).wait(2).to({regY:29.3,scaleY:1.51,skewX:102.6,skewY:97,x:509.2,y:430.5},0).wait(2).to({regY:29.6,scaleY:1.51,skewX:106.1,skewY:100.5,x:508.4,y:431.7},0).to({_off:true},10).wait(701));
	this.timeline.addTween(cjs.Tween.get(this.instance_97).wait(37).to({_off:false},0).wait(2).to({regY:34.8,scaleX:1.49,scaleY:1.49,rotation:-14.6,x:453.3,y:598.4},0).wait(2).to({rotation:-8.3,x:445.3,y:524.4},0).wait(2).to({regX:48.1,regY:34.5,rotation:-5,x:441.6,y:486.7},0).wait(2).to({regX:47.9,regY:34.8,rotation:-3.3,x:439.4,y:468.7},0).wait(2).to({regY:34.7,scaleX:1.49,scaleY:1.49,rotation:-2,x:441,y:447.2},0).wait(24).to({regX:54,regY:35.5,rotation:-1.3,x:446.3,y:450.6},0).wait(2).to({regX:48.4,regY:34.7,rotation:-0.8,x:437.8,y:449.2},0).wait(2).to({regX:49.6,regY:34.8,rotation:-0.3,x:439.3,y:448.9},0).wait(2).to({regX:48.4,rotation:0,x:437.3,y:448.5},0).wait(62).to({regX:49.6,rotation:-0.3,x:439.3,y:448.9},0).wait(2).to({regX:48.4,regY:34.7,rotation:-0.8,x:437.8,y:449.2},0).wait(2).to({regX:53.9,regY:35.5,rotation:-1.3,x:446.1,y:450.6},0).wait(2).to({regX:47.9,regY:34.7,rotation:-2,x:437.4,y:450.1},0).wait(36).to({regX:48.4,regY:34.6,rotation:-0.5,x:439.2,y:449.4},0).wait(2).to({regX:46.1,regY:40.2,rotation:0.5,x:436.7,y:457.2},0).wait(2).to({regX:48,regY:34.2,rotation:1.8,x:440.6,y:447.8},0).wait(2).to({regX:48.4,regY:34.8,rotation:3.2,x:442.1,y:448.2},0).wait(64).to({regX:49.6,rotation:-0.3,x:439.3,y:448.9},0).wait(2).to({regX:48.4,regY:34.7,rotation:-0.8,x:437.8,y:449.2},0).wait(2).to({regX:54.2,regY:35.5,rotation:-1.3,x:446.6,y:450.6},0).wait(2).to({regX:48.4,regY:34.8,rotation:0,x:437.3,y:448.5},0).wait(2).to({y:448.4},0).wait(4).to({y:448.5},0).wait(36).to({y:448.4},0).wait(2).to({y:449.4},0).wait(2).to({y:448.9},0).wait(2).to({y:448.5},0).wait(2).to({_off:true},38).wait(6).to({_off:false},0).wait(4).to({y:448.4},0).wait(4).to({y:448.5},0).wait(39).to({y:448.4},0).wait(4).to({y:448.5},0).to({_off:true},4).wait(2).to({_off:false,y:449.4},0).wait(2).to({y:448.9},0).to({_off:true},2).wait(51).to({_off:false,y:448.5},0).wait(6).to({y:448.9},0).wait(2).to({y:449.4},0).wait(2).to({y:450.5},0).wait(2).to({y:448.4},0).wait(2).to({y:448.5},0).wait(6).to({y:448.4},0).wait(4).to({y:448.5},0).wait(12).to({y:448.4},0).wait(4).to({y:449.4},0).wait(2).to({y:448.4},0).wait(4).to({y:448.5},0).wait(4).to({y:448.4},0).wait(4).to({y:448.5},0).to({_off:true},44).wait(6).to({_off:false},0).wait(26).to({_off:true},8).wait(137));
	this.timeline.addTween(cjs.Tween.get(this.instance_98).wait(345).to({_off:false},0).wait(2).to({regX:76.9,regY:57,scaleX:1.02,scaleY:0.98,skewX:11.8,x:446.7,y:460.1},0).wait(2).to({regX:77.2,regY:56.4,scaleX:1.04,scaleY:0.97,skewX:12.2,skewY:5.6,x:446.9,y:461.4},0).to({_off:true},2).wait(55).to({_off:false},0).to({_off:true},2).wait(312).to({_off:false,regX:77.3,regY:56.9,scaleX:1,scaleY:0.99,skewX:11.3,skewY:5.8,x:447.2,y:455.2},0).wait(2).to({regX:78.1,regY:56.2,scaleY:0.99,x:448.2,y:453.1},0).wait(2).to({regX:77,regY:56,x:447.2,y:452},0).wait(2).to({regX:77.2,regY:56.4,scaleX:1,scaleY:0.99,skewX:11.4,skewY:6,y:451.7},0).to({y:713.6},6).wait(6));
	this.timeline.addTween(cjs.Tween.get(this.instance_99).wait(412).to({_off:false},0).to({_off:true},51).wait(98).to({_off:false,regY:6.4,scaleX:1.51,rotation:0,skewX:6,skewY:5.8,x:476.7,y:453},0).wait(2).to({scaleX:1.5,scaleY:1.49,rotation:5.8,skewX:0,skewY:0,x:476.5,y:451.3},0).wait(2).to({scaleX:1.5,y:450.5},0).to({_off:true},2).wait(171));
	this.timeline.addTween(cjs.Tween.get(this.instance_100).wait(601).to({_off:false},0).wait(2).to({regX:32.2,scaleX:1.61,scaleY:1.52,skewX:3,skewY:-6,y:410.7},0).wait(2).to({regX:32.1,scaleX:1.65,scaleY:1.49,skewX:3.3,skewY:-5.8,x:442.9,y:410.4},0).wait(4).to({regX:32.2,scaleX:1.63,scaleY:1.51,x:443.4,y:409.3},0).wait(2).to({regX:33,regY:9.8,scaleX:1.62,scaleY:1.51,skewX:3.1,skewY:-6,x:444.9,y:408.2},0).wait(2).to({regX:32.1,regY:10.1,scaleX:1.61,scaleY:1.52,skewX:3.2,skewY:-6.1,x:443.5,y:408.3},0).wait(40).to({regX:32.2,scaleY:1.52,skewX:3,skewY:-6,x:443.6,y:410.7},0).wait(2).to({regX:32.1,scaleX:1.73,scaleY:1.52,skewX:3.2,skewY:-6.1,y:412.8},0).wait(2).to({scaleX:1.61,x:443.5},0).to({_off:true},59).wait(22));

	// Murray Head
	this.head = new lib.MurrayHead();
	this.head.parent = this;
	this.head.setTransform(444.9,601.9,1.5,1.5,-10.4,0,0,39.5,49.9);
	this.head._off = true;

	this.timeline.addTween(cjs.Tween.get(this.head).wait(9).to({_off:false},0).to({y:349},8).wait(2).to({regX:39.8,scaleX:1.52,scaleY:1.48,rotation:0,skewX:-10.6,skewY:-10,y:352.7},0).wait(2).to({regX:39.6,regY:49.8,scaleX:1.54,scaleY:1.46,skewX:-11.1,skewY:-9.8,x:444.2,y:356.6},0).wait(2).to({regX:39.5,regY:49.9,scaleX:1.52,scaleY:1.48,skewX:-10.6,skewY:-10,x:444.5,y:352.8},0).wait(2).to({regX:39.6,scaleX:1.51,scaleY:1.49,skewX:-10.5,skewY:-10.1,x:444.9,y:350.9},0).wait(2).to({regX:39.5,scaleX:1.5,scaleY:1.5,rotation:-10.4,skewX:0,skewY:0,y:349},0).wait(10).to({regY:49.7,rotation:-27.4,x:428.7,y:655.9},0).wait(2).to({regY:49.6,scaleX:1.5,scaleY:1.5,rotation:-14.6,x:434.5,y:503.3},0).wait(2).to({regY:49.8,rotation:-8.3,x:437.3,y:427.4},0).wait(2).to({rotation:-5,x:438.7,y:389.3},0).wait(2).to({regY:50.1,rotation:-3.3,x:439.4,y:370.7},0).wait(2).to({regX:0,regY:0,scaleX:1.5,scaleY:1.5,rotation:-2,x:381.9,y:275.7},0).wait(24).to({regX:39.5,regY:49.7,rotation:-1.3,x:440.6,y:350.7},0).wait(2).to({regX:45.1,regY:49.4,rotation:-0.8,x:449.7,y:349.7},0).wait(2).to({regX:39.6,regY:49.8,rotation:-0.3,x:442.2,y:350},0).wait(2).to({regX:39.5,rotation:0,x:442.5,y:349.6},0).wait(62).to({regX:39.6,rotation:-0.3,x:442.2,y:350},0).wait(2).to({regX:45,regY:49.4,rotation:-0.8,x:449.6,y:349.7},0).wait(2).to({regX:39.5,regY:49.7,rotation:-1.3,x:440.6,y:350.7},0).wait(2).to({regY:49.8,rotation:-2,x:440,y:351.2},0).wait(36).to({regX:36.1,regY:45.1,rotation:-0.5,x:438,y:343.8},0).wait(2).to({regX:35.7,regY:46.1,rotation:0.5,x:440.8,y:344.8},0).wait(2).to({regX:39.6,regY:49.8,rotation:1.8,x:449.8,y:350},0).wait(2).to({regX:39.5,rotation:3.2,x:452.9,y:349.7},0).wait(64).to({regX:39.6,rotation:-0.3,x:442.2,y:350},0).wait(2).to({regX:45.3,regY:49.4,rotation:-0.8,x:450,y:349.7},0).wait(2).to({regX:39.5,regY:49.7,rotation:-1.3,x:440.6,y:350.7},0).wait(2).to({regY:49.8,rotation:-3,x:440.4,y:349.7},0).wait(2).to({rotation:-4.8,x:449.4,y:349.9},0).wait(2).to({regX:39.4,regY:50.6,rotation:-6.9,x:458.5,y:350.9},0).wait(2).to({regX:39.3,regY:50.2,scaleX:1.5,scaleY:1.5,rotation:-11.3,x:463.4,y:349.5},0).wait(2).to({regX:39.4,regY:50.1,scaleX:1.5,scaleY:1.5,rotation:-15.6,x:468.6,y:348.6},0).wait(34).to({regX:39.6,regY:49.8,scaleX:1.5,scaleY:1.5,rotation:-13,x:456.9,y:348.5},0).wait(2).to({regY:49.9,scaleX:1.53,rotation:-10.3,x:444.2,y:354.1},0).wait(2).to({regY:49.8,scaleX:1.52,x:444.6,y:351.4},0).wait(2).to({regX:39.5,regY:49.9,scaleX:1.5,scaleY:1.5,rotation:-10.4,x:444.9,y:349},0).wait(40).to({regX:39.6,regY:49.8,scaleX:1.52,scaleY:1.5,rotation:-10.3,x:444.6,y:351.4},0).wait(2).to({regY:49.9,scaleX:1.53,x:444.2,y:354.1},0).wait(2).to({scaleX:1.56,scaleY:1.5,rotation:-10.4,x:443.3,y:359.4},0).wait(2).to({regX:38.6,regY:49.8,scaleX:1.5,rotation:-4.5,x:416.1,y:332.9},0).wait(4).to({regX:40.9,regY:44.9,rotation:-2.1,x:417.3,y:328},0).wait(2).to({regX:39.5,regY:49.8,rotation:-1,x:414.6,y:336.7},0).wait(2).to({rotation:0,x:413.6,y:338},0).wait(39).to({rotation:-1,x:414.6,y:336.7},0).wait(2).to({regX:40.9,regY:44.8,rotation:-2.1,x:417.3,y:327.9},0).wait(2).to({regX:38.6,regY:49.8,rotation:-4.5,x:416.1,y:332.9},0).wait(4).to({regX:39.6,regY:49.9,scaleX:1.56,rotation:-10.4,x:443.3,y:359.4},0).wait(2).to({scaleX:1.53,scaleY:1.5,rotation:-10.3,x:444.2,y:354.1},0).wait(2).to({regY:49.8,scaleX:1.52,x:444.6,y:351.4},0).wait(2).to({regX:39.5,regY:49.9,scaleX:1.5,scaleY:1.5,rotation:-10.4,x:444.9,y:349},0).wait(57).to({regX:39.6,regY:49.8,scaleX:1.52,scaleY:1.5,rotation:-10.3,x:444.6,y:351.4},0).wait(2).to({regY:49.9,scaleX:1.53,x:444.2,y:354.1},0).wait(2).to({scaleX:1.56,scaleY:1.5,rotation:-10.4,x:443.3,y:359.4},0).wait(2).to({regX:39.5,scaleX:1.5,scaleY:1.5,rotation:-10.3,x:444.9,y:342.5},0).wait(2).to({regX:39.6,regY:50,x:445.1,y:339.5},0).wait(2).to({regX:38.7,regY:49.9,scaleX:1.47,scaleY:1.53,rotation:0,skewX:-9.2,skewY:-10.4,x:446.7,y:329.8},0).wait(4).to({scaleX:1.48,scaleY:1.52,skewX:-9.8,skewY:-10.3,x:445.6,y:333},0).wait(2).to({regY:50,scaleX:1.49,scaleY:1.51,skewX:-10,x:445.1,y:334.8},0).wait(2).to({regX:39.3,regY:49.9,scaleX:1.5,scaleY:1.5,rotation:-10.4,skewX:0,skewY:0,x:444.6,y:336.2},0).wait(12).to({regX:39.4,regY:50.2,scaleX:1.5,scaleY:1.5,rotation:-10.3,x:445,y:339.8},0).wait(2).to({regX:39.6,regY:49.9,x:445.1,y:342.5},0).wait(2).to({scaleX:1.53,x:444.2,y:354.1},0).wait(2).to({scaleX:1.5,x:445.1,y:350},0).wait(2).to({regX:42.1,regY:50.9,scaleX:1.51,scaleY:1.5,rotation:0,skewX:-10.3,skewY:-10.1,x:449,y:353.1},0).wait(2).to({regX:39.5,regY:50,scaleX:1.52,scaleY:1.5,x:445.1,y:354.7},0).wait(2).to({regX:39.6,regY:49.9,scaleX:1.54,scaleY:1.5,skewX:-10.7,x:445.5,y:359},0).wait(2).to({scaleX:1.52,scaleY:1.5,skewX:-10.5,skewY:-10.3,x:445.1,y:358},0).wait(2).to({regX:40,regY:48.3,scaleX:1.51,scaleY:1.5,rotation:-10.3,skewX:0,skewY:0,x:445.2,y:355},0).wait(2).to({regX:39.3,regY:49.9,scaleX:1.5,scaleY:1.5,rotation:-10.4,x:444.6,y:357},0).wait(44).to({regX:39.5,regY:50.1,scaleX:1.5,scaleY:1.5,rotation:-10.3,x:445,y:353.3},0).wait(2).to({regX:39.4,y:351.3},0).wait(2).to({regX:39.1,regY:49.6,scaleX:1.5,scaleY:1.5,x:444.4,y:349.6},0).wait(2).to({regX:39.5,regY:49.9,scaleX:1.5,scaleY:1.5,rotation:-10.4,x:444.9,y:349},0).wait(34).to({regX:39.9,regY:48.5,scaleX:1.5,scaleY:1.5,rotation:-11.5,x:445.5,y:347.1},0).wait(2).to({regX:39.6,regY:49.8,rotation:-12.8,x:445.8,y:349.3},0).wait(2).to({regX:39.5,regY:49.9,scaleX:1.5,scaleY:1.5,rotation:-15.2,x:446.6,y:350},0).wait(4).to({regX:40.5,regY:50.2,scaleX:1.5,scaleY:1.5,rotation:-15.1,x:447.2,y:347.2},0).wait(2).to({regX:39.5,x:444.7,y:346.1},0).wait(2).to({regX:38.2,regY:48.7,scaleX:1.5,scaleY:1.5,rotation:-15.2,x:440.2,y:343.2},0).wait(40).to({regX:39.6,regY:49.8,scaleX:1.5,scaleY:1.5,rotation:-12.8,x:445.8,y:349.3},0).wait(2).to({regX:39.9,regY:48.5,rotation:-11.5,x:445.5,y:347.1},0).wait(2).to({regX:39.5,regY:49.9,scaleX:1.5,scaleY:1.5,rotation:-10.4,x:444.9,y:349},0).wait(63).to({scaleX:1.5,scaleY:1.5,rotation:-10.3,y:345.9},0).wait(2).to({regX:39.6,regY:50,x:445.1,y:344.6},0).wait(2).to({regX:39.5,regY:49.9,x:444.9,y:343.8},0).wait(2).to({scaleX:1.5,scaleY:1.5,rotation:-10.4,y:343},0).to({y:604.9},6).wait(6));

	// Collar
	this.instance_102 = new lib.MurrayShirtCollarLeft_1();
	this.instance_102.parent = this;
	this.instance_102.setTransform(436.7,724.3,2.551,1.411,0,-6,-29.9,31.9,10.2);
	this.instance_102._off = true;

	this.instance_103 = new lib.MurrayShirtLeftArm_001_1();
	this.instance_103.parent = this;
	this.instance_103.setTransform(508.7,430.7,1.183,1.502,0,106,100.8,22.1,29.6);
	this.instance_103._off = true;

	this.instance_104 = new lib.MurrayNeck1_1();
	this.instance_104.parent = this;
	this.instance_104.setTransform(445.1,331.9,1.479,1.533,0,13,2.8,19.6,8);
	this.instance_104._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_102).wait(37).to({_off:false},0).wait(2).to({regX:32.3,regY:10.3,scaleX:2.55,scaleY:1.41,skewX:6.5,skewY:-17.1,x:428.2,y:570.1},0).wait(2).to({regX:32,regY:10.2,skewX:12.8,skewY:-10.6,x:422.5,y:493.2},0).wait(2).to({regY:10,scaleX:2.55,skewX:16.1,skewY:-7.5,x:420.4,y:454.3},0).wait(2).to({regX:31.9,regY:10.2,scaleY:1.41,skewX:17.6,skewY:-5.8,x:418.8,y:435.3},0).wait(2).to({scaleX:2.55,scaleY:1.41,skewX:19.4,skewY:-4.4,x:421.5,y:413.3},0).wait(24).to({regX:32,regY:10.3,scaleY:1.41,skewX:19.8,skewY:-3.8,x:418.3,y:415.7},0).wait(2).to({skewX:20.3,skewY:-3.3,y:415.1},0).wait(2).to({regX:32.1,regY:10.7,scaleX:2.55,skewX:20.8,skewY:-2.8,x:418.4},0).wait(2).to({regX:30.8,regY:10,scaleX:2.55,scaleY:1.41,skewX:21.4,skewY:-2.5,x:415.5,y:413.7},0).wait(62).to({regX:32.1,regY:10.7,scaleX:2.55,scaleY:1.41,skewX:20.8,skewY:-2.8,x:418.4,y:415.1},0).wait(2).to({regX:32,regY:10.3,scaleX:2.55,skewX:20.3,skewY:-3.3,x:418.3},0).wait(2).to({skewX:19.8,skewY:-3.8,y:415.7},0).wait(2).to({regX:31.9,regY:10.2,scaleY:1.41,skewX:19.4,skewY:-4.4,x:417.8,y:416.2},0).wait(36).to({scaleY:1.41,skewX:20.6,skewY:-3,x:419.5,y:415.3},0).wait(2).to({regX:32,skewX:21.8,skewY:-1.8,x:421.5,y:414.4},0).wait(2).to({skewX:23.3,skewY:-0.5,x:423.1,y:413.4},0).wait(2).to({scaleY:1.41,skewX:24.6,skewY:0.7,x:425.2,y:412.5},0).wait(64).to({regX:32.1,regY:10.7,scaleX:2.55,scaleY:1.41,skewX:20.8,skewY:-2.8,x:418.4,y:415.1},0).wait(2).to({regX:32,regY:10.3,scaleX:2.55,skewX:20.3,skewY:-3.3,x:418.3},0).wait(2).to({skewX:19.8,skewY:-3.8,y:415.7},0).wait(2).to({regX:32.5,regY:10.2,scaleX:2.61,scaleY:1.44,skewX:22.5,skewY:-3.2,x:422.2,y:414.7},0).wait(2).to({regY:12.2,scaleX:2.38,scaleY:1.42,skewX:17.5,skewY:-2.5,x:428.4,y:414.6},0).wait(2).to({regX:30.9,regY:10.7,scaleX:2.21,scaleY:1.44,skewX:16,skewY:-1.8,x:434.7,y:409.8},0).wait(2).to({regX:32,regY:10.5,scaleX:2.04,scaleY:1.45,skewX:13.3,skewY:-1.5,x:446.7,y:406.9},0).wait(2).to({regY:10.3,scaleX:1.87,scaleY:1.47,skewX:10.7,skewY:-1.3,x:456.3,y:404.4},0).wait(34).to({regY:10.2,scaleX:1.74,scaleY:1.49,skewX:6.8,skewY:-3.5,x:450,y:408.4},0).wait(2).to({scaleX:1.68,scaleY:1.5,skewX:3.3,skewY:-10.5,x:443.2,y:415.4},0).wait(2).to({regX:32.1,regY:10.1,scaleX:1.64,scaleY:1.51,skewX:3.1,skewY:-8.3,x:443.5,y:413.9},0).wait(2).to({scaleX:1.61,scaleY:1.52,skewX:3.2,skewY:-6.1,y:412.8},0).wait(2).to({_off:true},38).wait(6).to({_off:false,regX:31.2,regY:10.3,scaleX:1.49,scaleY:1.56,skewX:0.3,skewY:0,x:428,y:397.5},0).wait(4).to({regX:32.1,regY:10.2,scaleY:1.53,skewX:0,x:429,y:400.5},0).wait(2).to({regY:10.3,scaleY:1.51,x:428.8,y:402.2},0).wait(2).to({scaleY:1.49,x:428.6,y:403.7},0).wait(39).to({scaleY:1.51,x:428.8,y:402.2},0).wait(2).to({regY:10.2,scaleY:1.53,x:429,y:400.5},0).wait(2).to({regX:31.2,regY:10.3,scaleY:1.56,skewX:0.3,x:428,y:397.5},0).to({_off:true},4).wait(2).to({_off:false,regX:32,regY:10.2,scaleX:1.68,scaleY:1.5,skewX:3.3,skewY:-10.5,x:443.2,y:415.4},0).wait(2).to({regX:32.1,regY:10.1,scaleX:1.64,scaleY:1.51,skewX:3.1,skewY:-8.3,x:443.5,y:413.9},0).to({_off:true},2).wait(51).to({_off:false,scaleX:1.61,scaleY:1.52,skewX:3.2,skewY:-6.1,y:412.8},0).wait(6).to({scaleX:1.64,scaleY:1.51,skewX:3.1,skewY:-8.3,y:413.9},0).wait(2).to({regX:32,regY:10.2,scaleX:1.68,scaleY:1.5,skewX:3.3,skewY:-10.5,x:443.2,y:415.4},0).wait(2).to({regX:32.4,regY:10,scaleX:1.75,scaleY:1.48,skewX:3.4,skewY:-15.2,x:443.5,y:417.3},0).wait(2).to({regX:32.1,regY:10.1,scaleX:1.6,scaleY:1.58,skewX:3.3,skewY:-6.3,x:444.2,y:405.5},0).wait(2).to({regX:31.7,regY:10.5,scaleX:1.59,scaleY:1.61,skewX:3.5,skewY:-6.3,x:443.8,y:402.6},0).wait(2).to({regX:31.9,regY:10.2,scaleX:1.66,scaleY:1.63,skewX:3.9,skewY:-5.4,x:444.7,y:395.5},0).wait(4).to({regX:32.1,regY:10,scaleX:1.62,skewX:3.8,skewY:-6,x:445,y:396.7},0).wait(2).to({regY:10.1,scaleX:1.6,scaleY:1.63,skewY:-6.3,y:397.6},0).wait(2).to({scaleX:1.58,skewX:3.7,skewY:-6.6,x:444.9,y:398.2},0).wait(12).to({scaleX:1.59,scaleY:1.61,skewX:3.5,skewY:-6.3,x:444.8,y:401.7},0).wait(2).to({regX:32.9,regY:10.2,scaleX:1.6,scaleY:1.58,skewX:3.3,x:445.5,y:405.5},0).wait(2).to({regX:32,scaleX:1.68,scaleY:1.5,skewY:-10.5,x:443.2,y:415.4},0).wait(2).to({regX:32.1,regY:10.1,scaleX:1.61,scaleY:1.52,skewX:3,skewY:-6,x:443.6,y:413.7},0).wait(2).to({scaleX:1.63,skewY:-5.8,y:415.7},0).wait(2).to({regX:35.6,regY:9.1,scaleX:1.65,x:449.5,y:415.6},0).wait(2).to({regX:32.1,regY:10.1,scaleX:1.69,scaleY:1.52,skewX:3.3,x:443.9,y:421.8},0).wait(2).to({scaleX:1.67,x:443.7,y:420.8},0).wait(2).to({scaleX:1.66,x:443.5,y:420.3},0).wait(2).to({regX:32,scaleX:1.65,skewX:3.2,skewY:-5.9,x:443.3,y:419.8},0).wait(44).to({scaleX:1.63,scaleY:1.52,skewX:3.1,skewY:-6,x:443.4,y:416.3},0).wait(2).to({regX:31.9,regY:9.6,scaleX:1.62,skewX:3,y:413.8},0).wait(2).to({regX:32,regY:9.7,scaleX:1.61,x:443.5,y:413.2},0).wait(2).to({regX:32.1,regY:10.1,scaleX:1.61,scaleY:1.52,skewX:3.2,skewY:-6.1,y:412.8},0).wait(26).to({_off:true},8).wait(137));
	this.timeline.addTween(cjs.Tween.get(this.instance_103).wait(345).to({_off:false},0).wait(2).to({regX:22,regY:29.5,scaleX:1.18,scaleY:1.5,skewY:101.3,x:509.2,y:429.7},0).wait(2).to({regX:22.4,regY:29.4,scaleX:1.17,scaleY:1.49,skewX:80.2,skewY:76.8,x:500.3,y:419.8},0).to({_off:true},2).wait(55).to({_off:false},0).to({_off:true},2).wait(330));
	this.timeline.addTween(cjs.Tween.get(this.instance_104).wait(601).to({_off:false},0).wait(2).to({regX:19.7,regY:9.8,scaleX:1.48,scaleY:1.52,skewX:11.1,skewY:0,x:442.8,y:335.7},0).wait(2).to({regX:19.4,regY:9.7,scaleX:1.49,scaleY:1.51,skewX:7.5,skewY:-6.4,x:439,y:337.7},0).wait(4).to({regX:19.6,regY:9.8,scaleX:1.48,scaleY:1.53,skewX:4.8,skewY:-6.5,x:436.9,y:336.2},0).wait(2).to({regY:9.7,scaleX:1.48,scaleY:1.53,skewX:3.3,x:435.7,y:335.2},0).wait(2).to({regY:9.8,scaleX:1.48,scaleY:1.54,skewX:2.1,skewY:-6.6,x:434.5,y:334.5},0).wait(40).to({regX:19.7,scaleX:1.48,scaleY:1.52,skewX:11.1,skewY:0,x:442.8,y:335.7},0).wait(2).to({regX:19.6,regY:8,scaleX:1.48,scaleY:1.53,skewX:13,skewY:2.8,x:445.1,y:331.9},0).wait(2).to({regX:19.7,regY:9.8,scaleX:1.48,scaleY:1.54,skewX:14.8,skewY:6.1,x:446.5,y:333.7},0).to({_off:true},59).wait(22));

	// Murray Shirt Collar Right
	this.instance_105 = new lib.MurrayNeck1_1();
	this.instance_105.parent = this;
	this.instance_105.setTransform(446.3,586.6,1.475,1.543,0,14.8,6.1,19.6,9.8);
	this.instance_105._off = true;

	this.instance_106 = new lib.Murray3ShirtHem_1();
	this.instance_106.parent = this;
	this.instance_106.setTransform(441.7,747.3,1.491,0.677,0,-3.9,-7.7,5.5,33.9);
	this.instance_106.shadow = new cjs.Shadow("rgba(0,0,0,1)",-1,0,5);
	this.instance_106._off = true;

	this.instance_107 = new lib.MurrayShirtCollarLeft_1();
	this.instance_107.parent = this;
	this.instance_107.setTransform(443.5,412.8,1.609,1.519,0,3.2,-6.1,32.1,10.1);

	this.instance_108 = new lib.MurrayShirtShape_004_1();
	this.instance_108.parent = this;
	this.instance_108.setTransform(447.2,457.7,0.998,0.991,0,11.4,6,77.2,56.4);

	this.instance_109 = new lib.MurrayShirtLeftArm_001_1();
	this.instance_109.parent = this;
	this.instance_109.setTransform(506.6,428.7,1.187,1.506,0,108,102.3,22.1,29.5);
	this.instance_109._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_105}]},9).to({state:[{t:this.instance_105}]},8).to({state:[{t:this.instance_105}]},2).to({state:[{t:this.instance_105}]},2).to({state:[{t:this.instance_105}]},2).to({state:[{t:this.instance_105}]},2).to({state:[{t:this.instance_105}]},2).to({state:[{t:this.instance_106}]},10).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},24).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},62).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},36).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},64).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},34).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},44).to({state:[{t:this.instance_106}]},4).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},39).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},2).to({state:[]},4).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_107}]},2).to({state:[{t:this.instance_106}]},51).to({state:[{t:this.instance_106}]},4).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},4).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},10).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},44).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},26).to({state:[{t:this.instance_106}]},8).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},4).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},40).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_106}]},2).to({state:[{t:this.instance_108}]},59).to({state:[{t:this.instance_109}]},4).to({state:[{t:this.instance_109}]},2).to({state:[{t:this.instance_109}]},2).to({state:[{t:this.instance_109}]},2).to({state:[{t:this.instance_109}]},6).wait(6));
	this.timeline.addTween(cjs.Tween.get(this.instance_105).wait(9).to({_off:false},0).to({regX:19.7,x:446.5,y:333.7},8).wait(2).to({regX:19.6,scaleX:1.5,scaleY:1.52,skewX:15.3,skewY:5.8,x:446,y:337.9},0).wait(2).to({regX:19.7,regY:9.9,scaleX:1.52,scaleY:1.5,skewX:15.8,skewY:5.7,x:445.7,y:342.1},0).wait(2).to({regX:19.6,regY:9.8,scaleX:1.5,scaleY:1.52,skewX:15.3,skewY:5.8,x:445.9,y:337.8},0).wait(2).to({regX:19.7,scaleX:1.49,scaleY:1.53,skewX:15,x:446.2,y:335.7},0).wait(2).to({scaleX:1.48,scaleY:1.54,skewX:14.8,skewY:6.1,x:446.5,y:333.7},0).to({_off:true},10).wait(701));
	this.timeline.addTween(cjs.Tween.get(this.instance_106).wait(37).to({_off:false},0).wait(2).to({regY:34,scaleY:0.68,skewX:8.8,skewY:5,x:427.1,y:593.2},0).wait(2).to({scaleX:1.49,skewX:15.1,skewY:11.3,x:419.8,y:516.2},0).wait(2).to({regX:5.7,regY:34.1,skewX:18.3,skewY:14.5,x:416.4,y:477.9},0).wait(2).to({regX:5.5,scaleX:1.49,scaleY:0.68,skewX:19.8,skewY:16.1,x:414.3,y:458.5},0).wait(2).to({regY:34,scaleX:1.49,scaleY:0.68,skewX:21.6,skewY:17.8,x:416.1,y:436.4},0).wait(24).to({regX:5.2,regY:34.1,scaleX:1.49,skewX:22,skewY:18.3,x:411.9,y:438.4},0).wait(2).to({regX:5.4,skewX:22.5,skewY:18.6,x:412,y:437.9},0).wait(2).to({regX:5.5,scaleX:1.49,scaleY:0.68,skewX:23,skewY:19.1,x:412.1,y:437.3},0).wait(2).to({regY:34,scaleX:1.49,scaleY:0.68,skewX:23.5,skewY:19.7,x:412,y:436.6},0).wait(62).to({regY:34.1,scaleX:1.49,scaleY:0.68,skewX:23,skewY:19.1,x:412.1,y:437.3},0).wait(2).to({regX:5.4,scaleX:1.49,scaleY:0.68,skewX:22.5,skewY:18.6,x:412,y:437.9},0).wait(2).to({regX:5.2,skewX:22,skewY:18.3,x:411.9,y:438.4},0).wait(2).to({regX:5.5,regY:34,scaleX:1.49,skewX:21.6,skewY:17.8,x:412.4,y:439.2},0).wait(36).to({regX:5.4,regY:33.7,scaleX:1.49,skewX:22.8,skewY:19,x:413.6,y:438},0).wait(2).to({regY:34.1,skewX:24.1,skewY:20.3,x:414.9,y:437.1},0).wait(2).to({regX:5.5,regY:33.9,skewX:25.3,skewY:21.6,x:416.3,y:436},0).wait(2).to({regY:34,scaleX:1.49,skewX:26.7,skewY:22.9,x:417.5,y:434.9},0).wait(64).to({regY:34.1,scaleX:1.49,scaleY:0.68,skewX:23,skewY:19.1,x:412.1,y:437.3},0).wait(2).to({regX:5.4,scaleX:1.49,scaleY:0.68,skewX:22.5,skewY:18.6,x:412,y:437.9},0).wait(2).to({regX:5.2,skewX:22,skewY:18.3,x:411.9,y:438.4},0).wait(2).to({regX:5.5,regY:34,scaleX:1.49,skewX:23.5,skewY:19.7,x:415.2,y:436.6},0).wait(2).to({regX:5.2,regY:34.1,scaleX:1.48,scaleY:0.68,skewX:22.3,skewY:19,x:423.7,y:434.6},0).wait(2).to({regX:5.7,regY:34,scaleX:1.48,scaleY:0.69,skewX:21.3,skewY:18.3,x:433.1,y:432.6},0).wait(2).to({regX:5.5,regY:33.8,scaleX:1.47,scaleY:0.7,skewX:20.1,skewY:17.6,x:443.1,y:430.4},0).wait(2).to({regY:34.2,scaleX:1.47,scaleY:0.71,skewX:19.1,skewY:17.1,x:453.5,y:428.3},0).wait(34).to({regX:5.7,regY:34.1,scaleX:1.49,scaleY:0.73,skewX:16.6,skewY:16.8,x:449,y:434.1},0).wait(2).to({regX:5.5,regY:34,scaleX:1.54,scaleY:0.74,skewX:14.6,skewY:16.3,x:443.7,y:441.9},0).wait(2).to({regY:34.2,scaleX:1.53,scaleY:0.75,skewX:14.3,skewY:16.6,y:440.9},0).wait(2).to({regX:5.6,regY:34,scaleX:1.52,scaleY:0.75,skewX:14.2,skewY:16.9,x:444,y:439.8},0).wait(46).to({regX:6.4,regY:33,scaleX:1.49,scaleY:0.8,skewX:5.6,skewY:5.8,x:433.2,y:423.7},0).wait(4).to({regX:6.2,regY:33.9,scaleY:0.78,rotation:5.5,skewX:0,skewY:0,x:432.6,y:426.9},0).wait(2).to({scaleY:0.77,x:432.5,y:428.2},0).wait(2).to({regX:8.1,regY:33.8,scaleY:0.76,x:435.1,y:429.6},0).wait(39).to({regX:6.2,regY:33.9,scaleY:0.77,x:432.5,y:428.2},0).wait(2).to({scaleY:0.78,x:432.6,y:426.9},0).wait(2).to({regX:6.4,regY:33,scaleY:0.8,rotation:0,skewX:5.6,skewY:5.8,x:433.2,y:423.7},0).to({_off:true},4).wait(2).to({_off:false,regX:5.5,regY:34,scaleX:1.54,scaleY:0.74,skewX:14.6,skewY:16.3,x:443.7,y:441.9},0).wait(2).to({regY:34.2,scaleX:1.53,scaleY:0.75,skewX:14.3,skewY:16.6,y:440.9},0).to({_off:true},2).wait(51).to({_off:false,regX:5.6,regY:34,scaleX:1.52,scaleY:0.75,skewX:14.2,skewY:16.9,x:444,y:439.8},0).wait(6).to({regX:5.5,regY:34.2,scaleX:1.53,scaleY:0.75,skewX:14.3,skewY:16.6,x:443.7,y:440.9},0).wait(2).to({regY:34,scaleX:1.54,scaleY:0.74,skewX:14.6,skewY:16.3,y:441.9},0).wait(2).to({regX:5.7,scaleX:1.57,scaleY:0.74,skewX:15.2,skewY:15.9,y:444},0).wait(2).to({regX:5.4,scaleX:1.5,scaleY:0.78,skewX:14,skewY:17.6,x:444.2,y:433.5},0).wait(2).to({regX:5.5,scaleX:1.5,scaleY:0.79,skewX:13.8,skewY:18,x:444.6,y:430.4},0).wait(2).to({regX:5.4,regY:34.3,scaleX:1.49,scaleY:0.81,skewY:18.6,y:424.1},0).wait(4).to({regX:5.6,regY:34.2,scaleX:1.49,scaleY:0.81,skewY:18.5,x:444.9,y:425.9},0).wait(2).to({y:426.7},0).wait(2).to({scaleX:1.49,scaleY:0.81,skewY:18.6,y:427.4},0).wait(12).to({regX:5.8,scaleX:1.5,scaleY:0.79,skewY:18,x:445,y:430.7},0).wait(2).to({regX:5.5,scaleX:1.5,scaleY:0.78,skewX:14,skewY:17.6,x:444.3,y:433.6},0).wait(2).to({regY:34,scaleX:1.54,scaleY:0.74,skewX:14.6,skewY:16.3,x:443.7,y:441.9},0).wait(2).to({regX:5.6,scaleX:1.52,scaleY:0.75,skewX:14.3,skewY:16.8,x:444,y:440.6},0).wait(2).to({regX:5.5,regY:33.8,scaleX:1.53,skewY:16.5,y:442.4},0).wait(2).to({regX:5.7,regY:34,scaleX:1.55,scaleY:0.75,skewX:14.5,skewY:16.3,x:444.4,y:444.8},0).wait(2).to({regX:6.2,regY:33.8,scaleX:1.59,scaleY:0.76,skewX:14.9,skewY:16.2,x:445.3,y:448.9},0).wait(2).to({regX:5.6,regY:34,scaleX:1.56,scaleY:0.75,skewX:14.6,skewY:16.3,x:444,y:447.8},0).wait(2).to({regX:5.2,regY:33.8,scaleX:1.55,skewX:14.5,x:443.4,y:446.9},0).wait(2).to({regX:5.5,regY:34.1,scaleX:1.55,skewY:16.6,x:443.8,y:446.8},0).wait(44).to({regY:34,scaleX:1.53,scaleY:0.75,skewX:14.3,x:444,y:443.3},0).wait(2).to({regX:5.7,scaleX:1.52,skewY:16.8,x:444.3,y:441.6},0).wait(2).to({regX:5.4,scaleX:1.52,scaleY:0.75,x:443.9,y:440.6},0).wait(2).to({regX:5.6,scaleX:1.52,scaleY:0.75,skewX:14.2,skewY:16.9,x:444,y:439.8},0).wait(36).to({scaleX:1.51,skewX:14.1,skewY:16.8,x:443.9,y:437.9},0).wait(2).to({regX:5.8,scaleX:1.55,scaleY:0.74,skewX:14.9,skewY:16.2,x:443.7,y:437},0).wait(4).to({regX:4.8,regY:34.7,scaleX:1.53,scaleY:0.75,skewX:14.5,skewY:16.5,x:442.4,y:436.2},0).wait(2).to({regX:5.5,regY:34,scaleX:1.52,scaleY:0.75,skewX:14.3,skewY:16.6,x:443.7,y:435.7},0).wait(2).to({regX:5.6,scaleX:1.52,scaleY:0.75,skewX:14.2,skewY:16.9,x:444,y:435.3},0).wait(40).to({scaleX:1.51,skewX:14.1,skewY:16.8,x:443.9,y:437.9},0).wait(2).to({scaleX:1.52,skewX:14.2,skewY:16.9,x:444,y:439.8},0).wait(2).to({_off:true},59).wait(22));
	this.timeline.addTween(cjs.Tween.get(this.instance_109).wait(720).to({_off:false},0).wait(2).to({scaleY:1.51,skewX:109,skewY:103.3,x:505.6,y:427},0).wait(2).to({regX:22.3,regY:29.1,skewX:109.5,skewY:103.8,y:426.7},0).wait(2).to({regX:22,regY:29.4,scaleX:1.19,scaleY:1.51,skewX:110.1,skewY:104.5,x:504.7,y:425.5},0).to({regY:29.3,skewX:106.1,skewY:100.5,x:508.8,y:687.7},6).wait(6));

	// Murray Shirt Button 1
	this.instance_110 = new lib.MurrayShirtShape_001_1();
	this.instance_110.parent = this;
	this.instance_110.setTransform(475,745.3,0.995,0.953,0,-18.9,-17.8,78.4,55.1);
	this.instance_110._off = true;

	this.instance_111 = new lib.MurrayShirtShape_001_B_1();
	this.instance_111.parent = this;
	this.instance_111.setTransform(445.1,453.6,0.968,0.965,0,9,5.8,76.8,56.6);

	this.instance_112 = new lib.MurrayShirtShape_002_B_1();
	this.instance_112.parent = this;
	this.instance_112.setTransform(446.7,456,0.968,0.979,0,9.6,5.8,77.7,57);

	this.instance_113 = new lib.MurrayShirtShape_003_1();
	this.instance_113.parent = this;
	this.instance_113.setTransform(446.5,453.9,0.967,1.022,0,9.3,5.8,77.4,56.3);

	this.instance_114 = new lib.MurrayShirtShape_005_1();
	this.instance_114.parent = this;
	this.instance_114.setTransform(448.9,455.3,0.982,1.097,0,10.7,5.8,77.8,57.1);

	this.instance_115 = new lib.MurrayShirtShape_004_1();
	this.instance_115.parent = this;
	this.instance_115.setTransform(446.7,460.1,1.018,0.979,0,11.8,5.8,76.9,57);
	this.instance_115._off = true;

	this.instance_116 = new lib.MurrayNeck1_1();
	this.instance_116.parent = this;
	this.instance_116.setTransform(442.7,337.1,1.531,1.52,0,11.6,4.5,18.6,9.5);
	this.instance_116._off = true;

	this.instance_117 = new lib.MurrayShirtShape_000_1();
	this.instance_117.parent = this;
	this.instance_117.setTransform(435.4,443.7,1.002,1.046,0,0.3,0,77,56.2);
	this.instance_117._off = true;

	this.instance_118 = new lib.Murray3ShirtHem_1();
	this.instance_118.parent = this;
	this.instance_118.setTransform(444,439.8,1.515,0.752,0,14.2,16.9,5.6,34);

	this.instance_119 = new lib.MurrayShirtLeftArm_001_1();
	this.instance_119.parent = this;
	this.instance_119.setTransform(508.4,431.7,1.188,1.507,0,106.1,100.5,22.1,29.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_110}]},37).to({state:[{t:this.instance_110}]},2).to({state:[{t:this.instance_110}]},2).to({state:[{t:this.instance_110}]},2).to({state:[{t:this.instance_110}]},2).to({state:[{t:this.instance_110}]},2).to({state:[{t:this.instance_110}]},24).to({state:[{t:this.instance_110}]},2).to({state:[{t:this.instance_110}]},2).to({state:[{t:this.instance_110}]},2).to({state:[{t:this.instance_110}]},62).to({state:[{t:this.instance_110}]},2).to({state:[{t:this.instance_110}]},2).to({state:[{t:this.instance_110}]},2).to({state:[{t:this.instance_110}]},36).to({state:[{t:this.instance_110}]},2).to({state:[{t:this.instance_110}]},2).to({state:[{t:this.instance_110}]},2).to({state:[{t:this.instance_110}]},64).to({state:[{t:this.instance_110}]},2).to({state:[{t:this.instance_110}]},2).to({state:[{t:this.instance_110}]},2).to({state:[{t:this.instance_111}]},2).to({state:[{t:this.instance_112}]},2).to({state:[{t:this.instance_113,p:{regY:56.3,scaleY:1.022,skewX:9.3,skewY:5.8,x:446.5,y:453.9}}]},2).to({state:[{t:this.instance_113,p:{regY:56.2,scaleY:1.006,skewX:10.9,skewY:6,x:448.4,y:451}}]},2).to({state:[{t:this.instance_114}]},34).to({state:[{t:this.instance_115}]},2).to({state:[{t:this.instance_115}]},2).to({state:[{t:this.instance_115}]},2).to({state:[{t:this.instance_115}]},2).to({state:[{t:this.instance_116}]},38).to({state:[{t:this.instance_116}]},2).to({state:[{t:this.instance_116}]},2).to({state:[{t:this.instance_117}]},2).to({state:[{t:this.instance_117}]},4).to({state:[{t:this.instance_117}]},2).to({state:[{t:this.instance_117}]},2).to({state:[{t:this.instance_117}]},39).to({state:[{t:this.instance_117}]},2).to({state:[{t:this.instance_117}]},2).to({state:[{t:this.instance_116}]},4).to({state:[{t:this.instance_115}]},2).to({state:[{t:this.instance_115}]},2).to({state:[{t:this.instance_118}]},2).to({state:[{t:this.instance_115}]},51).to({state:[{t:this.instance_115}]},4).to({state:[{t:this.instance_115}]},2).to({state:[{t:this.instance_115}]},2).to({state:[{t:this.instance_115}]},2).to({state:[{t:this.instance_115}]},2).to({state:[{t:this.instance_115}]},2).to({state:[{t:this.instance_115}]},2).to({state:[{t:this.instance_115}]},4).to({state:[{t:this.instance_115}]},2).to({state:[{t:this.instance_115}]},2).to({state:[{t:this.instance_115}]},10).to({state:[{t:this.instance_115}]},2).to({state:[{t:this.instance_115}]},2).to({state:[{t:this.instance_115}]},2).to({state:[{t:this.instance_115}]},2).to({state:[{t:this.instance_115}]},2).to({state:[{t:this.instance_115}]},2).to({state:[{t:this.instance_115}]},2).to({state:[{t:this.instance_115}]},2).to({state:[{t:this.instance_115}]},2).to({state:[{t:this.instance_115}]},2).to({state:[{t:this.instance_115}]},44).to({state:[{t:this.instance_115}]},2).to({state:[{t:this.instance_115}]},2).to({state:[{t:this.instance_115}]},2).to({state:[{t:this.instance_115}]},26).to({state:[{t:this.instance_115}]},8).to({state:[{t:this.instance_115}]},2).to({state:[{t:this.instance_115}]},2).to({state:[{t:this.instance_115}]},4).to({state:[{t:this.instance_115}]},2).to({state:[{t:this.instance_115}]},2).to({state:[{t:this.instance_115}]},40).to({state:[{t:this.instance_115}]},2).to({state:[{t:this.instance_115}]},2).to({state:[{t:this.instance_119}]},59).to({state:[{t:this.instance_116}]},4).to({state:[{t:this.instance_116}]},2).to({state:[{t:this.instance_116}]},2).to({state:[{t:this.instance_116}]},2).to({state:[{t:this.instance_116}]},6).wait(6));
	this.timeline.addTween(cjs.Tween.get(this.instance_110).wait(37).to({_off:false},0).wait(2).to({regX:77.9,regY:55.6,scaleX:0.99,skewX:-6.1,skewY:-5,x:458.8,y:599},0).wait(2).to({regX:78.1,regY:55.5,skewX:0.1,skewY:1.3,x:451.1,y:525.4},0).wait(2).to({regX:77.9,regY:55.6,skewX:3.3,skewY:4.5,x:446.9,y:488.7},0).wait(2).to({regX:78.4,regY:55.4,skewX:4.8,skewY:6,x:445.5,y:470.3},0).wait(2).to({regX:78.3,scaleX:1,skewX:6.5,skewY:7.7,x:446.9,y:449.1},0).wait(24).to({regX:77.5,regY:55.6,scaleX:0.99,skewX:7,skewY:8,x:442.3,y:451.6},0).wait(2).to({regX:78.1,regY:56.3,skewX:7.5,skewY:8.5,x:442.5,y:452},0).wait(2).to({regX:77.3,regY:56.1,scaleY:0.95,skewX:7.8,skewY:9,x:441.5,y:451.3},0).wait(2).to({regX:75.7,regY:55.4,scaleX:1,scaleY:0.95,skewX:8.5,skewY:9.6,x:439.8,y:450},0).wait(62).to({regX:77.3,regY:56.1,scaleX:0.99,scaleY:0.95,skewX:7.8,skewY:9,x:441.5,y:451.3},0).wait(2).to({regX:78.1,regY:56.3,scaleY:0.95,skewX:7.5,skewY:8.5,x:442.5,y:452},0).wait(2).to({regX:77.5,regY:55.6,skewX:7,skewY:8,x:442.3,y:451.6},0).wait(2).to({regX:78.3,regY:55.4,scaleX:1,skewX:6.5,skewY:7.7,x:443.2,y:451.9},0).wait(36).to({regX:77.7,regY:55.6,scaleX:0.99,skewX:7.8,skewY:8.8,x:443.5,y:451.6},0).wait(2).to({regX:81.4,regY:57.8,skewX:9,skewY:10.1,x:447.8,y:453.9},0).wait(2).to({regX:77.3,regY:56.1,skewX:10.3,skewY:11.5,x:444.9,y:451.2},0).wait(2).to({regX:76.8,scaleX:1,skewX:11.7,skewY:12.8,x:445.4,y:450.7},0).wait(64).to({regX:77.3,scaleX:0.99,scaleY:0.95,skewX:7.8,skewY:9,x:441.5,y:451.3},0).wait(2).to({regX:78.1,regY:56.3,scaleY:0.95,skewX:7.5,skewY:8.5,x:442.5,y:452},0).wait(2).to({regX:77.5,regY:55.6,skewX:7,skewY:8,x:442.3,y:451.6},0).wait(2).to({regX:77.4,regY:56.2,scaleX:0.97,skewX:8.5,skewY:6,x:444.9,y:451},0).to({_off:true},2).wait(479));
	this.timeline.addTween(cjs.Tween.get(this.instance_115).wait(301).to({_off:false},0).wait(2).to({regX:77.5,regY:57.7,scaleX:1.01,scaleY:0.99,skewX:11.5,x:447.3,y:459.8},0).wait(2).to({regX:77.2,regY:56.4,scaleX:1,scaleY:0.99,skewX:11.4,skewY:6,x:447.2,y:457.7},0).wait(2).to({_off:true},38).wait(63).to({_off:false,regX:76.9,regY:57,scaleX:1.02,scaleY:0.98,skewX:11.8,skewY:5.8,x:446.7,y:460.1},0).wait(2).to({regX:77.5,regY:57.7,scaleX:1.01,scaleY:0.99,skewX:11.5,x:447.3,y:459.8},0).to({_off:true},2).wait(51).to({_off:false,regX:77.2,regY:56.4,scaleX:1,scaleY:0.99,skewX:11.4,skewY:6,x:447.2,y:457.7},0).wait(6).to({regX:77.5,regY:57.7,scaleX:1.01,scaleY:0.99,skewX:11.5,skewY:5.8,x:447.3,y:459.8},0).wait(2).to({regX:76.9,regY:57,scaleX:1.02,scaleY:0.98,skewX:11.8,x:446.7,y:460.1},0).wait(2).to({regX:77.2,regY:56.4,scaleX:1.04,scaleY:0.97,skewX:12.2,skewY:5.6,x:446.9,y:461.4},0).wait(2).to({regX:77,regY:57.1,scaleX:1,scaleY:1.03,skewX:11.3,skewY:7.5,x:448.2,y:452.8},0).wait(2).to({regX:77.3,regY:56.5,scaleX:1,scaleY:1.05,skewX:11.1,skewY:8.3,x:449.3,y:449.4},0).wait(2).to({regX:77.2,regY:56.6,scaleX:0.97,scaleY:1.07,skewX:8.9,skewY:9.1,x:449.8,y:446.8},0).wait(4).to({regX:79.4,regY:57,scaleX:0.99,skewX:10.5,skewY:9,x:451.9,y:447.5},0).wait(2).to({regX:77.5,regY:56.2,scaleX:1,skewX:11.3,x:450.2,y:446.4},0).wait(2).to({regX:77.2,regY:56.6,scaleX:1.01,scaleY:1.07,skewX:12.2,skewY:9.1,x:449.7,y:446.8},0).wait(12).to({regX:77.3,scaleX:1,scaleY:1.05,skewX:11.6,skewY:8.3,x:449.1,y:449.5},0).wait(2).to({regX:77,regY:57.1,scaleX:1,scaleY:1.03,skewX:11.3,skewY:7.5,x:448.2,y:452.8},0).wait(2).to({regX:76.9,regY:57,scaleX:1.02,scaleY:0.98,skewX:11.8,skewY:5.8,x:446.7,y:460.1},0).wait(2).to({regX:76.3,regY:56.6,scaleX:1,scaleY:0.99,skewX:11.3,x:446.3,y:458.6},0).wait(2).to({regX:77.4,regY:56.3,scaleX:1.01,scaleY:0.99,x:447.6,y:460.6},0).wait(2).to({regX:77.2,regY:56.4,scaleX:1.02,skewX:11.5,skewY:5.6,x:447.5,y:462.6},0).wait(2).to({scaleX:1.05,scaleY:0.99,skewX:12,skewY:5.7,x:447.7,y:466.7},0).wait(2).to({scaleX:1.03,scaleY:0.99,skewX:11.8,skewY:5.8,x:447.4,y:465.6},0).wait(2).to({regX:78.2,regY:55.4,scaleX:1.03,skewX:11.6,x:448.6,y:464.3},0).wait(2).to({regX:77.2,regY:56.4,scaleX:1.02,x:447.2,y:464.7},0).wait(44).to({regY:56.5,scaleX:1.01,scaleY:0.99,skewX:11.5,y:461.2},0).wait(2).to({regX:77,regY:56.6,scaleX:1,skewX:11.3,x:447,y:459.6},0).wait(2).to({regX:77.2,regY:56.5,scaleX:1,scaleY:0.99,x:447.2,y:458.6},0).wait(2).to({regY:56.4,scaleX:1,scaleY:0.99,skewX:11.4,skewY:6,y:457.7},0).wait(36).to({scaleX:1,scaleY:1.01,skewX:11.3,skewY:5.8,x:447.3},0).wait(2).to({scaleX:1.02,scaleY:1.03,skewX:11.9,skewY:5.7,x:446.7,y:458.8},0).wait(4).to({regX:79,regY:55.4,scaleX:1.01,scaleY:1.04,skewX:11.5,skewY:5.8,x:449,y:457.4},0).wait(2).to({regX:77.2,regY:56.5,scaleX:1,scaleY:1.04,x:447,y:457.9},0).wait(2).to({regY:56.1,scaleX:1,scaleY:1.05,skewX:11.4,skewY:6,x:447.3,y:457.4},0).wait(40).to({regY:56.4,scaleX:1,scaleY:1.01,skewX:11.3,skewY:5.8,y:457.7},0).wait(2).to({scaleX:1,scaleY:0.99,skewX:11.4,skewY:6,x:447.2},0).wait(2).to({_off:true},59).wait(22));
	this.timeline.addTween(cjs.Tween.get(this.instance_116).wait(345).to({_off:false},0).wait(2).to({regX:17.1,regY:11.1,scaleX:1.59,scaleY:1.5,skewX:8.5,skewY:3,x:437.6,y:343.4},0).wait(2).to({regX:19.7,regY:9.8,scaleX:1.7,scaleY:1.46,skewX:2.3,skewY:0.3,x:437.4,y:349.7},0).to({_off:true},2).wait(55).to({_off:false,skewY:0.3},0).to({_off:true},2).wait(312).to({_off:false,regX:19.5,regY:9.2,scaleX:1.48,scaleY:1.54,skewX:14.8,skewY:6,x:446.4,y:329.9},0).wait(2).to({regX:19.9,scaleX:1.47,scaleY:1.54,x:447,y:328.6},0).wait(2).to({regX:19.7,regY:9.8,scaleY:1.54,x:446.4,y:328.8},0).wait(2).to({regY:10,scaleX:1.48,scaleY:1.54,skewY:6.1,y:328},0).to({regY:9.8,x:446.5,y:589.6},6).wait(6));
	this.timeline.addTween(cjs.Tween.get(this.instance_117).wait(351).to({_off:false},0).wait(4).to({regY:56.1,scaleY:1.02,skewX:0,x:435.2,y:445.6},0).wait(2).to({regX:79.5,regY:56.3,scaleY:1.01,x:437.6,y:446.9},0).wait(2).to({regX:77,regY:56.2,scaleY:1,x:434.9,y:447.9},0).wait(39).to({regX:79.5,regY:56.3,scaleY:1.01,x:437.6,y:446.9},0).wait(2).to({regX:77,regY:56.1,scaleY:1.02,x:435.2,y:445.6},0).wait(2).to({regY:56.2,scaleY:1.05,skewX:0.3,x:435.4,y:443.7},0).to({_off:true},4).wait(332));

	// Murray Shirt Collar Right
	this.instance_120 = new lib.MurrayNeck2_1();
	this.instance_120.parent = this;
	this.instance_120.setTransform(440.2,618.7,1.475,1.543,0,14.8,6.1,22.8,4);
	this.instance_120._off = true;

	this.instance_121 = new lib.MurrayShirtLeftArm_001_1();
	this.instance_121.parent = this;
	this.instance_121.setTransform(515.6,708.4,1.5,1.5,58.1,0,0,22.2,29.4);
	this.instance_121._off = true;

	this.instance_122 = new lib.ShirtLeftArm_1();
	this.instance_122.parent = this;
	this.instance_122.setTransform(485.6,444.9,1.505,1.5,0,0,-4.8,22,34.9);
	this.instance_122._off = true;

	this.instance_123 = new lib.MurrayShirtShape_004_1();
	this.instance_123.parent = this;
	this.instance_123.setTransform(447.2,457.7,0.998,0.991,0,11.4,6,77.2,56.4);

	this.instance_124 = new lib.MurrayLeftArm2_0001_1();
	this.instance_124.parent = this;
	this.instance_124.setTransform(525.4,413.7,1.341,1.487,0,134.7,-33.1,18.9,38.8);

	this.instance_125 = new lib.ShirtLeftArm_008_1();
	this.instance_125.parent = this;
	this.instance_125.setTransform(498.3,393.4,1.325,1.551,0,18.3,1.7,22.2,29.4);
	this.instance_125._off = true;

	this.instance_126 = new lib.neckPatc_1();
	this.instance_126.parent = this;
	this.instance_126.setTransform(550.4,461.1,0.648,0.813,0,0,0,12.9,15.5);

	this.instance_127 = new lib.MurrayLeftThumb_110_1();
	this.instance_127.parent = this;
	this.instance_127.setTransform(554,448.5,1,1,0,0,0,14.2,12.7);

	this.instance_128 = new lib.MurrayNeck1_1();
	this.instance_128.parent = this;
	this.instance_128.setTransform(446.7,337.8,1.475,1.542,0,14.8,6,19.9,10.2);
	this.instance_128._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_120}]},9).to({state:[{t:this.instance_120}]},8).to({state:[{t:this.instance_120}]},2).to({state:[{t:this.instance_120}]},2).to({state:[{t:this.instance_120}]},2).to({state:[{t:this.instance_120}]},2).to({state:[{t:this.instance_120}]},2).to({state:[{t:this.instance_121}]},10).to({state:[{t:this.instance_121}]},2).to({state:[{t:this.instance_121}]},2).to({state:[{t:this.instance_121}]},2).to({state:[{t:this.instance_121}]},2).to({state:[{t:this.instance_121}]},2).to({state:[{t:this.instance_121}]},24).to({state:[{t:this.instance_121}]},2).to({state:[{t:this.instance_121}]},2).to({state:[{t:this.instance_121}]},2).to({state:[{t:this.instance_121}]},62).to({state:[{t:this.instance_121}]},2).to({state:[{t:this.instance_121}]},2).to({state:[{t:this.instance_121}]},2).to({state:[{t:this.instance_121}]},36).to({state:[{t:this.instance_121}]},2).to({state:[{t:this.instance_121}]},2).to({state:[{t:this.instance_121}]},2).to({state:[{t:this.instance_121}]},64).to({state:[{t:this.instance_121}]},2).to({state:[{t:this.instance_121}]},2).to({state:[{t:this.instance_121}]},2).to({state:[{t:this.instance_121}]},2).to({state:[{t:this.instance_121}]},2).to({state:[{t:this.instance_121}]},2).to({state:[{t:this.instance_121}]},2).to({state:[{t:this.instance_121}]},34).to({state:[{t:this.instance_121}]},2).to({state:[{t:this.instance_121}]},2).to({state:[{t:this.instance_121}]},2).to({state:[{t:this.instance_121}]},2).to({state:[{t:this.instance_120}]},38).to({state:[{t:this.instance_120}]},2).to({state:[{t:this.instance_120}]},2).to({state:[{t:this.instance_122}]},2).to({state:[{t:this.instance_122}]},4).to({state:[{t:this.instance_122}]},2).to({state:[{t:this.instance_122}]},2).to({state:[{t:this.instance_122}]},39).to({state:[{t:this.instance_122}]},2).to({state:[{t:this.instance_122}]},2).to({state:[{t:this.instance_120}]},4).to({state:[{t:this.instance_121}]},2).to({state:[{t:this.instance_121}]},2).to({state:[{t:this.instance_123}]},2).to({state:[{t:this.instance_121}]},51).to({state:[{t:this.instance_121}]},4).to({state:[{t:this.instance_121}]},2).to({state:[{t:this.instance_121}]},2).to({state:[{t:this.instance_121}]},2).to({state:[{t:this.instance_121},{t:this.instance_124}]},2).to({state:[{t:this.instance_121}]},2).to({state:[{t:this.instance_125}]},2).to({state:[{t:this.instance_125}]},4).to({state:[{t:this.instance_125}]},2).to({state:[{t:this.instance_125}]},2).to({state:[{t:this.instance_125}]},10).to({state:[{t:this.instance_125}]},2).to({state:[{t:this.instance_125}]},2).to({state:[{t:this.instance_121}]},2).to({state:[{t:this.instance_121}]},2).to({state:[{t:this.instance_121}]},2).to({state:[{t:this.instance_121},{t:this.instance_127},{t:this.instance_126}]},2).to({state:[{t:this.instance_121}]},2).to({state:[{t:this.instance_121}]},2).to({state:[{t:this.instance_121}]},2).to({state:[{t:this.instance_121}]},2).to({state:[{t:this.instance_128}]},44).to({state:[{t:this.instance_128}]},2).to({state:[{t:this.instance_128}]},2).to({state:[{t:this.instance_121}]},2).to({state:[{t:this.instance_121}]},26).to({state:[{t:this.instance_121}]},8).to({state:[{t:this.instance_121}]},2).to({state:[{t:this.instance_121}]},2).to({state:[{t:this.instance_121}]},4).to({state:[{t:this.instance_121}]},2).to({state:[{t:this.instance_121}]},2).to({state:[{t:this.instance_121}]},40).to({state:[{t:this.instance_121}]},2).to({state:[{t:this.instance_121}]},2).to({state:[{t:this.instance_128}]},59).to({state:[{t:this.instance_120}]},4).to({state:[{t:this.instance_120}]},2).to({state:[{t:this.instance_120}]},2).to({state:[{t:this.instance_120}]},2).to({state:[{t:this.instance_120}]},6).wait(6));
	this.timeline.addTween(cjs.Tween.get(this.instance_120).wait(9).to({_off:false},0).to({y:365.7},8).wait(2).to({regX:22.7,regY:4.3,scaleX:1.5,scaleY:1.52,skewX:15.3,skewY:5.8,x:439.4,y:369.8},0).wait(2).to({regX:22.9,regY:4,scaleX:1.52,scaleY:1.5,skewX:15.8,skewY:5.7,x:439.3,y:373},0).wait(2).to({regX:22.8,scaleX:1.5,scaleY:1.52,skewX:15.3,skewY:5.8,x:439.6,y:369.4},0).wait(2).to({regY:3.9,scaleX:1.49,scaleY:1.53,skewX:15,x:439.9,y:367.4},0).wait(2).to({regY:4,scaleX:1.48,scaleY:1.54,skewX:14.8,skewY:6.1,x:440.2,y:365.7},0).to({_off:true},10).wait(308).to({_off:false,regY:3.8,scaleX:1.49,scaleY:1.53,skewX:15,skewY:5.8,x:440.1,y:367.1},0).wait(2).to({regX:22.9,regY:3.9,scaleX:1.51,scaleY:1.53,skewX:15.3,y:368.6},0).wait(2).to({regY:4,scaleX:1.54,scaleY:1.51,skewX:15.8,skewY:5.7,x:439.7,y:371.9},0).to({_off:true},2).wait(55).to({_off:false},0).to({_off:true},2).wait(312).to({_off:false,regX:22.8,scaleX:1.48,scaleY:1.54,skewX:14.8,skewY:6,x:440.2,y:362.8},0).wait(2).to({scaleX:1.47,scaleY:1.54,y:361.2},0).wait(2).to({scaleY:1.54,y:360.5},0).wait(2).to({scaleX:1.48,scaleY:1.54,skewY:6.1,y:359.7},0).to({regX:22.9,x:440.3,y:621.7},6).wait(6));
	this.timeline.addTween(cjs.Tween.get(this.instance_121).wait(37).to({_off:false},0).wait(2).to({regX:22.1,regY:29.6,scaleX:1.5,scaleY:1.5,rotation:70.9,x:505.4,y:572.1},0).wait(2).to({rotation:77.2,x:500.5,y:503.9},0).wait(2).to({scaleX:1.5,scaleY:1.5,rotation:80.5,x:498.1,y:469.8},0).wait(2).to({rotation:82,x:496.8,y:452.8},0).wait(2).to({scaleX:1.5,scaleY:1.5,rotation:83.5,x:499.3,y:432.9},0).wait(24).to({regY:28.9,scaleX:1.5,scaleY:1.5,rotation:84.2,x:496.6,y:435.6},0).wait(2).to({regX:22.7,regY:27.8,rotation:84.7,x:498.3,y:436.5},0).wait(2).to({regX:21.8,regY:29.1,rotation:85.2,x:496.2,y:435.3},0).wait(2).to({regX:22,regY:29.6,scaleX:1.5,scaleY:1.5,rotation:85.5,x:495.3,y:435.8},0).wait(62).to({regX:21.8,regY:29.1,scaleX:1.5,scaleY:1.5,rotation:85.2,x:496.2,y:435.3},0).wait(2).to({regX:22.7,regY:27.8,rotation:84.7,x:498.3,y:436.5},0).wait(2).to({regX:22.1,regY:28.9,rotation:84.2,x:496.6,y:435.6},0).wait(2).to({regY:29.6,scaleX:1.5,scaleY:1.5,rotation:83.5,x:495.7,y:435.7},0).wait(36).to({rotation:85,x:496.9,y:436.5},0).wait(2).to({regX:20.7,regY:29.4,rotation:86.2,x:498.3,y:435.2},0).wait(2).to({regX:25.9,regY:26.2,rotation:87.5,x:504.8,y:443.5},0).wait(2).to({regX:26.6,regY:31.1,rotation:88.7,x:498.6,y:445.7},0).wait(64).to({regX:21.8,regY:29.1,scaleX:1.5,scaleY:1.5,rotation:85.2,x:496.2,y:435.3},0).wait(2).to({regX:22.7,regY:27.8,rotation:84.7,x:498.3,y:436.5},0).wait(2).to({regX:22.1,regY:28.9,rotation:84.2,x:496.6,y:435.6},0).wait(2).to({regX:21.5,regY:29.5,scaleX:1.5,scaleY:1.5,rotation:81.3,y:433.1},0).wait(2).to({regX:27.2,regY:26.9,rotation:88.9,x:503,y:440.4},0).wait(2).to({regX:20.8,regY:31.2,scaleX:1.5,scaleY:1.5,rotation:96.3,x:499.1,y:429.3},0).wait(2).to({regX:22.1,regY:29.6,rotation:101.8,x:504.3,y:429.4},0).wait(2).to({scaleX:1.5,scaleY:1.5,rotation:107.5,x:507.1,y:427},0).wait(34).to({regX:22.2,scaleX:1.34,scaleY:1.5,rotation:0,skewX:106.8,skewY:103.8,x:507.8,y:429.5},0).wait(2).to({regX:22,regY:29.5,scaleX:1.18,scaleY:1.5,skewX:106,skewY:101.3,x:509.2,y:429.7},0).wait(2).to({regX:22.1,regY:29.6,scaleX:1.18,scaleY:1.5,skewY:100.8,x:508.7,y:430.7},0).wait(2).to({scaleX:1.19,scaleY:1.51,skewX:106.1,skewY:100.5,x:508.4,y:431.7},0).wait(2).to({_off:true},38).wait(63).to({_off:false,regX:22,regY:29.5,scaleX:1.18,scaleY:1.5,skewX:106,skewY:101.3,x:509.2,y:429.7},0).wait(2).to({regX:22.1,regY:29.6,scaleX:1.18,scaleY:1.5,skewY:100.8,x:508.7,y:430.7},0).to({_off:true},2).wait(51).to({_off:false,scaleX:1.19,scaleY:1.51,skewX:106.1,skewY:100.5,x:508.4,y:431.7},0).wait(6).to({scaleX:1.18,scaleY:1.5,skewX:106,skewY:100.8,x:508.7,y:430.7},0).wait(2).to({regX:22,regY:29.5,scaleX:1.18,scaleY:1.5,skewY:101.3,x:509.2,y:429.7},0).wait(2).to({regX:22.4,regY:29.4,scaleX:1.17,scaleY:1.49,skewX:105.9,skewY:102.5,x:509.9,y:428.4},0).wait(2).to({regX:21.8,scaleX:1.8,scaleY:1.3,skewX:14.8,skewY:24.8,x:495.8,y:430},0).wait(2).to({regX:21.7,scaleX:1.84,scaleY:1.32,skewX:35.5,skewY:23.9,x:490.1,y:415.2},0).to({_off:true},2).wait(24).to({_off:false,regX:22,regY:29.5,scaleX:1.18,scaleY:1.5,skewX:106,skewY:101.3,x:509.2,y:429.7},0).wait(2).to({regX:22.2,scaleX:1.09,scaleY:1.38,skewX:101.8,skewY:101,x:508.4,y:434.2},0).wait(2).to({regX:22.1,regY:29.6,scaleX:1.08,scaleY:1.36,rotation:99.5,skewX:0,skewY:0,y:434.1},0).wait(2).to({regX:21.7,regY:29.5,scaleX:1.06,scaleY:1.33,rotation:0,skewX:97.3,skewY:98.3,x:508.7,y:433.8},0).wait(2).to({regX:21.2,regY:29.7,scaleX:1.02,scaleY:1.29,skewX:92.8,skewY:95.8},0).wait(2).to({regX:21.3,regY:29.9,skewX:95.8,skewY:98.6,x:508.2,y:434.5},0).wait(2).to({regX:24.2,skewX:97.3,skewY:100.1,x:507.6,y:437.7},0).wait(2).to({regX:20.9,regY:29.7,skewX:98.8,skewY:101.7,x:508.4,y:434.8},0).to({_off:true},44).wait(6).to({_off:false,regX:22.1,regY:29.6,scaleX:1.19,scaleY:1.51,skewX:106.1,skewY:100.5,y:431.7},0).wait(36).to({regX:22.2,regY:29.4,scaleX:1.2,scaleY:1.48,skewX:106.3,skewY:103.5,x:506.8,y:426.8},0).wait(2).to({regX:22.1,regY:29.7,scaleX:1.19,scaleY:1.48,skewX:105.7,skewY:109.8,x:507.3,y:423.4},0).wait(4).to({regY:29.6,scaleX:1.21,scaleY:1.47,skewX:106.1,skewY:108.6,x:505.7,y:421.7},0).wait(2).to({regX:22.2,scaleX:1.22,scaleY:1.46,skewX:106.3,skewY:108.1,x:504.9,y:420.9},0).wait(2).to({regY:29.7,scaleX:1.23,scaleY:1.45,skewX:106.7,skewY:107.6,x:503.9,y:420},0).wait(40).to({regY:29.4,scaleX:1.2,scaleY:1.48,skewX:106.3,skewY:103.5,x:506.8,y:426.8},0).wait(2).to({regX:22.1,regY:29.6,scaleX:1.19,scaleY:1.51,skewX:106.1,skewY:100.5,x:508.4,y:431.7},0).wait(2).to({_off:true},59).wait(22));
	this.timeline.addTween(cjs.Tween.get(this.instance_122).wait(351).to({_off:false},0).wait(4).to({regY:29.7,scaleX:1.5,skewY:-2.3,x:483,y:440.8},0).wait(2).to({regX:21.9,regY:29.6,scaleX:1.5,skewY:-1,x:482.2,y:442.9},0).wait(2).to({regX:22,scaleX:1.5,skewY:0,x:480.9,y:444.3},0).wait(39).to({regX:21.9,scaleX:1.5,skewY:-1,x:482.2,y:442.9},0).wait(2).to({regX:22,regY:29.7,scaleX:1.5,skewY:-2.3,x:483,y:440.8},0).wait(2).to({regY:35,scaleX:1.51,skewY:-4.8,x:485.6,y:445.1},0).to({_off:true},4).wait(332));
	this.timeline.addTween(cjs.Tween.get(this.instance_125).wait(479).to({_off:false},0).wait(4).to({scaleY:1.53,skewX:18.1,skewY:3.5,x:497.8,y:396},0).wait(2).to({regX:21.8,scaleX:1.33,scaleY:1.53,skewX:18,skewY:4.3,x:497,y:397.2},0).wait(2).to({regX:22.2,scaleX:1.33,scaleY:1.52,skewX:17.9,skewY:5.4,x:497.2,y:398.5},0).wait(12).to({scaleX:1.31,scaleY:1.52,skewX:41.9,skewY:33.8,x:500.2,y:408.4},0).wait(2).to({regY:29.2,scaleX:1.31,scaleY:1.52,skewX:65.9,skewY:62.2,x:503.1,y:418.1},0).to({_off:true},2).wait(235));
	this.timeline.addTween(cjs.Tween.get(this.instance_128).wait(561).to({_off:false},0).wait(2).to({regY:9.8,scaleX:1.47,scaleY:1.54,x:446.8,y:335.5},0).wait(2).to({regX:20.2,x:447.3,y:334.7},0).to({_off:true},2).wait(149).to({_off:false,regX:19.7,scaleX:1.48,scaleY:1.54,skewY:6.1,x:446.5,y:333.7},0).to({_off:true},4).wait(18));

	// Murray Shirt Button 1
	this.instance_129 = new lib.MurrayNeck3_1();
	this.instance_129.parent = this;
	this.instance_129.setTransform(436.9,642.2,1.305,1.5,6,0,0,37.2,7.8);
	this.instance_129._off = true;

	this.instance_130 = new lib.MurrayNeck1_1();
	this.instance_130.parent = this;
	this.instance_130.setTransform(424.7,640.5,1.475,1.543,0,-12.6,-21.3,19.5,10);
	this.instance_130._off = true;

	this.instance_131 = new lib.MurrayShirtStitches();
	this.instance_131.parent = this;
	this.instance_131.setTransform(437.3,448.5,1.492,1.492,0,0,0,48.4,34.8);

	this.instance_132 = new lib.MurrayNeck2_1();
	this.instance_132.parent = this;
	this.instance_132.setTransform(440.2,367.8,1.475,1.542,0,14.8,6,22.8,4);
	this.instance_132._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_129}]},9).to({state:[{t:this.instance_129}]},8).to({state:[{t:this.instance_129}]},2).to({state:[{t:this.instance_129}]},2).to({state:[{t:this.instance_129}]},2).to({state:[{t:this.instance_129}]},2).to({state:[{t:this.instance_129}]},2).to({state:[{t:this.instance_130}]},10).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_130}]},24).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_130}]},62).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_130}]},36).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_130}]},64).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_130}]},34).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_129}]},38).to({state:[{t:this.instance_129}]},2).to({state:[{t:this.instance_129}]},2).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_130}]},4).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_130}]},39).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_129}]},4).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_131}]},2).to({state:[{t:this.instance_130}]},51).to({state:[{t:this.instance_130}]},4).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_130}]},4).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_130}]},10).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_132}]},44).to({state:[{t:this.instance_132}]},2).to({state:[{t:this.instance_132}]},2).to({state:[{t:this.instance_130}]},2).to({state:[{t:this.instance_130}]},26).to({state:[{t:this.instance_132}]},8).to({state:[{t:this.instance_132}]},2).to({state:[{t:this.instance_132}]},2).to({state:[{t:this.instance_132}]},4).to({state:[{t:this.instance_132}]},2).to({state:[{t:this.instance_132}]},2).to({state:[{t:this.instance_132}]},40).to({state:[{t:this.instance_132}]},2).to({state:[{t:this.instance_132}]},2).to({state:[{t:this.instance_132}]},59).to({state:[]},4).wait(18));
	this.timeline.addTween(cjs.Tween.get(this.instance_129).wait(9).to({_off:false},0).to({y:389.2},8).wait(2).to({scaleX:1.32,scaleY:1.48,rotation:0,skewX:6,skewY:5.8,x:437.1,y:392.6},0).wait(2).to({regX:38.2,scaleX:1.35,scaleY:1.45,skewX:6.3,skewY:5.6,y:395.8},0).wait(2).to({regX:37.3,scaleX:1.32,scaleY:1.48,skewX:6,skewY:5.8,x:436.4,y:392.5},0).wait(2).to({regX:37.4,regY:7.5,scaleX:1.27,scaleY:1.5,rotation:5.8,skewX:0,skewY:0,x:435.4,y:387},0).wait(2).to({regY:7.6,y:386.3},0).to({_off:true},10).wait(308).to({_off:false,regX:37.2,regY:7.7,scaleX:1.32,scaleY:1.49,rotation:0,skewX:6,skewY:5.8,x:436.7,y:390.5},0).wait(2).to({regY:7.8,scaleX:1.33,scaleY:1.48,x:436.5,y:392},0).wait(2).to({regX:38.7,regY:6.5,scaleX:1.36,scaleY:1.46,skewX:6.4,skewY:5.6,x:438.4,y:393},0).to({_off:true},2).wait(55).to({_off:false},0).to({_off:true},2).wait(330));
	this.timeline.addTween(cjs.Tween.get(this.instance_130).wait(37).to({_off:false},0).wait(2).to({regX:19.7,regY:9.8,scaleX:1.47,skewX:0,skewY:-8.5,x:434.2,y:487.6},0).wait(2).to({scaleX:1.48,skewX:6.3,skewY:-2.1,x:438.8,y:411.4},0).wait(2).to({regX:19.8,regY:10.2,skewX:9.6,skewY:0.8,x:441.1,y:373.9},0).wait(2).to({regY:9.8,scaleY:1.54,skewX:11.1,skewY:2.3,x:442.4,y:354.2},0).wait(2).to({regX:19.7,scaleY:1.54,skewX:12.9,skewY:4.1,x:447,y:332.3},0).wait(24).to({scaleY:1.54,skewX:13.3,skewY:4.5,x:444.1,y:334.8},0).wait(2).to({regX:19.6,regY:9.9,skewX:13.8,skewY:5,x:444.8,y:334.6},0).wait(2).to({regX:19.2,regY:9.8,scaleX:1.47,skewX:14.3,skewY:5.5,x:444.9,y:334.1},0).wait(2).to({regX:19.7,scaleX:1.48,scaleY:1.54,skewX:14.8,skewY:6.1,x:446.5,y:333.7},0).wait(62).to({regX:19.2,scaleX:1.47,scaleY:1.54,skewX:14.3,skewY:5.5,x:444.9,y:334.1},0).wait(2).to({regX:19.6,regY:9.9,scaleX:1.48,skewX:13.8,skewY:5,x:444.8,y:334.6},0).wait(2).to({regX:19.7,regY:9.8,skewX:13.3,skewY:4.5,x:444.1,y:334.8},0).wait(2).to({scaleY:1.54,skewX:12.9,skewY:4.1,x:443.4,y:335.2},0).wait(36).to({scaleY:1.54,skewX:14.1,skewY:5.3,x:447,y:334.8},0).wait(2).to({regX:20.7,regY:9.4,skewX:15.3,skewY:6.5,x:452.1,y:334.2},0).wait(2).to({regX:20.1,regY:9.6,scaleX:1.47,skewX:16.8,skewY:7.8,x:454.8,y:334},0).wait(2).to({regX:20.4,regY:9.8,scaleX:1.48,scaleY:1.54,skewX:18,skewY:9.3,x:458.7,y:334.2},0).wait(64).to({regX:19.2,scaleX:1.47,scaleY:1.54,skewX:14.3,skewY:5.5,x:444.9,y:334.1},0).wait(2).to({regX:19.6,regY:9.9,scaleX:1.48,skewX:13.8,skewY:5,x:444.8,y:334.6},0).wait(2).to({regX:19.7,regY:9.8,skewX:13.3,skewY:4.5,x:444.1,y:334.8},0).wait(2).to({regX:19.6,regY:9.9,scaleY:1.54,skewX:11.9,skewY:3.1,x:443.3,y:333.7},0).wait(2).to({scaleY:1.54,skewX:10.8,skewY:2,x:448.9,y:334.1},0).wait(2).to({regY:9.8,scaleY:1.54,skewX:9.8,skewY:1,x:454.4,y:334.4},0).wait(2).to({regX:19.7,scaleY:1.54,skewX:7.3,skewY:-1.3,x:458.6,y:334.7},0).wait(2).to({regX:19.6,scaleY:1.54,skewX:4.9,skewY:-3.9,x:462.4,y:335},0).wait(34).to({skewX:9.8,skewY:1,x:454.4,y:334.5},0).wait(2).to({regX:17.1,regY:11.1,scaleX:1.59,scaleY:1.5,skewX:8.5,skewY:3,x:437.6,y:343.4},0).wait(2).to({regX:18.6,regY:9.5,scaleX:1.53,scaleY:1.52,skewX:11.6,skewY:4.5,x:442.7,y:337.1},0).wait(2).to({regX:19.7,regY:9.8,scaleX:1.48,scaleY:1.54,skewX:14.8,skewY:6.1,x:446.5,y:333.7},0).wait(2).to({_off:true},38).wait(6).to({_off:false,regX:19.4,regY:10,scaleX:1.5,scaleY:1.57,skewX:0.3,skewY:0,x:414,y:323.2},0).wait(4).to({regX:19.3,scaleY:1.53,skewX:0,x:413.2,y:327.9},0).wait(2).to({regX:19.4,scaleY:1.52,x:413.1,y:330.2},0).wait(2).to({scaleY:1.5,x:412.8,y:332.5},0).wait(39).to({scaleY:1.52,x:413.1,y:330.2},0).wait(2).to({regX:19.3,scaleY:1.53,x:413.2,y:327.9},0).wait(2).to({regX:19.4,scaleY:1.57,skewX:0.3,x:414,y:323.2},0).to({_off:true},4).wait(2).to({_off:false,regX:17.1,regY:11.1,scaleX:1.59,scaleY:1.5,skewX:8.5,skewY:3,x:437.6,y:343.4},0).wait(2).to({regX:18.6,regY:9.5,scaleX:1.53,scaleY:1.52,skewX:11.6,skewY:4.5,x:442.7,y:337.1},0).to({_off:true},2).wait(51).to({_off:false,regX:19.7,regY:9.8,scaleX:1.48,scaleY:1.54,skewX:14.8,skewY:6.1,x:446.5,y:333.7},0).wait(6).to({regX:18.6,regY:9.5,scaleX:1.53,scaleY:1.52,skewX:11.6,skewY:4.5,x:442.7,y:337.1},0).wait(2).to({regX:17.1,regY:11.1,scaleX:1.59,scaleY:1.5,skewX:8.5,skewY:3,x:437.6,y:343.4},0).wait(2).to({regX:19.7,regY:9.8,scaleX:1.7,scaleY:1.46,skewX:2.3,skewY:0.3,x:437.4,y:349.7},0).wait(2).to({scaleX:1.48,scaleY:1.54,skewX:14.8,skewY:6,x:446.5,y:327.3},0).wait(2).to({regX:19.6,scaleX:1.47,scaleY:1.54,x:446.3,y:324.2},0).wait(2).to({regX:19.7,scaleX:1.44,scaleY:1.61,skewX:13.2,skewY:6.5,y:315.3},0).wait(4).to({regX:19.8,regY:10.2,scaleX:1.46,scaleY:1.58,skewX:14,skewY:6.3,y:318.8},0).wait(2).to({regX:19.6,regY:9.9,scaleX:1.47,scaleY:1.56,skewX:14.3,skewY:6,x:446.4,y:319.6},0).wait(2).to({regX:19.7,regY:9.8,scaleX:1.48,scaleY:1.54,skewX:14.8,skewY:6.1,x:446.5,y:320.9},0).wait(12).to({scaleX:1.47,scaleY:1.54,skewY:6,x:446.6,y:324},0).wait(2).to({regX:19.6,scaleX:1.48,scaleY:1.54,x:446.4,y:327.3},0).wait(2).to({regX:17.1,regY:11.1,scaleX:1.59,scaleY:1.5,skewX:8.5,skewY:3,x:437.6,y:343.4},0).wait(2).to({regX:19.6,regY:9.8,scaleX:1.47,scaleY:1.54,skewX:14.8,skewY:6,x:446.4,y:334.5},0).wait(2).to({scaleX:1.48,skewY:5.8,x:446.6,y:336.6},0).wait(2).to({regX:20,regY:9.5,scaleX:1.49,scaleY:1.54,skewX:15,x:447.4,y:338.3},0).wait(2).to({regX:19.5,regY:9.7,scaleX:1.52,scaleY:1.55,skewX:15.2,skewY:5.9,x:446.7,y:342.5},0).wait(2).to({regX:19.7,regY:9.8,scaleX:1.5,scaleY:1.54,skewX:15,skewY:5.8,x:446.8,y:341.8},0).wait(2).to({scaleX:1.49,scaleY:1.54,skewX:14.8,skewY:6,x:446.6,y:341.2},0).wait(2).to({regX:19.6,scaleX:1.48,skewY:6.1,x:446.3,y:340.7},0).to({_off:true},44).wait(6).to({_off:false,regX:19.7,x:446.5,y:333.7},0).wait(26).to({_off:true},8).wait(137));
	this.timeline.addTween(cjs.Tween.get(this.instance_132).wait(561).to({_off:false},0).wait(2).to({scaleX:1.47,scaleY:1.54,y:366.7},0).wait(2).to({regX:22.9,x:440.3,y:366.2},0).to({_off:true},2).wait(34).to({_off:false,regX:22.8,scaleX:1.48,scaleY:1.53,skewX:13,skewY:2.8,x:439.2,y:365.6},0).wait(2).to({regX:22.9,regY:3.9,scaleX:1.48,scaleY:1.52,skewX:11.1,skewY:0,x:438.4,y:365.2},0).wait(2).to({regY:4.2,scaleX:1.49,scaleY:1.51,skewX:7.5,skewY:-6.4,x:436.3,y:364.8},0).wait(4).to({regX:22.8,regY:4,scaleX:1.48,scaleY:1.53,skewX:4.8,skewY:-6.5,x:435.1,y:363.4},0).wait(2).to({regY:3.9,scaleX:1.48,scaleY:1.53,skewX:3.3,x:434.6,y:362.6},0).wait(2).to({regY:3.6,scaleX:1.48,scaleY:1.54,skewX:2.1,skewY:-6.6,x:434.1,y:361.5},0).wait(40).to({regX:22.9,regY:3.9,scaleX:1.48,scaleY:1.52,skewX:11.1,skewY:0,x:438.4,y:365.2},0).wait(2).to({regX:22.8,regY:4,scaleX:1.48,scaleY:1.53,skewX:13,skewY:2.8,x:439.2,y:365.6},0).wait(2).to({scaleX:1.48,scaleY:1.54,skewX:14.8,skewY:6.1,x:440.2,y:365.7},0).wait(59).to({_off:true},4).wait(18));

	// Murray Shirt Button 1
	this.instance_133 = new lib.MurrayNeck2_3_4_1();
	this.instance_133.parent = this;
	this.instance_133.setTransform(433.3,668.4,1.475,1.543,0,-12.6,-21.3,22.7,2);
	this.instance_133._off = true;

	this.instance_134 = new lib.MurrayNeck2_1();
	this.instance_134.parent = this;
	this.instance_134.setTransform(439,365.9,1.475,1.543,0,11.9,3.1,22.9,4);
	this.instance_134._off = true;

	this.instance_135 = new lib.MurrayNeck1_1();
	this.instance_135.parent = this;
	this.instance_135.setTransform(446.5,333.7,1.475,1.543,0,14.8,6.1,19.7,9.8);

	this.instance_136 = new lib.MurrayNeck3_1();
	this.instance_136.parent = this;
	this.instance_136.setTransform(435.4,388.6,1.274,1.5,5.8,0,0,37.4,7.7);
	this.instance_136._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_133}]},37).to({state:[{t:this.instance_133}]},2).to({state:[{t:this.instance_133}]},2).to({state:[{t:this.instance_133}]},2).to({state:[{t:this.instance_133}]},2).to({state:[{t:this.instance_133}]},2).to({state:[{t:this.instance_133}]},24).to({state:[{t:this.instance_133}]},2).to({state:[{t:this.instance_133}]},2).to({state:[{t:this.instance_133}]},2).to({state:[{t:this.instance_133}]},62).to({state:[{t:this.instance_133}]},2).to({state:[{t:this.instance_133}]},2).to({state:[{t:this.instance_133}]},2).to({state:[{t:this.instance_133}]},36).to({state:[{t:this.instance_133}]},2).to({state:[{t:this.instance_133}]},2).to({state:[{t:this.instance_133}]},2).to({state:[{t:this.instance_133}]},64).to({state:[{t:this.instance_133}]},2).to({state:[{t:this.instance_133}]},2).to({state:[{t:this.instance_134}]},2).to({state:[{t:this.instance_134}]},2).to({state:[{t:this.instance_134}]},2).to({state:[{t:this.instance_134}]},2).to({state:[{t:this.instance_134}]},2).to({state:[{t:this.instance_134}]},34).to({state:[{t:this.instance_134}]},2).to({state:[{t:this.instance_134}]},2).to({state:[{t:this.instance_134}]},2).to({state:[{t:this.instance_134}]},2).to({state:[]},38).to({state:[{t:this.instance_134}]},6).to({state:[{t:this.instance_134}]},4).to({state:[{t:this.instance_134}]},2).to({state:[{t:this.instance_134}]},2).to({state:[{t:this.instance_134}]},39).to({state:[{t:this.instance_134}]},2).to({state:[{t:this.instance_134}]},2).to({state:[]},4).to({state:[{t:this.instance_134}]},2).to({state:[{t:this.instance_134}]},2).to({state:[{t:this.instance_135}]},2).to({state:[{t:this.instance_134}]},51).to({state:[{t:this.instance_134}]},4).to({state:[{t:this.instance_134}]},2).to({state:[{t:this.instance_134}]},2).to({state:[{t:this.instance_134}]},2).to({state:[{t:this.instance_134}]},2).to({state:[{t:this.instance_134}]},2).to({state:[{t:this.instance_134}]},2).to({state:[{t:this.instance_134}]},4).to({state:[{t:this.instance_134}]},2).to({state:[{t:this.instance_134}]},2).to({state:[{t:this.instance_134}]},10).to({state:[{t:this.instance_134}]},2).to({state:[{t:this.instance_134}]},2).to({state:[{t:this.instance_134}]},2).to({state:[{t:this.instance_134}]},2).to({state:[{t:this.instance_134}]},2).to({state:[{t:this.instance_134}]},2).to({state:[{t:this.instance_134}]},2).to({state:[{t:this.instance_134}]},2).to({state:[{t:this.instance_134}]},2).to({state:[{t:this.instance_134}]},2).to({state:[{t:this.instance_136}]},44).to({state:[{t:this.instance_136}]},2).to({state:[{t:this.instance_136}]},2).to({state:[{t:this.instance_134}]},2).to({state:[{t:this.instance_134}]},26).to({state:[]},8).to({state:[{t:this.instance_136}]},119).to({state:[{t:this.instance_136}]},2).to({state:[{t:this.instance_136}]},2).to({state:[{t:this.instance_136}]},2).to({state:[{t:this.instance_136}]},6).wait(6));
	this.timeline.addTween(cjs.Tween.get(this.instance_133).wait(37).to({_off:false},0).wait(2).to({regX:22.8,regY:1.7,scaleX:1.47,skewX:0,skewY:-8.5,x:436.2,y:515.8},0).wait(2).to({regX:23,scaleX:1.48,skewX:6.3,skewY:-2.1,x:437.9,y:440},0).wait(2).to({regX:22.8,regY:1.9,skewX:9.6,skewY:0.8,x:438.2,y:402.3},0).wait(2).to({regX:22.7,regY:2.3,scaleY:1.54,skewX:11.1,skewY:2.3,x:438.3,y:383.9},0).wait(2).to({regX:22.8,regY:2,scaleY:1.54,skewX:12.9,skewY:4.1,x:442.5,y:361.5},0).wait(24).to({regY:4.1,scaleY:1.54,skewX:13.3,skewY:4.5,x:438.6,y:367.1},0).wait(2).to({regY:3.9,skewX:13.8,skewY:5,x:439.2,y:366.5},0).wait(2).to({regX:22.9,scaleX:1.47,skewX:14.3,skewY:5.5,x:439.8,y:366.1},0).wait(2).to({regX:22.4,regY:4,scaleX:1.48,scaleY:1.54,skewX:14.8,skewY:6.1,x:439.6,y:365.7},0).wait(62).to({regX:22.9,regY:3.9,scaleX:1.47,scaleY:1.54,skewX:14.3,skewY:5.5,x:439.8,y:366.1},0).wait(2).to({regX:22.8,scaleX:1.48,skewX:13.8,skewY:5,x:439.2,y:366.5},0).wait(2).to({regY:4.1,skewX:13.3,skewY:4.5,x:438.6,y:367.1},0).wait(2).to({regY:2,scaleY:1.54,skewX:12.9,skewY:4.1,x:438.9,y:364.3},0).wait(36).to({regX:22.2,regY:3,scaleY:1.54,skewX:14.1,skewY:5.3,x:440.6,y:365.4},0).wait(2).to({regX:22.9,regY:3.9,skewX:15.3,skewY:6.5,x:444.1,y:366.5},0).wait(2).to({regX:22.8,regY:3.8,scaleX:1.47,skewX:16.8,skewY:7.8,x:446.8,y:365.9},0).wait(2).to({regX:23.1,scaleX:1.48,scaleY:1.54,skewX:18,skewY:9.3,x:450.2,y:365.5},0).wait(64).to({regX:22.9,regY:3.9,scaleX:1.47,scaleY:1.54,skewX:14.3,skewY:5.5,x:439.8,y:366.1},0).wait(2).to({regX:22.8,scaleX:1.48,skewX:13.8,skewY:5,x:439.2,y:366.5},0).wait(2).to({regY:4.1,skewX:13.3,skewY:4.5,x:438.6,y:367.1},0).to({_off:true},2).wait(481));
	this.timeline.addTween(cjs.Tween.get(this.instance_134).wait(257).to({_off:false},0).wait(2).to({regX:22.2,regY:5,scaleY:1.54,skewX:12.6,skewY:3.8,x:444.4,y:367.2},0).wait(2).to({regX:22.8,regY:3.9,skewX:13.6,skewY:4.8,x:452.5,y:365.6},0).wait(2).to({regY:4,skewX:13,skewY:4.3,x:458.6,y:365.8},0).wait(2).to({regX:21.2,scaleY:1.54,skewX:12.6,skewY:3.8,x:462.4,y:365.6},0).wait(34).to({regX:22.6,regY:3.9,scaleY:1.54,skewX:13.6,skewY:4.8,x:452.4},0).wait(2).to({regX:22.9,scaleX:1.51,scaleY:1.53,skewX:15.3,skewY:5.8,x:440.1,y:368.6},0).wait(2).to({regX:22.8,regY:3.8,scaleX:1.49,scaleY:1.53,skewX:15,y:367.1},0).wait(2).to({regY:4,scaleX:1.48,scaleY:1.54,skewX:14.8,skewY:6.1,x:440.2,y:365.7},0).wait(2).to({_off:true},38).wait(6).to({_off:false,regX:22.9,scaleX:1.5,scaleY:1.57,skewX:0.3,skewY:0,x:416.5,y:356.2},0).wait(4).to({regX:22.8,regY:3.9,scaleY:1.53,skewX:0,x:415.9,y:360.1},0).wait(2).to({regX:22.9,regY:4,scaleY:1.52,x:415.8,y:362.2},0).wait(2).to({scaleY:1.5,x:415.5,y:364.2},0).wait(39).to({scaleY:1.52,x:415.8,y:362.2},0).wait(2).to({regX:22.8,regY:3.9,scaleY:1.53,x:415.9,y:360.1},0).wait(2).to({regX:22.9,regY:4,scaleY:1.57,skewX:0.3,x:416.5,y:356.2},0).to({_off:true},4).wait(2).to({_off:false,regY:3.9,scaleX:1.51,scaleY:1.53,skewX:15.3,skewY:5.8,x:440.1,y:368.6},0).wait(2).to({regX:22.8,regY:3.8,scaleX:1.49,scaleY:1.53,skewX:15,y:367.1},0).to({_off:true},2).wait(51).to({_off:false,regY:4,scaleX:1.48,scaleY:1.54,skewX:14.8,skewY:6.1,x:440.2,y:365.7},0).wait(6).to({regY:3.8,scaleX:1.49,scaleY:1.53,skewX:15,skewY:5.8,x:440.1,y:367.1},0).wait(2).to({regX:22.9,regY:3.9,scaleX:1.51,scaleY:1.53,skewX:15.3,y:368.6},0).wait(2).to({regY:4,scaleX:1.54,scaleY:1.51,skewX:15.8,skewY:5.7,x:439.7,y:371.9},0).wait(2).to({regX:22.8,regY:3.9,scaleX:1.48,scaleY:1.54,skewX:14.8,skewY:6,x:440.2,y:359.2},0).wait(2).to({regX:24.8,regY:-0.1,scaleX:1.47,scaleY:1.54,x:444.7,y:350.4},0).wait(2).to({regX:22.9,regY:4.4,scaleX:1.44,scaleY:1.61,skewX:13.2,skewY:6.5,x:440.6,y:349.6},0).wait(4).to({regX:22.8,regY:4,scaleX:1.46,scaleY:1.58,skewX:14,skewY:6.3,x:440.4,y:351},0).wait(2).to({regY:3.6,scaleX:1.47,scaleY:1.56,skewX:14.3,skewY:6,y:351.4},0).wait(2).to({regY:4,scaleX:1.48,scaleY:1.54,skewX:14.8,skewY:6.1,x:440.2,y:352.9},0).wait(12).to({regX:25.1,regY:2.8,scaleX:1.47,scaleY:1.54,skewY:6,x:444,y:354.7},0).wait(2).to({regX:22.8,regY:3.9,scaleX:1.48,scaleY:1.54,x:440.2,y:359.2},0).wait(2).to({regX:22.9,scaleX:1.51,scaleY:1.53,skewX:15.3,skewY:5.8,x:440.1,y:368.6},0).wait(2).to({regY:4,scaleX:1.47,scaleY:1.54,skewX:14.8,skewY:6,x:440.3,y:366.3},0).wait(2).to({regX:23.4,scaleX:1.48,skewY:5.8,x:441.2,y:367.8},0).wait(2).to({regX:22.9,scaleX:1.49,scaleY:1.54,skewX:15,x:440.5,y:369},0).wait(2).to({scaleX:1.52,scaleY:1.55,skewX:15.2,skewY:5.9,x:440.6,y:371.7},0).wait(2).to({scaleX:1.5,scaleY:1.54,skewX:15,skewY:5.8,x:440.5,y:370.7},0).wait(2).to({regX:22.8,scaleX:1.49,scaleY:1.54,skewX:14.8,skewY:6,x:440.2,y:370.2},0).wait(2).to({scaleX:1.48,skewY:6.1,y:369.7},0).to({_off:true},44).wait(6).to({_off:false,y:365.7},0).wait(26).to({_off:true},8).wait(137));
	this.timeline.addTween(cjs.Tween.get(this.instance_136).wait(561).to({_off:false},0).wait(2).to({regX:37.3,regY:7.4,scaleY:1.5,x:435.3,y:386.6},0).wait(2).to({regX:37.4,regY:7.6,x:435.4,y:386.3},0).to({_off:true},2).wait(153).to({_off:false,y:384.5},0).wait(2).to({regX:37.2,regY:7.7,scaleX:1.3,x:437,y:384.6},0).wait(2).to({regX:37.4,regY:7.8,x:437.2,y:384},0).wait(2).to({regX:37.3,scaleX:1.31,scaleY:1.5,rotation:6,x:437,y:383.2},0).to({regX:37.2,regY:7.9,x:436.9,y:645.3},6).wait(6));

	// Murray Shirt Collar Left
	this.instance_137 = new lib.MurrayShirtRightArm_001_1();
	this.instance_137.parent = this;
	this.instance_137.setTransform(393.3,693.7,1.426,1.532,0,-71.7,-60,39.1,30.9);
	this.instance_137._off = true;

	this.instance_138 = new lib.MurrayNeck3_1();
	this.instance_138.parent = this;
	this.instance_138.setTransform(442.1,693.8,1.5,1.5,-21.4,0,0,37.3,7.8);
	this.instance_138._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_137).wait(9).to({_off:false},0).to({y:440.7},8).wait(2).to({scaleX:1.42,scaleY:1.53,skewX:-63.5,skewY:-51.9,x:390.7,y:439.9},0).wait(2).to({scaleX:1.43,scaleY:1.53,skewX:-55.2,skewY:-43.5,x:388,y:439},0).wait(2).to({regY:31.2,scaleX:1.42,scaleY:1.53,skewX:-63.5,skewY:-51.9,x:391.1,y:440.1},0).wait(2).to({regY:30.8,skewX:-67.7,skewY:-55.9,x:391.9,y:440.2},0).wait(2).to({regY:30.9,scaleX:1.43,scaleY:1.53,skewX:-71.7,skewY:-60,x:393.3,y:440.7},0).to({_off:true},10).wait(701));
	this.timeline.addTween(cjs.Tween.get(this.instance_138).wait(37).to({_off:false},0).wait(2).to({regX:37.2,regY:7.7,scaleX:1.5,scaleY:1.5,rotation:-8.6,x:438.7,y:542.3},0).wait(2).to({regX:37.4,rotation:-2.3,x:437.5,y:466.6},0).wait(2).to({regX:37.3,scaleX:1.5,scaleY:1.5,rotation:0.8,x:436.7,y:428.7},0).wait(2).to({regX:37.2,rotation:2.3,x:436.1,y:409.8},0).wait(2).to({regX:37.3,regY:7.8,rotation:4,x:439.5,y:388.1},0).wait(24).to({regX:37.2,regY:7.7,rotation:4.5,x:436,y:390.4},0).wait(2).to({regX:37.3,rotation:4.8,x:436.5,y:390},0).wait(2).to({regX:37.2,regY:7.8,scaleX:1.5,scaleY:1.5,rotation:5.3,x:436.6,y:389.7},0).wait(2).to({regX:37.3,regY:7.7,scaleX:1.5,scaleY:1.5,rotation:6,x:437,y:389.1},0).wait(62).to({regX:37.2,regY:7.8,scaleX:1.5,scaleY:1.5,rotation:5.3,x:436.6,y:389.7},0).wait(2).to({regX:37.3,regY:7.7,scaleX:1.5,scaleY:1.5,rotation:4.8,x:436.5,y:390},0).wait(2).to({regX:37.2,rotation:4.5,x:436,y:390.4},0).wait(2).to({regX:37.3,regY:7.8,rotation:4,x:435.8,y:390.9},0).wait(36).to({regX:37.1,regY:7.7,rotation:5.3,x:437.9,y:390.3},0).wait(2).to({regX:37.3,regY:7.8,scaleX:1.5,scaleY:1.5,rotation:6.5,x:440.5,y:390},0).wait(2).to({regY:7.7,rotation:7.8,x:442.9,y:389.3},0).wait(2).to({regX:37.2,regY:7.8,scaleX:1.5,scaleY:1.5,rotation:9.2,x:445,y:388.9},0).wait(64).to({scaleX:1.5,scaleY:1.5,rotation:5.3,x:436.6,y:389.7},0).wait(2).to({regX:37.3,regY:7.7,scaleX:1.5,scaleY:1.5,rotation:4.8,x:436.5,y:390},0).wait(2).to({regX:37.2,rotation:4.5,x:436,y:390.4},0).wait(2).to({regX:37.4,regY:7.8,rotation:3,x:437,y:389.5},0).wait(2).to({regY:7.9,scaleX:1.46,scaleY:1.5,rotation:0,skewX:5.5,skewY:3.8,x:442.8},0).wait(2).to({regX:37.3,regY:7.8,scaleX:1.42,scaleY:1.51,skewX:8.3,skewY:4.8,x:448.3,y:389.2},0).wait(2).to({regX:37.2,regY:7.7,scaleX:1.37,scaleY:1.51,skewX:9.5,skewY:4.3,x:453.7,y:389.1},0).wait(2).to({regX:36.8,regY:8.9,scaleX:1.33,scaleY:1.51,skewX:10.9,skewY:3.7,x:458.6,y:391},0).wait(34).to({regX:36.4,regY:8,scaleX:1.42,scaleY:1.51,skewX:8.3,skewY:4.8,x:447.1,y:389.6},0).wait(2).to({regX:37.2,regY:7.8,scaleX:1.33,scaleY:1.48,skewX:6,skewY:5.8,x:436.5,y:392},0).wait(2).to({regX:37.4,regY:7.5,scaleX:1.27,scaleY:1.5,rotation:5.8,skewX:0,skewY:0,x:435.4,y:387.8},0).wait(2).to({regY:7.6,y:386.3},0).wait(2).to({_off:true},38).wait(371).to({_off:false},0).to({_off:true},4).wait(18));

	// Murray 3Shirt Hem
	this.instance_139 = new lib.MurrayShirtRightArm_001_1();
	this.instance_139.parent = this;
	this.instance_139.setTransform(392.8,440.5,1.424,1.53,0,-70.5,-58.7,39.1,30.9);
	this.instance_139._off = true;

	this.instance_140 = new lib.MurrayNeck2_1();
	this.instance_140.parent = this;
	this.instance_140.setTransform(440.2,365.7,1.475,1.543,0,14.8,6.1,22.8,4);

	this.instance_141 = new lib.MurrayNeck3_002_1();
	this.instance_141.parent = this;
	this.instance_141.setTransform(435.8,387.4,1.499,1.499,-6.6,0,0,37.2,7.2);
	this.instance_141._off = true;

	this.instance_142 = new lib.MurrayNeck3_1();
	this.instance_142.parent = this;
	this.instance_142.setTransform(435.4,386.3,1.274,1.499,5.8,0,0,37.4,7.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_139}]},345).to({state:[{t:this.instance_139}]},2).to({state:[{t:this.instance_139}]},2).to({state:[]},2).to({state:[{t:this.instance_139}]},55).to({state:[]},2).to({state:[{t:this.instance_140}]},4).to({state:[]},51).to({state:[{t:this.instance_141}]},140).to({state:[{t:this.instance_141}]},2).to({state:[{t:this.instance_141}]},4).to({state:[{t:this.instance_141}]},2).to({state:[{t:this.instance_141}]},2).to({state:[{t:this.instance_141}]},40).to({state:[{t:this.instance_142}]},2).to({state:[{t:this.instance_142}]},2).to({state:[]},59).to({state:[{t:this.instance_139}]},4).to({state:[{t:this.instance_139}]},2).to({state:[{t:this.instance_139}]},2).to({state:[{t:this.instance_139}]},2).to({state:[{t:this.instance_139}]},6).wait(6));
	this.timeline.addTween(cjs.Tween.get(this.instance_139).wait(345).to({_off:false},0).wait(2).to({skewX:-69.2,skewY:-57.4,x:392.3,y:440.3},0).wait(2).to({scaleX:1.43,scaleY:1.53,skewX:-28.8,skewY:-17.1,x:383.8,y:438},0).to({_off:true},2).wait(55).to({_off:false,scaleX:1.42,scaleY:1.34,skewX:-7.7,skewY:-7.8,x:382,y:439},0).to({_off:true},2).wait(312).to({_off:false,scaleX:1.42,scaleY:1.53,skewX:-74.2,skewY:-62.5,x:394.1,y:437.8},0).wait(2).to({regY:31,scaleX:1.42,scaleY:1.53,skewX:-75.5,skewY:-63.7,x:394.6,y:436.3},0).wait(2).to({regX:39.2,regY:30.9,scaleX:1.42,skewX:-76.2,skewY:-64.4,x:394.7,y:435.5},0).wait(2).to({regX:39.1,scaleX:1.43,scaleY:1.53,skewX:-76.7,skewY:-65,x:395,y:434.7},0).to({skewX:-71.7,skewY:-60,x:393.3,y:696.7},6).wait(6));
	this.timeline.addTween(cjs.Tween.get(this.instance_141).wait(603).to({_off:false},0).wait(2).to({regX:36.9,regY:7.7,scaleX:1.52,scaleY:1.44,rotation:0,skewX:-1.6,skewY:-6.5,x:435.5,y:387.3},0).wait(4).to({regX:37.2,scaleX:1.51,scaleY:1.47,skewX:-4,x:436.1,y:386.4},0).wait(2).to({regX:37.3,scaleX:1.5,scaleY:1.49,skewX:-5.3,x:436.2,y:386},0).wait(2).to({regX:37.2,scaleX:1.5,scaleY:1.5,rotation:-6.7,skewX:0,skewY:0,x:435.9,y:385.6},0).wait(40).to({regY:7.2,scaleX:1.5,scaleY:1.5,rotation:-6.6,x:435.8,y:387.4},0).to({_off:true},2).wait(83));

	// Murray Patch
	this.instance_143 = new lib.MurrayShirtRightArm_001_1();
	this.instance_143.parent = this;
	this.instance_143.setTransform(419,759.4,1.237,1.169,0,-105.3,-100.4,39.4,30.8);
	this.instance_143.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,6);
	this.instance_143._off = true;

	this.instance_144 = new lib.MurrayShirtRightArm_1();
	this.instance_144.parent = this;
	this.instance_144.setTransform(399.8,425.3,1.356,1.424,0,-84.6,-60.7,39.4,30.9);
	this.instance_144._off = true;

	this.instance_145 = new lib.MurrayNeck3_1();
	this.instance_145.parent = this;
	this.instance_145.setTransform(422,380.2,1.5,1.567,0,0.3,0,37.3,7.7);
	this.instance_145._off = true;

	this.instance_146 = new lib.MurrayLeftThumb_110_1();
	this.instance_146.parent = this;
	this.instance_146.setTransform(554,448.5,1,1,0,0,0,14.2,12.7);

	this.instance_147 = new lib.MurrayShirtLeftArm_001_1();
	this.instance_147.parent = this;
	this.instance_147.setTransform(508.7,433.8,1.059,1.332,0,97.3,98.3,21.7,29.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_143}]},37).to({state:[{t:this.instance_143}]},2).to({state:[{t:this.instance_143}]},2).to({state:[{t:this.instance_143}]},2).to({state:[{t:this.instance_143}]},2).to({state:[{t:this.instance_143}]},2).to({state:[{t:this.instance_144}]},24).to({state:[]},2).to({state:[{t:this.instance_144}]},2).to({state:[{t:this.instance_144}]},2).to({state:[{t:this.instance_144}]},2).to({state:[{t:this.instance_144}]},2).to({state:[{t:this.instance_144}]},2).to({state:[{t:this.instance_144}]},2).to({state:[{t:this.instance_144}]},2).to({state:[{t:this.instance_144}]},2).to({state:[{t:this.instance_144}]},2).to({state:[{t:this.instance_144}]},2).to({state:[{t:this.instance_144}]},2).to({state:[{t:this.instance_144}]},2).to({state:[{t:this.instance_144}]},2).to({state:[{t:this.instance_144}]},2).to({state:[{t:this.instance_144}]},2).to({state:[{t:this.instance_144}]},2).to({state:[{t:this.instance_144}]},2).to({state:[{t:this.instance_144}]},2).to({state:[{t:this.instance_144}]},2).to({state:[{t:this.instance_144}]},2).to({state:[{t:this.instance_144}]},2).to({state:[{t:this.instance_144}]},2).to({state:[{t:this.instance_144}]},2).to({state:[{t:this.instance_144}]},2).to({state:[{t:this.instance_144}]},2).to({state:[{t:this.instance_144}]},2).to({state:[{t:this.instance_144}]},2).to({state:[{t:this.instance_144}]},2).to({state:[{t:this.instance_144}]},2).to({state:[{t:this.instance_144}]},2).to({state:[{t:this.instance_144}]},2).to({state:[{t:this.instance_144}]},2).to({state:[{t:this.instance_144}]},2).to({state:[{t:this.instance_144}]},2).to({state:[{t:this.instance_144}]},2).to({state:[{t:this.instance_143}]},2).to({state:[{t:this.instance_143}]},36).to({state:[{t:this.instance_143}]},2).to({state:[{t:this.instance_143}]},2).to({state:[{t:this.instance_143}]},2).to({state:[{t:this.instance_144}]},64).to({state:[{t:this.instance_144}]},2).to({state:[{t:this.instance_144}]},2).to({state:[{t:this.instance_143}]},2).to({state:[{t:this.instance_143}]},2).to({state:[{t:this.instance_143}]},2).to({state:[{t:this.instance_143}]},2).to({state:[{t:this.instance_143}]},2).to({state:[{t:this.instance_143}]},34).to({state:[{t:this.instance_143}]},2).to({state:[{t:this.instance_143}]},2).to({state:[{t:this.instance_143}]},2).to({state:[{t:this.instance_143}]},2).to({state:[]},38).to({state:[{t:this.instance_145}]},6).to({state:[{t:this.instance_145}]},4).to({state:[{t:this.instance_145}]},2).to({state:[{t:this.instance_145}]},2).to({state:[{t:this.instance_145}]},39).to({state:[{t:this.instance_145}]},2).to({state:[{t:this.instance_145}]},2).to({state:[]},4).to({state:[{t:this.instance_145}]},2).to({state:[{t:this.instance_145}]},2).to({state:[]},2).to({state:[{t:this.instance_145}]},51).to({state:[{t:this.instance_145}]},4).to({state:[{t:this.instance_145}]},2).to({state:[{t:this.instance_145}]},2).to({state:[{t:this.instance_145}]},2).to({state:[{t:this.instance_145}]},2).to({state:[{t:this.instance_145}]},2).to({state:[{t:this.instance_145}]},2).to({state:[{t:this.instance_145}]},4).to({state:[{t:this.instance_145}]},2).to({state:[{t:this.instance_145}]},2).to({state:[{t:this.instance_145}]},10).to({state:[{t:this.instance_145}]},2).to({state:[{t:this.instance_145}]},2).to({state:[{t:this.instance_145}]},2).to({state:[{t:this.instance_145}]},2).to({state:[{t:this.instance_145}]},2).to({state:[{t:this.instance_145}]},2).to({state:[{t:this.instance_145}]},2).to({state:[{t:this.instance_145}]},2).to({state:[{t:this.instance_145}]},2).to({state:[{t:this.instance_145}]},2).to({state:[{t:this.instance_147,p:{regX:21.7,regY:29.5,scaleX:1.059,scaleY:1.332,skewX:97.3,skewY:98.3,x:508.7,y:433.8}},{t:this.instance_146}]},44).to({state:[{t:this.instance_147,p:{regX:21.9,regY:29.6,scaleX:1.106,scaleY:1.395,skewX:102.3,skewY:101,x:508.3,y:433.7}}]},2).to({state:[{t:this.instance_147,p:{regX:22.2,regY:29.6,scaleX:1.141,scaleY:1.443,skewX:103.8,skewY:100.6,x:508.3,y:432.9}}]},2).to({state:[{t:this.instance_145}]},2).to({state:[{t:this.instance_145}]},26).to({state:[{t:this.instance_145}]},8).to({state:[]},2).to({state:[{t:this.instance_143}]},113).to({state:[]},4).wait(18));
	this.timeline.addTween(cjs.Tween.get(this.instance_143).wait(37).to({_off:false},0).wait(2).to({regX:39.5,skewX:-92.5,skewY:-87.7,x:402.9,y:599.8},0).wait(2).to({regX:39.6,scaleX:1.24,skewX:-86.2,skewY:-81.5,x:394.8,y:519.9},0).wait(2).to({regX:39.4,skewX:-83,skewY:-78.2,x:390.9,y:480.2},0).wait(2).to({regY:30.9,scaleY:1.17,skewX:-81.5,skewY:-76.7,x:389.1,y:460.2},0).wait(2).to({regX:39.5,scaleX:1.24,scaleY:1.17,skewX:-79.8,skewY:-75,x:390.5,y:437.4},0).to({_off:true},24).wait(74).to({_off:false,x:386.9,y:440.3},0).wait(36).to({regX:39.6,scaleX:1.3,scaleY:1.23,skewX:-59.7,skewY:-57.4,x:389.4,y:439},0).wait(2).to({scaleX:1.37,scaleY:1.29,skewX:-39.4,skewY:-39.9,x:391.9,y:437.9},0).wait(2).to({regX:39.5,scaleX:1.43,scaleY:1.35,skewX:-19.3,skewY:-22.3,x:394.2,y:436.8},0).wait(2).to({regX:39.4,scaleX:1.5,scaleY:1.41,skewX:0.9,skewY:-4.8,x:396.7,y:435.6},0).to({_off:true},64).wait(6).to({_off:false,regX:39.5,regY:30.8,scaleX:1.24,scaleY:1.17,skewX:-77.8,skewY:-73,x:386.3,y:436.8},0).wait(2).to({regX:39.7,regY:30.7,scaleX:1.26,scaleY:1.28,skewX:-56.4,skewY:-54.1,x:387.1,y:433.2},0).wait(2).to({regX:39.4,regY:30.9,scaleX:1.28,scaleY:1.39,skewX:-34.8,skewY:-35.1,x:387.8,y:430.2},0).wait(2).to({scaleX:1.18,scaleY:1.38,skewX:-51.1,skewY:-48.7,x:386,y:426.2},0).wait(2).to({regX:39.1,regY:31,scaleX:1.07,scaleY:1.38,skewX:-67.3,skewY:-62.3,x:384.1,y:422},0).wait(34).to({regY:30.9,scaleX:1.25,scaleY:1.45,skewX:-69.7,skewY:-61.2,x:388.6,y:431.3},0).wait(2).to({scaleX:1.42,scaleY:1.53,skewX:-69.2,skewY:-57.4,x:392.3,y:440.3},0).wait(2).to({skewX:-70.5,skewY:-58.7,x:392.8,y:440.5},0).wait(2).to({scaleX:1.43,scaleY:1.53,skewX:-71.7,skewY:-60,x:393.3,y:440.7},0).wait(2).to({_off:true},38).wait(371).to({_off:false},0).to({_off:true},4).wait(18));
	this.timeline.addTween(cjs.Tween.get(this.instance_144).wait(71).to({_off:false},0).to({_off:true},2).wait(2).to({_off:false,regY:30.8,scaleX:1.56,scaleY:1.83,skewX:-58.2,skewY:-41.1,x:407.2,y:433.1},0).wait(2).to({regX:39.2,regY:30.7,scaleX:1.49,scaleY:1.51,skewX:-3.8,skewY:-3.7,x:395.7,y:440.3},0).wait(2).to({regX:39.3,regY:30.8,scaleX:1.49,scaleY:1.51,rotation:-2.6,skewX:0,skewY:0,x:395.8,y:440.4},0).wait(2).to({regX:39.1,scaleX:1.49,scaleY:1.51,rotation:-1.6,x:395.6},0).wait(2).to({scaleX:1.48,scaleY:1.51,rotation:-0.3},0).wait(2).to({regY:30.7,scaleX:1.48,scaleY:1.52,rotation:0,skewX:0.6,skewY:0.8,x:395.5,y:440.3},0).wait(2).to({regX:38.8,regY:30.9,scaleX:1.48,scaleY:1.52,rotation:1.9,skewX:0,skewY:0,x:395.1,y:440.6},0).wait(2).to({regX:44.4,regY:30.8,scaleX:1.48,scaleY:1.52,rotation:0,skewX:0.6,skewY:0.8,x:403.5,y:440.2},0).wait(2).to({regX:34,regY:33,scaleX:1.48,scaleY:1.51,rotation:-0.3,skewX:0,skewY:0,x:388.1,y:443.4},0).wait(2).to({regX:39.4,regY:29.8,scaleX:1.49,scaleY:1.51,rotation:-1.6,x:395.9,y:438.9},0).wait(2).to({regY:30.5,scaleX:1.49,scaleY:1.51,rotation:-2.6,y:440.2},0).wait(2).to({regX:39.2,regY:30.7,scaleX:1.49,scaleY:1.51,rotation:0,skewX:-3.8,skewY:-3.7,x:395.7,y:440.3},0).wait(2).to({regX:39.3,regY:30.8,scaleX:1.49,scaleY:1.51,rotation:-2.6,skewX:0,skewY:0,x:395.8,y:440.4},0).wait(2).to({regX:39.1,scaleX:1.49,scaleY:1.51,rotation:-1.6,x:395.6},0).wait(2).to({scaleX:1.48,scaleY:1.51,rotation:-0.3},0).wait(2).to({regY:30.7,scaleX:1.48,scaleY:1.52,rotation:0,skewX:0.6,skewY:0.8,x:395.5,y:440.3},0).wait(2).to({regX:38.8,regY:30.9,scaleX:1.48,scaleY:1.52,rotation:1.9,skewX:0,skewY:0,x:395.1,y:440.6},0).wait(2).to({regX:44.4,regY:30.8,scaleX:1.48,scaleY:1.52,rotation:0,skewX:0.6,skewY:0.8,x:403.5,y:440.2},0).wait(2).to({regX:34,regY:33,scaleX:1.48,scaleY:1.51,rotation:-0.3,skewX:0,skewY:0,x:388.1,y:443.4},0).wait(2).to({regX:39.4,regY:29.8,scaleX:1.49,scaleY:1.51,rotation:-1.6,x:395.9,y:438.9},0).wait(2).to({regY:30.5,scaleX:1.49,scaleY:1.51,rotation:-2.6,x:396,y:440.1},0).wait(2).to({regX:39.2,regY:29.2,scaleX:1.49,scaleY:1.51,rotation:0,skewX:-3.8,skewY:-3.7,x:395.6,y:438},0).wait(2).to({regX:39.5,regY:30.8,scaleX:1.49,scaleY:1.51,rotation:-2.6,skewX:0,skewY:0,x:396,y:440.5},0).wait(2).to({regX:39.1,scaleX:1.49,scaleY:1.51,rotation:-1.6,x:395.6,y:440.4},0).wait(2).to({scaleX:1.48,scaleY:1.51,rotation:-0.3},0).wait(2).to({regY:30.7,scaleX:1.48,scaleY:1.52,rotation:0,skewX:0.6,skewY:0.8,x:395.5,y:440.3},0).wait(2).to({regX:38.8,regY:30.9,scaleX:1.48,scaleY:1.52,rotation:1.9,skewX:0,skewY:0,x:395.1,y:440.6},0).wait(2).to({regX:42.9,regY:28.9,scaleX:1.48,scaleY:1.52,rotation:0,skewX:0.6,skewY:0.8,x:401.3,y:437.3},0).wait(2).to({regX:39.1,regY:30.9,scaleX:1.48,scaleY:1.51,rotation:-0.3,skewX:0,skewY:0,x:395.6,y:440.1},0).wait(2).to({regX:39.3,regY:29.8,scaleX:1.49,scaleY:1.51,rotation:-1.6,x:395.8,y:438.9},0).wait(2).to({regX:39.8,regY:32,scaleX:1.49,scaleY:1.51,rotation:-2.6,x:396.8,y:442.5},0).wait(2).to({regX:39.2,regY:29.2,scaleX:1.49,scaleY:1.51,rotation:0,skewX:-3.8,skewY:-3.7,x:395.6,y:438},0).wait(2).to({regX:39.4,regY:30.8,scaleX:1.56,scaleY:1.83,skewX:-58.2,skewY:-41.1,x:407.2,y:433.1},0).wait(2).to({regX:39.5,scaleX:1.48,scaleY:1.52,skewX:-70.5,skewY:-46.2,x:402.1,y:426.5},0).wait(2).to({regX:39.4,regY:30.9,scaleX:1.36,scaleY:1.42,skewX:-84.6,skewY:-60.7,x:399.8,y:425.3},0).to({_off:true},2).wait(106).to({_off:false,regY:30.8,scaleX:1.56,scaleY:1.83,skewX:-58.2,skewY:-41.1,x:407.2,y:433.1},0).wait(2).to({regX:39.5,scaleX:1.48,scaleY:1.52,skewX:-70.5,skewY:-46.2,x:402.1,y:426.5},0).wait(2).to({regX:39.4,regY:30.9,scaleX:1.36,scaleY:1.42,skewX:-84.6,skewY:-60.7,x:399.8,y:425.3},0).to({_off:true},2).wait(481));
	this.timeline.addTween(cjs.Tween.get(this.instance_145).wait(351).to({_off:false},0).wait(4).to({scaleY:1.53,skewX:0,x:421.6,y:383.6},0).wait(2).to({regY:7.8,scaleY:1.52,x:421.4,y:385.5},0).wait(2).to({regY:7.7,scaleY:1.5,x:421.1,y:387.1},0).wait(39).to({regY:7.8,scaleY:1.52,x:421.4,y:385.5},0).wait(2).to({regY:7.7,scaleY:1.53,x:421.6,y:383.6},0).wait(2).to({scaleY:1.57,skewX:0.3,x:422,y:380.2},0).to({_off:true},4).wait(2).to({_off:false,regX:37.2,regY:7.8,scaleX:1.33,scaleY:1.48,skewX:6,skewY:5.8,x:436.5,y:392},0).wait(2).to({regY:7.7,scaleX:1.32,scaleY:1.49,x:436.7,y:390.5},0).to({_off:true},2).wait(51).to({_off:false,regX:37.4,regY:7.6,scaleX:1.27,scaleY:1.5,rotation:5.8,skewX:0,skewY:0,x:435.4,y:386.3},0).wait(4).to({regX:37.2,regY:7.8,scaleX:1.31,scaleY:1.5,rotation:6,x:436.9,y:389.2},0).wait(2).to({regY:7.7,scaleX:1.32,scaleY:1.49,rotation:0,skewX:6,skewY:5.8,x:436.7,y:390.5},0).wait(2).to({regY:7.8,scaleX:1.33,scaleY:1.48,x:436.5,y:392},0).wait(2).to({regX:38.7,regY:6.5,scaleX:1.36,scaleY:1.46,skewX:6.4,skewY:5.6,x:438.4,y:393},0).wait(2).to({regX:37.1,regY:8.8,scaleX:1.31,scaleY:1.5,rotation:5.8,skewX:0,skewY:0,x:436.6,y:384.4},0).wait(2).to({regX:37.2,regY:7.8,scaleX:1.3,scaleY:1.5,x:437,y:379.6},0).wait(2).to({regX:37.3,regY:7.5,scaleX:1.28,scaleY:1.57,rotation:0,skewX:4.9,skewY:6.4,x:437.9,y:373.1},0).wait(4).to({regX:37.4,regY:7.8,scaleX:1.29,scaleY:1.54,skewX:5.3,skewY:6,x:437.6,y:375.1},0).wait(2).to({regX:37.3,scaleX:1.3,scaleY:1.52,skewX:5.5,x:437.2,y:375.7},0).wait(2).to({regX:37.2,scaleX:1.31,scaleY:1.5,rotation:6,skewX:0,skewY:0,x:436.9,y:376.4},0).wait(12).to({regY:9.2,rotation:5.8,x:436.7,y:378.4},0).wait(2).to({regY:7.8,rotation:6,x:436.9,y:376.4},0).wait(2).to({scaleX:1.33,scaleY:1.48,rotation:0,skewX:6,skewY:5.8,x:436.5,y:392},0).wait(2).to({regX:37.3,regY:7.7,scaleX:1.27,scaleY:1.5,rotation:5.8,skewX:0,skewY:0,x:435.3,y:386.4},0).wait(2).to({regY:7.8,scaleX:1.28,y:388.4},0).wait(2).to({regX:37.2,regY:7.7,scaleX:1.29,y:389.9},0).wait(2).to({regX:37.9,regY:9.3,scaleX:1.31,scaleY:1.5,rotation:0,skewX:6.1,skewY:5.8,x:436,y:396},0).wait(2).to({regX:37.4,regY:7.7,scaleX:1.29,skewX:6,x:435.6,y:392.6},0).wait(2).to({regX:37.3,scaleX:1.28,x:435.4,y:392.1},0).wait(2).to({scaleX:1.27,rotation:6,skewX:0,skewY:0,x:435.3,y:391.6},0).to({_off:true},44).wait(6).to({_off:false,regX:37.4,regY:7.6,scaleX:1.27,scaleY:1.5,rotation:5.8,x:435.4,y:386.3},0).wait(34).to({regX:37.5,regY:7.4,scaleX:1.31,scaleY:1.5,rotation:6,x:435.3,y:387.7},0).to({_off:true},2).wait(135));

	// Layer 166
	this.instance_148 = new lib.MurrayArm1_1();
	this.instance_148.parent = this;
	this.instance_148.setTransform(373.8,717.9,1.5,1.123,0,-164.3,15.7,32.8,37.1);
	this.instance_148._off = true;

	this.instance_149 = new lib.MurrayNeck3_1();
	this.instance_149.parent = this;
	this.instance_149.setTransform(435.4,386.3,1.274,1.499,5.8,0,0,37.4,7.6);

	this.instance_150 = new lib.MurrayShirtRightArm_001_1();
	this.instance_150.parent = this;
	this.instance_150.setTransform(390.7,437.6,1.262,1.375,0,-69.8,-80.8,39.2,30.9);

	this.instance_151 = new lib.MurrayArm1_007_1();
	this.instance_151.parent = this;
	this.instance_151.setTransform(338.5,450.6,1.5,1.003,0,-39.7,150.7,32.8,37);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_148}]},9).to({state:[{t:this.instance_148}]},8).to({state:[{t:this.instance_148}]},2).to({state:[{t:this.instance_148}]},2).to({state:[{t:this.instance_148}]},2).to({state:[{t:this.instance_148}]},2).to({state:[{t:this.instance_148}]},2).to({state:[]},10).to({state:[{t:this.instance_149}]},375).to({state:[]},51).to({state:[{t:this.instance_150,p:{regY:30.9,x:390.7,y:437.6,regX:39.2,scaleX:1.262,scaleY:1.375,skewX:-69.8,skewY:-80.8}}]},138).to({state:[{t:this.instance_150,p:{regY:31.2,x:391.1,y:430.1,regX:39.2,scaleX:1.262,scaleY:1.375,skewX:-69.8,skewY:-80.8}},{t:this.instance_151}]},2).to({state:[]},2).to({state:[{t:this.instance_150,p:{regY:31.2,x:391.1,y:430.1,regX:39.2,scaleX:1.262,scaleY:1.375,skewX:-69.8,skewY:-80.8}},{t:this.instance_151}]},48).to({state:[{t:this.instance_150,p:{regY:30.9,x:390.7,y:437.6,regX:39.2,scaleX:1.262,scaleY:1.375,skewX:-69.8,skewY:-80.8}}]},2).to({state:[{t:this.instance_150,p:{regY:30.9,x:393.3,y:440.7,regX:39.1,scaleX:1.426,scaleY:1.532,skewX:-71.7,skewY:-60}}]},2).to({state:[]},59).wait(22));
	this.timeline.addTween(cjs.Tween.get(this.instance_148).wait(9).to({_off:false},0).to({y:464.9},8).wait(2).to({regY:37.2,scaleX:1.5,scaleY:1.12,skewX:-156.2,skewY:23.8,x:368.1,y:460.6},0).wait(2).to({regX:32.6,scaleX:1.5,scaleY:1.12,skewX:-147.8,skewY:32.2,x:362.3,y:456.4},0).wait(2).to({regX:32.9,regY:37.1,scaleX:1.5,scaleY:1.12,skewX:-156.2,skewY:23.8,x:368.3,y:460.8},0).wait(2).to({regX:33,regY:37,skewX:-160.2,skewY:19.8,x:371.2,y:463},0).wait(2).to({regX:32.8,regY:37.1,scaleX:1.5,scaleY:1.12,skewX:-164.3,skewY:15.7,x:373.8,y:464.9},0).to({_off:true},10).wait(701));

	// Murray Shirt Button 1
	this.instance_152 = new lib.MurrayPalm_41_1();
	this.instance_152.parent = this;
	this.instance_152.setTransform(337.4,757.9,1,1.092,-38.2,0,0,31.7,25.2);
	this.instance_152._off = true;

	this.instance_153 = new lib.MurrayArm2_1();
	this.instance_153.parent = this;
	this.instance_153.setTransform(360.6,469.4,1.474,1.765,0,-74.5,-40.1,30.8,23.4);
	this.instance_153._off = true;

	this.instance_154 = new lib.MurrayArm1_1();
	this.instance_154.parent = this;
	this.instance_154.setTransform(372.7,464.3,1.499,1.122,0,-163,17,32.8,37.1);
	this.instance_154._off = true;

	this.instance_155 = new lib.MurrayShirtRightArm_1();
	this.instance_155.parent = this;
	this.instance_155.setTransform(380.1,435.5,1.5,1.5,3.5,0,0,39.1,30.8);
	this.instance_155._off = true;

	this.instance_156 = new lib.MurrayShirtRightArm_001_1();
	this.instance_156.parent = this;
	this.instance_156.setTransform(392.3,440.3,1.424,1.53,0,-69.2,-57.4,39.1,30.9);
	this.instance_156._off = true;

	this.instance_157 = new lib.ShirtRightArm_008_1();
	this.instance_157.parent = this;
	this.instance_157.setTransform(367.7,404.6,1.456,1.519,0,8.6,23.2,39.1,30.8);
	this.instance_157._off = true;

	this.instance_158 = new lib.MurrayPointerFinger_108_1();
	this.instance_158.parent = this;
	this.instance_158.setTransform(574.7,444.7,1,1,0,0,180,16.9,15.8);

	this.instance_159 = new lib.MurrayMiddleFinger_108_1();
	this.instance_159.parent = this;
	this.instance_159.setTransform(588.2,452.6,1,1,0,15,-165,15.4,13.5);

	this.instance_160 = new lib.MurrayPinky_108_1();
	this.instance_160.parent = this;
	this.instance_160.setTransform(602.6,445.8,1,1,0,0,180,15,12.7);

	this.instance_161 = new lib.MurrayLeftPalm_108_1();
	this.instance_161.parent = this;
	this.instance_161.setTransform(570.3,450.2,1,1,0,0,0,24.5,16.3);

	this.instance_162 = new lib.MurrayLeftArm2_0001_1();
	this.instance_162.parent = this;
	this.instance_162.setTransform(528.6,467,1.497,1.349,0,123.9,-56.1,19.2,38.8);

	this.instance_163 = new lib.MurrayPointerFinger_039_1();
	this.instance_163.parent = this;
	this.instance_163.setTransform(550.5,501,1,1,-163.8,0,0,28.2,29.6);

	this.instance_164 = new lib.MurrayMiddleFinger_1();
	this.instance_164.parent = this;
	this.instance_164.setTransform(560.7,492,2.068,1.984,0,-148.9,-142.6,16,12.7);

	this.instance_165 = new lib.MurrayPinky_037_1();
	this.instance_165.parent = this;
	this.instance_165.setTransform(580.4,498.5,1,0.999,0,-173.6,6.4,9.9,27.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_152}]},9).to({state:[{t:this.instance_152}]},8).to({state:[{t:this.instance_152}]},2).to({state:[{t:this.instance_152}]},2).to({state:[{t:this.instance_152}]},2).to({state:[{t:this.instance_152}]},2).to({state:[{t:this.instance_152}]},2).to({state:[]},10).to({state:[{t:this.instance_153}]},34).to({state:[]},2).to({state:[{t:this.instance_153}]},2).to({state:[{t:this.instance_153}]},2).to({state:[{t:this.instance_153}]},2).to({state:[{t:this.instance_153}]},2).to({state:[{t:this.instance_153}]},2).to({state:[{t:this.instance_153}]},2).to({state:[{t:this.instance_153}]},2).to({state:[{t:this.instance_153}]},2).to({state:[{t:this.instance_153}]},2).to({state:[{t:this.instance_153}]},2).to({state:[{t:this.instance_153}]},2).to({state:[{t:this.instance_153}]},2).to({state:[{t:this.instance_153}]},2).to({state:[{t:this.instance_153}]},2).to({state:[{t:this.instance_153}]},2).to({state:[{t:this.instance_153}]},2).to({state:[{t:this.instance_153}]},2).to({state:[{t:this.instance_153}]},2).to({state:[{t:this.instance_153}]},2).to({state:[{t:this.instance_153}]},2).to({state:[{t:this.instance_153}]},2).to({state:[{t:this.instance_153}]},2).to({state:[{t:this.instance_153}]},2).to({state:[{t:this.instance_153}]},2).to({state:[{t:this.instance_153}]},2).to({state:[{t:this.instance_153}]},2).to({state:[{t:this.instance_153}]},2).to({state:[{t:this.instance_153}]},2).to({state:[{t:this.instance_153}]},2).to({state:[{t:this.instance_153}]},2).to({state:[{t:this.instance_153}]},2).to({state:[{t:this.instance_153}]},2).to({state:[{t:this.instance_153}]},2).to({state:[{t:this.instance_153}]},2).to({state:[{t:this.instance_153}]},2).to({state:[]},2).to({state:[{t:this.instance_153}]},106).to({state:[{t:this.instance_153}]},2).to({state:[{t:this.instance_153}]},2).to({state:[]},2).to({state:[{t:this.instance_154}]},88).to({state:[{t:this.instance_154}]},2).to({state:[{t:this.instance_154}]},2).to({state:[{t:this.instance_155}]},2).to({state:[{t:this.instance_155}]},4).to({state:[{t:this.instance_155}]},2).to({state:[{t:this.instance_155}]},2).to({state:[{t:this.instance_155}]},39).to({state:[{t:this.instance_155}]},2).to({state:[{t:this.instance_155}]},2).to({state:[{t:this.instance_154}]},4).to({state:[{t:this.instance_156}]},2).to({state:[{t:this.instance_156}]},2).to({state:[]},2).to({state:[{t:this.instance_156}]},51).to({state:[{t:this.instance_156}]},4).to({state:[{t:this.instance_156}]},2).to({state:[{t:this.instance_156}]},2).to({state:[{t:this.instance_156}]},2).to({state:[{t:this.instance_156}]},2).to({state:[{t:this.instance_156}]},2).to({state:[{t:this.instance_157}]},2).to({state:[{t:this.instance_157}]},4).to({state:[{t:this.instance_157}]},2).to({state:[{t:this.instance_157}]},2).to({state:[{t:this.instance_157}]},10).to({state:[{t:this.instance_157}]},2).to({state:[{t:this.instance_157}]},2).to({state:[{t:this.instance_156}]},2).to({state:[]},2).to({state:[{t:this.instance_162,p:{regX:19.2,regY:38.8,scaleX:1.497,scaleY:1.349,skewX:123.9,skewY:-56.1,x:528.6,y:467}},{t:this.instance_161},{t:this.instance_160},{t:this.instance_159},{t:this.instance_158}]},56).to({state:[]},2).to({state:[{t:this.instance_165},{t:this.instance_164},{t:this.instance_163},{t:this.instance_152},{t:this.instance_162,p:{regX:19.1,regY:38.7,scaleX:1.458,scaleY:1.351,skewX:154.8,skewY:-25.2,x:509.9,y:460.5}}]},2).to({state:[]},2).to({state:[{t:this.instance_156}]},26).to({state:[]},8).wait(137));
	this.timeline.addTween(cjs.Tween.get(this.instance_152).wait(9).to({_off:false},0).to({y:504.9},8).wait(2).to({regX:32,regY:25.3,scaleX:1,scaleY:1.09,rotation:-29.9,x:327,y:495.1},0).wait(2).to({regX:31.2,regY:25.6,scaleX:1,scaleY:1.09,rotation:-21.8,x:316,y:485.3},0).wait(2).to({regX:31.7,regY:25.2,scaleX:1,scaleY:1.09,rotation:-29.9,x:326.9,y:494.8},0).wait(2).to({regX:31.8,scaleX:1,rotation:-34.1,x:332.3,y:499.8},0).wait(2).to({regX:31.7,scaleX:1,scaleY:1.09,rotation:-38.2,x:337.4,y:504.9},0).to({_off:true},10).wait(528).to({_off:false,regX:31.8,regY:25.1,rotation:0,skewX:8.5,skewY:-171.5,x:557.3,y:503.3},0).to({_off:true},2).wait(171));
	this.timeline.addTween(cjs.Tween.get(this.instance_153).wait(71).to({_off:false},0).to({_off:true},2).wait(2).to({_off:false,regX:33.2,regY:24.6,scaleY:1.46,skewX:-32.4,skewY:-33.4,x:339.9,y:457.3},0).wait(2).to({regY:24.7,scaleX:1.5,skewX:7.4,skewY:18.1,x:338,y:420.4},0).wait(2).to({scaleX:1.5,scaleY:1.46,skewX:10.3,skewY:21,x:338.9,y:420.2},0).wait(2).to({regX:33.3,regY:24.6,scaleX:1.5,skewX:13.4,skewY:23.9,x:339.8,y:419.9},0).wait(2).to({regX:33.6,regY:24.3,scaleX:1.5,skewX:16.3,skewY:26.8,x:341.1,y:419.6},0).wait(2).to({regX:33.2,regY:24.4,scaleX:1.5,skewX:19.3,skewY:30.1,x:341.5,y:419.3},0).wait(2).to({regY:24.7,scaleX:1.5,scaleY:1.46,skewX:22.4,skewY:33.1,x:342.2,y:419.5},0).wait(2).to({regY:24.6,scaleX:1.5,scaleY:1.46,skewX:19.3,skewY:30.1,x:341.5},0).wait(2).to({regY:24.7,scaleX:1.5,skewX:16.3,skewY:26.8,x:340.5,y:419.8},0).wait(2).to({regX:33.3,scaleX:1.5,skewX:13.4,skewY:23.9,x:339.8,y:420},0).wait(2).to({scaleX:1.5,skewX:10.3,skewY:21,x:339,y:420.3},0).wait(2).to({regX:33.2,scaleX:1.5,scaleY:1.46,skewX:7.4,skewY:18.1,x:338,y:420.4},0).wait(2).to({scaleX:1.5,scaleY:1.46,skewX:10.3,skewY:21,x:338.9,y:420.2},0).wait(2).to({regX:33.3,regY:24.6,scaleX:1.5,skewX:13.4,skewY:23.9,x:339.8,y:419.9},0).wait(2).to({regX:33.6,regY:24.3,scaleX:1.5,skewX:16.3,skewY:26.8,x:341.1,y:419.6},0).wait(2).to({regX:33.2,regY:24.4,scaleX:1.5,skewX:19.3,skewY:30.1,x:341.5,y:419.3},0).wait(2).to({regY:24.7,scaleX:1.5,scaleY:1.46,skewX:22.4,skewY:33.1,x:342.2,y:419.5},0).wait(2).to({regY:24.6,scaleX:1.5,scaleY:1.46,skewX:19.3,skewY:30.1,x:341.5},0).wait(2).to({regY:24.7,scaleX:1.5,skewX:16.3,skewY:26.8,x:340.5,y:419.8},0).wait(2).to({regX:33.3,scaleX:1.5,skewX:13.4,skewY:23.9,x:339.8,y:420},0).wait(2).to({scaleX:1.5,skewX:10.3,skewY:21,x:339,y:420.3},0).wait(2).to({regX:33.2,scaleX:1.5,scaleY:1.46,skewX:7.4,skewY:18.1,x:338,y:420.4},0).wait(2).to({scaleX:1.5,scaleY:1.46,skewX:10.3,skewY:21,x:338.9,y:420.2},0).wait(2).to({regX:33.3,regY:24.6,scaleX:1.5,skewX:13.4,skewY:23.9,x:339.8,y:419.9},0).wait(2).to({regX:33.6,regY:24.3,scaleX:1.5,skewX:16.3,skewY:26.8,x:341.1,y:419.6},0).wait(2).to({regX:33.2,regY:24.4,scaleX:1.5,skewX:19.3,skewY:30.1,x:341.5,y:419.3},0).wait(2).to({regY:24.7,scaleX:1.5,scaleY:1.46,skewX:22.4,skewY:33.1,x:342.2,y:419.5},0).wait(2).to({regY:24.6,scaleX:1.5,scaleY:1.46,skewX:19.3,skewY:30.1,x:341.5},0).wait(2).to({regY:24.7,scaleX:1.5,skewX:16.3,skewY:26.8,x:340.5,y:419.8},0).wait(2).to({regX:33.3,scaleX:1.5,skewX:13.4,skewY:23.9,x:339.8,y:420},0).wait(2).to({scaleX:1.5,skewX:10.3,skewY:21,x:339,y:420.3},0).wait(2).to({regX:33.2,scaleX:1.5,scaleY:1.46,skewX:7.4,skewY:18.1,x:338,y:420.4},0).wait(2).to({regY:24.6,scaleX:1.47,skewX:-32.4,skewY:-33.4,x:339.9,y:457.3},0).wait(2).to({regX:33.3,regY:24.7,scaleY:1.77,skewX:-67.8,x:365.1,y:455.5},0).wait(2).to({regX:30.8,regY:23.4,skewX:-74.5,skewY:-40.1,x:360.6,y:469.4},0).to({_off:true},2).wait(106).to({_off:false,regX:33.2,regY:24.6,scaleY:1.46,skewX:-32.4,skewY:-33.4,x:339.9,y:457.3},0).wait(2).to({regX:33.3,regY:24.7,scaleY:1.77,skewX:-67.8,x:365.1,y:455.5},0).wait(2).to({regX:30.8,regY:23.4,skewX:-74.5,skewY:-40.1,x:360.6,y:469.4},0).to({_off:true},2).wait(481));
	this.timeline.addTween(cjs.Tween.get(this.instance_154).wait(345).to({_off:false},0).wait(2).to({regX:32.6,regY:37.2,scaleY:1.12,skewX:-161.7,skewY:18.3,x:371.4,y:463.3},0).wait(2).to({regX:32.7,regY:37,scaleX:1.5,scaleY:1.12,skewX:-121.4,skewY:58.6,x:352.9,y:442.4},0).to({_off:true},2).wait(55).to({_off:false,skewX:-97.7,skewY:82.3,x:362.3,y:443.8},0).to({_off:true},2).wait(330));
	this.timeline.addTween(cjs.Tween.get(this.instance_155).wait(351).to({_off:false},0).wait(4).to({regX:39.2,rotation:1.6,x:381.7,y:439.6},0).wait(2).to({regX:33.8,regY:30.9,rotation:0.8,x:374.3,y:441.6},0).wait(2).to({regX:39.1,regY:30.8,rotation:0,x:383,y:443.5},0).wait(39).to({regX:33.7,regY:30.9,rotation:0.8,x:374.2,y:441.6},0).wait(2).to({regX:39.2,regY:30.8,rotation:1.6,x:381.7,y:439.6},0).wait(2).to({regX:39.1,rotation:3.5,x:380.1,y:435.5},0).to({_off:true},4).wait(332));
	this.timeline.addTween(cjs.Tween.get(this.instance_156).wait(408).to({_off:false},0).wait(2).to({skewX:-70.5,skewY:-58.7,x:392.8,y:440.5},0).to({_off:true},2).wait(51).to({_off:false,scaleX:1.43,scaleY:1.53,skewX:-71.7,skewY:-60,x:393.3,y:440.7},0).wait(6).to({scaleX:1.42,scaleY:1.53,skewX:-70.5,skewY:-58.7,x:392.8,y:440.5},0).wait(2).to({skewX:-69.2,skewY:-57.4,x:392.3,y:440.3},0).wait(2).to({scaleX:1.43,scaleY:1.53,skewX:-66.5,skewY:-54.8,x:391.1,y:439.7},0).wait(2).to({regX:45.1,scaleY:1.5,skewX:4.4,skewY:0,x:385.9,y:436},0).wait(2).to({regX:39,scaleX:1.52,scaleY:1.38,skewX:4.4,skewY:5.8,x:377.2,y:425.3},0).to({_off:true},2).wait(24).to({_off:false,regX:39.1,scaleX:1.42,scaleY:1.53,skewX:-69.2,skewY:-57.4,x:392.3,y:440.3},0).to({_off:true},2).wait(88).to({_off:false,scaleX:1.43,scaleY:1.53,skewX:-71.7,skewY:-60,x:393.3,y:440.7},0).to({_off:true},8).wait(137));
	this.timeline.addTween(cjs.Tween.get(this.instance_157).wait(479).to({_off:false},0).wait(4).to({regX:39.2,regY:31.1,scaleX:1.44,scaleY:1.52,skewX:8.5,skewY:21.6,x:369.1,y:408.3},0).wait(2).to({regX:39.1,regY:30.9,scaleX:1.43,scaleY:1.53,skewY:20.8,x:369.8,y:409.4},0).wait(2).to({regY:30.8,scaleX:1.43,scaleY:1.53,skewY:20.2,x:370.5,y:410.7},0).wait(12).to({regY:30.6,scaleX:1.5,scaleY:1.45,skewX:-7.8,skewY:-3.3,x:373.4,y:419.3},0).wait(2).to({regY:30.7,scaleX:1.57,scaleY:1.36,skewX:-24.4,skewY:-26.7,x:376.2,y:428.3},0).to({_off:true},2).wait(235));

	// Murray Shirt Button 1
	this.instance_166 = new lib.MurrayPointerFinger_039_1();
	this.instance_166.parent = this;
	this.instance_166.setTransform(343.1,756.5,1,1,0,134.1,-45.9,28.3,29.1);
	this.instance_166._off = true;

	this.instance_167 = new lib.MurrayArm1_1();
	this.instance_167.parent = this;
	this.instance_167.setTransform(425.6,788.4,1.287,1.212,0,163.2,-26.7,32.7,33.7);
	this.instance_167.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,-2,5);
	this.instance_167._off = true;

	this.instance_168 = new lib.MurrayPalm_41_1();
	this.instance_168.parent = this;
	this.instance_168.setTransform(337.4,509.3,1,1,4.2,0,0,31.8,25.1);

	this.instance_169 = new lib.MurrayPointerFinger_039_1();
	this.instance_169.parent = this;
	this.instance_169.setTransform(336.1,494.5,1,1,0,163.3,-16.7,28.6,29.2);

	this.instance_170 = new lib.MurrayPinky_037_1();
	this.instance_170.parent = this;
	this.instance_170.setTransform(318.7,503.1,1,0.999,0,173.1,-6.9,9.3,25.8);

	this.instance_171 = new lib.MurrayArm1_009_1();
	this.instance_171.parent = this;
	this.instance_171.setTransform(365.6,439.3,1.5,1.5,0,-101.1,78.9,32.8,37.1);

	this.instance_172 = new lib.MurrayShirtRightArm_001_1();
	this.instance_172.parent = this;
	this.instance_172.setTransform(393.3,440.7,1.426,1.532,0,-71.7,-60,39.1,30.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_166}]},9).to({state:[{t:this.instance_166}]},8).to({state:[{t:this.instance_166}]},2).to({state:[{t:this.instance_166}]},2).to({state:[{t:this.instance_166}]},2).to({state:[{t:this.instance_166}]},2).to({state:[{t:this.instance_166}]},2).to({state:[{t:this.instance_167}]},10).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_170},{t:this.instance_169},{t:this.instance_166},{t:this.instance_168},{t:this.instance_167}]},24).to({state:[]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},36).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_171}]},2).to({state:[{t:this.instance_167}]},64).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},34).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[]},38).to({state:[{t:this.instance_172}]},67).to({state:[]},51).to({state:[{t:this.instance_167}]},253).to({state:[{t:this.instance_167}]},4).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},2).to({state:[{t:this.instance_167}]},6).wait(6));
	this.timeline.addTween(cjs.Tween.get(this.instance_166).wait(9).to({_off:false},0).to({y:503.6},8).wait(2).to({regX:28.4,regY:28.9,scaleX:1,scaleY:1,skewX:142.4,skewY:-37.6,x:332.8,y:494.4},0).wait(2).to({regY:29.1,scaleX:1,scaleY:1,skewX:150.5,skewY:-29.5,x:322.2,y:485},0).wait(2).to({regX:28.3,regY:28.9,scaleX:1,scaleY:1,skewX:142.4,skewY:-37.6,x:332.7,y:494.5},0).wait(2).to({regX:28.4,regY:29.1,skewX:138.1,skewY:-41.9,x:337.9,y:498.9},0).wait(2).to({regX:28.3,scaleX:1,scaleY:1,skewX:134.1,skewY:-45.9,x:343.1,y:503.6},0).to({_off:true},10).wait(34).to({_off:false,regX:29,regY:32.2,skewX:176.5,skewY:-3.5,x:344.9,y:501.5},0).to({_off:true},2).wait(665));
	this.timeline.addTween(cjs.Tween.get(this.instance_167).wait(37).to({_off:false},0).wait(2).to({regX:32.6,regY:33.6,scaleX:1.29,skewX:176,skewY:-14,x:402.8,y:629},0).wait(2).to({scaleX:1.29,skewX:182.3,skewY:-7.5,x:391.5,y:549.3},0).wait(2).to({regX:32.5,scaleX:1.29,skewX:185.3,skewY:-4.3,x:385.7,y:509.4},0).wait(2).to({skewX:186.8,skewY:-2.8,x:382.9,y:489.6},0).wait(2).to({regX:32.6,scaleX:1.29,skewX:188.6,skewY:-1.3,x:383.8,y:466.7},0).wait(24).to({regX:32.1,regY:37.4,scaleX:1.88,scaleY:0.9,skewX:346.9,skewY:-40.9,x:366.8,y:474.8},0).to({_off:true},2).wait(2).to({_off:false,regX:32.7,regY:37.3,scaleX:1.73,skewX:342.4,skewY:-33,x:333.8,y:449.6},0).wait(2).to({regY:37.1,scaleX:1.5,scaleY:1.5,rotation:3.1,skewX:360,skewY:0,x:348.7,y:410.9},0).wait(2).to({regX:32.8,regY:37,scaleX:1.5,scaleY:1.43,rotation:0,skewX:371.3,skewY:8.8,x:348.9},0).wait(2).to({regY:37.1,scaleY:1.35,skewX:379.9,skewY:14.9,x:348.8,y:411},0).wait(2).to({regY:36.9,scaleX:1.5,scaleY:1.28,skewX:388.3,skewY:20.8,y:410.6},0).wait(2).to({regX:32.9,regY:37.1,scaleY:1.21,skewX:396.9,skewY:27,y:410.9},0).wait(2).to({regX:32.6,scaleX:1.5,scaleY:1.14,skewX:405.4,skewY:33.1,x:348.5,y:410.8},0).wait(2).to({scaleX:1.5,scaleY:1.21,skewX:396.9,skewY:27},0).wait(2).to({regX:32.5,scaleY:1.28,skewX:388.3,skewY:20.8,x:348.1,y:410.7},0).wait(2).to({regX:32.6,scaleX:1.5,scaleY:1.35,skewX:379.9,skewY:14.9,x:348.4},0).wait(2).to({regX:33.1,regY:37.6,scaleY:1.43,skewX:371.3,skewY:8.8,x:349.2,y:411.6},0).wait(2).to({regX:32.7,regY:37.1,scaleX:1.5,scaleY:1.5,rotation:3.1,skewX:360,skewY:0,x:348.7,y:410.9},0).wait(2).to({regX:32.8,regY:37,scaleX:1.5,scaleY:1.43,rotation:0,skewX:371.3,skewY:8.8,x:348.9},0).wait(2).to({regY:37.1,scaleY:1.35,skewX:379.9,skewY:14.9,x:348.8,y:411},0).wait(2).to({regY:36.9,scaleX:1.5,scaleY:1.28,skewX:388.3,skewY:20.8,y:410.6},0).wait(2).to({regX:32.9,regY:37.1,scaleY:1.21,skewX:396.9,skewY:27,y:410.9},0).wait(2).to({regX:32.6,scaleX:1.5,scaleY:1.14,skewX:405.4,skewY:33.1,x:348.5,y:410.8},0).wait(2).to({scaleX:1.5,scaleY:1.21,skewX:396.9,skewY:27},0).wait(2).to({regX:32.5,scaleY:1.28,skewX:388.3,skewY:20.8,x:348.1,y:410.7},0).wait(2).to({regX:32.6,scaleX:1.5,scaleY:1.35,skewX:379.9,skewY:14.9,x:348.4},0).wait(2).to({regX:33.1,regY:37.6,scaleY:1.43,skewX:371.3,skewY:8.8,x:349.2,y:411.6},0).wait(2).to({regX:32.7,regY:37.1,scaleX:1.5,scaleY:1.5,rotation:3.1,skewX:360,skewY:0,x:348.7,y:410.9},0).wait(2).to({regX:32.8,regY:37,scaleX:1.5,scaleY:1.43,rotation:0,skewX:371.3,skewY:8.8,x:348.9},0).wait(2).to({regY:37.1,scaleY:1.35,skewX:379.9,skewY:14.9,x:348.8,y:411},0).wait(2).to({regY:36.9,scaleX:1.5,scaleY:1.28,skewX:388.3,skewY:20.8,y:410.6},0).wait(2).to({regX:32.9,regY:37.1,scaleY:1.21,skewX:396.9,skewY:27,y:410.9},0).wait(2).to({regX:32.6,scaleX:1.5,scaleY:1.14,skewX:405.4,skewY:33.1,x:348.5,y:410.8},0).wait(2).to({scaleX:1.5,scaleY:1.21,skewX:396.9,skewY:27},0).wait(2).to({regX:32.5,scaleY:1.28,skewX:388.3,skewY:20.8,x:348.1,y:410.7},0).wait(2).to({regX:32.6,scaleX:1.5,scaleY:1.35,skewX:379.9,skewY:14.9,x:348.4},0).wait(2).to({regX:33.1,regY:37.6,scaleY:1.43,skewX:371.3,skewY:8.8,x:349.2,y:411.6},0).wait(2).to({regX:32.7,regY:37.1,scaleX:1.5,scaleY:1.5,rotation:3.1,skewX:360,skewY:0,x:348.7,y:410.9},0).wait(2).to({regX:32.2,regY:37.2,scaleX:1.73,scaleY:0.9,rotation:0,skewX:368.6,skewY:-6.7,x:339.4,y:457.4},0).wait(2).to({regX:32.6,regY:37.4,scaleX:1.88,skewX:353.6,skewY:-34.2,x:366.2,y:462.2},0).wait(2).to({regX:32.1,scaleY:0.9,skewX:346.9,skewY:-40.9,x:366.8,y:474.8},0).wait(2).to({regX:32.6,regY:33.6,scaleX:1.29,scaleY:1.21,skewX:188.6,skewY:-1.3,x:380.2,y:469.5},0).wait(36).to({regX:32.9,regY:36.9,scaleX:1.34,scaleY:1.28,skewX:206.1,skewY:18.8,x:377.2,y:459},0).wait(2).to({regY:36.8,scaleX:1.39,scaleY:1.35,skewX:223.8,skewY:38.8,x:373.2,y:452.5},0).wait(2).to({regY:36.9,scaleX:1.45,scaleY:1.43,skewX:241.4,skewY:58.9,x:369.4,y:445.9},0).to({_off:true},2).wait(64).to({_off:false,regX:32.2,regY:37.2,scaleX:1.73,scaleY:0.9,skewX:368.6,skewY:-6.7,x:339.4,y:457.4},0).wait(2).to({regX:32.6,regY:37.4,scaleX:1.88,skewX:353.6,skewY:-34.2,x:366.2,y:462.2},0).wait(2).to({regX:32.1,scaleY:0.9,skewX:346.9,skewY:-40.9,x:366.8,y:474.8},0).wait(2).to({regX:32.8,regY:37,scaleX:1.29,scaleY:1.21,skewX:190.6,skewY:0.7,x:379.7,y:461.8},0).wait(2).to({regY:37.2,scaleX:1.37,scaleY:1.3,skewX:205.3,skewY:20.3,x:372.1,y:452.7},0).wait(2).to({regX:32.5,regY:37.1,scaleX:1.45,scaleY:1.38,skewX:220.2,skewY:40.2,x:363.9,y:443.6},0).wait(2).to({regX:32.7,regY:37,scaleX:1.42,scaleY:1.32,skewX:217.3,skewY:37.3,x:366.1,y:444},0).wait(2).to({regX:32.5,regY:37.3,scaleX:1.4,scaleY:1.27,skewX:214.5,skewY:34.5,x:367.9,y:443.7},0).wait(34).to({regX:32.8,regY:37.2,scaleX:1.45,scaleY:1.19,skewX:205.1,skewY:25.1,x:371,y:454.4},0).wait(2).to({regX:32.6,scaleX:1.5,scaleY:1.12,skewX:198.3,skewY:18.3,x:371.4,y:463.3},0).wait(2).to({regX:32.8,regY:37.1,scaleY:1.12,skewX:197,skewY:17,x:372.7,y:464.3},0).wait(2).to({scaleX:1.5,scaleY:1.12,skewX:195.7,skewY:15.7,x:373.8,y:464.9},0).wait(2).to({_off:true},38).wait(371).to({_off:false},0).wait(4).to({regX:32.6,regY:36.6,scaleX:1.5,scaleY:1.12,skewX:193.1,skewY:13.1,x:375.5,y:463.4},0).wait(2).to({regX:32.8,regY:37,scaleX:1.5,scaleY:1.12,skewX:191.8,skewY:11.8,x:377.1,y:461.9},0).wait(2).to({regX:32.3,regY:37.2,scaleX:1.5,scaleY:1.12,skewX:191.3,skewY:11.3,x:376.9,y:460.9},0).wait(2).to({regX:33.3,regY:36.8,scaleX:1.5,scaleY:1.12,skewX:190.8,skewY:10.8,x:378.3,y:461},0).to({regX:32.7,regY:37,skewX:195.7,skewY:15.7,x:373.6,y:720.9},6).wait(6));

	// Patch
	this.instance_173 = new lib.MurrayMiddleFinger_1();
	this.instance_173.parent = this;
	this.instance_173.setTransform(327.5,747.3,2.068,1.984,0,119.2,-67.1,15.9,13.3);
	this.instance_173._off = true;

	this.instance_174 = new lib.MurrayPalm_41_1();
	this.instance_174.parent = this;
	this.instance_174.setTransform(415.9,842.4,1,1,-27.4,0,0,31.4,25.4);
	this.instance_174._off = true;

	this.instance_175 = new lib.MurrayShirtRightArm_1();
	this.instance_175.parent = this;
	this.instance_175.setTransform(399.6,427.3,1.326,1.459,0,-79.6,-53.5,39.4,30.9);

	this.instance_176 = new lib.MurrayArm2_1();
	this.instance_176.parent = this;
	this.instance_176.setTransform(362.9,458.9,1.495,1.375,0,-73.6,-52,33.5,24.7);

	this.instance_177 = new lib.MurrayArm1_1();
	this.instance_177.parent = this;
	this.instance_177.setTransform(345.3,467.3,1.628,0.845,0,-63.8,-79.2,32.4,37.4);
	this.instance_177._off = true;

	this.instance_178 = new lib.MurrayThumb_037_1();
	this.instance_178.parent = this;
	this.instance_178.setTransform(308.3,469.3,0.943,0.943,-72.4,0,0,17.1,19.5);

	this.instance_179 = new lib.MurrayPalm_037_1();
	this.instance_179.parent = this;
	this.instance_179.setTransform(305.4,484.5,0.943,0.943,-72.4,0,0,29.4,23.5);

	this.instance_180 = new lib.MurrayPointerFinger_1();
	this.instance_180.parent = this;
	this.instance_180.setTransform(297.1,476.1,1.414,1.608,6.7,0,0,21.6,8.3);

	this.instance_181 = new lib.MurrayPinky_037_1();
	this.instance_181.parent = this;
	this.instance_181.setTransform(277.9,494.2,0.943,0.943,-72.4,0,0,7,14.6);

	this.instance_182 = new lib.MurrayPalm_1();
	this.instance_182.parent = this;
	this.instance_182.setTransform(320.1,371.6,1.611,1.561,44.7,0,0,30.4,29.7);
	this.instance_182._off = true;

	this.instance_183 = new lib.MurrayArm1_007_1();
	this.instance_183.parent = this;
	this.instance_183.setTransform(338.3,434.4,1.5,1.204,0,-21.9,150.7,32.4,37);
	this.instance_183._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_173}]},9).to({state:[{t:this.instance_173}]},8).to({state:[{t:this.instance_173}]},2).to({state:[{t:this.instance_173}]},2).to({state:[{t:this.instance_173}]},2).to({state:[{t:this.instance_173}]},2).to({state:[{t:this.instance_173}]},2).to({state:[{t:this.instance_174}]},10).to({state:[{t:this.instance_174}]},2).to({state:[{t:this.instance_174}]},2).to({state:[{t:this.instance_174}]},2).to({state:[{t:this.instance_174}]},2).to({state:[{t:this.instance_174}]},2).to({state:[]},24).to({state:[{t:this.instance_181},{t:this.instance_173},{t:this.instance_180},{t:this.instance_179},{t:this.instance_178,p:{regX:17.1,regY:19.5,scaleX:0.943,scaleY:0.943,rotation:-72.4,x:308.3,y:469.3}},{t:this.instance_177},{t:this.instance_176},{t:this.instance_175}]},2).to({state:[{t:this.instance_178,p:{regX:17.2,regY:19.9,scaleX:1,scaleY:1,rotation:-26.2,x:305,y:423.4}}]},2).to({state:[{t:this.instance_182}]},2).to({state:[{t:this.instance_182}]},2).to({state:[{t:this.instance_182}]},2).to({state:[{t:this.instance_182}]},2).to({state:[{t:this.instance_182}]},2).to({state:[{t:this.instance_182}]},2).to({state:[{t:this.instance_182}]},2).to({state:[{t:this.instance_182}]},2).to({state:[{t:this.instance_182}]},2).to({state:[{t:this.instance_182}]},2).to({state:[{t:this.instance_182}]},2).to({state:[{t:this.instance_182}]},2).to({state:[{t:this.instance_182}]},2).to({state:[{t:this.instance_182}]},2).to({state:[{t:this.instance_182}]},2).to({state:[{t:this.instance_182}]},2).to({state:[{t:this.instance_182}]},2).to({state:[{t:this.instance_182}]},2).to({state:[{t:this.instance_182}]},2).to({state:[{t:this.instance_182}]},2).to({state:[{t:this.instance_182}]},2).to({state:[{t:this.instance_182}]},2).to({state:[{t:this.instance_182}]},2).to({state:[{t:this.instance_182}]},2).to({state:[{t:this.instance_182}]},2).to({state:[{t:this.instance_182}]},2).to({state:[{t:this.instance_182}]},2).to({state:[{t:this.instance_182}]},2).to({state:[{t:this.instance_182}]},2).to({state:[{t:this.instance_182}]},2).to({state:[{t:this.instance_182}]},2).to({state:[{t:this.instance_178,p:{regX:17,regY:19.8,scaleX:1,scaleY:1,rotation:0,x:325.7,y:421.1}}]},2).to({state:[]},2).to({state:[{t:this.instance_174}]},4).to({state:[]},36).to({state:[{t:this.instance_178,p:{regX:17,regY:19.8,scaleX:1,scaleY:1,rotation:0,x:325.7,y:421.1}}]},70).to({state:[]},2).to({state:[{t:this.instance_174}]},48).to({state:[{t:this.instance_174}]},2).to({state:[{t:this.instance_174}]},2).to({state:[{t:this.instance_174}]},2).to({state:[]},38).to({state:[{t:this.instance_177}]},67).to({state:[]},51).to({state:[{t:this.instance_177}]},138).to({state:[{t:this.instance_177}]},2).to({state:[{t:this.instance_183}]},2).to({state:[{t:this.instance_183}]},4).to({state:[{t:this.instance_183}]},2).to({state:[{t:this.instance_183}]},2).to({state:[{t:this.instance_177}]},40).to({state:[{t:this.instance_177}]},2).to({state:[{t:this.instance_177}]},2).to({state:[{t:this.instance_174}]},59).to({state:[{t:this.instance_174}]},4).to({state:[{t:this.instance_174}]},2).to({state:[{t:this.instance_174}]},2).to({state:[{t:this.instance_174}]},2).to({state:[{t:this.instance_174}]},6).wait(6));
	this.timeline.addTween(cjs.Tween.get(this.instance_173).wait(9).to({_off:false},0).to({regX:16.2,x:327.8,y:493.8},8).wait(2).to({scaleX:2.07,scaleY:1.98,skewX:127.4,skewY:-58.9,x:319,y:482.5},0).wait(2).to({regX:16.4,scaleX:2.07,scaleY:1.98,skewX:135.6,skewY:-50.6,x:310.5,y:471},0).wait(2).to({regX:16.2,scaleX:2.07,scaleY:1.98,skewX:127.4,skewY:-58.9,x:319,y:482.6},0).wait(2).to({regX:16.4,skewX:123.3,skewY:-63,x:323.6,y:487.8},0).wait(2).to({regX:16.2,scaleX:2.07,scaleY:1.98,skewX:119.2,skewY:-67.1,x:327.8,y:493.8},0).to({_off:true},10).wait(36).to({_off:false,regX:15,regY:9,scaleX:1.41,scaleY:1.69,rotation:-10.3,skewX:0,skewY:0,x:283.5,y:482},0).to({_off:true},2).wait(663));
	this.timeline.addTween(cjs.Tween.get(this.instance_174).wait(37).to({_off:false},0).wait(2).to({regX:31.6,regY:25.2,scaleX:1,scaleY:1,rotation:-14.6,x:382.2,y:677.9},0).wait(2).to({rotation:-8.3,x:365.3,y:595.7},0).wait(2).to({regX:31.4,regY:24.8,scaleX:1,scaleY:1,rotation:-5,x:356.6,y:554.4},0).wait(2).to({regX:31.6,regY:25.1,rotation:-3.3,x:352.8,y:534.1},0).wait(2).to({rotation:-2,x:352.1,y:510.7},0).to({_off:true},24).wait(74).to({_off:false,regX:31.7,x:348.5,y:513.6},0).to({_off:true},36).wait(120).to({_off:false,regX:31.8,regY:25.2,scaleX:1,scaleY:1.09,rotation:-35.6,x:333.7,y:501.7},0).wait(2).to({regX:31.7,rotation:-36.9,x:335.5,y:503.3},0).wait(2).to({scaleX:1,scaleY:1.09,rotation:-38.2,x:337.4,y:504.9},0).wait(2).to({_off:true},38).wait(371).to({_off:false},0).wait(4).to({regX:31.8,scaleX:1,scaleY:1.09,rotation:-40.6,x:341.3,y:504.2},0).wait(2).to({scaleY:1.09,rotation:-41.9,x:343,y:503.8},0).wait(2).to({regX:31.9,regY:25.1,rotation:-42.6,x:344,y:503.5},0).wait(2).to({regX:31.6,regY:25.2,scaleX:1,scaleY:1.09,rotation:-43.2,x:344.9,y:503.6},0).to({regX:31.7,rotation:-38.2,x:337.4,y:760.9},6).wait(6));
	this.timeline.addTween(cjs.Tween.get(this.instance_177).wait(73).to({_off:false},0).to({_off:true},2).wait(337).to({_off:false,regX:32.8,regY:37.1,scaleX:1.5,scaleY:1.12,skewX:-164.3,skewY:15.7,x:373.8,y:464.9},0).to({_off:true},51).wait(138).to({_off:false,regX:33,skewX:-149.3,skewY:30.7,x:380.4,y:453.3},0).wait(2).to({regX:32.7,scaleX:1.5,scaleY:1.12,skewX:-97.8,skewY:82.2,x:362.2,y:446.2},0).to({_off:true},2).wait(48).to({_off:false},0).wait(2).to({regX:33,scaleX:1.5,scaleY:1.12,skewX:-149.3,skewY:30.7,x:380.4,y:453.3},0).wait(2).to({regX:32.8,skewX:-164.3,skewY:15.7,x:373.8,y:464.9},0).to({_off:true},59).wait(22));
	this.timeline.addTween(cjs.Tween.get(this.instance_182).wait(77).to({_off:false},0).wait(2).to({regX:32.6,regY:28.3,scaleX:1.61,scaleY:1.56,rotation:54.7,x:330.2,y:374.9},0).wait(2).to({regX:30,regY:31.2,scaleX:1.61,scaleY:1.56,rotation:64.7,y:375.1},0).wait(2).to({regX:30.9,regY:29.7,scaleX:1.61,scaleY:1.56,rotation:73,x:335,y:374.9},0).wait(2).to({regX:30.7,rotation:81.4,x:337.2,y:374.2},0).wait(2).to({regX:30.6,regY:29.4,scaleX:1.61,scaleY:1.56,rotation:89.6,x:339.4,y:373.6},0).wait(2).to({regX:31,regY:29.2,scaleX:1.61,scaleY:1.56,rotation:81.4,x:337.6,y:374.7},0).wait(2).to({regX:30.7,regY:29.7,rotation:73,x:334.5,y:374.9},0).wait(2).to({regX:30,regY:31.2,scaleX:1.61,scaleY:1.56,rotation:64.7,x:330.2,y:375.1},0).wait(2).to({regX:30.7,regY:29.7,scaleX:1.61,scaleY:1.56,rotation:45.1,x:332.4,y:372.8},0).wait(2).to({regX:30.4,regY:29.8,scaleX:1.61,scaleY:1.56,rotation:25.7,x:331.5,y:370.7},0).wait(2).to({regX:30.5,regY:29.6,scaleX:1.61,scaleY:1.56,rotation:45.1,x:332.3,y:372.7},0).wait(2).to({regX:30,regY:31.2,scaleX:1.61,scaleY:1.56,rotation:64.7,x:330.2,y:375.1},0).wait(2).to({regX:30.9,regY:29.7,scaleX:1.61,scaleY:1.56,rotation:73,x:335,y:374.9},0).wait(2).to({regX:30.7,rotation:81.4,x:337.2,y:374.2},0).wait(2).to({regX:30.6,regY:29.4,scaleX:1.61,scaleY:1.56,rotation:89.6,x:339.4,y:373.6},0).wait(2).to({regX:31,regY:29.2,scaleX:1.61,scaleY:1.56,rotation:81.4,x:337.6,y:374.7},0).wait(2).to({regX:30.7,regY:29.7,rotation:73,x:334.5,y:374.9},0).wait(2).to({regX:30,regY:31.2,scaleX:1.61,scaleY:1.56,rotation:64.7,x:330.2,y:375.1},0).wait(2).to({regX:30.7,regY:29.7,scaleX:1.61,scaleY:1.56,rotation:45.1,x:332.4,y:372.8},0).wait(2).to({regX:30.4,regY:29.8,scaleX:1.61,scaleY:1.56,rotation:25.7,x:331.5,y:370.7},0).wait(2).to({regX:30.5,regY:29.6,scaleX:1.61,scaleY:1.56,rotation:45.1,x:332.3,y:372.7},0).wait(2).to({regX:30,regY:31.2,scaleX:1.61,scaleY:1.56,rotation:64.7,x:330.2,y:375.1},0).wait(2).to({regX:30.9,regY:29.7,scaleX:1.61,scaleY:1.56,rotation:73,x:335,y:374.9},0).wait(2).to({regX:30.7,rotation:81.4,x:337.2,y:374.2},0).wait(2).to({regX:30.6,regY:29.4,scaleX:1.61,scaleY:1.56,rotation:89.6,x:339.4,y:373.6},0).wait(2).to({regX:31,regY:29.2,scaleX:1.61,scaleY:1.56,rotation:81.4,x:337.6,y:374.7},0).wait(2).to({regX:30.7,regY:29.7,rotation:73,x:334.5,y:374.9},0).wait(2).to({regX:30,regY:31.2,scaleX:1.61,scaleY:1.56,rotation:64.7,x:330.2,y:375.1},0).wait(2).to({regX:30.7,regY:29.7,scaleX:1.61,scaleY:1.56,rotation:45.1,x:332.4,y:372.8},0).wait(2).to({regX:30.4,regY:29.8,scaleX:1.61,scaleY:1.56,rotation:25.7,x:331.5,y:370.7},0).to({_off:true},2).wait(599));
	this.timeline.addTween(cjs.Tween.get(this.instance_183).wait(605).to({_off:false},0).wait(4).to({regX:32.9,scaleX:1.5,scaleY:1.16,skewX:-25.6,x:338.1,y:436.1},0).wait(2).to({regX:32.6,regY:36.9,scaleY:1.14,skewX:-27.3,x:338.5,y:436.4},0).wait(2).to({regX:32.8,regY:37,scaleX:1.5,scaleY:1.12,skewX:-29.3,y:437.4},0).to({_off:true},40).wait(85));

	// Shirt Stitches
	this.instance_184 = new lib.MurrayArm2_1();
	this.instance_184.parent = this;
	this.instance_184.setTransform(344.2,419.2,1.5,1.249,27.2,0,0,33.2,24.6);
	this.instance_184._off = true;

	this.instance_185 = new lib.MurrayArm1_1();
	this.instance_185.parent = this;
	this.instance_185.setTransform(351.8,442,1.5,1.123,0,-131.9,48.1,32.6,36.9);
	this.instance_185._off = true;

	this.instance_186 = new lib.MurrayPalm_41_1();
	this.instance_186.parent = this;
	this.instance_186.setTransform(337.4,504.9,1,1.092,-38.2,0,0,31.7,25.2);

	this.instance_187 = new lib.MurrayPointerFinger_039_1();
	this.instance_187.parent = this;
	this.instance_187.setTransform(550.5,501,1,1,-163.8,0,0,28.2,29.6);
	this.instance_187._off = true;

	this.instance_188 = new lib.MurrayMiddleFinger_1();
	this.instance_188.parent = this;
	this.instance_188.setTransform(561.3,492.3,2.068,1.984,0,-148.9,-142.6,15.7,12.8);

	this.instance_189 = new lib.MurrayPinky_037_1();
	this.instance_189.parent = this;
	this.instance_189.setTransform(580.4,498.5,1,0.999,0,-173.6,6.4,9.9,27.1);

	this.instance_190 = new lib.MurrayLeftArm2_0001_1();
	this.instance_190.parent = this;
	this.instance_190.setTransform(515.6,463.9,1.458,1.351,0,154.8,-25.2,19.1,38.8);

	this.instance_191 = new lib.neckPatc_1();
	this.instance_191.parent = this;
	this.instance_191.setTransform(535.6,477,0.732,0.732,0,0,0,12.9,15.5);

	this.instance_192 = new lib.MurrayLeftThumb_110_1();
	this.instance_192.parent = this;
	this.instance_192.setTransform(546.9,478.3,1,1,0,0,0,14.2,12.7);

	this.instance_193 = new lib.MurrayPointerFinger_108_1();
	this.instance_193.parent = this;
	this.instance_193.setTransform(567.6,474.5,1,1,0,0,180,16.9,15.8);

	this.instance_194 = new lib.MurrayMiddleFinger_108_1();
	this.instance_194.parent = this;
	this.instance_194.setTransform(580.8,483.7,1,1,0,15,-165,15.4,14.8);

	this.instance_195 = new lib.MurrayPinky_108_1();
	this.instance_195.parent = this;
	this.instance_195.setTransform(595.5,475.7,1,1,0,0,180,15,12.7);

	this.instance_196 = new lib.MurrayLeftPalm_108_1();
	this.instance_196.parent = this;
	this.instance_196.setTransform(563.2,480,1,1,0,0,0,24.5,16.3);

	this.instance_197 = new lib.Murray_right_arm_down();
	this.instance_197.parent = this;
	this.instance_197.setTransform(369.2,470.3,1,1,0,0,0,73.7,79.7);
	this.instance_197._off = true;

	this.instance_198 = new lib.MurrayThumb_241_1();
	this.instance_198.parent = this;
	this.instance_198.setTransform(361.6,378.4,1,1,0,0,0,16.4,20.1);
	this.instance_198._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_184}]},351).to({state:[{t:this.instance_184}]},4).to({state:[{t:this.instance_184}]},2).to({state:[{t:this.instance_184}]},2).to({state:[{t:this.instance_184}]},39).to({state:[{t:this.instance_184}]},2).to({state:[{t:this.instance_184}]},2).to({state:[{t:this.instance_185}]},4).to({state:[{t:this.instance_185}]},2).to({state:[{t:this.instance_185}]},2).to({state:[{t:this.instance_186,p:{regX:31.7,regY:25.2,rotation:-38.2,skewX:0,skewY:0,x:337.4,y:504.9}}]},2).to({state:[{t:this.instance_185}]},51).to({state:[]},4).to({state:[{t:this.instance_190,p:{regX:19.1,scaleX:1.458,scaleY:1.351,skewX:154.8,skewY:-25.2,x:515.6,y:463.9}},{t:this.instance_189},{t:this.instance_188},{t:this.instance_187},{t:this.instance_186,p:{regX:31.8,regY:25.1,rotation:0,skewX:8.5,skewY:-171.5,x:557.3,y:503.3}}]},38).to({state:[{t:this.instance_190,p:{regX:19.2,scaleX:1.497,scaleY:1.349,skewX:147.4,skewY:-32.6,x:516.8,y:462.1}},{t:this.instance_196,p:{x:563.2,y:480}},{t:this.instance_195,p:{x:595.5,y:475.7}},{t:this.instance_194,p:{regY:14.8,x:580.8,y:483.7}},{t:this.instance_193,p:{x:567.6,y:474.5}},{t:this.instance_192},{t:this.instance_191}]},2).to({state:[{t:this.instance_190,p:{regX:19.2,scaleX:1.497,scaleY:1.349,skewX:123.9,skewY:-56.1,x:528.6,y:467}},{t:this.instance_196,p:{x:570.3,y:450.2}},{t:this.instance_195,p:{x:602.6,y:445.8}},{t:this.instance_194,p:{regY:13.5,x:588.2,y:452.6}},{t:this.instance_193,p:{x:574.7,y:444.7}}]},2).to({state:[]},2).to({state:[{t:this.instance_197}]},6).to({state:[{t:this.instance_197}]},44).to({state:[{t:this.instance_197}]},2).to({state:[{t:this.instance_197}]},2).to({state:[{t:this.instance_197}]},2).to({state:[{t:this.instance_185}]},26).to({state:[]},8).to({state:[{t:this.instance_198}]},4).to({state:[{t:this.instance_198}]},4).to({state:[{t:this.instance_198}]},2).to({state:[{t:this.instance_198}]},2).to({state:[]},40).to({state:[{t:this.instance_186,p:{regX:31.7,regY:25.2,rotation:-38.2,skewX:0,skewY:0,x:337.4,y:504.9}}]},4).to({state:[{t:this.instance_187}]},59).to({state:[{t:this.instance_187}]},4).to({state:[{t:this.instance_187}]},2).to({state:[{t:this.instance_187}]},2).to({state:[{t:this.instance_187}]},2).to({state:[{t:this.instance_187}]},6).wait(6));
	this.timeline.addTween(cjs.Tween.get(this.instance_184).wait(351).to({_off:false},0).wait(4).to({regY:24.7,scaleX:1.5,scaleY:1.25,rotation:25.3,x:345.2,y:424.4},0).wait(2).to({regX:33.4,regY:24.6,rotation:24.5,x:345.9,y:426.9},0).wait(2).to({regX:33.5,regY:24.8,scaleX:1.5,scaleY:1.25,rotation:23.7,x:346.4,y:429.7},0).wait(39).to({regX:33.4,regY:24.6,scaleX:1.5,scaleY:1.25,rotation:24.5,x:345.9,y:426.9},0).wait(2).to({regX:33.2,regY:24.7,rotation:25.3,x:345.2,y:424.4},0).wait(2).to({regY:24.6,scaleX:1.5,scaleY:1.25,rotation:27.2,x:344.2,y:419.2},0).to({_off:true},4).wait(332));
	this.timeline.addTween(cjs.Tween.get(this.instance_185).wait(406).to({_off:false},0).wait(2).to({regY:37.2,scaleX:1.5,scaleY:1.12,skewX:-161.7,skewY:18.3,x:371.4,y:463.3},0).wait(2).to({regX:32.8,regY:37.1,scaleY:1.12,skewX:-163,skewY:17,x:372.7,y:464.3},0).to({_off:true},2).wait(51).to({_off:false,scaleX:1.5,scaleY:1.12,skewX:-164.3,skewY:15.7,x:373.8,y:464.9},0).to({_off:true},4).wait(126).to({_off:false},0).to({_off:true},8).wait(137));
	this.timeline.addTween(cjs.Tween.get(this.instance_187).wait(505).to({_off:false},0).to({_off:true},2).wait(209).to({_off:false,regX:28.3,regY:29.1,rotation:0,skewX:134.1,skewY:-45.9,x:343.1,y:503.6},0).wait(4).to({regY:28.9,scaleX:1,scaleY:1,skewX:131.6,skewY:-48.4,x:346.8,y:502.8},0).wait(2).to({regX:28.4,skewX:130.4,skewY:-49.6,x:348.7,y:502.3},0).wait(2).to({regY:29,skewX:129.6,skewY:-50.4,x:349.5,y:502},0).wait(2).to({regX:28.2,regY:29.1,scaleX:1,scaleY:1,skewX:129.1,skewY:-50.9,x:350.4,y:501.8},0).to({regX:28.3,skewX:134.1,skewY:-45.9,x:343.1,y:759.5},6).wait(6));
	this.timeline.addTween(cjs.Tween.get(this.instance_197).wait(517).to({_off:false},0).wait(44).to({y:469.3},0).wait(2).to({y:468.3},0).wait(2).to({y:467.4},0).wait(2).to({y:466.4},0).to({_off:true},26).wait(145));
	this.timeline.addTween(cjs.Tween.get(this.instance_198).wait(605).to({_off:false},0).wait(4).to({x:361.2,y:382.3},0).wait(2).to({x:361,y:384.2},0).wait(2).to({x:360.8,y:386.1},0).to({_off:true},40).wait(85));

	// Shirt Collar Left
	this.instance_199 = new lib.MurrayPinky_037_1();
	this.instance_199.parent = this;
	this.instance_199.setTransform(314.1,766.1,1,0.999,143.9,0,0,9.8,27.5);
	this.instance_199._off = true;

	this.instance_200 = new lib.MurrayPointerFinger_039_1();
	this.instance_200.parent = this;
	this.instance_200.setTransform(415.3,835.3,1,1,0,144.9,-35.1,28.4,30.1);
	this.instance_200.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);
	this.instance_200._off = true;

	this.instance_201 = new lib.MurrayPalm_037_1();
	this.instance_201.parent = this;
	this.instance_201.setTransform(290.6,431.8,1,1,-26.2,0,0,29.2,23.2);

	this.instance_202 = new lib.MurrayPalm_41_1();
	this.instance_202.parent = this;
	this.instance_202.setTransform(345.5,508.8,1,1,0,0,0,31.7,25.1);
	this.instance_202._off = true;

	this.instance_203 = new lib.MurrayArm1_1();
	this.instance_203.parent = this;
	this.instance_203.setTransform(344.9,408.1,1.242,1.505,0,-1.1,3.5,32.8,37.2);
	this.instance_203._off = true;

	this.instance_204 = new lib.MurrayArm1_016_1();
	this.instance_204.parent = this;
	this.instance_204.setTransform(543.7,434.5,1.637,0.83,0,176.5,164.9,33.1,36.9);

	this.instance_205 = new lib.MurrayArm1_016_1();
	this.instance_205.parent = this;
	this.instance_205.setTransform(340.8,422.6,1.762,1.012,0,159.7,0.7,33.2,36.6);

	this.instance_206 = new lib.MurrayArm1_1();
	this.instance_206.parent = this;
	this.instance_206.setTransform(340.2,388.7,1.5,1.13,0,-77.6,95.9,32.8,37.1);

	this.instance_207 = new lib.Murray_right_arm_down();
	this.instance_207.parent = this;
	this.instance_207.setTransform(369.2,466.4,1,1,0,0,0,73.7,79.7);
	this.instance_207._off = true;

	this.instance_208 = new lib.MurrayPointerFinger_237_1();
	this.instance_208.parent = this;
	this.instance_208.setTransform(368.1,372.4,1.122,1.426,26.9,0,0,15.7,33.5);
	this.instance_208._off = true;

	this.instance_209 = new lib.MurrayMiddleFinger_1();
	this.instance_209.parent = this;
	this.instance_209.setTransform(327.8,493.8,2.068,1.984,0,119.2,-67.1,16.2,13.3);
	this.instance_209._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_199}]},9).to({state:[{t:this.instance_199}]},8).to({state:[{t:this.instance_199}]},2).to({state:[{t:this.instance_199}]},2).to({state:[{t:this.instance_199}]},2).to({state:[{t:this.instance_199}]},2).to({state:[{t:this.instance_199}]},2).to({state:[{t:this.instance_200}]},10).to({state:[{t:this.instance_200}]},2).to({state:[{t:this.instance_200}]},2).to({state:[{t:this.instance_200}]},2).to({state:[{t:this.instance_200}]},2).to({state:[{t:this.instance_200}]},2).to({state:[]},24).to({state:[{t:this.instance_201,p:{rotation:-26.2,x:290.6,y:431.8}}]},4).to({state:[]},2).to({state:[{t:this.instance_201,p:{rotation:0,x:309.3,y:422.4}}]},62).to({state:[]},2).to({state:[{t:this.instance_200}]},4).to({state:[]},36).to({state:[{t:this.instance_201,p:{rotation:0,x:309.3,y:422.4}}]},70).to({state:[]},2).to({state:[{t:this.instance_202}]},4).to({state:[{t:this.instance_202}]},2).to({state:[]},2).to({state:[{t:this.instance_200}]},40).to({state:[{t:this.instance_200}]},2).to({state:[{t:this.instance_200}]},2).to({state:[{t:this.instance_200}]},2).to({state:[{t:this.instance_202}]},38).to({state:[{t:this.instance_202}]},2).to({state:[{t:this.instance_202}]},2).to({state:[{t:this.instance_203}]},2).to({state:[{t:this.instance_203}]},4).to({state:[{t:this.instance_203}]},2).to({state:[{t:this.instance_203}]},2).to({state:[{t:this.instance_203}]},39).to({state:[{t:this.instance_203}]},2).to({state:[{t:this.instance_203}]},2).to({state:[{t:this.instance_202}]},4).to({state:[{t:this.instance_202}]},2).to({state:[{t:this.instance_202}]},2).to({state:[{t:this.instance_200}]},2).to({state:[{t:this.instance_202}]},51).to({state:[{t:this.instance_203}]},4).to({state:[{t:this.instance_203}]},2).to({state:[{t:this.instance_203}]},2).to({state:[{t:this.instance_203}]},2).to({state:[{t:this.instance_205,p:{regX:33.2,regY:36.6,scaleY:1.012,x:340.8,y:422.6}},{t:this.instance_204,p:{regX:33.1,scaleY:0.83,skewX:176.5,skewY:164.9,x:543.7,y:434.5}}]},2).to({state:[{t:this.instance_205,p:{regX:32.8,regY:33.6,scaleY:1.203,x:339.8,y:394.8}},{t:this.instance_204,p:{regX:32.8,scaleY:1.132,skewX:-168.5,skewY:179.9,x:544.1,y:401.6}}]},2).to({state:[{t:this.instance_203}]},2).to({state:[{t:this.instance_203}]},4).to({state:[{t:this.instance_203}]},2).to({state:[{t:this.instance_203}]},2).to({state:[{t:this.instance_206,p:{regX:32.8,regY:37.1,x:340.2,y:388.7,scaleX:1.5,scaleY:1.13,skewX:-77.6,skewY:95.9}},{t:this.instance_203}]},10).to({state:[{t:this.instance_206,p:{regX:32.6,regY:37.2,x:343.7,y:416.8,scaleX:1.5,scaleY:1.13,skewX:-77.6,skewY:95.9}},{t:this.instance_203}]},2).to({state:[{t:this.instance_206,p:{regX:32.9,regY:37.1,x:344.6,y:438.7,scaleX:1.318,scaleY:1.3,skewX:-128.2,skewY:62.3}},{t:this.instance_203}]},2).to({state:[{t:this.instance_203}]},2).to({state:[{t:this.instance_207}]},2).to({state:[{t:this.instance_207}]},2).to({state:[{t:this.instance_207}]},2).to({state:[{t:this.instance_207}]},2).to({state:[{t:this.instance_207}]},2).to({state:[{t:this.instance_207}]},2).to({state:[]},2).to({state:[{t:this.instance_202}]},76).to({state:[]},8).to({state:[{t:this.instance_208}]},4).to({state:[{t:this.instance_208}]},4).to({state:[{t:this.instance_208}]},2).to({state:[{t:this.instance_208}]},2).to({state:[]},40).to({state:[{t:this.instance_200}]},4).to({state:[{t:this.instance_209}]},59).to({state:[{t:this.instance_209}]},4).to({state:[{t:this.instance_209}]},2).to({state:[{t:this.instance_209}]},2).to({state:[{t:this.instance_209}]},2).to({state:[{t:this.instance_209}]},6).wait(6));
	this.timeline.addTween(cjs.Tween.get(this.instance_199).wait(9).to({_off:false},0).to({y:513.1},8).wait(2).to({regY:27.6,scaleX:1,scaleY:1,rotation:152.2,x:302.8,y:499.5},0).wait(2).to({scaleX:1,scaleY:1,rotation:160.4,x:291.5,y:485.9},0).wait(2).to({regX:10,regY:27.2,scaleX:1,scaleY:1,rotation:152.2,x:302.8,y:500},0).wait(2).to({regX:9.8,regY:27.5,scaleX:1,rotation:148.1,x:308.5,y:506.4},0).wait(2).to({scaleX:1,scaleY:1,rotation:143.9,x:314.1,y:513.1},0).to({_off:true},10).wait(701));
	this.timeline.addTween(cjs.Tween.get(this.instance_200).wait(37).to({_off:false},0).wait(2).to({regX:28.3,scaleX:1,scaleY:1,skewX:157.7,skewY:-22.3,x:382.9,y:671.4},0).wait(2).to({regX:28.6,regY:29.9,skewX:164.2,skewY:-15.8,x:367.1,y:589.4},0).wait(2).to({regX:28.2,regY:30.1,skewX:167.2,skewY:-12.8,x:358.6,y:548.3},0).wait(2).to({regY:29.8,skewX:168.9,skewY:-11.1,x:354.6,y:528.1},0).wait(2).to({regX:28.4,regY:30,scaleX:1,scaleY:1,skewX:170.3,skewY:-9.7,x:354.4,y:504.5},0).to({_off:true},24).wait(74).to({_off:false,regY:30.1,x:350.7,y:507.3},0).to({_off:true},36).wait(120).to({_off:false,regY:29.1,scaleX:1,scaleY:1,skewX:136.6,skewY:-43.4,x:339.3,y:500.6},0).wait(2).to({regY:28.9,skewX:135.4,skewY:-44.6,x:341.4,y:502.3},0).wait(2).to({regX:28.3,regY:29.1,scaleX:1,scaleY:1,skewX:134.1,skewY:-45.9,x:343.1,y:503.6},0).wait(2).to({_off:true},38).wait(67).to({_off:false},0).to({_off:true},51).wait(194).to({_off:false},0).to({_off:true},59).wait(22));
	this.timeline.addTween(cjs.Tween.get(this.instance_202).wait(257).to({_off:false},0).wait(2).to({regX:31.8,regY:24.8,rotation:-15.7,x:330.6,y:493.9},0).to({_off:true},2).wait(84).to({_off:false,regX:31.7,regY:25.2,scaleX:1,scaleY:1.09,rotation:-36.9,x:335.5,y:503.3},0).wait(2).to({regX:31.8,rotation:-35.6,x:333.7,y:501.7},0).wait(2).to({regX:30.2,scaleX:1,scaleY:1.09,rotation:4.7,x:297.7,y:446.8},0).to({_off:true},2).wait(55).to({_off:false,regX:31.7,regY:25.1,rotation:26.1,x:300,y:456.2},0).wait(2).to({regX:31.8,regY:25.2,scaleX:1,scaleY:1.09,rotation:-35.6,x:333.7,y:501.7},0).wait(2).to({regX:31.7,rotation:-36.9,x:335.5,y:503.3},0).to({_off:true},2).wait(51).to({_off:false,scaleX:1,scaleY:1.09,rotation:-38.2,x:337.4,y:504.9},0).to({_off:true},4).wait(126).to({_off:false},0).to({_off:true},8).wait(137));
	this.timeline.addTween(cjs.Tween.get(this.instance_203).wait(351).to({_off:false},0).wait(4).to({regY:37.1,skewX:-2.8,skewY:1.6,x:345.5,y:413.1},0).wait(2).to({regX:32.7,skewX:-3.6,skewY:0.8,x:345.7,y:415.6},0).wait(2).to({skewX:-4.6,skewY:0,x:346,y:418.1},0).wait(39).to({skewX:-3.6,skewY:0.8,x:345.7,y:415.6},0).wait(2).to({regX:32.8,skewX:-2.8,skewY:1.6,x:345.5,y:413.1},0).wait(2).to({regY:37.2,skewX:-1.1,skewY:3.5,x:344.9,y:408.1},0).to({_off:true},4).wait(61).to({_off:false,regY:37.1,scaleX:1.5,scaleY:1.12,skewX:-164.3,skewY:15.7,x:373.8,y:464.9},0).wait(2).to({scaleX:1.5,scaleY:1.12,skewX:-163,skewY:17,x:372.7,y:464.3},0).wait(2).to({regX:32.6,regY:37.2,scaleY:1.12,skewX:-161.7,skewY:18.3,x:371.4,y:463.3},0).wait(2).to({regY:36.9,scaleX:1.5,scaleY:1.12,skewX:-159.1,skewY:20.9,x:369.2,y:462.1},0).to({_off:true},2).wait(4).to({_off:false,regX:33,regY:37.4,scaleX:1.5,scaleY:1.15,skewX:13,skewY:182.3,x:520.7,y:374.5},0).wait(4).to({regY:37.5,scaleX:1.5,scaleY:1.14,skewX:12.6,skewY:184,x:520.3,y:377.5},0).wait(2).to({regY:37.4,scaleX:1.5,scaleY:1.13,skewX:12.5,skewY:185,x:520.1,y:378.9},0).wait(2).to({regX:32.7,regY:36.9,scaleX:1.5,scaleY:1.13,skewX:12.4,skewY:185.9,x:519.9,y:380.5},0).wait(12).to({regX:32.5,regY:37.1,x:523.5,y:409.1},0).wait(2).to({regX:33.2,regY:36.8,skewX:72.4,skewY:245.9,x:540.4,y:431.1},0).wait(2).to({regX:32.6,regY:37.2,scaleX:1.5,scaleY:1.12,skewX:198.3,skewY:378.3,x:371.4,y:463.3},0).to({_off:true},2).wait(233));
	this.timeline.addTween(cjs.Tween.get(this.instance_207).wait(505).to({_off:false},0).wait(2).to({scaleY:0.98,rotation:0.8,x:368.4,y:467.2},0).wait(2).to({scaleY:0.97,rotation:1.8,x:367.7,y:468},0).wait(2).to({regY:79.6,scaleY:0.95,rotation:2.7,x:366.9,y:468.8},0).wait(2).to({regX:68.2,regY:79.7,scaleY:0.97,rotation:1.8,x:362.2,y:469.2},0).wait(2).to({regX:74.8,regY:84.2,scaleY:0.98,rotation:0.8,x:369.5,y:474.4},0).to({_off:true},2).wait(221));
	this.timeline.addTween(cjs.Tween.get(this.instance_208).wait(605).to({_off:false},0).wait(4).to({regX:14.2,regY:30.9,scaleX:1.12,scaleY:1.31,rotation:26.8,x:369.5,y:372.5},0).wait(2).to({regX:14.1,regY:31,scaleY:1.25,x:369.9,y:374.5},0).wait(2).to({regY:30.9,scaleX:1.12,scaleY:1.2,rotation:26.9,x:370.5,y:376.4},0).to({_off:true},40).wait(85));
	this.timeline.addTween(cjs.Tween.get(this.instance_209).wait(716).to({_off:false},0).wait(4).to({regX:16,scaleX:2.07,scaleY:1.98,skewX:116.6,skewY:-69.7,x:330.7,y:493.9},0).wait(2).to({regX:16.2,scaleX:2.07,scaleY:1.98,skewX:115.3,skewY:-70.9,x:332.3,y:493.3},0).wait(2).to({regX:16.1,skewX:114.8,skewY:-71.5,x:333,y:493.4},0).wait(2).to({regX:16,regY:14,scaleX:2.07,scaleY:1.98,skewX:114.2,skewY:-72.1,x:332.9,y:493},0).to({regX:16.2,regY:13.3,skewX:119.2,skewY:-67.1,x:327.8,y:749.7},6).wait(6));

	// Shirt Hem
	this.instance_210 = new lib.MurrayLeftArm2_0001_1();
	this.instance_210.parent = this;
	this.instance_210.setTransform(516.7,717,1.499,1.351,0,154.8,-25.2,19.1,38.7);
	this.instance_210._off = true;

	this.instance_211 = new lib.MurrayMiddleFinger_1();
	this.instance_211.parent = this;
	this.instance_211.setTransform(405.5,828.1,2.068,1.984,0,130,-56.3,16.2,13.3);
	this.instance_211.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);
	this.instance_211._off = true;

	this.instance_212 = new lib.MurrayPointerFinger_1();
	this.instance_212.parent = this;
	this.instance_212.setTransform(291,419.3,1.5,1.705,52.9,0,0,21.4,8.3);

	this.instance_213 = new lib.MurrayPinky_037_1();
	this.instance_213.parent = this;
	this.instance_213.setTransform(314.1,513.1,1,0.999,143.9,0,0,9.8,27.5);
	this.instance_213._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_210}]},9).to({state:[{t:this.instance_210}]},8).to({state:[{t:this.instance_210}]},2).to({state:[{t:this.instance_210}]},2).to({state:[{t:this.instance_210}]},2).to({state:[{t:this.instance_210}]},2).to({state:[{t:this.instance_210}]},2).to({state:[{t:this.instance_211}]},10).to({state:[{t:this.instance_211}]},2).to({state:[{t:this.instance_211}]},2).to({state:[{t:this.instance_211}]},2).to({state:[{t:this.instance_211}]},2).to({state:[{t:this.instance_211}]},2).to({state:[]},24).to({state:[{t:this.instance_212,p:{rotation:52.9,x:291,y:419.3}}]},4).to({state:[{t:this.instance_211}]},2).to({state:[{t:this.instance_211}]},2).to({state:[{t:this.instance_211}]},2).to({state:[{t:this.instance_211}]},2).to({state:[{t:this.instance_211}]},2).to({state:[{t:this.instance_211}]},2).to({state:[{t:this.instance_211}]},2).to({state:[{t:this.instance_211}]},2).to({state:[{t:this.instance_211}]},2).to({state:[{t:this.instance_211}]},2).to({state:[{t:this.instance_211}]},2).to({state:[{t:this.instance_211}]},2).to({state:[{t:this.instance_211}]},2).to({state:[{t:this.instance_211}]},2).to({state:[{t:this.instance_211}]},2).to({state:[{t:this.instance_211}]},2).to({state:[{t:this.instance_211}]},2).to({state:[{t:this.instance_211}]},2).to({state:[{t:this.instance_211}]},2).to({state:[{t:this.instance_211}]},2).to({state:[{t:this.instance_211}]},2).to({state:[{t:this.instance_211}]},2).to({state:[{t:this.instance_211}]},2).to({state:[{t:this.instance_211}]},2).to({state:[{t:this.instance_211}]},2).to({state:[{t:this.instance_211}]},2).to({state:[{t:this.instance_211}]},2).to({state:[{t:this.instance_211}]},2).to({state:[{t:this.instance_211}]},2).to({state:[{t:this.instance_211}]},2).to({state:[{t:this.instance_211}]},2).to({state:[{t:this.instance_212,p:{rotation:79.1,x:315.3,y:411.3}}]},2).to({state:[]},2).to({state:[{t:this.instance_213}]},575).to({state:[{t:this.instance_213}]},4).to({state:[{t:this.instance_213}]},2).to({state:[{t:this.instance_213}]},2).to({state:[{t:this.instance_213}]},2).to({state:[{t:this.instance_213}]},6).wait(6));
	this.timeline.addTween(cjs.Tween.get(this.instance_210).wait(9).to({_off:false},0).to({regY:38.8,y:463.9},8).wait(2).to({scaleX:1.5,scaleY:1.35,skewX:147.9,skewY:-32.1,x:521.1,y:459.8},0).wait(2).to({regY:38.6,scaleX:1.5,scaleY:1.35,skewX:141.1,skewY:-38.9,x:525.4,y:455.9},0).wait(2).to({scaleX:1.5,scaleY:1.35,skewX:147.9,skewY:-32.1,x:521.2,y:459.9},0).wait(2).to({skewX:151.4,skewY:-28.6,x:518.9,y:461.9},0).wait(2).to({regY:38.8,scaleX:1.5,scaleY:1.35,skewX:154.8,skewY:-25.2,x:516.7,y:463.9},0).to({_off:true},10).wait(701));
	this.timeline.addTween(cjs.Tween.get(this.instance_211).wait(37).to({_off:false},0).wait(2).to({scaleX:2.06,scaleY:1.98,skewX:142.7,skewY:-43.6,x:375.2,y:662.3},0).wait(2).to({scaleX:2.06,scaleY:1.98,skewX:149.2,skewY:-37.1,x:360.1,y:579.5},0).wait(2).to({regX:16.1,regY:13.7,scaleX:2.06,scaleY:1.98,skewX:152.4,skewY:-34.1,x:352,y:537.5},0).wait(2).to({regX:16.3,regY:13.3,scaleX:2.06,scaleY:1.98,skewX:153.9,skewY:-32.4,x:348.9,y:517.2},0).wait(2).to({regX:16.2,scaleX:2.07,scaleY:1.98,skewX:155.5,skewY:-30.8,x:348.7,y:493.8},0).to({_off:true},24).wait(6).to({_off:false,regX:15,regY:9.2,scaleX:1.5,scaleY:1.79,rotation:50.2,skewX:0,skewY:0,x:315,y:339},0).wait(2).to({regX:15.1,scaleX:1.5,scaleY:1.78,rotation:60.2,x:327,y:340.7},0).wait(2).to({regX:14.7,scaleX:1.5,scaleY:1.79,rotation:70.2,x:338.8,y:341.9},0).wait(2).to({regX:15.3,scaleX:1.5,scaleY:1.79,rotation:78.5,x:345.5,y:344.2},0).wait(2).to({regX:20.8,regY:8.6,scaleX:1.5,scaleY:1.79,rotation:86.9,x:353.4,y:353.8},0).wait(2).to({regX:15,regY:9.2,rotation:95.1,x:358.3,y:346.6},0).wait(2).to({regX:15.1,regY:9.1,rotation:86.9,x:352,y:345.2},0).wait(2).to({regY:9,scaleX:1.5,scaleY:1.79,rotation:78.5,x:345.7,y:343.7},0).wait(2).to({regX:14.7,regY:9.2,scaleX:1.5,scaleY:1.79,rotation:70.2,x:338.8,y:341.9},0).wait(2).to({regX:15,scaleX:1.5,scaleY:1.78,rotation:50.7,x:327.6},0).wait(2).to({regX:15.1,regY:9.4,scaleX:1.5,scaleY:1.79,rotation:31.2,x:316,y:341.6},0).wait(2).to({regX:15.2,regY:9.2,scaleX:1.5,scaleY:1.78,rotation:50.7,x:327.8,y:341.9},0).wait(2).to({regX:14.7,scaleX:1.5,scaleY:1.79,rotation:70.2,x:338.8},0).wait(2).to({regX:15.3,scaleX:1.5,scaleY:1.79,rotation:78.5,x:345.5,y:344.2},0).wait(2).to({regX:20.8,regY:8.6,scaleX:1.5,scaleY:1.79,rotation:86.9,x:353.4,y:353.8},0).wait(2).to({regX:15,regY:9.2,rotation:95.1,x:358.3,y:346.6},0).wait(2).to({regX:15.1,regY:9.1,rotation:86.9,x:352,y:345.2},0).wait(2).to({regY:9,scaleX:1.5,scaleY:1.79,rotation:78.5,x:345.7,y:343.7},0).wait(2).to({regX:14.7,regY:9.2,scaleX:1.5,scaleY:1.79,rotation:70.2,x:338.8,y:341.9},0).wait(2).to({regX:15,scaleX:1.5,scaleY:1.78,rotation:50.7,x:327.6},0).wait(2).to({regX:15.1,regY:9.4,scaleX:1.5,scaleY:1.79,rotation:31.2,x:316,y:341.6},0).wait(2).to({regX:15.2,regY:9.2,scaleX:1.5,scaleY:1.78,rotation:50.7,x:327.8,y:341.9},0).wait(2).to({regX:14.7,scaleX:1.5,scaleY:1.79,rotation:70.2,x:338.8},0).wait(2).to({regX:15.3,scaleX:1.5,scaleY:1.79,rotation:78.5,x:345.5,y:344.2},0).wait(2).to({regX:20.8,regY:8.6,scaleX:1.5,scaleY:1.79,rotation:86.9,x:353.4,y:353.8},0).wait(2).to({regX:15,regY:9.2,rotation:95.1,x:358.3,y:346.6},0).wait(2).to({regX:15.1,regY:9.1,rotation:86.9,x:352,y:345.2},0).wait(2).to({regY:9,scaleX:1.5,scaleY:1.79,rotation:78.5,x:345.7,y:343.7},0).wait(2).to({regX:14.7,regY:9.2,scaleX:1.5,scaleY:1.79,rotation:70.2,x:338.8,y:341.9},0).wait(2).to({regX:15,scaleX:1.5,scaleY:1.78,rotation:50.7,x:327.6},0).wait(2).to({regX:15.1,regY:9.4,scaleX:1.5,scaleY:1.79,rotation:31.2,x:316,y:341.6},0).to({_off:true},2).wait(599));
	this.timeline.addTween(cjs.Tween.get(this.instance_213).wait(716).to({_off:false},0).wait(4).to({regY:27.9,scaleX:1,scaleY:1,x:317.8,y:508.6},0).wait(2).to({regX:9.9,regY:27.2,x:320.2,y:507.2},0).wait(2).to({regX:9.8,regY:27.6,x:321.1,y:505.8},0).wait(2).to({regX:10,regY:27.3,scaleX:1,scaleY:1,x:322.1,y:504.9},0).to({regX:9.8,regY:27.5,x:314.1,y:769.1},6).wait(6));

	// Murray Shirt Shape
	this.instance_214 = new lib.MurrayPalm_41_1();
	this.instance_214.parent = this;
	this.instance_214.setTransform(548.6,763.4,1,1.092,0,38.2,-141.8,31.7,25.2);
	this.instance_214._off = true;

	this.instance_215 = new lib.MurrayPinky_037_1();
	this.instance_215.parent = this;
	this.instance_215.setTransform(389.9,842.4,1,0.999,163.7,0,0,10,27.3);
	this.instance_215.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,5);
	this.instance_215._off = true;

	this.instance_216 = new lib.MurrayMiddleFinger_1();
	this.instance_216.parent = this;
	this.instance_216.setTransform(276.6,413.8,1.5,1.787,35.9,0,0,15.1,9.2);
	this.instance_216._off = true;

	this.instance_217 = new lib.MurrayPointerFinger_1();
	this.instance_217.parent = this;
	this.instance_217.setTransform(332.3,347,1.5,1.705,67.2,0,0,21.4,8.4);
	this.instance_217._off = true;

	this.instance_218 = new lib.MurrayPointerFinger_039_1();
	this.instance_218.parent = this;
	this.instance_218.setTransform(349.7,503.4,1,1,0,172.3,-7.7,29.9,29);
	this.instance_218._off = true;

	this.instance_219 = new lib.MurrayPalm_1();
	this.instance_219.parent = this;
	this.instance_219.setTransform(326.7,371.3,1.5,1.5,3.5,0,0,30.6,29.5);
	this.instance_219._off = true;

	this.instance_220 = new lib.MurrayArm1_1();
	this.instance_220.parent = this;
	this.instance_220.setTransform(337.7,381.1,1.491,1.146,0,-74.4,96,33,37.3);
	this.instance_220._off = true;

	this.instance_221 = new lib.MurrayMiddleFinger_237_1();
	this.instance_221.parent = this;
	this.instance_221.setTransform(361.6,362.6,1,1,33.4,0,0,13.2,12.3);
	this.instance_221._off = true;

	this.instance_222 = new lib.MurrayLeftArm2_0001_1();
	this.instance_222.parent = this;
	this.instance_222.setTransform(516.7,463.9,1.499,1.351,0,154.8,-25.2,19.1,38.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_214}]},9).to({state:[{t:this.instance_214}]},8).to({state:[{t:this.instance_214}]},2).to({state:[{t:this.instance_214}]},2).to({state:[{t:this.instance_214}]},2).to({state:[{t:this.instance_214}]},2).to({state:[{t:this.instance_214}]},2).to({state:[{t:this.instance_215}]},10).to({state:[{t:this.instance_215}]},2).to({state:[{t:this.instance_215}]},2).to({state:[{t:this.instance_215}]},2).to({state:[{t:this.instance_215}]},2).to({state:[{t:this.instance_215}]},2).to({state:[]},24).to({state:[{t:this.instance_216}]},4).to({state:[{t:this.instance_217}]},2).to({state:[{t:this.instance_217}]},2).to({state:[{t:this.instance_217}]},2).to({state:[{t:this.instance_217}]},2).to({state:[{t:this.instance_217}]},2).to({state:[{t:this.instance_217}]},2).to({state:[{t:this.instance_217}]},2).to({state:[{t:this.instance_217}]},2).to({state:[{t:this.instance_217}]},2).to({state:[{t:this.instance_217}]},2).to({state:[{t:this.instance_217}]},2).to({state:[{t:this.instance_217}]},2).to({state:[{t:this.instance_217}]},2).to({state:[{t:this.instance_217}]},2).to({state:[{t:this.instance_217}]},2).to({state:[{t:this.instance_217}]},2).to({state:[{t:this.instance_217}]},2).to({state:[{t:this.instance_217}]},2).to({state:[{t:this.instance_217}]},2).to({state:[{t:this.instance_217}]},2).to({state:[{t:this.instance_217}]},2).to({state:[{t:this.instance_217}]},2).to({state:[{t:this.instance_217}]},2).to({state:[{t:this.instance_217}]},2).to({state:[{t:this.instance_217}]},2).to({state:[{t:this.instance_217}]},2).to({state:[{t:this.instance_217}]},2).to({state:[{t:this.instance_217}]},2).to({state:[{t:this.instance_217}]},2).to({state:[{t:this.instance_217}]},2).to({state:[{t:this.instance_217}]},2).to({state:[{t:this.instance_216}]},2).to({state:[]},2).to({state:[{t:this.instance_216}]},4).to({state:[]},36).to({state:[{t:this.instance_217}]},70).to({state:[]},2).to({state:[{t:this.instance_218}]},4).to({state:[{t:this.instance_218}]},2).to({state:[]},2).to({state:[{t:this.instance_216}]},40).to({state:[{t:this.instance_216}]},2).to({state:[{t:this.instance_216}]},2).to({state:[{t:this.instance_216}]},2).to({state:[{t:this.instance_218}]},38).to({state:[{t:this.instance_218}]},2).to({state:[{t:this.instance_218}]},2).to({state:[{t:this.instance_219}]},2).to({state:[{t:this.instance_219}]},4).to({state:[{t:this.instance_219}]},2).to({state:[{t:this.instance_219}]},2).to({state:[{t:this.instance_219}]},39).to({state:[{t:this.instance_219}]},2).to({state:[{t:this.instance_219}]},2).to({state:[{t:this.instance_218}]},4).to({state:[{t:this.instance_218}]},2).to({state:[{t:this.instance_218}]},2).to({state:[{t:this.instance_216}]},2).to({state:[{t:this.instance_218}]},51).to({state:[]},4).to({state:[{t:this.instance_220}]},12).to({state:[{t:this.instance_220}]},4).to({state:[{t:this.instance_220}]},2).to({state:[{t:this.instance_220}]},2).to({state:[]},10).to({state:[{t:this.instance_218}]},96).to({state:[]},8).to({state:[{t:this.instance_221}]},4).to({state:[{t:this.instance_221}]},4).to({state:[{t:this.instance_221}]},2).to({state:[{t:this.instance_221}]},2).to({state:[]},40).to({state:[{t:this.instance_216}]},4).to({state:[{t:this.instance_222}]},59).to({state:[]},4).wait(18));
	this.timeline.addTween(cjs.Tween.get(this.instance_214).wait(9).to({_off:false},0).to({y:510.4},8).wait(2).to({regX:31.8,scaleX:1,scaleY:1.09,skewX:31.3,skewY:-148.7,x:558,y:501.9},0).wait(2).to({regX:31.7,scaleX:1,scaleY:1.09,skewX:24.5,skewY:-155.5,x:567.4,y:493.4},0).wait(2).to({scaleX:1,scaleY:1.09,skewX:31.3,skewY:-148.7,x:558,y:501.9},0).wait(2).to({regY:25.3,scaleX:1,skewX:34.8,skewY:-145.2,x:553.3,y:506.2},0).wait(2).to({regY:25.2,scaleX:1,scaleY:1.09,skewX:38.2,skewY:-141.8,x:548.6,y:510.4},0).to({_off:true},10).wait(701));
	this.timeline.addTween(cjs.Tween.get(this.instance_215).wait(37).to({_off:false},0).wait(2).to({regX:10.3,regY:27.9,rotation:176.5,x:357,y:672.1},0).wait(2).to({regX:10,regY:28.1,rotation:182.8,x:341.1,y:586.9},0).wait(2).to({regX:9.9,regY:27.7,rotation:185.8,x:333.1,y:545},0).wait(2).to({regX:9.6,regY:27.5,scaleX:1,scaleY:1,rotation:187.3,x:329.3,y:524},0).wait(2).to({regX:9.8,regY:27.6,scaleX:1,scaleY:1,rotation:189.1,x:328.7,y:499.7},0).to({_off:true},24).wait(667));
	this.timeline.addTween(cjs.Tween.get(this.instance_216).wait(75).to({_off:false},0).to({_off:true},2).wait(62).to({_off:false,rotation:62.1,x:304.7,y:400.1},0).to({_off:true},2).wait(4).to({_off:false,regX:16.2,regY:13.3,scaleX:2.07,scaleY:1.98,rotation:0,skewX:155.5,skewY:-30.8,x:345,y:496.6},0).to({_off:true},36).wait(120).to({_off:false,scaleX:2.07,scaleY:1.98,skewX:121.8,skewY:-64.5,x:324.4,y:490.1},0).wait(2).to({regY:13.4,scaleY:1.98,skewX:120.4,skewY:-65.9,x:325.9,y:491.8},0).wait(2).to({regY:13.3,scaleX:2.07,scaleY:1.98,skewX:119.2,skewY:-67.1,x:327.8,y:493.8},0).wait(2).to({_off:true},38).wait(67).to({_off:false},0).to({_off:true},51).wait(194).to({_off:false},0).to({_off:true},59).wait(22));
	this.timeline.addTween(cjs.Tween.get(this.instance_217).wait(77).to({_off:false},0).wait(2).to({regY:8.3,scaleX:1.5,scaleY:1.7,rotation:77.2,x:342.5,y:351.5},0).wait(2).to({regX:21.5,regY:8.4,scaleX:1.5,scaleY:1.71,rotation:87.1,x:352.4,y:355.8},0).wait(2).to({regX:21.6,regY:9.3,rotation:95.3,x:355.1,y:358.8},0).wait(2).to({regX:21.5,regY:8.4,scaleX:1.5,scaleY:1.7,rotation:103.8,x:360.8,y:361.6},0).wait(2).to({regX:21.4,regY:8.3,scaleX:1.5,scaleY:1.71,rotation:112.1,x:365.1,y:364.6},0).wait(2).to({regX:21.1,regY:8.6,scaleX:1.5,scaleY:1.7,rotation:103.8,x:360.5,y:361},0).wait(2).to({regX:21.6,regY:8.4,scaleY:1.71,rotation:95.3,x:356.5,y:359},0).wait(2).to({regX:21.5,scaleX:1.5,rotation:87.1,x:352.4,y:355.8},0).wait(2).to({regX:21.6,scaleX:1.5,scaleY:1.7,rotation:67.7,x:343.7,y:349.9},0).wait(2).to({regX:21.4,regY:8.6,scaleX:1.5,scaleY:1.71,rotation:48.2,x:334.8,y:343.5},0).wait(2).to({regY:8.5,scaleX:1.5,scaleY:1.7,rotation:67.7,x:343.7,y:349.6},0).wait(2).to({regX:21.5,regY:8.4,scaleX:1.5,scaleY:1.71,rotation:87.1,x:352.4,y:355.8},0).wait(2).to({regX:21.6,regY:9.3,rotation:95.3,x:355.1,y:358.8},0).wait(2).to({regX:21.5,regY:8.4,scaleX:1.5,scaleY:1.7,rotation:103.8,x:360.8,y:361.6},0).wait(2).to({regX:21.4,regY:8.3,scaleX:1.5,scaleY:1.71,rotation:112.1,x:365.1,y:364.6},0).wait(2).to({regX:21.1,regY:8.6,scaleX:1.5,scaleY:1.7,rotation:103.8,x:360.5,y:361},0).wait(2).to({regX:21.6,regY:8.4,scaleY:1.71,rotation:95.3,x:356.5,y:359},0).wait(2).to({regX:21.5,scaleX:1.5,rotation:87.1,x:352.4,y:355.8},0).wait(2).to({regX:21.6,scaleX:1.5,scaleY:1.7,rotation:67.7,x:343.7,y:349.9},0).wait(2).to({regX:21.4,regY:8.6,scaleX:1.5,scaleY:1.71,rotation:48.2,x:334.8,y:343.5},0).wait(2).to({regY:8.5,scaleX:1.5,scaleY:1.7,rotation:67.7,x:343.7,y:349.6},0).wait(2).to({regX:21.5,regY:8.4,scaleX:1.5,scaleY:1.71,rotation:87.1,x:352.4,y:355.8},0).wait(2).to({regX:21.6,regY:9.3,rotation:95.3,x:355.1,y:358.8},0).wait(2).to({regX:21.5,regY:8.4,scaleX:1.5,scaleY:1.7,rotation:103.8,x:360.8,y:361.6},0).wait(2).to({regX:21.4,regY:8.3,scaleX:1.5,scaleY:1.71,rotation:112.1,x:365.1,y:364.6},0).wait(2).to({regX:21.1,regY:8.6,scaleX:1.5,scaleY:1.7,rotation:103.8,x:360.5,y:361},0).wait(2).to({regX:21.6,regY:8.4,scaleY:1.71,rotation:95.3,x:356.5,y:359},0).wait(2).to({regX:21.5,scaleX:1.5,rotation:87.1,x:352.4,y:355.8},0).wait(2).to({regX:21.6,scaleX:1.5,scaleY:1.7,rotation:67.7,x:343.7,y:349.9},0).wait(2).to({regX:21.4,regY:8.6,scaleX:1.5,scaleY:1.71,rotation:48.2,x:334.8,y:343.5},0).to({_off:true},2).wait(112).to({_off:false,regY:8.3,rotation:79.1,x:315.3,y:411.3},0).to({_off:true},2).wait(485));
	this.timeline.addTween(cjs.Tween.get(this.instance_218).wait(257).to({_off:false},0).wait(2).to({regX:28.6,regY:29.2,skewX:156.6,skewY:-23.4,x:331.9,y:488.3},0).to({_off:true},2).wait(84).to({_off:false,regX:28.4,regY:28.9,scaleX:1,scaleY:1,skewX:135.4,skewY:-44.6,x:341.4,y:502.3},0).wait(2).to({regY:29.1,skewX:136.6,skewY:-43.4,x:339.3,y:500.6},0).wait(2).to({scaleX:1,scaleY:1,skewX:177,skewY:-3,x:304.3,y:449.9},0).to({_off:true},2).wait(55).to({_off:false,regX:28.7,regY:29.2,skewX:198.4,skewY:18.4,x:303.9,y:460.9},0).wait(2).to({regX:28.4,regY:29.1,scaleX:1,scaleY:1,skewX:136.6,skewY:-43.4,x:339.3,y:500.6},0).wait(2).to({regY:28.9,skewX:135.4,skewY:-44.6,x:341.4,y:502.3},0).to({_off:true},2).wait(51).to({_off:false,regX:28.3,regY:29.1,scaleX:1,scaleY:1,skewX:134.1,skewY:-45.9,x:343.1,y:503.6},0).to({_off:true},4).wait(126).to({_off:false},0).to({_off:true},8).wait(137));
	this.timeline.addTween(cjs.Tween.get(this.instance_219).wait(351).to({_off:false},0).wait(4).to({regX:30.9,regY:24,rotation:1.6,x:327,y:368.7},0).wait(2).to({regX:30.5,regY:29.4,rotation:0.8,x:325.9,y:379.6},0).wait(2).to({regY:29.5,rotation:0,x:325.7,y:382.6},0).wait(39).to({regY:29.4,rotation:0.8,x:325.9,y:379.6},0).wait(2).to({regX:30.9,regY:23.9,rotation:1.6,x:327,y:368.6},0).wait(2).to({regX:30.6,regY:29.5,rotation:3.5,x:326.7,y:371.3},0).to({_off:true},4).wait(332));
	this.timeline.addTween(cjs.Tween.get(this.instance_220).wait(479).to({_off:false},0).wait(4).to({regX:32.9,regY:37.2,y:385.7},0).wait(2).to({regX:32.8,x:337.8,y:387.9},0).wait(2).to({regY:37.1,scaleX:1.5,scaleY:1.13,skewX:-77.6,skewY:95.9,x:340.2,y:388.7},0).to({_off:true},10).wait(241));
	this.timeline.addTween(cjs.Tween.get(this.instance_221).wait(605).to({_off:false},0).wait(4).to({regX:12.9,regY:12.4,scaleX:1,scaleY:1,x:361,y:366.4},0).wait(2).to({regX:12.8,regY:12.5,x:360.6,y:368.3},0).wait(2).to({regX:13,scaleX:1,scaleY:1,x:360.5,y:370.3},0).to({_off:true},40).wait(85));

	// Shirt Left Arm
	this.instance_223 = new lib.MurrayPointerFinger_039_1();
	this.instance_223.parent = this;
	this.instance_223.setTransform(543.6,758.1,1,1,-134.1,0,0,28.2,29.2);
	this.instance_223._off = true;

	this.instance_224 = new lib.MurrayPinky_037_1();
	this.instance_224.parent = this;
	this.instance_224.setTransform(263.2,417.9,1,1,-26.2,0,0,7,14.3);
	this.instance_224._off = true;

	this.instance_225 = new lib.MurrayMiddleFinger_1();
	this.instance_225.parent = this;
	this.instance_225.setTransform(304.7,400.1,1.5,1.787,62.1,0,0,15.1,9.2);

	this.instance_226 = new lib.MurrayShirtLeftArm_001_1();
	this.instance_226.parent = this;
	this.instance_226.setTransform(508.4,431.7,1.188,1.507,0,106.1,100.5,22.1,29.6);

	this.instance_227 = new lib.MurrayPinky_237_1();
	this.instance_227.parent = this;
	this.instance_227.setTransform(344.2,358.9,1,1,48.4,0,0,8.9,10);
	this.instance_227._off = true;

	this.instance_228 = new lib.MurrayPalm_41_1();
	this.instance_228.parent = this;
	this.instance_228.setTransform(548.6,510.4,1,1.092,0,38.2,-141.8,31.7,25.2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_223}]},9).to({state:[{t:this.instance_223}]},8).to({state:[{t:this.instance_223}]},2).to({state:[{t:this.instance_223}]},2).to({state:[{t:this.instance_223}]},2).to({state:[{t:this.instance_223}]},2).to({state:[{t:this.instance_223}]},2).to({state:[]},10).to({state:[{t:this.instance_224}]},38).to({state:[]},2).to({state:[{t:this.instance_224}]},62).to({state:[]},2).to({state:[{t:this.instance_224}]},4).to({state:[]},36).to({state:[{t:this.instance_225,p:{regX:15.1,regY:9.2,scaleX:1.5,scaleY:1.787,rotation:62.1,skewX:0,skewY:0,x:304.7,y:400.1}}]},70).to({state:[]},2).to({state:[{t:this.instance_225,p:{regX:16.2,regY:13.4,scaleX:2.068,scaleY:1.984,rotation:0,skewX:157.4,skewY:-28.9,x:342.6,y:491.6}}]},4).to({state:[{t:this.instance_225,p:{regX:16.2,regY:13.4,scaleX:2.068,scaleY:1.984,rotation:0,skewX:141.7,skewY:-44.6,x:323.1,y:478.5}}]},2).to({state:[]},2).to({state:[{t:this.instance_224}]},40).to({state:[{t:this.instance_224}]},2).to({state:[{t:this.instance_224}]},2).to({state:[]},2).to({state:[{t:this.instance_226}]},105).to({state:[]},51).to({state:[{t:this.instance_227}]},142).to({state:[{t:this.instance_227}]},4).to({state:[{t:this.instance_227}]},2).to({state:[{t:this.instance_227}]},2).to({state:[]},40).to({state:[{t:this.instance_228}]},63).to({state:[]},4).wait(18));
	this.timeline.addTween(cjs.Tween.get(this.instance_223).wait(9).to({_off:false},0).to({y:505.2},8).wait(2).to({scaleX:1,scaleY:1,rotation:-140.9,x:552.4,y:497.3},0).wait(2).to({regY:29.1,scaleX:1,scaleY:1,rotation:-147.8,x:561.2,y:489.5},0).wait(2).to({regX:28,regY:28.9,scaleX:1,scaleY:1,rotation:-140.9,x:552.4,y:497.6},0).wait(2).to({regX:28.1,regY:29.1,rotation:-137.4,x:548,y:501.3},0).wait(2).to({regX:28.2,regY:29.2,scaleX:1,scaleY:1,rotation:-134.1,x:543.6,y:505.2},0).to({_off:true},10).wait(701));
	this.timeline.addTween(cjs.Tween.get(this.instance_224).wait(75).to({_off:false},0).to({_off:true},2).wait(62).to({_off:false,rotation:0,x:290.9,y:397.7},0).to({_off:true},2).wait(4).to({_off:false,regX:9.8,regY:27.6,scaleY:1,rotation:-170.9,x:325,y:502.6},0).to({_off:true},36).wait(120).to({_off:false,scaleX:1,scaleY:1,rotation:-213.4,x:309.9,y:508.8},0).wait(2).to({regY:27.4,rotation:-214.8,x:312,y:511},0).wait(2).to({regY:27.5,scaleX:1,scaleY:1,rotation:-216.1,x:314.1,y:513.1},0).to({_off:true},2).wait(431));
	this.timeline.addTween(cjs.Tween.get(this.instance_227).wait(605).to({_off:false},0).wait(4).to({regX:9,scaleX:1,scaleY:1,x:343.9,y:362.8},0).wait(2).to({regX:8.9,regY:10.1,x:343.5,y:364.7},0).wait(2).to({regX:9,scaleX:1,scaleY:1,x:343.4,y:366.7},0).to({_off:true},40).wait(85));

	// Murray Head
	this.instance_229 = new lib.MurrayMiddleFinger_1();
	this.instance_229.parent = this;
	this.instance_229.setTransform(557.3,755,2.068,1.984,0,-119.2,-112.9,16,12.8);
	this.instance_229._off = true;

	this.instance_230 = new lib.MurrayPinky_037_1();
	this.instance_230.parent = this;
	this.instance_230.setTransform(290.9,397.7,1,1,0,0,0,7,14.3);
	this.instance_230._off = true;

	this.instance_231 = new lib.MurrayLeftPalm_079_1();
	this.instance_231.parent = this;
	this.instance_231.setTransform(563.8,488.4,1,1,0,0,0,33.4,16.1);

	this.instance_232 = new lib.MurrayThumb_108_1();
	this.instance_232.parent = this;
	this.instance_232.setTransform(551.6,495.8,0.727,1.052,58.7,0,0,21.7,14.1);

	this.instance_233 = new lib.MurrayLeftArm2_0001_1();
	this.instance_233.parent = this;
	this.instance_233.setTransform(517,461,1.506,1.322,0,155.5,-24.6,19.1,38.8);

	this.instance_234 = new lib.MurrayPalm_41_1();
	this.instance_234.parent = this;
	this.instance_234.setTransform(548.1,507.6,0.986,1.091,0,39.1,-141.7,31.7,25.1);
	this.instance_234._off = true;

	this.instance_235 = new lib.MurrayPalm_340_1();
	this.instance_235.parent = this;
	this.instance_235.setTransform(294.9,333,1.095,1,0,6,12,32.3,32.6);
	this.instance_235._off = true;

	this.instance_236 = new lib.MurrayPalm_108_1();
	this.instance_236.parent = this;
	this.instance_236.setTransform(358.6,378,1,1,-6.3,0,0,28.9,13.7);
	this.instance_236._off = true;

	this.instance_237 = new lib.MurrayPointerFinger_039_1();
	this.instance_237.parent = this;
	this.instance_237.setTransform(543.6,505.2,1,1,-134.1,0,0,28.2,29.2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_229}]},9).to({state:[{t:this.instance_229}]},8).to({state:[{t:this.instance_229}]},2).to({state:[{t:this.instance_229}]},2).to({state:[{t:this.instance_229}]},2).to({state:[{t:this.instance_229}]},2).to({state:[{t:this.instance_229}]},2).to({state:[]},10).to({state:[{t:this.instance_230}]},214).to({state:[]},2).to({state:[{t:this.instance_230}]},4).to({state:[{t:this.instance_230}]},2).to({state:[]},2).to({state:[{t:this.instance_231}]},4).to({state:[{t:this.instance_232}]},34).to({state:[{t:this.instance_234},{t:this.instance_233,p:{regX:19.1,regY:38.8,scaleX:1.506,scaleY:1.322,skewX:155.5,skewY:-24.6,x:517,y:461}}]},2).to({state:[{t:this.instance_234},{t:this.instance_233,p:{regX:19.4,regY:38.7,scaleX:1.502,scaleY:1.336,skewX:155.2,skewY:-24.8,x:517.3,y:462.3}}]},2).to({state:[]},2).to({state:[{t:this.instance_230}]},2).to({state:[{t:this.instance_229}]},38).to({state:[{t:this.instance_229}]},2).to({state:[{t:this.instance_229}]},2).to({state:[{t:this.instance_229}]},2).to({state:[{t:this.instance_229}]},4).to({state:[{t:this.instance_229}]},2).to({state:[{t:this.instance_229}]},2).to({state:[{t:this.instance_229}]},39).to({state:[{t:this.instance_229}]},2).to({state:[{t:this.instance_229}]},2).to({state:[{t:this.instance_229}]},4).to({state:[{t:this.instance_229}]},2).to({state:[{t:this.instance_229}]},2).to({state:[{t:this.instance_230}]},2).to({state:[{t:this.instance_229}]},51).to({state:[{t:this.instance_234}]},4).to({state:[{t:this.instance_234}]},2).to({state:[{t:this.instance_234}]},2).to({state:[{t:this.instance_234}]},2).to({state:[]},2).to({state:[{t:this.instance_235}]},4).to({state:[{t:this.instance_235}]},4).to({state:[{t:this.instance_235}]},2).to({state:[{t:this.instance_235}]},2).to({state:[]},10).to({state:[{t:this.instance_234}]},6).to({state:[]},2).to({state:[{t:this.instance_229}]},88).to({state:[]},8).to({state:[{t:this.instance_236}]},4).to({state:[{t:this.instance_236}]},4).to({state:[{t:this.instance_236}]},2).to({state:[{t:this.instance_236}]},2).to({state:[]},40).to({state:[{t:this.instance_237}]},63).to({state:[]},4).wait(18));
	this.timeline.addTween(cjs.Tween.get(this.instance_229).wait(9).to({_off:false},0).to({y:502.1},8).wait(2).to({regY:12.7,scaleX:2.07,scaleY:1.98,skewX:-126.1,skewY:-119.8,x:565.9,y:493},0).wait(2).to({regX:15.6,regY:13.2,scaleX:2.07,scaleY:1.98,skewX:-132.9,skewY:-126.6,x:574.9,y:483.3},0).wait(2).to({regX:16.1,regY:14.2,scaleX:2.07,scaleY:1.98,skewX:-126.1,skewY:-119.8,x:567.6,y:490.8},0).wait(2).to({regX:15.7,regY:12.5,skewX:-122.6,skewY:-116.3,x:561,y:498.1},0).wait(2).to({regX:16,regY:12.8,scaleX:2.07,scaleY:1.98,skewX:-119.2,skewY:-112.9,x:557.3,y:502.1},0).to({_off:true},10).wait(308).to({_off:false,regX:16.2,regY:13.4,scaleX:2.07,scaleY:1.98,skewX:-239.6,skewY:-65.9,x:325.9,y:491.8},0).wait(2).to({regY:13.3,scaleY:1.98,skewX:-238.2,skewY:-64.5,x:324.4,y:490.1},0).wait(2).to({regX:16,regY:13.4,scaleX:2.07,scaleY:1.98,skewX:-197.9,skewY:-24.2,x:299.4,y:432.2},0).wait(2).to({regX:16.9,regY:9.1,scaleX:1.5,scaleY:1.5,rotation:3.5,skewX:-360,skewY:0,x:310.1,y:355.5},0).wait(4).to({regX:15.1,regY:8.3,rotation:1.6,x:306.5,y:360.4},0).wait(2).to({regX:10.6,regY:11.5,rotation:0.8,x:299.1,y:368.3},0).wait(2).to({regX:15.1,regY:9.1,rotation:0,x:305.5,y:367.9},0).wait(39).to({regX:10.6,regY:11.5,rotation:0.8,x:299.1,y:368.3},0).wait(2).to({regX:15.1,regY:8.3,rotation:1.6,x:306.5,y:360.4},0).wait(2).to({regX:16.9,regY:9.1,rotation:3.5,x:310.1,y:355.5},0).wait(4).to({regX:16.4,regY:13.3,scaleX:2.07,scaleY:1.98,rotation:0,skewX:-536.5,skewY:-2.7,x:306.3,y:442.8},0).wait(2).to({regX:16.2,scaleX:2.07,scaleY:1.98,skewX:-598.2,skewY:-64.5,x:324.4,y:490.1},0).wait(2).to({regY:13.4,scaleY:1.98,skewX:-599.6,skewY:-65.9,x:325.9,y:491.8},0).to({_off:true},2).wait(51).to({_off:false,regY:13.3,scaleX:2.07,scaleY:1.98,skewX:-600.8,skewY:-67.1,x:327.8,y:493.8},0).to({_off:true},4).wait(126).to({_off:false},0).to({_off:true},8).wait(137));
	this.timeline.addTween(cjs.Tween.get(this.instance_230).wait(251).to({_off:false},0).to({_off:true},2).wait(4).to({_off:false,regX:9.8,regY:29.7,scaleY:1,rotation:-168.9,x:322.9,y:494.9},0).wait(2).to({regX:9.3,regY:27.2,rotation:-184.6,x:305.7,y:489.5},0).to({_off:true},2).wait(46).to({_off:false,regX:9.8,regY:27.5,rotation:-216.1,x:314.1,y:513.1},0).to({_off:true},38).wait(67).to({_off:false},0).to({_off:true},51).wait(275));
	this.timeline.addTween(cjs.Tween.get(this.instance_234).wait(301).to({_off:false},0).wait(2).to({regX:31.8,regY:25.2,scaleX:0.99,scaleY:1.09,skewX:38.6,skewY:-141.9,x:548.3,y:508.9},0).to({_off:true},2).wait(162).to({_off:false,regX:31.7,scaleX:1,scaleY:1.09,rotation:-38.2,skewX:0,skewY:0,x:337.4,y:504.9},0).wait(2).to({scaleX:1,scaleY:1.09,rotation:-36.9,x:335.5,y:503.3},0).wait(2).to({regX:31.8,rotation:-35.6,x:333.7,y:501.7},0).wait(2).to({regX:31.7,regY:25.1,scaleX:1,scaleY:1.09,rotation:-33,x:329.7,y:498.4},0).to({_off:true},2).wait(28).to({_off:false,regX:31.8,regY:25.2,scaleX:1,scaleY:1.09,rotation:-35.6,x:333.7,y:501.7},0).to({_off:true},2).wait(233));
	this.timeline.addTween(cjs.Tween.get(this.instance_235).wait(479).to({_off:false},0).wait(4).to({regX:32.4,regY:30.8,scaleX:1.05,skewX:2.8,skewY:5.8,x:297.6,y:337.5},0).wait(2).to({regX:33.7,regY:27.1,scaleX:1.02,skewX:1.3,skewY:2.8,x:300.2,y:337.1},0).wait(2).to({regX:32.6,regY:32.9,scaleX:1,skewX:0,skewY:0,x:300.1,y:345.7},0).to({_off:true},10).wait(241));
	this.timeline.addTween(cjs.Tween.get(this.instance_236).wait(605).to({_off:false},0).wait(4).to({regX:31.2,regY:14.2,x:360.6,y:382.1},0).wait(2).to({regY:16.8,y:386.6},0).wait(2).to({regX:31.6,regY:14.2,x:360.5,y:385.9},0).to({_off:true},40).wait(85));

	// Murray Neck 1
	this.instance_238 = new lib.MurrayPinky_037_1();
	this.instance_238.parent = this;
	this.instance_238.setTransform(571.2,770.6,1,0.999,0,-143.9,36.1,10.1,27.1);
	this.instance_238._off = true;

	this.instance_239 = new lib.MurrayLeftArm1_1();
	this.instance_239.parent = this;
	this.instance_239.setTransform(532,714.3,1.499,1.499,-34.9,0,0,33.6,24.2);
	this.instance_239._off = true;

	this.instance_240 = new lib.MurrayLeftThumb_76_1();
	this.instance_240.parent = this;
	this.instance_240.setTransform(540.3,512.2,1,0.886,0,0,0,17.5,34.8);

	this.instance_241 = new lib.MurrayPointerFinger_039_1();
	this.instance_241.parent = this;
	this.instance_241.setTransform(559.2,477.7,1,1,163,0,0,28,29.3);
	this.instance_241._off = true;

	this.instance_242 = new lib.MurrayPointerFinger_1();
	this.instance_242.parent = this;
	this.instance_242.setTransform(322.6,352.3,1.5,1.5,3.5,0,0,21.4,8.4);
	this.instance_242._off = true;

	this.instance_243 = new lib.MurrayLeftArm2_0001_1();
	this.instance_243.parent = this;
	this.instance_243.setTransform(516.7,463.9,1.499,1.351,0,154.8,-25.2,19.1,38.8);

	this.instance_244 = new lib.MurrayPalm_340_1();
	this.instance_244.parent = this;
	this.instance_244.setTransform(300.1,345.7,1,1,0,0,0,32.6,32.9);

	this.instance_245 = new lib.MurrayThumb_353_1();
	this.instance_245.parent = this;
	this.instance_245.setTransform(294.5,425.9,1,1,0,0,0,19.9,35.6);

	this.instance_246 = new lib.MurrayLeftThumb_110_1();
	this.instance_246.parent = this;
	this.instance_246.setTransform(534.8,488.7,1.279,1,-16.7,0,0,14.2,12.7);
	this.instance_246._off = true;

	this.instance_247 = new lib.MurrayMiddleFinger_1();
	this.instance_247.parent = this;
	this.instance_247.setTransform(557.3,502.1,2.068,1.984,0,-119.2,-112.9,16,12.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_238}]},9).to({state:[{t:this.instance_238}]},8).to({state:[{t:this.instance_238}]},2).to({state:[{t:this.instance_238}]},2).to({state:[{t:this.instance_238}]},2).to({state:[{t:this.instance_238}]},2).to({state:[{t:this.instance_238}]},2).to({state:[{t:this.instance_239}]},10).to({state:[{t:this.instance_239}]},2).to({state:[{t:this.instance_239}]},2).to({state:[{t:this.instance_239}]},2).to({state:[{t:this.instance_239}]},2).to({state:[{t:this.instance_239}]},2).to({state:[{t:this.instance_239}]},24).to({state:[{t:this.instance_239}]},2).to({state:[{t:this.instance_239}]},2).to({state:[{t:this.instance_239}]},2).to({state:[{t:this.instance_239}]},62).to({state:[{t:this.instance_239}]},2).to({state:[{t:this.instance_239}]},2).to({state:[{t:this.instance_239}]},2).to({state:[]},36).to({state:[{t:this.instance_240,p:{x:540.3,y:512.2}}]},80).to({state:[{t:this.instance_240,p:{x:546.4,y:504.4}}]},2).to({state:[]},2).to({state:[{t:this.instance_241}]},34).to({state:[{t:this.instance_241}]},2).to({state:[{t:this.instance_241}]},2).to({state:[]},2).to({state:[{t:this.instance_238}]},40).to({state:[{t:this.instance_238}]},2).to({state:[{t:this.instance_238}]},2).to({state:[{t:this.instance_242}]},2).to({state:[{t:this.instance_242}]},4).to({state:[{t:this.instance_242}]},2).to({state:[{t:this.instance_242}]},2).to({state:[{t:this.instance_242}]},39).to({state:[{t:this.instance_242}]},2).to({state:[{t:this.instance_242}]},2).to({state:[{t:this.instance_238}]},4).to({state:[{t:this.instance_238}]},2).to({state:[{t:this.instance_238}]},2).to({state:[{t:this.instance_243}]},2).to({state:[]},51).to({state:[{t:this.instance_241}]},4).to({state:[{t:this.instance_241}]},2).to({state:[{t:this.instance_241}]},2).to({state:[{t:this.instance_241}]},2).to({state:[]},2).to({state:[{t:this.instance_244,p:{regX:32.6,scaleX:1,scaleY:1,skewX:0,skewY:0,x:300.1,y:345.7}}]},22).to({state:[{t:this.instance_244,p:{regX:32.8,scaleX:1.131,scaleY:1.199,skewX:-1.5,skewY:26.3,x:301.2,y:377.5}}]},2).to({state:[{t:this.instance_245}]},2).to({state:[{t:this.instance_241}]},2).to({state:[]},2).to({state:[{t:this.instance_246}]},100).to({state:[{t:this.instance_246}]},4).to({state:[{t:this.instance_246}]},2).to({state:[{t:this.instance_246}]},2).to({state:[]},40).to({state:[{t:this.instance_238}]},4).to({state:[{t:this.instance_247}]},59).to({state:[]},4).wait(18));
	this.timeline.addTween(cjs.Tween.get(this.instance_238).wait(9).to({_off:false},0).to({y:517.6},8).wait(2).to({regX:10.6,regY:27.4,scaleX:1,scaleY:1,skewX:-150.7,skewY:29.3,x:581.8,y:506.3},0).wait(2).to({regX:10,regY:27.1,scaleX:1,scaleY:1,skewX:-157.6,skewY:22.4,x:590.9,y:494.9},0).wait(2).to({regX:9.5,regY:27.6,scaleX:1,scaleY:1,skewX:-150.7,skewY:29.3,x:580.8,y:505.6},0).wait(2).to({regX:10.1,regY:27.1,skewX:-147.4,skewY:32.6,x:576.1,y:512},0).wait(2).to({scaleX:1,scaleY:1,skewX:-143.9,skewY:36.1,x:571.2,y:517.6},0).to({_off:true},10).wait(308).to({_off:false,regX:9.8,regY:27.4,scaleX:1,scaleY:1,rotation:145.2,skewX:0,skewY:0,x:312,y:511},0).wait(2).to({regY:27.6,rotation:146.6,x:309.9,y:508.8},0).wait(2).to({regX:10.6,regY:27.2,scaleX:1,scaleY:1,rotation:186.8,x:275.7,y:437.3},0).to({_off:true},2).wait(55).to({_off:false,regX:9.8,regY:27.5,rotation:208.2,x:282.4,y:438.9},0).wait(2).to({regY:27.6,scaleX:1,scaleY:1,rotation:146.6,x:309.9,y:508.8},0).wait(2).to({regY:27.4,rotation:145.2,x:312,y:511},0).to({_off:true},2).wait(245).to({_off:false,regY:27.5,scaleX:1,scaleY:1,rotation:143.9,x:314.1,y:513.1},0).to({_off:true},59).wait(22));
	this.timeline.addTween(cjs.Tween.get(this.instance_239).wait(37).to({_off:false},0).wait(2).to({regX:33.4,regY:24.1,scaleX:1.5,scaleY:1.5,rotation:-22.1,x:519.7,y:581.2},0).wait(2).to({scaleX:1.5,scaleY:1.5,rotation:-15.8,x:513.9,y:514.7},0).wait(2).to({regY:24,scaleX:1.5,scaleY:1.5,rotation:-12.5,x:510.9,y:481.3},0).wait(2).to({regX:33.9,regY:24.1,rotation:-11,x:510.2,y:464.8},0).wait(2).to({regX:33.5,regY:24.2,scaleX:1.5,scaleY:1.5,rotation:-9.5,x:511.7,y:445.3},0).wait(24).to({scaleX:1.5,scaleY:1.5,rotation:-8.8,x:507.9,y:448.4},0).wait(2).to({scaleX:1.5,scaleY:1.5,rotation:-8.5,x:507.7,y:448.5},0).wait(2).to({regY:24.3,scaleX:1.5,scaleY:1.5,rotation:-8,x:507.5,y:448.8},0).wait(2).to({scaleX:1.5,scaleY:1.5,rotation:-7.5,x:507.3,y:449},0).wait(62).to({scaleX:1.5,scaleY:1.5,rotation:-8,x:507.5,y:448.8},0).wait(2).to({regY:24.2,scaleX:1.5,scaleY:1.5,rotation:-8.5,x:507.7,y:448.5},0).wait(2).to({scaleX:1.5,scaleY:1.5,rotation:-8.8,x:507.9,y:448.4},0).wait(2).to({scaleX:1.5,scaleY:1.5,rotation:-9.5,x:508.1,y:448.2},0).to({_off:true},36).wait(557));
	this.timeline.addTween(cjs.Tween.get(this.instance_241).wait(299).to({_off:false},0).wait(2).to({regX:28.4,regY:29.1,scaleX:0.99,scaleY:1,rotation:0,skewX:-133.4,skewY:-133.9,x:542.9,y:502.4},0).wait(2).to({regX:28.1,regY:28.6,scaleX:0.99,scaleY:1,skewX:-133.6,x:543,y:504.3},0).to({_off:true},2).wait(162).to({_off:false,regX:28.3,regY:29.1,scaleX:1,skewX:-225.9,skewY:-45.9,x:343.1,y:503.6},0).wait(2).to({regX:28.4,regY:28.9,scaleX:1,scaleY:1,skewX:-224.6,skewY:-44.6,x:341.4,y:502.3},0).wait(2).to({regY:29.1,skewX:-223.4,skewY:-43.4,x:339.3,y:500.6},0).wait(2).to({scaleX:1,scaleY:1,skewX:-220.7,skewY:-40.7,x:335.5,y:497.6},0).to({_off:true},2).wait(28).to({_off:false,scaleX:1,scaleY:1,skewX:-223.4,skewY:-43.4,x:339.3,y:500.6},0).to({_off:true},2).wait(233));
	this.timeline.addTween(cjs.Tween.get(this.instance_242).wait(351).to({_off:false},0).wait(4).to({rotation:1.6,x:321.6,y:358},0).wait(2).to({regX:21.6,regY:13.8,rotation:0.8,x:321.2,y:369.1},0).wait(2).to({regX:21.4,regY:8.3,rotation:0,x:320.4,y:363.8},0).wait(39).to({regX:21.6,regY:13.8,rotation:0.8,x:321.2,y:369.1},0).wait(2).to({regX:21.4,regY:8.4,rotation:1.6,x:321.6,y:358},0).wait(2).to({rotation:3.5,x:322.6,y:352.3},0).to({_off:true},4).wait(332));
	this.timeline.addTween(cjs.Tween.get(this.instance_246).wait(605).to({_off:false},0).wait(4).to({regY:12.5,scaleX:1.14,rotation:-8.3,x:534.7,y:488.5},0).wait(2).to({regY:12.6,scaleX:1.07,rotation:-4,x:534.8,y:488.6},0).wait(2).to({regY:12.7,scaleX:1,rotation:0,y:488.7},0).to({_off:true},40).wait(85));

	// Neck 2
	this.instance_248 = new lib.Murray_bottom_1();
	this.instance_248.parent = this;
	this.instance_248.setTransform(446.1,543.2,0.78,1.165,0,0,0,87.5,48.2);
	this.instance_248._off = true;

	this.instance_249 = new lib.MurrayLeftArm2_0001_1();
	this.instance_249.parent = this;
	this.instance_249.setTransform(547.1,723.3,1.499,1.351,0,127.4,-52.6,19.1,38.9);
	this.instance_249._off = true;

	this.instance_250 = new lib.MurrayPointerFinger_108_1();
	this.instance_250.parent = this;
	this.instance_250.setTransform(566.5,490.6,1.177,0.805,0,-20.5,180,16.9,15.8);

	this.instance_251 = new lib.MurrayPointerFinger_237_1();
	this.instance_251.parent = this;
	this.instance_251.setTransform(568.6,466.6,1,1,0,21.2,-158.8,11.9,25.8);

	this.instance_252 = new lib.MurrayMiddleFinger_1();
	this.instance_252.parent = this;
	this.instance_252.setTransform(556.9,499.5,2.034,1.99,0,-118.6,-112.3,16,12.8);
	this.instance_252._off = true;

	this.instance_253 = new lib.MurrayPalm_41_1();
	this.instance_253.parent = this;
	this.instance_253.setTransform(548.6,510.4,1,1.092,0,38.2,-141.8,31.7,25.2);

	this.instance_254 = new lib.MurrayPointerFinger_039_1();
	this.instance_254.parent = this;
	this.instance_254.setTransform(543.6,505.2,1,1,-134.1,0,0,28.2,29.2);

	this.instance_255 = new lib.MurrayPinky_037_1();
	this.instance_255.parent = this;
	this.instance_255.setTransform(571.2,517.6,1,0.999,0,-143.9,36.1,10.1,27.1);

	this.instance_256 = new lib.MurrayMiddleFinger_353_1();
	this.instance_256.parent = this;
	this.instance_256.setTransform(297.3,408.9,1,1,0,0,0,11.3,16.6);

	this.instance_257 = new lib.MurrayLeftPalm_241_1();
	this.instance_257.parent = this;
	this.instance_257.setTransform(546,489.1,1.094,1.046,0,0,0,21.2,15.4);
	this.instance_257._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_248}]},17).to({state:[{t:this.instance_248}]},2).to({state:[{t:this.instance_248}]},2).to({state:[{t:this.instance_248}]},2).to({state:[{t:this.instance_248}]},2).to({state:[{t:this.instance_248}]},2).to({state:[{t:this.instance_249}]},10).to({state:[{t:this.instance_249}]},2).to({state:[{t:this.instance_249}]},2).to({state:[{t:this.instance_249}]},2).to({state:[{t:this.instance_249}]},2).to({state:[{t:this.instance_249}]},2).to({state:[{t:this.instance_249}]},24).to({state:[{t:this.instance_249}]},2).to({state:[{t:this.instance_249}]},2).to({state:[{t:this.instance_249}]},2).to({state:[{t:this.instance_249}]},62).to({state:[{t:this.instance_249}]},2).to({state:[{t:this.instance_249}]},2).to({state:[{t:this.instance_249}]},2).to({state:[]},36).to({state:[{t:this.instance_250,p:{scaleX:1.177,scaleY:0.805,skewX:-20.5,skewY:180,x:566.5,y:490.6}}]},80).to({state:[{t:this.instance_250,p:{scaleX:1.088,scaleY:0.903,skewX:-62.7,skewY:127.6,x:569.9,y:473.8}}]},2).to({state:[{t:this.instance_251}]},2).to({state:[]},34).to({state:[{t:this.instance_252}]},2).to({state:[{t:this.instance_252}]},2).to({state:[]},2).to({state:[{t:this.instance_255,p:{regY:27.1,scaleX:1,scaleY:0.999,skewX:-143.9,skewY:36.1,x:571.2,y:517.6,regX:10.1,rotation:0}},{t:this.instance_252},{t:this.instance_254,p:{regX:28.2,regY:29.2,scaleX:1,scaleY:1,rotation:-134.1,skewX:0,skewY:0,x:543.6,y:505.2}},{t:this.instance_253,p:{regX:31.7,regY:25.2,scaleX:1,scaleY:1.092,skewX:38.2,skewY:-141.8,x:548.6,y:510.4}},{t:this.instance_249}]},2).to({state:[]},38).to({state:[{t:this.instance_255,p:{regY:27.3,scaleX:0.977,scaleY:1,skewX:172,skewY:-9.8,x:594.7,y:468.7,regX:10.1,rotation:0}},{t:this.instance_252},{t:this.instance_254,p:{regX:28.1,regY:29.4,scaleX:0.972,scaleY:1.005,rotation:0,skewX:-178.4,skewY:-179.7,x:567.2,y:479.7}},{t:this.instance_253,p:{regX:31.9,regY:25,scaleX:0.976,scaleY:1.093,skewX:-5.9,skewY:172.4,x:574,y:479.9}},{t:this.instance_249}]},61).to({state:[{t:this.instance_255,p:{regY:26.4,scaleX:0.987,scaleY:0.998,skewX:-142.9,skewY:36.1,x:570.3,y:515.5,regX:10.3,rotation:0}},{t:this.instance_252},{t:this.instance_254,p:{regX:28.4,regY:29.1,scaleX:0.985,scaleY:1.001,rotation:0,skewX:-133.4,skewY:-133.9,x:542.9,y:502.4}},{t:this.instance_253,p:{regX:31.7,regY:25.1,scaleX:0.986,scaleY:1.091,skewX:39.1,skewY:-141.7,x:548.1,y:507.6}},{t:this.instance_249}]},2).to({state:[{t:this.instance_255,p:{regY:27.2,scaleX:0.993,scaleY:0.998,skewX:-143.4,skewY:36.1,x:570.8,y:516.1,regX:10.1,rotation:0}},{t:this.instance_252},{t:this.instance_254,p:{regX:28.1,regY:28.6,scaleX:0.991,scaleY:1,rotation:0,skewX:-133.6,skewY:-133.9,x:543,y:504.3}},{t:this.instance_253,p:{regX:31.8,regY:25.2,scaleX:0.992,scaleY:1.09,skewX:38.6,skewY:-141.9,x:548.3,y:508.9}},{t:this.instance_249}]},2).to({state:[{t:this.instance_253,p:{regX:31.7,regY:25.2,scaleX:1,scaleY:1.092,skewX:38.2,skewY:-141.8,x:548.6,y:510.4}}]},2).to({state:[{t:this.instance_255,p:{regY:27.5,scaleX:1,scaleY:0.999,skewX:0,skewY:0,x:314.1,y:513.1,regX:9.8,rotation:143.9}}]},51).to({state:[{t:this.instance_252}]},4).to({state:[{t:this.instance_252}]},2).to({state:[{t:this.instance_252}]},2).to({state:[{t:this.instance_252}]},2).to({state:[]},2).to({state:[{t:this.instance_256}]},26).to({state:[{t:this.instance_252}]},2).to({state:[]},2).to({state:[{t:this.instance_255,p:{regY:27.5,scaleX:1,scaleY:0.999,skewX:0,skewY:0,x:314.1,y:513.1,regX:9.8,rotation:143.9}}]},88).to({state:[]},8).to({state:[{t:this.instance_257}]},4).to({state:[{t:this.instance_257}]},4).to({state:[{t:this.instance_257}]},2).to({state:[{t:this.instance_257}]},2).to({state:[]},40).to({state:[{t:this.instance_255,p:{regY:27.1,scaleX:1,scaleY:0.999,skewX:-143.9,skewY:36.1,x:571.2,y:517.6,regX:10.1,rotation:0}}]},63).to({state:[]},4).wait(18));
	this.timeline.addTween(cjs.Tween.get(this.instance_248).wait(17).to({_off:false},0).wait(2).to({scaleX:0.91,scaleY:1.07,x:444.2,y:548},0).wait(2).to({regY:48.3,scaleX:1.03,scaleY:0.97,x:442.5,y:552.8},0).wait(2).to({scaleX:1.02,scaleY:0.98,x:443,y:552.1},0).wait(2).to({regY:48.1,scaleX:1.01,scaleY:0.99,x:443.2,y:551.5},0).wait(2).to({regY:48.3,scaleX:1,scaleY:1,x:443.4,y:551.3},0).to({_off:true},10).wait(701));
	this.timeline.addTween(cjs.Tween.get(this.instance_249).wait(37).to({_off:false},0).wait(2).to({regY:39,scaleX:1.5,scaleY:1.35,skewX:140.1,skewY:-39.9,x:532.5,y:592.9},0).wait(2).to({regX:18.9,scaleX:1.5,scaleY:1.35,skewX:146.4,skewY:-33.6,x:525,y:528},0).wait(2).to({regX:19.2,regY:38.9,scaleX:1.5,scaleY:1.35,skewX:149.7,skewY:-30.3,x:521.8,y:495.4},0).wait(2).to({regX:19.1,regY:39,scaleX:1.5,scaleY:1.35,skewX:151.2,skewY:-28.8,x:519.8,y:479.1},0).wait(2).to({regY:38.8,scaleX:1.5,scaleY:1.35,skewX:152.8,skewY:-27.2,x:521.6,y:460},0).wait(24).to({regX:19,regY:38.9,scaleX:1.5,scaleY:1.35,skewX:153.4,skewY:-26.6,x:517.5,y:463.2},0).wait(2).to({regX:19.2,regY:39,scaleX:1.5,scaleY:1.35,skewX:153.9,skewY:-26.1,x:517.3,y:463.1},0).wait(2).to({regX:19.1,regY:38.8,scaleX:1.5,scaleY:1.35,skewX:154.4,skewY:-25.6,x:517,y:463.6},0).wait(2).to({scaleX:1.5,scaleY:1.35,skewX:154.8,skewY:-25.2,x:516.7,y:463.9},0).wait(62).to({scaleX:1.5,scaleY:1.35,skewX:154.4,skewY:-25.6,x:517,y:463.6},0).wait(2).to({regX:19.2,regY:39,scaleX:1.5,scaleY:1.35,skewX:153.9,skewY:-26.1,x:517.3,y:463.1},0).wait(2).to({regX:19,regY:38.9,scaleX:1.5,scaleY:1.35,skewX:153.4,skewY:-26.6,x:517.5,y:463.2},0).wait(2).to({regX:19.1,regY:38.8,scaleX:1.5,scaleY:1.35,skewX:152.8,skewY:-27.2,x:518,y:462.8},0).to({_off:true},36).wait(126).to({_off:false,skewX:154.8,skewY:-25.2,x:516.7,y:463.9},0).to({_off:true},38).wait(61).to({_off:false,regX:19.8,regY:38.2,scaleX:1.51,scaleY:1.31,skewX:142.6,skewY:-37.6,x:525.4,y:444},0).wait(2).to({regX:19.1,regY:38.8,scaleX:1.51,scaleY:1.32,skewX:155.5,skewY:-24.6,x:517,y:461},0).wait(2).to({regX:19.4,regY:38.7,scaleX:1.5,scaleY:1.34,skewX:155.2,skewY:-24.8,x:517.3,y:462.3},0).to({_off:true},2).wait(326));
	this.timeline.addTween(cjs.Tween.get(this.instance_252).wait(301).to({_off:false},0).wait(2).to({regX:16.1,scaleX:2.05,scaleY:1.99,skewX:-118.8,skewY:-112.6,x:557,y:500.7},0).to({_off:true},2).wait(2).to({_off:false,regX:16,scaleX:2.07,scaleY:1.98,skewX:-119.2,skewY:-112.9,x:557.3,y:502.1},0).to({_off:true},38).wait(61).to({_off:false,regX:16.2,scaleX:2.01,scaleY:2,skewX:-164.1,skewY:-157.7,x:574.2,y:467.8},0).wait(2).to({regX:16,scaleX:2.03,scaleY:1.99,skewX:-118.6,skewY:-112.3,x:556.9,y:499.5},0).wait(2).to({regX:16.1,scaleX:2.05,scaleY:1.99,skewX:-118.8,skewY:-112.6,x:557,y:500.7},0).to({_off:true},2).wait(55).to({_off:false,regX:16.2,regY:13.3,scaleX:2.07,scaleY:1.98,skewX:-240.8,skewY:-67.1,x:327.8,y:493.8},0).wait(2).to({regY:13.4,scaleX:2.07,scaleY:1.98,skewX:-239.6,skewY:-65.9,x:325.9,y:491.8},0).wait(2).to({regY:13.3,scaleY:1.98,skewX:-238.2,skewY:-64.5,x:324.4,y:490.1},0).wait(2).to({scaleX:2.07,scaleY:1.98,skewX:-235.6,skewY:-61.9,x:321.1,y:486.5},0).to({_off:true},2).wait(28).to({_off:false,scaleX:2.07,scaleY:1.98,skewX:-238.2,skewY:-64.5,x:324.4,y:490.1},0).to({_off:true},2).wait(233));
	this.timeline.addTween(cjs.Tween.get(this.instance_257).wait(605).to({_off:false},0).wait(4).to({scaleX:1.05,x:544.9},0).wait(2).to({scaleX:1.02,x:544.4},0).wait(2).to({scaleX:1,x:543.9},0).to({_off:true},40).wait(85));

	// Shirt Collar Left
	this.instance_258 = new lib.MurrayMiddleFinger_108_1();
	this.instance_258.parent = this;
	this.instance_258.setTransform(578,494,0.969,0.872,0,15,-165,16,14.8);
	this.instance_258._off = true;

	this.instance_259 = new lib.MurrayPinky_037_1();
	this.instance_259.parent = this;
	this.instance_259.setTransform(570.3,515.5,0.987,0.998,0,-142.9,36.1,10.3,26.4);
	this.instance_259._off = true;

	this.instance_260 = new lib.MurrayPointerFinger_039_1();
	this.instance_260.parent = this;
	this.instance_260.setTransform(543.6,505.2,1,1,-134.1,0,0,28.2,29.2);

	this.instance_261 = new lib.MurrayLeftArm2_0001_1();
	this.instance_261.parent = this;
	this.instance_261.setTransform(516.7,463.9,1.499,1.351,0,154.8,-25.2,19.1,38.8);

	this.instance_262 = new lib.MurrayPalm_41_1();
	this.instance_262.parent = this;
	this.instance_262.setTransform(548.6,510.4,1,1.092,0,38.2,-141.8,31.7,25.2);

	this.instance_263 = new lib.MurrayPinky_353_1();
	this.instance_263.parent = this;
	this.instance_263.setTransform(302.7,408.3,1,1,0,0,0,9.8,10.3);

	this.instance_264 = new lib.Murray_bottom_1();
	this.instance_264.parent = this;
	this.instance_264.setTransform(443.4,551.3,1,1,0,0,0,87.5,48.3);

	this.instance_265 = new lib.exitarm();
	this.instance_265.parent = this;
	this.instance_265.setTransform(536.6,490.7);
	this.instance_265._off = true;
	this.instance_265.cache(-62,-76,120,147);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_258}]},261).to({state:[{t:this.instance_258}]},2).to({state:[{t:this.instance_258}]},2).to({state:[{t:this.instance_258}]},34).to({state:[{t:this.instance_259}]},2).to({state:[{t:this.instance_259}]},2).to({state:[]},2).to({state:[{t:this.instance_260}]},107).to({state:[{t:this.instance_262},{t:this.instance_261}]},51).to({state:[{t:this.instance_259}]},4).to({state:[{t:this.instance_259}]},2).to({state:[{t:this.instance_259}]},2).to({state:[{t:this.instance_259}]},2).to({state:[]},2).to({state:[{t:this.instance_263}]},26).to({state:[{t:this.instance_259}]},2).to({state:[]},2).to({state:[{t:this.instance_264}]},211).to({state:[{t:this.instance_265}]},4).to({state:[{t:this.instance_265}]},2).to({state:[{t:this.instance_265}]},2).to({state:[{t:this.instance_265}]},2).to({state:[{t:this.instance_265}]},6).wait(6));
	this.timeline.addTween(cjs.Tween.get(this.instance_258).wait(261).to({_off:false},0).wait(2).to({regX:15.8,regY:14.6,scaleX:0.97,scaleY:0.87,skewX:-36.2,skewY:-216.2,x:583.2,y:482},0).wait(2).to({regX:17.3,regY:14,scaleX:0.97,skewX:-30,skewY:-210,x:587.6,y:470.5},0).wait(34).to({regX:16.1,regY:14.6,scaleY:0.87,skewX:45,skewY:-135,x:582.6,y:497.4},0).to({_off:true},2).wait(437));
	this.timeline.addTween(cjs.Tween.get(this.instance_259).wait(301).to({_off:false},0).wait(2).to({regX:10.1,regY:27.2,scaleX:0.99,skewX:-143.4,x:570.8,y:516.1},0).to({_off:true},2).wait(162).to({_off:false,regX:9.8,regY:27.5,scaleX:1,scaleY:1,rotation:143.9,skewX:0,skewY:0,x:314.1,y:513.1},0).wait(2).to({regY:27.4,scaleX:1,scaleY:1,rotation:145.2,x:312,y:511},0).wait(2).to({regY:27.6,rotation:146.6,x:309.9,y:508.8},0).wait(2).to({regY:27.4,scaleX:1,scaleY:1,rotation:149.1,x:305.8,y:504.7},0).to({_off:true},2).wait(28).to({_off:false,regY:27.6,scaleX:1,scaleY:1,rotation:146.6,x:309.9,y:508.8},0).to({_off:true},2).wait(233));
	this.timeline.addTween(cjs.Tween.get(this.instance_265).wait(720).to({_off:false},0).wait(2).to({x:535,y:489.7},0).wait(2).to({x:533.3,y:488.7},0).wait(2).to({x:531.6,y:487.7,mode:"synched",startPosition:0},0).to({x:529.9,y:744,mode:"independent"},6).wait(6));

	// Neck 2
	this.instance_266 = new lib.MurrayPalm_41_1();
	this.instance_266.parent = this;
	this.instance_266.setTransform(603.4,741.8,1,1,0,-35.4,144.6,31.6,24.9);
	this.instance_266._off = true;

	this.instance_267 = new lib.MurrayPinky_108_1();
	this.instance_267.parent = this;
	this.instance_267.setTransform(578,493.8,1,0.441,0,15,-165,27.2,12.8);
	this.instance_267._off = true;

	this.instance_268 = new lib.MurrayLeftArm2_0001_1();
	this.instance_268.parent = this;
	this.instance_268.setTransform(516.7,463.9,1.499,1.351,0,154.8,-25.2,19.1,38.8);

	this.instance_269 = new lib.MurrayPointerFinger_039_1();
	this.instance_269.parent = this;
	this.instance_269.setTransform(543.6,505.2,1,1,-134.1,0,0,28.2,29.2);

	this.instance_270 = new lib.MurrayMiddleFinger_1();
	this.instance_270.parent = this;
	this.instance_270.setTransform(557.3,502.1,2.068,1.984,0,-119.2,-112.9,16,12.8);

	this.instance_271 = new lib.MurrayPinky_037_1();
	this.instance_271.parent = this;
	this.instance_271.setTransform(571.2,517.6,1,0.999,0,-143.9,36.1,10.1,27.1);

	this.instance_272 = new lib.MurrayLeftArm1_1();
	this.instance_272.parent = this;
	this.instance_272.setTransform(484.6,433.2,1.499,1.566,0,7.5,7.8,33.4,24.3);
	this.instance_272._off = true;

	this.instance_273 = new lib.MurrayMiddleFinger_108_1();
	this.instance_273.parent = this;
	this.instance_273.setTransform(548.5,480.4,1.237,1.018,0,-27.6,156.4,27.6,6.5);
	this.instance_273._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_266}]},37).to({state:[{t:this.instance_266}]},2).to({state:[{t:this.instance_266}]},2).to({state:[{t:this.instance_266}]},2).to({state:[{t:this.instance_266}]},2).to({state:[{t:this.instance_266}]},2).to({state:[{t:this.instance_266}]},24).to({state:[{t:this.instance_266}]},2).to({state:[{t:this.instance_266}]},2).to({state:[{t:this.instance_266}]},2).to({state:[{t:this.instance_266}]},62).to({state:[{t:this.instance_266}]},2).to({state:[{t:this.instance_266}]},2).to({state:[{t:this.instance_266}]},2).to({state:[]},36).to({state:[{t:this.instance_267}]},80).to({state:[{t:this.instance_267}]},2).to({state:[{t:this.instance_267}]},2).to({state:[{t:this.instance_267}]},34).to({state:[]},2).to({state:[{t:this.instance_271,p:{regY:27.1,scaleX:1,scaleY:0.999,skewX:-143.9,x:571.2,y:517.6,regX:10.1,skewY:36.1}},{t:this.instance_270,p:{regX:16,scaleX:2.068,scaleY:1.984,skewX:-119.2,skewY:-112.9,x:557.3,y:502.1}},{t:this.instance_269,p:{regX:28.2,regY:29.2,scaleX:1,rotation:-134.1,skewX:0,skewY:0,x:543.6,y:505.2,scaleY:1}},{t:this.instance_266},{t:this.instance_268,p:{regX:19.1,regY:38.8,scaleX:1.499,scaleY:1.351,skewX:154.8,skewY:-25.2,x:516.7,y:463.9}}]},4).to({state:[]},2).to({state:[{t:this.instance_271,p:{regY:27.2,scaleX:0.993,scaleY:0.998,skewX:-143.4,x:570.8,y:516.1,regX:10.1,skewY:36.1}},{t:this.instance_270,p:{regX:16.1,scaleX:2.05,scaleY:1.986,skewX:-118.8,skewY:-112.6,x:557,y:500.7}},{t:this.instance_269,p:{regX:28.1,regY:28.6,scaleX:0.991,rotation:0,skewX:-133.6,skewY:-133.9,x:543,y:504.3,scaleY:1}},{t:this.instance_266},{t:this.instance_268,p:{regX:19.4,regY:38.7,scaleX:1.502,scaleY:1.336,skewX:155.2,skewY:-24.8,x:517.3,y:462.3}}]},38).to({state:[{t:this.instance_271,p:{regY:26.4,scaleX:0.987,scaleY:0.998,skewX:-142.9,x:570.3,y:515.5,regX:10.3,skewY:36.1}},{t:this.instance_270,p:{regX:16,scaleX:2.034,scaleY:1.99,skewX:-118.6,skewY:-112.3,x:556.9,y:499.5}},{t:this.instance_269,p:{regX:28.4,regY:29.1,scaleX:0.985,rotation:0,skewX:-133.4,skewY:-133.9,x:542.9,y:502.4,scaleY:1.001}},{t:this.instance_266},{t:this.instance_268,p:{regX:19.1,regY:38.8,scaleX:1.506,scaleY:1.322,skewX:155.5,skewY:-24.6,x:517,y:461}}]},2).to({state:[{t:this.instance_271,p:{regY:27.2,scaleX:0.977,scaleY:1,skewX:-167.8,x:590,y:468.9,regX:9.6,skewY:10.4}},{t:this.instance_270,p:{regX:16,scaleX:2.005,scaleY:2.001,skewX:-143.9,skewY:-137.5,x:571.9,y:461.3}},{t:this.instance_269,p:{regX:28,regY:29.4,scaleX:0.972,rotation:0,skewX:-158.2,skewY:-159.5,x:561,y:469.8,scaleY:1.005}},{t:this.instance_266},{t:this.instance_268,p:{regX:19.4,regY:38.5,scaleX:1.512,scaleY:1.309,skewX:130.1,skewY:-50.1,x:520.8,y:444.7}}]},2).to({state:[{t:this.instance_272}]},2).to({state:[{t:this.instance_272}]},4).to({state:[{t:this.instance_272}]},2).to({state:[{t:this.instance_272}]},2).to({state:[{t:this.instance_272}]},39).to({state:[{t:this.instance_272}]},2).to({state:[{t:this.instance_272}]},2).to({state:[]},4).to({state:[{t:this.instance_270,p:{regX:16,scaleX:2.068,scaleY:1.984,skewX:-119.2,skewY:-112.9,x:557.3,y:502.1}}]},6).to({state:[{t:this.instance_269,p:{regX:28.2,regY:29.2,scaleX:1,rotation:-134.1,skewX:0,skewY:0,x:543.6,y:505.2,scaleY:1}}]},51).to({state:[]},4).to({state:[{t:this.instance_266},{t:this.instance_268,p:{regX:19.1,regY:38.8,scaleX:1.499,scaleY:1.351,skewX:154.8,skewY:-25.2,x:516.7,y:463.9}}]},126).to({state:[]},8).to({state:[{t:this.instance_273}]},4).to({state:[{t:this.instance_273}]},4).to({state:[{t:this.instance_273}]},2).to({state:[{t:this.instance_273}]},2).to({state:[]},40).to({state:[{t:this.instance_271,p:{regY:27.1,scaleX:1,scaleY:0.999,skewX:-143.9,x:571.2,y:517.6,regX:10.1,skewY:36.1}},{t:this.instance_270,p:{regX:16,scaleX:2.068,scaleY:1.984,skewX:-119.2,skewY:-112.9,x:557.3,y:502.1}},{t:this.instance_269,p:{regX:28.2,regY:29.2,scaleX:1,rotation:-134.1,skewX:0,skewY:0,x:543.6,y:505.2,scaleY:1}},{t:this.instance_266},{t:this.instance_268,p:{regX:19.1,regY:38.8,scaleX:1.499,scaleY:1.351,skewX:154.8,skewY:-25.2,x:516.7,y:463.9}}]},4).to({state:[]},59).wait(22));
	this.timeline.addTween(cjs.Tween.get(this.instance_266).wait(37).to({_off:false},0).wait(2).to({regY:24.8,scaleX:1,scaleY:1,skewX:-22.6,skewY:157.4,x:582.1,y:622.7},0).wait(2).to({skewX:-16.3,skewY:163.7,x:571.5,y:563.2},0).wait(2).to({regX:31.5,regY:24.7,skewX:-13,skewY:167,x:566.2,y:533.4},0).wait(2).to({skewX:-11.3,skewY:168.7,x:563.6,y:518.6},0).wait(2).to({regY:24.8,scaleX:1,scaleY:1,skewX:-10,skewY:170,x:564.5,y:500.8},0).wait(24).to({regX:33.8,regY:24.2,skewX:-7.8,skewY:172.2,x:557.6,y:504},0).wait(2).to({regX:31.6,regY:24.9,skewX:-5.5,skewY:174.5,x:559,y:505.1},0).wait(2).to({skewX:-3.3,skewY:176.7,x:558.1,y:505.7},0).wait(2).to({regX:31.7,regY:25.1,skewX:-1.3,skewY:178.7,x:557.2,y:506.4},0).wait(62).to({regX:31.6,regY:24.9,skewX:-3.3,skewY:176.7,x:558.1,y:505.7},0).wait(2).to({skewX:-5.5,skewY:174.5,x:559,y:505.1},0).wait(2).to({regX:33.8,regY:24.2,skewX:-7.8,skewY:172.2,x:557.6,y:504},0).wait(2).to({regX:31.5,regY:24.8,skewX:-10,skewY:170,x:560.9,y:503.6},0).to({_off:true},36).wait(124).to({_off:false,regX:31.7,regY:25.2,scaleY:1.09,skewX:38.2,skewY:218.2,x:548.6,y:510.4},0).to({_off:true},2).wait(38).to({_off:false,regX:31.8,scaleX:0.99,scaleY:1.09,skewX:38.6,skewY:218.1,x:548.3,y:508.9},0).wait(2).to({regX:31.7,regY:25.1,scaleX:0.99,scaleY:1.09,skewX:39.1,skewY:218.3,x:548.1,y:507.6},0).wait(2).to({regX:32.1,regY:25,scaleX:0.98,scaleY:1.09,skewX:14.3,skewY:192.6,x:567,y:472.2},0).to({_off:true},2).wait(242).to({_off:false,regX:31.7,regY:25.2,scaleX:1,scaleY:1.09,skewX:38.2,skewY:218.2,x:548.6,y:510.4},0).to({_off:true},8).wait(56).to({_off:false},0).to({_off:true},59).wait(22));
	this.timeline.addTween(cjs.Tween.get(this.instance_267).wait(261).to({_off:false},0).wait(2).to({regY:12.5,scaleX:1.02,scaleY:0.57,skewX:11.8,skewY:-170,x:581.4,y:484},0).wait(2).to({regY:12.8,scaleX:1.03,scaleY:0.7,skewX:8.7,skewY:-174.7,x:584.6,y:474.4},0).wait(34).to({regX:26.8,regY:2.4,scaleX:0.82,skewX:73.5,skewY:-114.6,x:595,y:490.3},0).to({_off:true},2).wait(437));
	this.timeline.addTween(cjs.Tween.get(this.instance_272).wait(351).to({_off:false},0).wait(4).to({regY:23.7,scaleY:1.53,skewX:7.3,skewY:7.5,x:484.5,y:434.6},0).wait(2).to({regY:24.4,scaleY:1.52,x:484.3,y:436.8},0).wait(2).to({regX:33.5,regY:24.3,scaleY:1.5,rotation:7.5,skewX:0,skewY:0,x:484.2,y:437.8},0).wait(39).to({regX:33.4,regY:24.4,scaleY:1.52,rotation:0,skewX:7.3,skewY:7.5,x:484.3,y:436.8},0).wait(2).to({regY:23.7,scaleY:1.53,x:484.5,y:434.6},0).wait(2).to({regY:24.3,scaleY:1.57,skewX:7.5,skewY:7.8,x:484.6,y:433.2},0).to({_off:true},4).wait(332));
	this.timeline.addTween(cjs.Tween.get(this.instance_273).wait(605).to({_off:false},0).wait(4).to({regX:27.7,scaleX:1.19,scaleY:1.01,skewX:-26.5,skewY:155.5,x:547.3,y:480.5},0).wait(2).to({regX:28.2,regY:5.9,scaleX:1.17,scaleY:1,skewX:-26,skewY:155,x:546,y:480.2},0).wait(2).to({regX:27.7,regY:6.5,scaleX:1.15,scaleY:1,skewX:-25.5,skewY:154.5,x:546.1,y:480.5},0).to({_off:true},40).wait(85));

	// Murray Neck 3
	this.instance_274 = new lib.MurrayPointerFinger_039_1();
	this.instance_274.parent = this;
	this.instance_274.setTransform(594.6,745,1,1,152.3,0,0,30.1,26.3);
	this.instance_274.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);
	this.instance_274._off = true;

	this.instance_275 = new lib.MurrayLeftArm1_1();
	this.instance_275.parent = this;
	this.instance_275.setTransform(509.3,449.5,1.499,1.499,-8.1,0,0,33.6,24.4);
	this.instance_275._off = true;

	this.instance_276 = new lib.MurrayLeftPalm_108_1();
	this.instance_276.parent = this;
	this.instance_276.setTransform(557.1,499.2,1.14,1,0,-169.8,10.2,25.1,16.4);

	this.instance_277 = new lib.MurrayLeftPalm_095_1();
	this.instance_277.parent = this;
	this.instance_277.setTransform(561,499.7,1,1,0,0,0,25.8,16.9);

	this.instance_278 = new lib.MurrayLeftArm2_0001_1();
	this.instance_278.parent = this;
	this.instance_278.setTransform(507.9,424.4,1.499,1.499,16.7,0,0,19.2,38.8);

	this.instance_279 = new lib.MurrayLeftPalm_0001_1();
	this.instance_279.parent = this;
	this.instance_279.setTransform(532.4,384.8,1.499,1.499,7.5,0,0,8.9,30.1);

	this.instance_280 = new lib.MurrayLeftMiddleFinger_0000_1();
	this.instance_280.parent = this;
	this.instance_280.setTransform(554.6,373.9,1.499,1.499,7.5,0,0,1.8,9.4);

	this.instance_281 = new lib.MurrayLeftPointerFinger_0000_1();
	this.instance_281.parent = this;
	this.instance_281.setTransform(546,362.7,1.499,1.499,7.5,0,0,9.7,8.3);

	this.instance_282 = new lib.MurrayPinky_037_1();
	this.instance_282.parent = this;
	this.instance_282.setTransform(571.2,517.6,1,0.999,0,-143.9,36.1,10.1,27.1);

	this.instance_283 = new lib.MurrayMiddleFinger_1();
	this.instance_283.parent = this;
	this.instance_283.setTransform(557.3,502.1,2.068,1.984,0,-119.2,-112.9,16,12.8);

	this.instance_284 = new lib.MurrayLeftPalm_340_1();
	this.instance_284.parent = this;
	this.instance_284.setTransform(582.6,332.4,1.053,1,0,0,-7.6,37.2,28.9);
	this.instance_284._off = true;

	this.instance_285 = new lib.MurrayLeftThumb_353_1();
	this.instance_285.parent = this;
	this.instance_285.setTransform(593.3,439.1,1,1,0,0,0,20.6,32.2);

	this.instance_286 = new lib.MurrayPinky_108_1();
	this.instance_286.parent = this;
	this.instance_286.setTransform(572.9,490.3,1.094,1,0,0,180,15.1,12.7);
	this.instance_286._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_274}]},37).to({state:[{t:this.instance_274}]},2).to({state:[{t:this.instance_274}]},2).to({state:[{t:this.instance_274}]},2).to({state:[{t:this.instance_274}]},2).to({state:[{t:this.instance_274}]},2).to({state:[{t:this.instance_274}]},24).to({state:[{t:this.instance_274}]},2).to({state:[{t:this.instance_274}]},2).to({state:[{t:this.instance_274}]},2).to({state:[{t:this.instance_274}]},62).to({state:[{t:this.instance_274}]},2).to({state:[{t:this.instance_274}]},2).to({state:[{t:this.instance_274}]},2).to({state:[{t:this.instance_275}]},36).to({state:[{t:this.instance_275}]},2).to({state:[{t:this.instance_275}]},2).to({state:[{t:this.instance_275}]},2).to({state:[{t:this.instance_275}]},64).to({state:[{t:this.instance_275}]},2).to({state:[{t:this.instance_275}]},2).to({state:[{t:this.instance_275}]},2).to({state:[{t:this.instance_275}]},2).to({state:[{t:this.instance_276,p:{regX:25.1,regY:16.4,x:557.1,y:499.2}}]},2).to({state:[{t:this.instance_276,p:{regX:24.9,regY:16,x:563.7,y:493.9}}]},2).to({state:[]},2).to({state:[{t:this.instance_277}]},34).to({state:[]},2).to({state:[{t:this.instance_281,p:{regX:9.7,regY:8.3,rotation:7.5,x:546,y:362.7}},{t:this.instance_280,p:{regX:1.8,regY:9.4,rotation:7.5,x:554.6,y:373.9}},{t:this.instance_279,p:{regX:8.9,rotation:7.5,x:532.4,y:384.8}},{t:this.instance_278,p:{regX:19.2,regY:38.8,scaleX:1.499,scaleY:1.499,rotation:16.7,x:507.9,y:424.4}}]},50).to({state:[{t:this.instance_281,p:{regX:9.6,regY:7.9,rotation:7.3,x:540.7,y:365.6}},{t:this.instance_280,p:{regX:1.9,regY:8.8,rotation:7.3,x:549.7,y:376.6}},{t:this.instance_279,p:{regX:9,rotation:7.3,x:527.3,y:388.3}},{t:this.instance_278,p:{regX:16.8,regY:36.1,scaleX:1.498,scaleY:1.498,rotation:12,x:502.1,y:425.5}}]},4).to({state:[{t:this.instance_281,p:{regX:9.3,regY:8.4,rotation:7.3,x:537.6,y:367.9}},{t:this.instance_280,p:{regX:2,regY:8.8,rotation:7.3,x:547.2,y:378.3}},{t:this.instance_279,p:{regX:9,rotation:7.3,x:524.7,y:390}},{t:this.instance_278,p:{regX:19.1,regY:38.9,scaleX:1.498,scaleY:1.498,rotation:9.8,x:503.1,y:433.3}}]},2).to({state:[{t:this.instance_281,p:{regX:9.7,regY:8.3,rotation:7.5,x:535.6,y:369.6}},{t:this.instance_280,p:{regX:1.9,regY:8.8,rotation:7.5,x:544.5,y:380}},{t:this.instance_279,p:{regX:8.9,rotation:7.5,x:522,y:391.8}},{t:this.instance_278,p:{regX:19.1,regY:38.8,scaleX:1.499,scaleY:1.499,rotation:7.5,x:501.5,y:436}}]},2).to({state:[{t:this.instance_281,p:{regX:9.3,regY:8.4,rotation:7.3,x:537.6,y:367.9}},{t:this.instance_280,p:{regX:2,regY:8.8,rotation:7.3,x:547.2,y:378.3}},{t:this.instance_279,p:{regX:9,rotation:7.3,x:524.7,y:390}},{t:this.instance_278,p:{regX:19.1,regY:38.9,scaleX:1.498,scaleY:1.498,rotation:9.8,x:503.1,y:433.3}}]},39).to({state:[{t:this.instance_281,p:{regX:9.6,regY:7.9,rotation:7.3,x:540.7,y:365.6}},{t:this.instance_280,p:{regX:1.9,regY:8.8,rotation:7.3,x:549.7,y:376.6}},{t:this.instance_279,p:{regX:9,rotation:7.3,x:527.3,y:388.3}},{t:this.instance_278,p:{regX:16.8,regY:36.1,scaleX:1.498,scaleY:1.498,rotation:12,x:502.1,y:425.5}}]},2).to({state:[{t:this.instance_281,p:{regX:9.7,regY:8.3,rotation:7.5,x:546,y:362.7}},{t:this.instance_280,p:{regX:1.8,regY:9.4,rotation:7.5,x:554.6,y:373.9}},{t:this.instance_279,p:{regX:8.9,rotation:7.5,x:532.4,y:384.8}},{t:this.instance_278,p:{regX:19.2,regY:38.8,scaleX:1.499,scaleY:1.499,rotation:16.7,x:507.9,y:424.4}}]},2).to({state:[]},4).to({state:[{t:this.instance_282}]},6).to({state:[{t:this.instance_283}]},51).to({state:[]},4).to({state:[{t:this.instance_284}]},12).to({state:[{t:this.instance_284}]},4).to({state:[{t:this.instance_284}]},2).to({state:[{t:this.instance_284}]},2).to({state:[{t:this.instance_284}]},10).to({state:[{t:this.instance_284}]},2).to({state:[{t:this.instance_285}]},2).to({state:[]},2).to({state:[{t:this.instance_274}]},90).to({state:[]},8).to({state:[{t:this.instance_286}]},4).to({state:[{t:this.instance_286}]},4).to({state:[{t:this.instance_286}]},2).to({state:[{t:this.instance_286}]},2).to({state:[]},40).wait(85));
	this.timeline.addTween(cjs.Tween.get(this.instance_274).wait(37).to({_off:false},0).wait(2).to({regY:26.2,scaleX:1,scaleY:1,rotation:165.2,x:573.1,y:624},0).wait(2).to({regY:26.4,rotation:171.5,x:562.1,y:563.1},0).wait(2).to({regX:30.4,regY:26.1,rotation:174.7,x:556.5,y:533.2},0).wait(2).to({regX:30.1,regY:26.4,scaleX:1,scaleY:1,rotation:176.2,x:554,y:517.8},0).wait(2).to({regX:30.6,regY:26.2,rotation:177.8,x:554.6,y:500},0).wait(24).to({regX:27.7,regY:29.5,rotation:180,x:553.1,y:499.8},0).wait(2).to({rotation:182,x:552.4,y:500.1},0).wait(2).to({regX:25.9,regY:28.3,rotation:184.3,x:553.5,y:501.8},0).wait(2).to({regX:27.7,regY:29.8,rotation:186.5,x:551.1,y:500.7},0).wait(62).to({regX:25.9,regY:28.3,rotation:184.3,x:553.5,y:501.8},0).wait(2).to({regX:27.7,regY:29.5,rotation:182,x:552.4,y:500.1},0).wait(2).to({rotation:180,x:553.1,y:499.8},0).wait(2).to({regX:30.6,regY:26.2,rotation:177.8,x:551,y:502.9},0).to({_off:true},36).wait(412).to({_off:false,regX:28.2,regY:29.2,rotation:225.9,x:543.6,y:505.2},0).to({_off:true},8).wait(137));
	this.timeline.addTween(cjs.Tween.get(this.instance_275).wait(181).to({_off:false},0).wait(2).to({regX:33.5,regY:24.2,rotation:-6.8,x:510.1,y:450.4},0).wait(2).to({rotation:-5.5,x:511,y:451.4},0).wait(2).to({rotation:-4.3,x:511.9,y:452.4},0).wait(64).to({regY:24.3,scaleX:1.5,scaleY:1.5,rotation:-8,x:507.5,y:448.8},0).wait(2).to({regY:24.2,scaleX:1.5,scaleY:1.5,rotation:-8.5,x:507.7,y:448.5},0).wait(2).to({scaleX:1.5,scaleY:1.5,rotation:-8.8,x:507.9,y:448.4},0).wait(2).to({regY:24.3,scaleX:1.5,scaleY:1.5,rotation:-11.7,x:509.5,y:446.2},0).wait(2).to({regY:24.2,rotation:-7.3,x:513,y:447.4},0).to({_off:true},2).wait(477));
	this.timeline.addTween(cjs.Tween.get(this.instance_284).wait(479).to({_off:false},0).wait(4).to({scaleX:1.03,skewY:-3.8,x:580.4,y:338.4},0).wait(2).to({regX:36.9,regY:34.8,scaleX:1.01,skewY:-1.8,x:579,y:347.3},0).wait(2).to({regX:37.2,regY:28.9,scaleX:1,skewY:0,x:578.2,y:344.4},0).wait(12).to({scaleY:1.19,skewX:-13.7,skewY:-46.5,x:582.5,y:372.9},0).to({_off:true},2).wait(237));
	this.timeline.addTween(cjs.Tween.get(this.instance_286).wait(605).to({_off:false},0).wait(4).to({scaleX:1.05,x:570.8},0).wait(2).to({regX:15,scaleX:1.02,x:569.7},0).wait(2).to({scaleX:1,x:568.6},0).to({_off:true},40).wait(85));

	// Layer 181
	this.instance_287 = new lib.MurrayPointerFinger_039_1();
	this.instance_287.parent = this;
	this.instance_287.setTransform(597.1,728.9,1,1,165.5,0,0,28.3,28.9);
	this.instance_287.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);
	this.instance_287._off = true;

	this.instance_288 = new lib.MurrayLeftArm2_0001_1();
	this.instance_288.parent = this;
	this.instance_288.setTransform(518.9,464.3,1.497,1.349,0,154.2,-25.8,19.2,38.6);
	this.instance_288._off = true;

	this.instance_289 = new lib.MurrayLeftArm1_1();
	this.instance_289.parent = this;
	this.instance_289.setTransform(520.5,444.4,1.499,1.499,-2.8,0,0,36.5,21.4);

	this.instance_290 = new lib.MurrayPinky_037_1();
	this.instance_290.parent = this;
	this.instance_290.setTransform(571.2,517.6,1,0.999,0,-143.9,36.1,10.1,27.1);

	this.instance_291 = new lib.MurrayLeftMiddleFinger_340_1();
	this.instance_291.parent = this;
	this.instance_291.setTransform(603.6,336.3,1.077,1,0,1.5,-12.8,13.8,7.6);
	this.instance_291._off = true;

	this.instance_292 = new lib.MurrayLeftMiddleFinger_353_1();
	this.instance_292.parent = this;
	this.instance_292.setTransform(592.2,426.3,1,1,0,0,0,14.6,21.4);

	this.instance_293 = new lib.MurrayMiddleFinger_1();
	this.instance_293.parent = this;
	this.instance_293.setTransform(557.3,502.1,2.068,1.984,0,-119.2,-112.9,16,12.8);

	this.instance_294 = new lib.MurrayShirtRightArm_001_1();
	this.instance_294.parent = this;
	this.instance_294.setTransform(393.4,422.2,1.005,1.501,0,-42.6,-56,39.9,31.4);
	this.instance_294._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_287}]},37).to({state:[{t:this.instance_287}]},2).to({state:[{t:this.instance_287}]},2).to({state:[{t:this.instance_287}]},2).to({state:[{t:this.instance_287}]},2).to({state:[{t:this.instance_287}]},2).to({state:[{t:this.instance_287}]},24).to({state:[{t:this.instance_287}]},2).to({state:[{t:this.instance_287}]},2).to({state:[{t:this.instance_287}]},2).to({state:[{t:this.instance_287}]},62).to({state:[{t:this.instance_287}]},2).to({state:[{t:this.instance_287}]},2).to({state:[{t:this.instance_287}]},2).to({state:[{t:this.instance_288}]},36).to({state:[{t:this.instance_288}]},2).to({state:[{t:this.instance_288}]},2).to({state:[{t:this.instance_288}]},2).to({state:[{t:this.instance_288}]},64).to({state:[{t:this.instance_288}]},2).to({state:[{t:this.instance_288}]},2).to({state:[{t:this.instance_288}]},2).to({state:[{t:this.instance_288}]},2).to({state:[{t:this.instance_289,p:{regX:36.5,regY:21.4,rotation:-2.8,x:520.5,y:444.4}}]},2).to({state:[{t:this.instance_289,p:{regX:33.5,regY:24.2,rotation:1.4,x:516.2,y:448.8}}]},2).to({state:[]},2).to({state:[{t:this.instance_290}]},198).to({state:[]},4).to({state:[{t:this.instance_291}]},12).to({state:[{t:this.instance_291}]},4).to({state:[{t:this.instance_291}]},2).to({state:[{t:this.instance_291}]},2).to({state:[{t:this.instance_291}]},10).to({state:[{t:this.instance_291}]},2).to({state:[{t:this.instance_292}]},2).to({state:[]},2).to({state:[{t:this.instance_293}]},90).to({state:[]},8).to({state:[{t:this.instance_294}]},4).to({state:[{t:this.instance_294}]},4).to({state:[{t:this.instance_294}]},2).to({state:[{t:this.instance_294}]},2).to({state:[]},40).wait(85));
	this.timeline.addTween(cjs.Tween.get(this.instance_287).wait(37).to({_off:false},0).wait(2).to({regX:28.2,regY:29.7,rotation:178.2,x:579,y:608.3},0).wait(2).to({regX:28.4,regY:29.4,rotation:184.5,x:569.8,y:548.8},0).wait(2).to({regX:28.2,regY:29.1,rotation:187.8,x:565.4,y:519.2},0).wait(2).to({regX:28.4,regY:29.8,scaleX:1,scaleY:1,rotation:189.3,x:563.1,y:503.5},0).wait(2).to({regX:28.3,regY:29.2,scaleX:1,scaleY:1,rotation:190.9,x:564.4,y:486.2},0).wait(24).to({regX:26.7,regY:26.7,scaleX:1,scaleY:1,rotation:193,x:561.4,y:492.5},0).wait(2).to({regX:28.2,regY:29.1,rotation:195.3,x:560.2,y:490.5},0).wait(2).to({regX:28.3,regY:29.7,rotation:197.3,x:560,y:490.7},0).wait(2).to({regY:29.2,scaleX:1,scaleY:1,rotation:199.6,x:559.5,y:491.8},0).wait(62).to({regY:29.7,scaleX:1,scaleY:1,rotation:197.3,x:560,y:490.7},0).wait(2).to({regX:28.2,regY:29.1,rotation:195.3,x:560.2,y:490.5},0).wait(2).to({regX:26.7,regY:26.7,rotation:193,x:561.4,y:492.5},0).wait(2).to({regX:28.3,regY:29.2,scaleX:1,scaleY:1,rotation:190.9,x:560.8,y:489.1},0).to({_off:true},36).wait(557));
	this.timeline.addTween(cjs.Tween.get(this.instance_288).wait(181).to({_off:false},0).wait(2).to({regX:19.1,regY:38.7,skewX:155.4,skewY:-24.6,x:519.4,y:465.5},0).wait(2).to({regY:38.9,scaleX:1.5,skewX:156.7,skewY:-23.3,x:519.8,y:466.6},0).wait(2).to({regX:18.9,scaleX:1.5,scaleY:1.35,skewX:158,skewY:-22,x:520.2,y:468},0).wait(64).to({regX:19.1,regY:38.8,scaleX:1.5,scaleY:1.35,skewX:154.4,skewY:-25.6,x:517,y:463.6},0).wait(2).to({regX:19.2,regY:39,scaleX:1.5,scaleY:1.35,skewX:153.9,skewY:-26.1,x:517.3,y:463.1},0).wait(2).to({regX:19,regY:38.9,scaleX:1.5,scaleY:1.35,skewX:153.4,skewY:-26.6,x:517.5,y:463.2},0).wait(2).to({regY:38.8,scaleX:1.5,scaleY:1.35,skewX:150.6,skewY:-29.4,x:519.8,y:460.4},0).wait(2).to({scaleX:1.5,skewX:148.7,skewY:-29.3,x:519,y:463.6},0).to({_off:true},2).wait(477));
	this.timeline.addTween(cjs.Tween.get(this.instance_291).wait(479).to({_off:false},0).wait(4).to({regX:14.8,regY:7.5,scaleX:1.04,skewX:0.6,skewY:-6.3,x:600.8,y:344.1},0).wait(2).to({regX:8.8,regY:9.1,scaleX:1.02,skewX:0.3,skewY:-3.1,x:592.7,y:350.1},0).wait(2).to({regX:13.8,regY:7.5,scaleX:1,skewX:0,skewY:0,x:596,y:352.4},0).wait(12).to({regX:13.7,regY:7.7,scaleX:1.23,scaleY:2.09,rotation:-71,x:584.2,y:374.2},0).to({_off:true},2).wait(237));
	this.timeline.addTween(cjs.Tween.get(this.instance_294).wait(605).to({_off:false},0).wait(4).to({regX:39.3,regY:30.9,scaleX:1,scaleY:1.5,skewY:-56.1,x:392.6,y:422.1},0).wait(4).to({regX:39.9,regY:31.4,scaleX:1,scaleY:1.5,skewY:-56,x:393.4,y:422.2},0).to({_off:true},40).wait(85));

	// Shirt Right Arm
	this.instance_295 = new lib.MurrayPinky_037_1();
	this.instance_295.parent = this;
	this.instance_295.setTransform(618.9,725.8,1,0.999,155.7,0,0,6.2,25.7);
	this.instance_295.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,5);
	this.instance_295._off = true;

	this.instance_296 = new lib.MurrayPalm_41_1();
	this.instance_296.parent = this;
	this.instance_296.setTransform(560.2,505.2,1,1,0,-6,174,31.4,23.4);

	this.instance_297 = new lib.MurrayPointerFinger_039_1();
	this.instance_297.parent = this;
	this.instance_297.setTransform(548.6,501.3,1,1,-178.3,0,0,32.6,30);

	this.instance_298 = new lib.MurrayPointerFinger_039_1();
	this.instance_298.parent = this;
	this.instance_298.setTransform(561.2,492.1,1,1,-165.1,0,0,28.2,29.2);

	this.instance_299 = new lib.MurrayLeftArm2_0001_1();
	this.instance_299.parent = this;
	this.instance_299.setTransform(517.9,467.4,1.497,1.355,0,146.9,-29.1,18.3,38.2);
	this.instance_299._off = true;

	this.instance_300 = new lib.MurrayMiddleFinger_1();
	this.instance_300.parent = this;
	this.instance_300.setTransform(557.3,502.1,2.068,1.984,0,-119.2,-112.9,16,12.8);

	this.instance_301 = new lib.MurrayLeftThumb_337_1();
	this.instance_301.parent = this;
	this.instance_301.setTransform(495.5,411.5,1,1,0,0,0,17.1,9.1);

	this.instance_302 = new lib.MurrayLeftPointerFinger_340_1();
	this.instance_302.parent = this;
	this.instance_302.setTransform(592.9,330.9,1.112,1,0,0,-20.2,18.1,8.3);
	this.instance_302._off = true;

	this.instance_303 = new lib.MurrayLeftArm2_003_1();
	this.instance_303.parent = this;
	this.instance_303.setTransform(516.3,462.3,1.497,1.349,0,147.4,-32.6,18.9,38.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_295}]},37).to({state:[{t:this.instance_295}]},2).to({state:[{t:this.instance_295}]},2).to({state:[{t:this.instance_295}]},2).to({state:[{t:this.instance_295}]},2).to({state:[{t:this.instance_295}]},2).to({state:[{t:this.instance_295}]},24).to({state:[{t:this.instance_295}]},2).to({state:[{t:this.instance_295}]},2).to({state:[{t:this.instance_295}]},2).to({state:[{t:this.instance_295}]},62).to({state:[{t:this.instance_295}]},2).to({state:[{t:this.instance_295}]},2).to({state:[{t:this.instance_295}]},2).to({state:[{t:this.instance_295},{t:this.instance_298,p:{regX:28.2,rotation:-165.1,x:561.2,y:492.1,regY:29.2}},{t:this.instance_297,p:{regX:32.6,regY:30,rotation:-178.3,x:548.6,y:501.3,scaleX:1,skewX:0,skewY:0,scaleY:1}},{t:this.instance_296,p:{regX:31.4,regY:23.4,skewX:-6,skewY:174,x:560.2,y:505.2,scaleY:1,scaleX:1}}]},36).to({state:[{t:this.instance_295},{t:this.instance_298,p:{regX:28.3,rotation:-162.3,x:561,y:494.2,regY:29.2}},{t:this.instance_297,p:{regX:27.7,regY:29.8,rotation:-175.5,x:552.9,y:503.4,scaleX:1,skewX:0,skewY:0,scaleY:1}},{t:this.instance_296,p:{regX:35.5,regY:21.9,skewX:-3.2,skewY:176.8,x:555.3,y:505.9,scaleY:1,scaleX:1}}]},2).to({state:[{t:this.instance_295},{t:this.instance_298,p:{regX:28.3,rotation:-159.4,x:561,y:496.2,regY:29.4}},{t:this.instance_297,p:{regX:26.7,regY:30.1,rotation:-172.6,x:553.3,y:505.1,scaleX:1,skewX:0,skewY:0,scaleY:1}},{t:this.instance_296,p:{regX:31.7,regY:25.1,skewX:-0.3,skewY:179.7,x:558.4,y:511,scaleY:1,scaleX:1}}]},2).to({state:[{t:this.instance_295},{t:this.instance_298,p:{regX:28.2,rotation:-157.2,x:560.4,y:499.3,regY:28.4}},{t:this.instance_297,p:{regX:26.4,regY:29.1,rotation:-170.4,x:552.8,y:508,scaleX:1,skewX:0,skewY:0,scaleY:1}},{t:this.instance_296,p:{regX:34.4,regY:29.1,skewX:1.9,skewY:-178.1,x:554.7,y:517,scaleY:1,scaleX:1}}]},2).to({state:[{t:this.instance_295},{t:this.instance_298,p:{regX:28.3,rotation:-160.4,x:559.5,y:491.8,regY:29.2}},{t:this.instance_297,p:{regX:27.7,regY:29.8,rotation:-173.5,x:551.1,y:500.7,scaleX:1,skewX:0,skewY:0,scaleY:1}},{t:this.instance_296,p:{regX:31.7,regY:25.1,skewX:-1.3,skewY:178.7,x:557.2,y:506.4,scaleY:1,scaleX:1}}]},64).to({state:[{t:this.instance_295},{t:this.instance_298,p:{regX:28.3,rotation:-161.9,x:560.3,y:491.3,regY:29.2}},{t:this.instance_297,p:{regX:29.1,regY:26.2,rotation:-175,x:550.3,y:503.9,scaleX:1,skewX:0,skewY:0,scaleY:1}},{t:this.instance_296,p:{regX:31.7,regY:25.1,skewX:-2.8,skewY:177.2,x:558.4,y:506,scaleY:1,scaleX:1}}]},2).to({state:[{t:this.instance_295},{t:this.instance_298,p:{regX:28.4,rotation:-163.3,x:561.9,y:490.4,regY:29.2}},{t:this.instance_297,p:{regX:27.7,regY:29.8,rotation:-176.5,x:554,y:499.8,scaleX:1,skewX:0,skewY:0,scaleY:1}},{t:this.instance_296,p:{regX:30.6,regY:28.8,skewX:-4.2,skewY:175.8,x:561.9,y:508.7,scaleY:1,scaleX:1}}]},2).to({state:[{t:this.instance_295},{t:this.instance_298,p:{regX:28.2,rotation:-163.7,x:570,y:485.7,regY:29.2}},{t:this.instance_297,p:{regX:27.7,regY:29.8,rotation:-176.8,x:562,y:495,scaleX:1,skewX:0,skewY:0,scaleY:1}},{t:this.instance_296,p:{regX:29.1,regY:26.9,skewX:-4.6,skewY:175.4,x:571.2,y:502,scaleY:1,scaleX:1}}]},2).to({state:[{t:this.instance_295},{t:this.instance_298,p:{regX:28.2,rotation:-168.5,x:567,y:484.3,regY:29.1}},{t:this.instance_297,p:{regX:27.9,regY:29.5,rotation:178.3,x:559.7,y:494.6,scaleX:1,skewX:0,skewY:0,scaleY:1}},{t:this.instance_296,p:{regX:30.6,regY:23.9,skewX:-9.4,skewY:170.6,x:567.7,y:497.7,scaleY:1,scaleX:1}}]},2).to({state:[{t:this.instance_299}]},2).to({state:[{t:this.instance_299}]},2).to({state:[{t:this.instance_299}]},2).to({state:[{t:this.instance_299}]},34).to({state:[]},2).to({state:[{t:this.instance_295},{t:this.instance_300,p:{regX:16,scaleX:2.068,scaleY:1.984,skewX:-119.2,skewY:-112.9,x:557.3,y:502.1}},{t:this.instance_297,p:{regX:28.2,regY:29.2,rotation:-134.1,x:543.6,y:505.2,scaleX:1,skewX:0,skewY:0,scaleY:1}},{t:this.instance_296,p:{regX:31.7,regY:25.2,skewX:38.2,skewY:-141.8,x:548.6,y:510.4,scaleY:1.092,scaleX:1}},{t:this.instance_299}]},166).to({state:[{t:this.instance_295},{t:this.instance_300,p:{regX:16.1,scaleX:2.05,scaleY:1.986,skewX:-118.8,skewY:-112.6,x:557,y:500.7}},{t:this.instance_297,p:{regX:28.1,regY:28.6,rotation:0,x:543,y:504.3,scaleX:0.991,skewX:-133.6,skewY:-133.9,scaleY:1}},{t:this.instance_296,p:{regX:31.8,regY:25.2,skewX:38.6,skewY:-141.9,x:548.3,y:508.9,scaleY:1.09,scaleX:0.992}},{t:this.instance_299}]},2).to({state:[{t:this.instance_295},{t:this.instance_300,p:{regX:16,scaleX:2.034,scaleY:1.99,skewX:-118.6,skewY:-112.3,x:556.9,y:499.5}},{t:this.instance_297,p:{regX:28.4,regY:29.1,rotation:0,x:542.9,y:502.4,scaleX:0.985,skewX:-133.4,skewY:-133.9,scaleY:1.001}},{t:this.instance_296,p:{regX:31.7,regY:25.1,skewX:39.1,skewY:-141.7,x:548.1,y:507.6,scaleY:1.091,scaleX:0.986}},{t:this.instance_299}]},2).to({state:[{t:this.instance_295},{t:this.instance_300,p:{regX:16,scaleX:2.005,scaleY:2.001,skewX:-118.2,skewY:-111.8,x:556.4,y:496.8}},{t:this.instance_297,p:{regX:27.9,regY:29.4,rotation:0,x:542.9,y:499.8,scaleX:0.972,skewX:-132.5,skewY:-133.8,scaleY:1.005}},{t:this.instance_296,p:{regX:31.9,regY:24.9,skewX:40,skewY:-141.7,x:547.5,y:504.5,scaleY:1.093,scaleX:0.976}},{t:this.instance_299}]},2).to({state:[{t:this.instance_301}]},2).to({state:[]},2).to({state:[{t:this.instance_302}]},2).to({state:[{t:this.instance_302}]},4).to({state:[{t:this.instance_302}]},2).to({state:[{t:this.instance_302}]},2).to({state:[{t:this.instance_302}]},10).to({state:[{t:this.instance_302}]},2).to({state:[{t:this.instance_302}]},2).to({state:[{t:this.instance_295},{t:this.instance_300,p:{regX:16,scaleX:2.034,scaleY:1.99,skewX:-118.6,skewY:-112.3,x:556.9,y:499.5}},{t:this.instance_297,p:{regX:28.4,regY:29.1,rotation:0,x:542.9,y:502.4,scaleX:0.985,skewX:-133.4,skewY:-133.9,scaleY:1.001}},{t:this.instance_296,p:{regX:31.7,regY:25.1,skewX:39.1,skewY:-141.7,x:548.1,y:507.6,scaleY:1.091,scaleX:0.986}},{t:this.instance_299}]},2).to({state:[]},2).to({state:[{t:this.instance_299}]},6).to({state:[{t:this.instance_299}]},2).to({state:[{t:this.instance_299}]},2).to({state:[{t:this.instance_299}]},2).to({state:[]},44).to({state:[{t:this.instance_303}]},2).to({state:[]},2).to({state:[{t:this.instance_295},{t:this.instance_300,p:{regX:16,scaleX:2.068,scaleY:1.984,skewX:-119.2,skewY:-112.9,x:557.3,y:502.1}},{t:this.instance_297,p:{regX:28.2,regY:29.2,rotation:-134.1,x:543.6,y:505.2,scaleX:1,skewX:0,skewY:0,scaleY:1}},{t:this.instance_296,p:{regX:31.7,regY:25.2,skewX:38.2,skewY:-141.8,x:548.6,y:510.4,scaleY:1.092,scaleX:1}},{t:this.instance_299}]},2).to({state:[{t:this.instance_295}]},26).to({state:[{t:this.instance_299}]},8).to({state:[{t:this.instance_299}]},2).to({state:[{t:this.instance_299}]},2).to({state:[{t:this.instance_299}]},4).to({state:[{t:this.instance_299}]},2).to({state:[{t:this.instance_299}]},2).to({state:[{t:this.instance_299}]},40).to({state:[{t:this.instance_299}]},2).to({state:[]},2).wait(81));
	this.timeline.addTween(cjs.Tween.get(this.instance_295).wait(37).to({_off:false},0).wait(2).to({scaleX:1,scaleY:1,rotation:168.5,x:600.4,y:610.9},0).wait(2).to({regX:5.8,regY:25.5,rotation:174.9,x:591.4,y:553.6},0).wait(2).to({regX:6.2,regY:25.7,scaleX:1,scaleY:1,rotation:178,x:586.4,y:524.8},0).wait(2).to({regY:25.8,rotation:179.7,x:584,y:510.3},0).wait(2).to({regY:25.3,rotation:181.1,x:585.4,y:493.5},0).wait(24).to({regX:12.5,regY:23.8,rotation:183.3,x:574.6,y:498.9},0).wait(2).to({regX:9,regY:25.7,rotation:185.3,x:577.6,y:498.7},0).wait(2).to({regX:8.1,regY:27.5,scaleX:1,rotation:187.5,x:578.2,y:498.5},0).wait(2).to({regX:9.7,regY:26.9,scaleX:1,rotation:189.8,x:575.9,y:500},0).wait(62).to({regX:8.1,regY:27.5,scaleX:1,rotation:187.5,x:578.2,y:498.5},0).wait(2).to({regX:9,regY:25.7,scaleX:1,rotation:185.3,x:577.6,y:498.7},0).wait(2).to({regX:12.5,regY:23.8,rotation:183.3,x:574.6,y:498.9},0).wait(2).to({regX:6.2,regY:25.4,rotation:181.1,x:581.7,y:496.3},0).wait(36).to({regX:8.5,regY:22.8,rotation:185.1,x:579,y:503.1},0).wait(2).to({regX:11.1,regY:29.4,rotation:187.8,x:576.7,y:499.2},0).wait(2).to({regX:10,regY:27.1,rotation:190.7,x:577,y:504.6},0).wait(2).to({regX:8.7,regY:27.2,rotation:193,x:577.6,y:507.6},0).wait(64).to({regX:8.3,regY:26.7,rotation:189.8,x:577.2,y:500.4},0).wait(2).to({regX:7,regY:28.4,rotation:188.3,x:579.8,y:498},0).wait(2).to({regX:9.5,regY:27.4,rotation:186.9,x:579.1,y:497.3},0).wait(2).to({regX:9,regY:26.8,rotation:186.5,x:587.5,y:493.1},0).wait(2).to({regX:10,regY:27.5,rotation:181.6,x:584.1,y:489.4},0).to({_off:true},2).wait(206).to({_off:false,regX:10.1,regY:27.1,rotation:360,skewX:-143.9,skewY:36.1,x:571.2,y:517.6},0).wait(2).to({regY:27.2,scaleX:0.99,scaleY:1,skewX:-143.4,x:570.8,y:516.1},0).wait(2).to({regX:10.3,regY:26.4,scaleX:0.99,skewX:-142.9,x:570.3,y:515.5},0).wait(2).to({regX:10.1,regY:27.2,scaleX:0.98,scaleY:1,skewX:-142.1,x:569.8,y:511.8},0).to({_off:true},2).wait(28).to({_off:false,regX:10.3,regY:26.4,scaleX:0.99,scaleY:1,skewX:-142.9,x:570.3,y:515.5},0).to({_off:true},2).wait(62).to({_off:false,regX:10.1,regY:27.1,scaleX:1,scaleY:1,skewX:-143.9,x:571.2,y:517.6},0).wait(26).to({_off:true},8).wait(137));
	this.timeline.addTween(cjs.Tween.get(this.instance_299).wait(261).to({_off:false},0).wait(2).to({regX:18.9,regY:38.6,scaleX:1.5,scaleY:1.36,skewX:142.9,skewY:-31.1,x:519.4,y:467.5},0).wait(2).to({regX:19.1,regY:38.7,scaleX:1.5,scaleY:1.36,skewX:138.9,skewY:-33.3,x:520.5,y:468.6},0).wait(34).to({regY:38.6,scaleX:1.5,scaleY:1.36,skewX:146.9,skewY:-29.1,x:518.8,y:466.4},0).to({_off:true},2).wait(166).to({_off:false,regY:38.8,scaleX:1.5,scaleY:1.35,skewX:154.8,skewY:-25.2,x:516.7,y:463.9},0).wait(2).to({regX:19.4,regY:38.7,scaleX:1.5,scaleY:1.34,skewX:155.2,skewY:-24.8,x:517.3,y:462.3},0).wait(2).to({regX:19.1,regY:38.8,scaleX:1.51,scaleY:1.32,skewX:155.5,skewY:-24.6,x:517,y:461},0).wait(2).to({regX:19.8,regY:38.3,scaleX:1.51,scaleY:1.31,skewX:155.8,skewY:-24.4,x:518.2,y:459.6},0).to({_off:true},2).wait(28).to({_off:false,regX:19.1,regY:38.8,scaleX:1.51,scaleY:1.32,skewX:155.5,skewY:-24.6,x:517,y:461},0).to({_off:true},2).wait(6).to({_off:false,regX:18.8,regY:38.5,scaleX:1.5,scaleY:1.35,skewX:133.8,skewY:-46.2,x:519.7,y:458.7},0).wait(2).to({regX:19.1,regY:39,scaleX:1.5,scaleY:1.35,skewX:136.9,skewY:-43.1,x:518,y:459},0).wait(2).to({regX:18.1,regY:39.9,skewX:138.4,skewY:-41.6,x:515.3,y:459.6},0).wait(2).to({regX:19.2,regY:39.1,scaleX:1.5,scaleY:1.35,skewX:139.8,skewY:-40.2,x:516.6,y:460},0).to({_off:true},44).wait(6).to({_off:false,regX:19.1,regY:38.8,skewX:154.8,skewY:-25.2,x:516.7,y:463.9},0).to({_off:true},26).wait(8).to({_off:false},0).wait(2).to({regX:18.9,regY:38.3,scaleX:1.53,scaleY:1.32,skewX:157.7,skewY:-24.6,x:513,y:459.5},0).wait(2).to({regX:19.1,regY:38.8,scaleX:1.62,scaleY:1.24,skewX:161,skewY:-22.3,x:511.1,y:454.4},0).wait(4).to({scaleX:1.6,scaleY:1.26,skewX:161.2,skewY:-23.1,x:509.6,y:453.2},0).wait(2).to({regX:19,regY:38.7,scaleX:1.59,scaleY:1.28,skewY:-23.5,x:508.8,y:452.8},0).wait(2).to({regX:19.1,regY:38.8,scaleX:1.58,scaleY:1.29,skewX:161.3,skewY:-23.9,x:508.1,y:452.1},0).wait(40).to({regX:18.9,regY:38.3,scaleX:1.53,scaleY:1.32,skewX:157.7,skewY:-24.6,x:513,y:459.5},0).wait(2).to({regX:19.1,regY:38.8,scaleX:1.5,scaleY:1.35,skewX:154.8,skewY:-25.2,x:516.7,y:463.9},0).to({_off:true},2).wait(81));
	this.timeline.addTween(cjs.Tween.get(this.instance_302).wait(479).to({_off:false},0).wait(4).to({regX:17.9,regY:8.2,scaleX:1.06,skewY:-10,x:589.1,y:338.3},0).wait(2).to({scaleX:1.03,skewY:-5,x:587.3,y:342},0).wait(2).to({regY:8.3,scaleX:1,skewY:0,x:585.5,y:345.7},0).wait(12).to({regX:18.2,regY:8.6,scaleX:1,scaleY:1,rotation:-46.7,x:577.8,y:367.8},0).wait(2).to({regX:18.4,regY:8.2,scaleX:1,scaleY:1,rotation:-75,x:587.5,y:422.2},0).to({_off:true},2).wait(235));

	// Murray_bottom
	this.instance_304 = new lib.Murray_bottom_1();
	this.instance_304.parent = this;
	this.instance_304.setTransform(444,557.1,1,1,0,0,0,87.5,48.3);
	this.instance_304._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_304).wait(47).to({_off:false},0).wait(416).to({x:443.4,y:557.3},0).wait(130).to({_off:true},123).wait(22));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;
// library properties:
lib.properties = {
	width: 550,
	height: 400,
	fps: 24,
	color: "#FFFFFF",
	opacity: 1.00,
	manifest: [
		{src:"../../../deploy/assets/images/MWIntro_atlas_.png?1528479358807", id:"MWIntro_atlas_"},
		{src:"../../../deploy/assets/images/MWIntro_atlas_2.png?1528479358809", id:"MWIntro_atlas_2"},
		{src:"../../../deploy/assets/images/MWIntro_atlas_3.png?1528479358815", id:"MWIntro_atlas_3"}
	],
	preloads: []
};




})(lib_MurrayIntro = lib_MurrayIntro||{}, images = images||{}, createjs = createjs||{}, ss = ss||{}, AdobeAn = AdobeAn||{});
var lib_MurrayIntro, images, createjs, ss, AdobeAn;